// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3e%3cpath fill=%27none%27 stroke=%27%23343a40%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%272%27 d=%27m2 5 6 6 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 20 20%27%3e%3cpath fill=%27none%27 stroke=%27%23fff%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%273%27 d=%27m6 10 3 3 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%272%27 fill=%27%23fff%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 20 20%27%3e%3cpath fill=%27none%27 stroke=%27%23fff%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%273%27 d=%27M6 10h8%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27rgba%280, 0, 0, 0.25%29%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27%2386b7fe%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27%23fff%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8 8%27%3e%3cpath fill=%27%23198754%27 d=%27M2.3 6.73.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 12 12%27 width=%2712%27 height=%2712%27 fill=%27none%27 stroke=%27%23dc3545%27%3e%3ccircle cx=%276%27 cy=%276%27 r=%274.5%27/%3e%3cpath stroke-linejoin=%27round%27 d=%27M5.8 3.6h.4L6 6.5z%27/%3e%3ccircle cx=%276%27 cy=%278.2%27 r=%27.6%27 fill=%27%23dc3545%27 stroke=%27none%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 30 30%27%3e%3cpath stroke=%27rgba%280, 0, 0, 0.55%29%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 stroke-width=%272%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 30 30%27%3e%3cpath stroke=%27rgba%28255, 255, 255, 0.55%29%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 stroke-width=%272%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27var%28--bs-body-color%29%27%3e%3cpath fill-rule=%27evenodd%27 d=%27M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%230c63e4%27%3e%3cpath fill-rule=%27evenodd%27 d=%27M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23000%27%3e%3cpath d=%27M.293.293a1 1 0 0 1 1.414 0L8 6.586 14.293.293a1 1 0 1 1 1.414 1.414L9.414 8l6.293 6.293a1 1 0 0 1-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 0 1-1.414-1.414L6.586 8 .293 1.707a1 1 0 0 1 0-1.414z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23fff%27%3e%3cpath d=%27M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23fff%27%3e%3cpath d=%27M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/*!
 * Bootstrap  v5.2.0 (https://getbootstrap.com/)
 * Copyright 2011-2022 The Bootstrap Authors
 * Copyright 2011-2022 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 */
:root {
  --bs-blue: #0d6efd;
  --bs-indigo: #6610f2;
  --bs-purple: #6f42c1;
  --bs-pink: #d63384;
  --bs-red: #dc3545;
  --bs-orange: #fd7e14;
  --bs-yellow: #ffc107;
  --bs-green: #198754;
  --bs-teal: #20c997;
  --bs-cyan: #0dcaf0;
  --bs-black: #000;
  --bs-white: #fff;
  --bs-gray: #6c757d;
  --bs-gray-dark: #343a40;
  --bs-gray-100: #f8f9fa;
  --bs-gray-200: #e9ecef;
  --bs-gray-300: #dee2e6;
  --bs-gray-400: #ced4da;
  --bs-gray-500: #adb5bd;
  --bs-gray-600: #6c757d;
  --bs-gray-700: #495057;
  --bs-gray-800: #343a40;
  --bs-gray-900: #212529;
  --bs-primary: #0d6efd;
  --bs-secondary: #6c757d;
  --bs-success: #198754;
  --bs-info: #0dcaf0;
  --bs-warning: #ffc107;
  --bs-danger: #dc3545;
  --bs-light: #f8f9fa;
  --bs-dark: #212529;
  --bs-primary-rgb: 13, 110, 253;
  --bs-secondary-rgb: 108, 117, 125;
  --bs-success-rgb: 25, 135, 84;
  --bs-info-rgb: 13, 202, 240;
  --bs-warning-rgb: 255, 193, 7;
  --bs-danger-rgb: 220, 53, 69;
  --bs-light-rgb: 248, 249, 250;
  --bs-dark-rgb: 33, 37, 41;
  --bs-white-rgb: 255, 255, 255;
  --bs-black-rgb: 0, 0, 0;
  --bs-body-color-rgb: 33, 37, 41;
  --bs-body-bg-rgb: 255, 255, 255;
  --bs-font-sans-serif: system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", "Noto Sans", "Liberation Sans", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  --bs-font-monospace: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  --bs-gradient: linear-gradient(180deg, rgba(255, 255, 255, 0.15), rgba(255, 255, 255, 0));
  --bs-body-font-family: var(--bs-font-sans-serif);
  --bs-body-font-size: 1rem;
  --bs-body-font-weight: 400;
  --bs-body-line-height: 1.5;
  --bs-body-color: #212529;
  --bs-body-bg: #fff;
  --bs-border-width: 1px;
  --bs-border-style: solid;
  --bs-border-color: #dee2e6;
  --bs-border-color-translucent: rgba(0, 0, 0, 0.175);
  --bs-border-radius: 0.375rem;
  --bs-border-radius-sm: 0.25rem;
  --bs-border-radius-lg: 0.5rem;
  --bs-border-radius-xl: 1rem;
  --bs-border-radius-2xl: 2rem;
  --bs-border-radius-pill: 50rem;
  --bs-link-color: #0d6efd;
  --bs-link-hover-color: #0a58ca;
  --bs-code-color: #d63384;
  --bs-highlight-bg: #fff3cd ;
}

*,
::after,
::before {
  box-sizing: border-box;
}

@media (prefers-reduced-motion: no-preference) {
  :root {
    scroll-behavior: smooth;
  }
}
body {
  margin: 0;
  font-family: var(--bs-body-font-family);
  font-size: var(--bs-body-font-size);
  font-weight: var(--bs-body-font-weight);
  line-height: var(--bs-body-line-height);
  color: var(--bs-body-color);
  text-align: var(--bs-body-text-align);
  background-color: var(--bs-body-bg);
  -webkit-text-size-adjust: 100%;
  -webkit-tap-highlight-color: transparent;
}

hr {
  margin: 1rem 0;
  color: inherit;
  border: 0;
  border-top: 1px solid;
  opacity: 0.25;
}

.h1,
.h2,
.h3,
.h4,
.h5,
.h6,
h1,
h2,
h3,
h4,
h5,
h6 {
  margin-top: 0;
  margin-bottom: 0.5rem;
  font-weight: 500;
  line-height: 1.2;
}

.h1,
h1 {
  font-size: calc(1.375rem + 1.5vw);
}

@media (min-width: 1200px) {
  .h1,
  h1 {
    font-size: 2.5rem;
  }
}
.h2,
h2 {
  font-size: calc(1.325rem + 0.9vw);
}

@media (min-width: 1200px) {
  .h2,
  h2 {
    font-size: 2rem;
  }
}
.h3,
h3 {
  font-size: calc(1.3rem + 0.6vw);
}

@media (min-width: 1200px) {
  .h3,
  h3 {
    font-size: 1.75rem;
  }
}
.h4,
h4 {
  font-size: calc(1.275rem + 0.3vw);
}

@media (min-width: 1200px) {
  .h4,
  h4 {
    font-size: 1.5rem;
  }
}
.h5,
h5 {
  font-size: 1.25rem;
}

.h6,
h6 {
  font-size: 1rem;
}

p {
  margin-top: 0;
  margin-bottom: 1rem;
}

abbr[title] {
  -webkit-text-decoration: underline dotted;
  text-decoration: underline dotted;
  cursor: help;
  text-decoration-skip-ink: none;
}

address {
  margin-bottom: 1rem;
  font-style: normal;
  line-height: inherit;
}

ol,
ul {
  padding-left: 2rem;
}

dl,
ol,
ul {
  margin-top: 0;
  margin-bottom: 1rem;
}

ol ol,
ol ul,
ul ol,
ul ul {
  margin-bottom: 0;
}

dt {
  font-weight: 700;
}

dd {
  margin-bottom: 0.5rem;
  margin-left: 0;
}

blockquote {
  margin: 0 0 1rem;
}

b,
strong {
  font-weight: bolder;
}

.small,
small {
  font-size: 0.875em;
}

.mark,
mark {
  padding: 0.1875em;
  background-color: var(--bs-highlight-bg);
}

sub,
sup {
  position: relative;
  font-size: 0.75em;
  line-height: 0;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

a {
  color: var(--bs-link-color);
  text-decoration: underline;
}

a:hover {
  color: var(--bs-link-hover-color);
}

a:not([href]):not([class]),
a:not([href]):not([class]):hover {
  color: inherit;
  text-decoration: none;
}

code,
kbd,
pre,
samp {
  font-family: var(--bs-font-monospace);
  font-size: 1em;
}

pre {
  display: block;
  margin-top: 0;
  margin-bottom: 1rem;
  overflow: auto;
  font-size: 0.875em;
}

pre code {
  font-size: inherit;
  color: inherit;
  word-break: normal;
}

code {
  font-size: 0.875em;
  color: var(--bs-code-color);
  word-wrap: break-word;
}

a > code {
  color: inherit;
}

kbd {
  padding: 0.1875rem 0.375rem;
  font-size: 0.875em;
  color: var(--bs-body-bg);
  background-color: var(--bs-body-color);
  border-radius: 0.25rem;
}

kbd kbd {
  padding: 0;
  font-size: 1em;
}

figure {
  margin: 0 0 1rem;
}

img,
svg {
  vertical-align: middle;
}

table {
  caption-side: bottom;
  border-collapse: collapse;
}

caption {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  color: #6c757d;
  text-align: left;
}

th {
  text-align: inherit;
  text-align: -webkit-match-parent;
}

tbody,
td,
tfoot,
th,
thead,
tr {
  border-color: inherit;
  border-style: solid;
  border-width: 0;
}

label {
  display: inline-block;
}

button {
  border-radius: 0;
}

button:focus:not(:focus-visible) {
  outline: 0;
}

button,
input,
optgroup,
select,
textarea {
  margin: 0;
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
}

button,
select {
  text-transform: none;
}

[role=button] {
  cursor: pointer;
}

select {
  word-wrap: normal;
}

select:disabled {
  opacity: 1;
}

[list]:not([type=date]):not([type=datetime-local]):not([type=month]):not([type=week]):not([type=time])::-webkit-calendar-picker-indicator {
  display: none !important;
}

[type=button],
[type=reset],
[type=submit],
button {
  -webkit-appearance: button;
}

[type=button]:not(:disabled),
[type=reset]:not(:disabled),
[type=submit]:not(:disabled),
button:not(:disabled) {
  cursor: pointer;
}

::-moz-focus-inner {
  padding: 0;
  border-style: none;
}

textarea {
  resize: vertical;
}

fieldset {
  min-width: 0;
  padding: 0;
  margin: 0;
  border: 0;
}

legend {
  float: left;
  width: 100%;
  padding: 0;
  margin-bottom: 0.5rem;
  font-size: calc(1.275rem + 0.3vw);
  line-height: inherit;
}

@media (min-width: 1200px) {
  legend {
    font-size: 1.5rem;
  }
}
legend + * {
  clear: left;
}

::-webkit-datetime-edit-day-field,
::-webkit-datetime-edit-fields-wrapper,
::-webkit-datetime-edit-hour-field,
::-webkit-datetime-edit-minute,
::-webkit-datetime-edit-month-field,
::-webkit-datetime-edit-text,
::-webkit-datetime-edit-year-field {
  padding: 0;
}

::-webkit-inner-spin-button {
  height: auto;
}

[type=search] {
  outline-offset: -2px;
  -webkit-appearance: textfield;
}

::-webkit-search-decoration {
  -webkit-appearance: none;
}

::-webkit-color-swatch-wrapper {
  padding: 0;
}

::file-selector-button {
  font: inherit;
  -webkit-appearance: button;
}

output {
  display: inline-block;
}

iframe {
  border: 0;
}

summary {
  display: list-item;
  cursor: pointer;
}

progress {
  vertical-align: baseline;
}

[hidden] {
  display: none !important;
}

.lead {
  font-size: 1.25rem;
  font-weight: 300;
}

.display-1 {
  font-size: calc(1.625rem + 4.5vw);
  font-weight: 300;
  line-height: 1.2;
}

@media (min-width: 1200px) {
  .display-1 {
    font-size: 5rem;
  }
}
.display-2 {
  font-size: calc(1.575rem + 3.9vw);
  font-weight: 300;
  line-height: 1.2;
}

@media (min-width: 1200px) {
  .display-2 {
    font-size: 4.5rem;
  }
}
.display-3 {
  font-size: calc(1.525rem + 3.3vw);
  font-weight: 300;
  line-height: 1.2;
}

@media (min-width: 1200px) {
  .display-3 {
    font-size: 4rem;
  }
}
.display-4 {
  font-size: calc(1.475rem + 2.7vw);
  font-weight: 300;
  line-height: 1.2;
}

@media (min-width: 1200px) {
  .display-4 {
    font-size: 3.5rem;
  }
}
.display-5 {
  font-size: calc(1.425rem + 2.1vw);
  font-weight: 300;
  line-height: 1.2;
}

@media (min-width: 1200px) {
  .display-5 {
    font-size: 3rem;
  }
}
.display-6 {
  font-size: calc(1.375rem + 1.5vw);
  font-weight: 300;
  line-height: 1.2;
}

@media (min-width: 1200px) {
  .display-6 {
    font-size: 2.5rem;
  }
}
.list-unstyled {
  padding-left: 0;
  list-style: none;
}

.list-inline {
  padding-left: 0;
  list-style: none;
}

.list-inline-item {
  display: inline-block;
}

.list-inline-item:not(:last-child) {
  margin-right: 0.5rem;
}

.initialism {
  font-size: 0.875em;
  text-transform: uppercase;
}

.blockquote {
  margin-bottom: 1rem;
  font-size: 1.25rem;
}

.blockquote > :last-child {
  margin-bottom: 0;
}

.blockquote-footer {
  margin-top: -1rem;
  margin-bottom: 1rem;
  font-size: 0.875em;
  color: #6c757d;
}

.blockquote-footer::before {
  content: "— ";
}

.img-fluid {
  max-width: 100%;
  height: auto;
}

.img-thumbnail {
  padding: 0.25rem;
  background-color: #fff;
  border: 1px solid var(--bs-border-color);
  border-radius: 0.375rem;
  max-width: 100%;
  height: auto;
}

.figure {
  display: inline-block;
}

.figure-img {
  margin-bottom: 0.5rem;
  line-height: 1;
}

.figure-caption {
  font-size: 0.875em;
  color: #6c757d;
}

.container,
.container-fluid,
.container-lg,
.container-md,
.container-sm,
.container-xl,
.container-xxl {
  --bs-gutter-x: 1.5rem;
  --bs-gutter-y: 0;
  width: 100%;
  padding-right: calc(var(--bs-gutter-x) * 0.5);
  padding-left: calc(var(--bs-gutter-x) * 0.5);
  margin-right: auto;
  margin-left: auto;
}

@media (min-width: 576px) {
  .container,
  .container-sm {
    max-width: 540px;
  }
}
@media (min-width: 768px) {
  .container,
  .container-md,
  .container-sm {
    max-width: 720px;
  }
}
@media (min-width: 992px) {
  .container,
  .container-lg,
  .container-md,
  .container-sm {
    max-width: 960px;
  }
}
@media (min-width: 1200px) {
  .container,
  .container-lg,
  .container-md,
  .container-sm,
  .container-xl {
    max-width: 1140px;
  }
}
@media (min-width: 1400px) {
  .container,
  .container-lg,
  .container-md,
  .container-sm,
  .container-xl,
  .container-xxl {
    max-width: 1320px;
  }
}
.row {
  --bs-gutter-x: 1.5rem;
  --bs-gutter-y: 0;
  display: flex;
  flex-wrap: wrap;
  margin-top: calc(-1 * var(--bs-gutter-y));
  margin-right: calc(-0.5 * var(--bs-gutter-x));
  margin-left: calc(-0.5 * var(--bs-gutter-x));
}

.row > * {
  flex-shrink: 0;
  width: 100%;
  max-width: 100%;
  padding-right: calc(var(--bs-gutter-x) * 0.5);
  padding-left: calc(var(--bs-gutter-x) * 0.5);
  margin-top: var(--bs-gutter-y);
}

.col {
  flex: 1 0;
}

.row-cols-auto > * {
  flex: 0 0 auto;
  width: auto;
}

.row-cols-1 > * {
  flex: 0 0 auto;
  width: 100%;
}

.row-cols-2 > * {
  flex: 0 0 auto;
  width: 50%;
}

.row-cols-3 > * {
  flex: 0 0 auto;
  width: 33.3333333333%;
}

.row-cols-4 > * {
  flex: 0 0 auto;
  width: 25%;
}

.row-cols-5 > * {
  flex: 0 0 auto;
  width: 20%;
}

.row-cols-6 > * {
  flex: 0 0 auto;
  width: 16.6666666667%;
}

.col-auto {
  flex: 0 0 auto;
  width: auto;
}

.col-1 {
  flex: 0 0 auto;
  width: 8.33333333%;
}

.col-2 {
  flex: 0 0 auto;
  width: 16.66666667%;
}

.col-3 {
  flex: 0 0 auto;
  width: 25%;
}

.col-4 {
  flex: 0 0 auto;
  width: 33.33333333%;
}

.col-5 {
  flex: 0 0 auto;
  width: 41.66666667%;
}

.col-6 {
  flex: 0 0 auto;
  width: 50%;
}

.col-7 {
  flex: 0 0 auto;
  width: 58.33333333%;
}

.col-8 {
  flex: 0 0 auto;
  width: 66.66666667%;
}

.col-9 {
  flex: 0 0 auto;
  width: 75%;
}

.col-10 {
  flex: 0 0 auto;
  width: 83.33333333%;
}

.col-11 {
  flex: 0 0 auto;
  width: 91.66666667%;
}

.col-12 {
  flex: 0 0 auto;
  width: 100%;
}

.offset-1 {
  margin-left: 8.33333333%;
}

.offset-2 {
  margin-left: 16.66666667%;
}

.offset-3 {
  margin-left: 25%;
}

.offset-4 {
  margin-left: 33.33333333%;
}

.offset-5 {
  margin-left: 41.66666667%;
}

.offset-6 {
  margin-left: 50%;
}

.offset-7 {
  margin-left: 58.33333333%;
}

.offset-8 {
  margin-left: 66.66666667%;
}

.offset-9 {
  margin-left: 75%;
}

.offset-10 {
  margin-left: 83.33333333%;
}

.offset-11 {
  margin-left: 91.66666667%;
}

.g-0,
.gx-0 {
  --bs-gutter-x: 0 ;
}

.g-0,
.gy-0 {
  --bs-gutter-y: 0 ;
}

.g-1,
.gx-1 {
  --bs-gutter-x: 0.25rem ;
}

.g-1,
.gy-1 {
  --bs-gutter-y: 0.25rem ;
}

.g-2,
.gx-2 {
  --bs-gutter-x: 0.5rem ;
}

.g-2,
.gy-2 {
  --bs-gutter-y: 0.5rem ;
}

.g-3,
.gx-3 {
  --bs-gutter-x: 1rem ;
}

.g-3,
.gy-3 {
  --bs-gutter-y: 1rem ;
}

.g-4,
.gx-4 {
  --bs-gutter-x: 1.5rem ;
}

.g-4,
.gy-4 {
  --bs-gutter-y: 1.5rem ;
}

.g-5,
.gx-5 {
  --bs-gutter-x: 3rem ;
}

.g-5,
.gy-5 {
  --bs-gutter-y: 3rem ;
}

@media (min-width: 576px) {
  .col-sm {
    flex: 1 0;
  }
  .row-cols-sm-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-sm-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-sm-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-sm-3 > * {
    flex: 0 0 auto;
    width: 33.3333333333%;
  }
  .row-cols-sm-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-sm-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-sm-6 > * {
    flex: 0 0 auto;
    width: 16.6666666667%;
  }
  .col-sm-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-sm-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-sm-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-sm-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-sm-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-sm-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-sm-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-sm-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-sm-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-sm-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-sm-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-sm-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-sm-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-sm-0 {
    margin-left: 0;
  }
  .offset-sm-1 {
    margin-left: 8.33333333%;
  }
  .offset-sm-2 {
    margin-left: 16.66666667%;
  }
  .offset-sm-3 {
    margin-left: 25%;
  }
  .offset-sm-4 {
    margin-left: 33.33333333%;
  }
  .offset-sm-5 {
    margin-left: 41.66666667%;
  }
  .offset-sm-6 {
    margin-left: 50%;
  }
  .offset-sm-7 {
    margin-left: 58.33333333%;
  }
  .offset-sm-8 {
    margin-left: 66.66666667%;
  }
  .offset-sm-9 {
    margin-left: 75%;
  }
  .offset-sm-10 {
    margin-left: 83.33333333%;
  }
  .offset-sm-11 {
    margin-left: 91.66666667%;
  }
  .g-sm-0,
  .gx-sm-0 {
    --bs-gutter-x: 0 ;
  }
  .g-sm-0,
  .gy-sm-0 {
    --bs-gutter-y: 0 ;
  }
  .g-sm-1,
  .gx-sm-1 {
    --bs-gutter-x: 0.25rem ;
  }
  .g-sm-1,
  .gy-sm-1 {
    --bs-gutter-y: 0.25rem ;
  }
  .g-sm-2,
  .gx-sm-2 {
    --bs-gutter-x: 0.5rem ;
  }
  .g-sm-2,
  .gy-sm-2 {
    --bs-gutter-y: 0.5rem ;
  }
  .g-sm-3,
  .gx-sm-3 {
    --bs-gutter-x: 1rem ;
  }
  .g-sm-3,
  .gy-sm-3 {
    --bs-gutter-y: 1rem ;
  }
  .g-sm-4,
  .gx-sm-4 {
    --bs-gutter-x: 1.5rem ;
  }
  .g-sm-4,
  .gy-sm-4 {
    --bs-gutter-y: 1.5rem ;
  }
  .g-sm-5,
  .gx-sm-5 {
    --bs-gutter-x: 3rem ;
  }
  .g-sm-5,
  .gy-sm-5 {
    --bs-gutter-y: 3rem ;
  }
}
@media (min-width: 768px) {
  .col-md {
    flex: 1 0;
  }
  .row-cols-md-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-md-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-md-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-md-3 > * {
    flex: 0 0 auto;
    width: 33.3333333333%;
  }
  .row-cols-md-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-md-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-md-6 > * {
    flex: 0 0 auto;
    width: 16.6666666667%;
  }
  .col-md-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-md-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-md-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-md-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-md-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-md-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-md-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-md-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-md-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-md-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-md-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-md-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-md-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-md-0 {
    margin-left: 0;
  }
  .offset-md-1 {
    margin-left: 8.33333333%;
  }
  .offset-md-2 {
    margin-left: 16.66666667%;
  }
  .offset-md-3 {
    margin-left: 25%;
  }
  .offset-md-4 {
    margin-left: 33.33333333%;
  }
  .offset-md-5 {
    margin-left: 41.66666667%;
  }
  .offset-md-6 {
    margin-left: 50%;
  }
  .offset-md-7 {
    margin-left: 58.33333333%;
  }
  .offset-md-8 {
    margin-left: 66.66666667%;
  }
  .offset-md-9 {
    margin-left: 75%;
  }
  .offset-md-10 {
    margin-left: 83.33333333%;
  }
  .offset-md-11 {
    margin-left: 91.66666667%;
  }
  .g-md-0,
  .gx-md-0 {
    --bs-gutter-x: 0 ;
  }
  .g-md-0,
  .gy-md-0 {
    --bs-gutter-y: 0 ;
  }
  .g-md-1,
  .gx-md-1 {
    --bs-gutter-x: 0.25rem ;
  }
  .g-md-1,
  .gy-md-1 {
    --bs-gutter-y: 0.25rem ;
  }
  .g-md-2,
  .gx-md-2 {
    --bs-gutter-x: 0.5rem ;
  }
  .g-md-2,
  .gy-md-2 {
    --bs-gutter-y: 0.5rem ;
  }
  .g-md-3,
  .gx-md-3 {
    --bs-gutter-x: 1rem ;
  }
  .g-md-3,
  .gy-md-3 {
    --bs-gutter-y: 1rem ;
  }
  .g-md-4,
  .gx-md-4 {
    --bs-gutter-x: 1.5rem ;
  }
  .g-md-4,
  .gy-md-4 {
    --bs-gutter-y: 1.5rem ;
  }
  .g-md-5,
  .gx-md-5 {
    --bs-gutter-x: 3rem ;
  }
  .g-md-5,
  .gy-md-5 {
    --bs-gutter-y: 3rem ;
  }
}
@media (min-width: 992px) {
  .col-lg {
    flex: 1 0;
  }
  .row-cols-lg-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-lg-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-lg-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-lg-3 > * {
    flex: 0 0 auto;
    width: 33.3333333333%;
  }
  .row-cols-lg-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-lg-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-lg-6 > * {
    flex: 0 0 auto;
    width: 16.6666666667%;
  }
  .col-lg-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-lg-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-lg-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-lg-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-lg-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-lg-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-lg-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-lg-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-lg-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-lg-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-lg-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-lg-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-lg-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-lg-0 {
    margin-left: 0;
  }
  .offset-lg-1 {
    margin-left: 8.33333333%;
  }
  .offset-lg-2 {
    margin-left: 16.66666667%;
  }
  .offset-lg-3 {
    margin-left: 25%;
  }
  .offset-lg-4 {
    margin-left: 33.33333333%;
  }
  .offset-lg-5 {
    margin-left: 41.66666667%;
  }
  .offset-lg-6 {
    margin-left: 50%;
  }
  .offset-lg-7 {
    margin-left: 58.33333333%;
  }
  .offset-lg-8 {
    margin-left: 66.66666667%;
  }
  .offset-lg-9 {
    margin-left: 75%;
  }
  .offset-lg-10 {
    margin-left: 83.33333333%;
  }
  .offset-lg-11 {
    margin-left: 91.66666667%;
  }
  .g-lg-0,
  .gx-lg-0 {
    --bs-gutter-x: 0 ;
  }
  .g-lg-0,
  .gy-lg-0 {
    --bs-gutter-y: 0 ;
  }
  .g-lg-1,
  .gx-lg-1 {
    --bs-gutter-x: 0.25rem ;
  }
  .g-lg-1,
  .gy-lg-1 {
    --bs-gutter-y: 0.25rem ;
  }
  .g-lg-2,
  .gx-lg-2 {
    --bs-gutter-x: 0.5rem ;
  }
  .g-lg-2,
  .gy-lg-2 {
    --bs-gutter-y: 0.5rem ;
  }
  .g-lg-3,
  .gx-lg-3 {
    --bs-gutter-x: 1rem ;
  }
  .g-lg-3,
  .gy-lg-3 {
    --bs-gutter-y: 1rem ;
  }
  .g-lg-4,
  .gx-lg-4 {
    --bs-gutter-x: 1.5rem ;
  }
  .g-lg-4,
  .gy-lg-4 {
    --bs-gutter-y: 1.5rem ;
  }
  .g-lg-5,
  .gx-lg-5 {
    --bs-gutter-x: 3rem ;
  }
  .g-lg-5,
  .gy-lg-5 {
    --bs-gutter-y: 3rem ;
  }
}
@media (min-width: 1200px) {
  .col-xl {
    flex: 1 0;
  }
  .row-cols-xl-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-xl-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-xl-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-xl-3 > * {
    flex: 0 0 auto;
    width: 33.3333333333%;
  }
  .row-cols-xl-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-xl-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-xl-6 > * {
    flex: 0 0 auto;
    width: 16.6666666667%;
  }
  .col-xl-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-xl-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-xl-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-xl-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-xl-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-xl-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-xl-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-xl-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-xl-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-xl-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-xl-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-xl-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-xl-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-xl-0 {
    margin-left: 0;
  }
  .offset-xl-1 {
    margin-left: 8.33333333%;
  }
  .offset-xl-2 {
    margin-left: 16.66666667%;
  }
  .offset-xl-3 {
    margin-left: 25%;
  }
  .offset-xl-4 {
    margin-left: 33.33333333%;
  }
  .offset-xl-5 {
    margin-left: 41.66666667%;
  }
  .offset-xl-6 {
    margin-left: 50%;
  }
  .offset-xl-7 {
    margin-left: 58.33333333%;
  }
  .offset-xl-8 {
    margin-left: 66.66666667%;
  }
  .offset-xl-9 {
    margin-left: 75%;
  }
  .offset-xl-10 {
    margin-left: 83.33333333%;
  }
  .offset-xl-11 {
    margin-left: 91.66666667%;
  }
  .g-xl-0,
  .gx-xl-0 {
    --bs-gutter-x: 0 ;
  }
  .g-xl-0,
  .gy-xl-0 {
    --bs-gutter-y: 0 ;
  }
  .g-xl-1,
  .gx-xl-1 {
    --bs-gutter-x: 0.25rem ;
  }
  .g-xl-1,
  .gy-xl-1 {
    --bs-gutter-y: 0.25rem ;
  }
  .g-xl-2,
  .gx-xl-2 {
    --bs-gutter-x: 0.5rem ;
  }
  .g-xl-2,
  .gy-xl-2 {
    --bs-gutter-y: 0.5rem ;
  }
  .g-xl-3,
  .gx-xl-3 {
    --bs-gutter-x: 1rem ;
  }
  .g-xl-3,
  .gy-xl-3 {
    --bs-gutter-y: 1rem ;
  }
  .g-xl-4,
  .gx-xl-4 {
    --bs-gutter-x: 1.5rem ;
  }
  .g-xl-4,
  .gy-xl-4 {
    --bs-gutter-y: 1.5rem ;
  }
  .g-xl-5,
  .gx-xl-5 {
    --bs-gutter-x: 3rem ;
  }
  .g-xl-5,
  .gy-xl-5 {
    --bs-gutter-y: 3rem ;
  }
}
@media (min-width: 1400px) {
  .col-xxl {
    flex: 1 0;
  }
  .row-cols-xxl-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-xxl-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-xxl-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-xxl-3 > * {
    flex: 0 0 auto;
    width: 33.3333333333%;
  }
  .row-cols-xxl-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-xxl-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-xxl-6 > * {
    flex: 0 0 auto;
    width: 16.6666666667%;
  }
  .col-xxl-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-xxl-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-xxl-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-xxl-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-xxl-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-xxl-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-xxl-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-xxl-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-xxl-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-xxl-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-xxl-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-xxl-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-xxl-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-xxl-0 {
    margin-left: 0;
  }
  .offset-xxl-1 {
    margin-left: 8.33333333%;
  }
  .offset-xxl-2 {
    margin-left: 16.66666667%;
  }
  .offset-xxl-3 {
    margin-left: 25%;
  }
  .offset-xxl-4 {
    margin-left: 33.33333333%;
  }
  .offset-xxl-5 {
    margin-left: 41.66666667%;
  }
  .offset-xxl-6 {
    margin-left: 50%;
  }
  .offset-xxl-7 {
    margin-left: 58.33333333%;
  }
  .offset-xxl-8 {
    margin-left: 66.66666667%;
  }
  .offset-xxl-9 {
    margin-left: 75%;
  }
  .offset-xxl-10 {
    margin-left: 83.33333333%;
  }
  .offset-xxl-11 {
    margin-left: 91.66666667%;
  }
  .g-xxl-0,
  .gx-xxl-0 {
    --bs-gutter-x: 0 ;
  }
  .g-xxl-0,
  .gy-xxl-0 {
    --bs-gutter-y: 0 ;
  }
  .g-xxl-1,
  .gx-xxl-1 {
    --bs-gutter-x: 0.25rem ;
  }
  .g-xxl-1,
  .gy-xxl-1 {
    --bs-gutter-y: 0.25rem ;
  }
  .g-xxl-2,
  .gx-xxl-2 {
    --bs-gutter-x: 0.5rem ;
  }
  .g-xxl-2,
  .gy-xxl-2 {
    --bs-gutter-y: 0.5rem ;
  }
  .g-xxl-3,
  .gx-xxl-3 {
    --bs-gutter-x: 1rem ;
  }
  .g-xxl-3,
  .gy-xxl-3 {
    --bs-gutter-y: 1rem ;
  }
  .g-xxl-4,
  .gx-xxl-4 {
    --bs-gutter-x: 1.5rem ;
  }
  .g-xxl-4,
  .gy-xxl-4 {
    --bs-gutter-y: 1.5rem ;
  }
  .g-xxl-5,
  .gx-xxl-5 {
    --bs-gutter-x: 3rem ;
  }
  .g-xxl-5,
  .gy-xxl-5 {
    --bs-gutter-y: 3rem ;
  }
}
.table {
  --bs-table-color: var(--bs-body-color);
  --bs-table-bg: transparent;
  --bs-table-border-color: var(--bs-border-color);
  --bs-table-accent-bg: transparent;
  --bs-table-striped-color: var(--bs-body-color);
  --bs-table-striped-bg: rgba(0, 0, 0, 0.05);
  --bs-table-active-color: var(--bs-body-color);
  --bs-table-active-bg: rgba(0, 0, 0, 0.1);
  --bs-table-hover-color: var(--bs-body-color);
  --bs-table-hover-bg: rgba(0, 0, 0, 0.075);
  width: 100%;
  margin-bottom: 1rem;
  color: var(--bs-table-color);
  vertical-align: top;
  border-color: var(--bs-table-border-color);
}

.table > :not(caption) > * > * {
  padding: 0.5rem 0.5rem;
  background-color: var(--bs-table-bg);
  border-bottom-width: 1px;
  box-shadow: inset 0 0 0 9999px var(--bs-table-accent-bg);
}

.table > tbody {
  vertical-align: inherit;
}

.table > thead {
  vertical-align: bottom;
}

.table-group-divider {
  border-top: 2px solid currentcolor;
}

.caption-top {
  caption-side: top;
}

.table-sm > :not(caption) > * > * {
  padding: 0.25rem 0.25rem;
}

.table-bordered > :not(caption) > * {
  border-width: 1px 0;
}

.table-bordered > :not(caption) > * > * {
  border-width: 0 1px;
}

.table-borderless > :not(caption) > * > * {
  border-bottom-width: 0;
}

.table-borderless > :not(:first-child) {
  border-top-width: 0;
}

.table-striped > tbody > tr:nth-of-type(odd) > * {
  --bs-table-accent-bg: var(--bs-table-striped-bg);
  color: var(--bs-table-striped-color);
}

.table-striped-columns > :not(caption) > tr > :nth-child(2n) {
  --bs-table-accent-bg: var(--bs-table-striped-bg);
  color: var(--bs-table-striped-color);
}

.table-active {
  --bs-table-accent-bg: var(--bs-table-active-bg);
  color: var(--bs-table-active-color);
}

.table-hover > tbody > tr:hover > * {
  --bs-table-accent-bg: var(--bs-table-hover-bg);
  color: var(--bs-table-hover-color);
}

.table-primary {
  --bs-table-color: #000;
  --bs-table-bg: #cfe2ff;
  --bs-table-border-color: #bacbe6;
  --bs-table-striped-bg: #c5d7f2;
  --bs-table-striped-color: #000;
  --bs-table-active-bg: #bacbe6;
  --bs-table-active-color: #000;
  --bs-table-hover-bg: #bfd1ec;
  --bs-table-hover-color: #000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-secondary {
  --bs-table-color: #000;
  --bs-table-bg: #e2e3e5;
  --bs-table-border-color: #cbccce;
  --bs-table-striped-bg: #d7d8da;
  --bs-table-striped-color: #000;
  --bs-table-active-bg: #cbccce;
  --bs-table-active-color: #000;
  --bs-table-hover-bg: #d1d2d4;
  --bs-table-hover-color: #000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-success {
  --bs-table-color: #000;
  --bs-table-bg: #d1e7dd;
  --bs-table-border-color: #bcd0c7;
  --bs-table-striped-bg: #c7dbd2;
  --bs-table-striped-color: #000;
  --bs-table-active-bg: #bcd0c7;
  --bs-table-active-color: #000;
  --bs-table-hover-bg: #c1d6cc;
  --bs-table-hover-color: #000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-info {
  --bs-table-color: #000;
  --bs-table-bg: #cff4fc;
  --bs-table-border-color: #badce3;
  --bs-table-striped-bg: #c5e8ef;
  --bs-table-striped-color: #000;
  --bs-table-active-bg: #badce3;
  --bs-table-active-color: #000;
  --bs-table-hover-bg: #bfe2e9;
  --bs-table-hover-color: #000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-warning {
  --bs-table-color: #000;
  --bs-table-bg: #fff3cd;
  --bs-table-border-color: #e6dbb9;
  --bs-table-striped-bg: #f2e7c3;
  --bs-table-striped-color: #000;
  --bs-table-active-bg: #e6dbb9;
  --bs-table-active-color: #000;
  --bs-table-hover-bg: #ece1be;
  --bs-table-hover-color: #000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-danger {
  --bs-table-color: #000;
  --bs-table-bg: #f8d7da;
  --bs-table-border-color: #dfc2c4;
  --bs-table-striped-bg: #eccccf;
  --bs-table-striped-color: #000;
  --bs-table-active-bg: #dfc2c4;
  --bs-table-active-color: #000;
  --bs-table-hover-bg: #e5c7ca;
  --bs-table-hover-color: #000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-light {
  --bs-table-color: #000;
  --bs-table-bg: #f8f9fa;
  --bs-table-border-color: #dfe0e1;
  --bs-table-striped-bg: #ecedee;
  --bs-table-striped-color: #000;
  --bs-table-active-bg: #dfe0e1;
  --bs-table-active-color: #000;
  --bs-table-hover-bg: #e5e6e7;
  --bs-table-hover-color: #000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-dark {
  --bs-table-color: #fff;
  --bs-table-bg: #212529;
  --bs-table-border-color: #373b3e;
  --bs-table-striped-bg: #2c3034;
  --bs-table-striped-color: #fff;
  --bs-table-active-bg: #373b3e;
  --bs-table-active-color: #fff;
  --bs-table-hover-bg: #323539;
  --bs-table-hover-color: #fff;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-responsive {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

@media (max-width: 575.98px) {
  .table-responsive-sm {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 767.98px) {
  .table-responsive-md {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 991.98px) {
  .table-responsive-lg {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 1199.98px) {
  .table-responsive-xl {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 1399.98px) {
  .table-responsive-xxl {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
.form-label {
  margin-bottom: 0.5rem;
}

.col-form-label {
  padding-top: calc(0.375rem + 1px);
  padding-bottom: calc(0.375rem + 1px);
  margin-bottom: 0;
  font-size: inherit;
  line-height: 1.5;
}

.col-form-label-lg {
  padding-top: calc(0.5rem + 1px);
  padding-bottom: calc(0.5rem + 1px);
  font-size: 1.25rem;
}

.col-form-label-sm {
  padding-top: calc(0.25rem + 1px);
  padding-bottom: calc(0.25rem + 1px);
  font-size: 0.875rem;
}

.form-text {
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: #6c757d;
}

.form-control {
  display: block;
  width: 100%;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #212529;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  appearance: none;
  border-radius: 0.375rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

@media (prefers-reduced-motion: reduce) {
  .form-control {
    transition: none;
  }
}
.form-control[type=file] {
  overflow: hidden;
}

.form-control[type=file]:not(:disabled):not([readonly]) {
  cursor: pointer;
}

.form-control:focus {
  color: #212529;
  background-color: #fff;
  border-color: #86b7fe;
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
}

.form-control::-webkit-date-and-time-value {
  height: 1.5em;
}

.form-control::placeholder {
  color: #6c757d;
  opacity: 1;
}

.form-control:disabled {
  background-color: #e9ecef;
  opacity: 1;
}

.form-control::file-selector-button {
  padding: 0.375rem 0.75rem;
  margin: -0.375rem -0.75rem;
  margin-inline-end: 0.75rem;
  color: #212529;
  background-color: #e9ecef;
  pointer-events: none;
  border-color: inherit;
  border-style: solid;
  border-width: 0;
  border-inline-end-width: 1px;
  border-radius: 0;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

@media (prefers-reduced-motion: reduce) {
  .form-control::file-selector-button {
    transition: none;
  }
}

.form-control:hover:not(:disabled):not([readonly])::file-selector-button {
  background-color: #dde0e3;
}

.form-control-plaintext {
  display: block;
  width: 100%;
  padding: 0.375rem 0;
  margin-bottom: 0;
  line-height: 1.5;
  color: #212529;
  background-color: transparent;
  border: solid transparent;
  border-width: 1px 0;
}

.form-control-plaintext:focus {
  outline: 0;
}

.form-control-plaintext.form-control-lg,
.form-control-plaintext.form-control-sm {
  padding-right: 0;
  padding-left: 0;
}

.form-control-sm {
  min-height: calc(1.5em + 0.5rem + 2px);
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
  border-radius: 0.25rem;
}

.form-control-sm::file-selector-button {
  padding: 0.25rem 0.5rem;
  margin: -0.25rem -0.5rem;
  margin-inline-end: 0.5rem;
}

.form-control-lg {
  min-height: calc(1.5em + 1rem + 2px);
  padding: 0.5rem 1rem;
  font-size: 1.25rem;
  border-radius: 0.5rem;
}

.form-control-lg::file-selector-button {
  padding: 0.5rem 1rem;
  margin: -0.5rem -1rem;
  margin-inline-end: 1rem;
}

textarea.form-control {
  min-height: calc(1.5em + 0.75rem + 2px);
}

textarea.form-control-sm {
  min-height: calc(1.5em + 0.5rem + 2px);
}

textarea.form-control-lg {
  min-height: calc(1.5em + 1rem + 2px);
}

.form-control-color {
  width: 3rem;
  height: calc(1.5em + 0.75rem + 2px);
  padding: 0.375rem;
}

.form-control-color:not(:disabled):not([readonly]) {
  cursor: pointer;
}

.form-control-color::-moz-color-swatch {
  border: 0 !important;
  border-radius: 0.375rem;
}

.form-control-color::-webkit-color-swatch {
  border-radius: 0.375rem;
}

.form-control-color.form-control-sm {
  height: calc(1.5em + 0.5rem + 2px);
}

.form-control-color.form-control-lg {
  height: calc(1.5em + 1rem + 2px);
}

.form-select {
  display: block;
  width: 100%;
  padding: 0.375rem 2.25rem 0.375rem 0.75rem;
  -moz-padding-start: calc(0.75rem - 3px);
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #212529;
  background-color: #fff;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right 0.75rem center;
  background-size: 16px 12px;
  border: 1px solid #ced4da;
  border-radius: 0.375rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  appearance: none;
}

@media (prefers-reduced-motion: reduce) {
  .form-select {
    transition: none;
  }
}
.form-select:focus {
  border-color: #86b7fe;
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
}

.form-select[multiple],
.form-select[size]:not([size="1"]) {
  padding-right: 0.75rem;
  background-image: none;
}

.form-select:disabled {
  background-color: #e9ecef;
}

.form-select:-moz-focusring {
  color: transparent;
  text-shadow: 0 0 0 #212529;
}

.form-select-sm {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  padding-left: 0.5rem;
  font-size: 0.875rem;
  border-radius: 0.25rem;
}

.form-select-lg {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  padding-left: 1rem;
  font-size: 1.25rem;
  border-radius: 0.5rem;
}

.form-check {
  display: block;
  min-height: 1.5rem;
  padding-left: 1.5em;
  margin-bottom: 0.125rem;
}

.form-check .form-check-input {
  float: left;
  margin-left: -1.5em;
}

.form-check-reverse {
  padding-right: 1.5em;
  padding-left: 0;
  text-align: right;
}

.form-check-reverse .form-check-input {
  float: right;
  margin-right: -1.5em;
  margin-left: 0;
}

.form-check-input {
  width: 1em;
  height: 1em;
  margin-top: 0.25em;
  vertical-align: top;
  background-color: #fff;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  border: 1px solid rgba(0, 0, 0, 0.25);
  appearance: none;
  -webkit-print-color-adjust: exact;
  print-color-adjust: exact;
}

.form-check-input[type=checkbox] {
  border-radius: 0.25em;
}

.form-check-input[type=radio] {
  border-radius: 50%;
}

.form-check-input:active {
  filter: brightness(90%);
}

.form-check-input:focus {
  border-color: #86b7fe;
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
}

.form-check-input:checked {
  background-color: #0d6efd;
  border-color: #0d6efd;
}

.form-check-input:checked[type=checkbox] {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

.form-check-input:checked[type=radio] {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}

.form-check-input[type=checkbox]:indeterminate {
  background-color: #0d6efd;
  border-color: #0d6efd;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}

.form-check-input:disabled {
  pointer-events: none;
  filter: none;
  opacity: 0.5;
}

.form-check-input:disabled ~ .form-check-label,
.form-check-input[disabled] ~ .form-check-label {
  cursor: default;
  opacity: 0.5;
}

.form-switch {
  padding-left: 2.5em;
}

.form-switch .form-check-input {
  width: 2em;
  margin-left: -2.5em;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  background-position: left center;
  border-radius: 2em;
  transition: background-position 0.15s ease-in-out;
}

@media (prefers-reduced-motion: reduce) {
  .form-switch .form-check-input {
    transition: none;
  }
}
.form-switch .form-check-input:focus {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
}

.form-switch .form-check-input:checked {
  background-position: right center;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
}

.form-switch.form-check-reverse {
  padding-right: 2.5em;
  padding-left: 0;
}

.form-switch.form-check-reverse .form-check-input {
  margin-right: -2.5em;
  margin-left: 0;
}

.form-check-inline {
  display: inline-block;
  margin-right: 1rem;
}

.btn-check {
  position: absolute;
  clip: rect(0, 0, 0, 0);
  pointer-events: none;
}

.btn-check:disabled + .btn,
.btn-check[disabled] + .btn {
  pointer-events: none;
  filter: none;
  opacity: 0.65;
}

.form-range {
  width: 100%;
  height: 1.5rem;
  padding: 0;
  background-color: transparent;
  appearance: none;
}

.form-range:focus {
  outline: 0;
}

.form-range:focus::-webkit-slider-thumb {
  box-shadow: 0 0 0 1px #fff, 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
}

.form-range:focus::-moz-range-thumb {
  box-shadow: 0 0 0 1px #fff, 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
}

.form-range::-moz-focus-outer {
  border: 0;
}

.form-range::-webkit-slider-thumb {
  width: 1rem;
  height: 1rem;
  margin-top: -0.25rem;
  background-color: #0d6efd;
  border: 0;
  border-radius: 1rem;
  -webkit-transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  appearance: none;
}

@media (prefers-reduced-motion: reduce) {
  .form-range::-webkit-slider-thumb {
    -webkit-transition: none;
    transition: none;
  }
}
.form-range::-webkit-slider-thumb:active {
  background-color: #b6d4fe;
}

.form-range::-webkit-slider-runnable-track {
  width: 100%;
  height: 0.5rem;
  color: transparent;
  cursor: pointer;
  background-color: #dee2e6;
  border-color: transparent;
  border-radius: 1rem;
}

.form-range::-moz-range-thumb {
  width: 1rem;
  height: 1rem;
  background-color: #0d6efd;
  border: 0;
  border-radius: 1rem;
  -moz-transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  appearance: none;
}

@media (prefers-reduced-motion: reduce) {
  .form-range::-moz-range-thumb {
    -moz-transition: none;
    transition: none;
  }
}
.form-range::-moz-range-thumb:active {
  background-color: #b6d4fe;
}

.form-range::-moz-range-track {
  width: 100%;
  height: 0.5rem;
  color: transparent;
  cursor: pointer;
  background-color: #dee2e6;
  border-color: transparent;
  border-radius: 1rem;
}

.form-range:disabled {
  pointer-events: none;
}

.form-range:disabled::-webkit-slider-thumb {
  background-color: #adb5bd;
}

.form-range:disabled::-moz-range-thumb {
  background-color: #adb5bd;
}

.form-floating {
  position: relative;
}

.form-floating > .form-control,
.form-floating > .form-control-plaintext,
.form-floating > .form-select {
  height: calc(3.5rem + 2px);
  line-height: 1.25;
}

.form-floating > label {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  padding: 1rem 0.75rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  pointer-events: none;
  border: 1px solid transparent;
  transform-origin: 0 0;
  transition: opacity 0.1s ease-in-out, transform 0.1s ease-in-out;
}

@media (prefers-reduced-motion: reduce) {
  .form-floating > label {
    transition: none;
  }
}
.form-floating > .form-control,
.form-floating > .form-control-plaintext {
  padding: 1rem 0.75rem;
}

.form-floating > .form-control-plaintext::placeholder,
.form-floating > .form-control::placeholder {
  color: transparent;
}

.form-floating > .form-control-plaintext:focus,
.form-floating > .form-control-plaintext:not(:placeholder-shown),
.form-floating > .form-control:focus,
.form-floating > .form-control:not(:placeholder-shown) {
  padding-top: 1.625rem;
  padding-bottom: 0.625rem;
}

.form-floating > .form-control-plaintext:-webkit-autofill,
.form-floating > .form-control:-webkit-autofill {
  padding-top: 1.625rem;
  padding-bottom: 0.625rem;
}

.form-floating > .form-select {
  padding-top: 1.625rem;
  padding-bottom: 0.625rem;
}

.form-floating > .form-control-plaintext ~ label,
.form-floating > .form-control:focus ~ label,
.form-floating > .form-control:not(:placeholder-shown) ~ label,
.form-floating > .form-select ~ label {
  opacity: 0.65;
  transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);
}

.form-floating > .form-control:-webkit-autofill ~ label {
  opacity: 0.65;
  transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);
}

.form-floating > .form-control-plaintext ~ label {
  border-width: 1px 0;
}

.input-group {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  width: 100%;
}

.input-group > .form-control,
.input-group > .form-floating,
.input-group > .form-select {
  position: relative;
  flex: 1 1 auto;
  width: 1%;
  min-width: 0;
}

.input-group > .form-control:focus,
.input-group > .form-floating:focus-within,
.input-group > .form-select:focus {
  z-index: 3;
}

.input-group .btn {
  position: relative;
  z-index: 2;
}

.input-group .btn:focus {
  z-index: 3;
}

.input-group-text {
  display: flex;
  align-items: center;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #212529;
  text-align: center;
  white-space: nowrap;
  background-color: #e9ecef;
  border: 1px solid #ced4da;
  border-radius: 0.375rem;
}

.input-group-lg > .btn,
.input-group-lg > .form-control,
.input-group-lg > .form-select,
.input-group-lg > .input-group-text {
  padding: 0.5rem 1rem;
  font-size: 1.25rem;
  border-radius: 0.5rem;
}

.input-group-sm > .btn,
.input-group-sm > .form-control,
.input-group-sm > .form-select,
.input-group-sm > .input-group-text {
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
  border-radius: 0.25rem;
}

.input-group-lg > .form-select,
.input-group-sm > .form-select {
  padding-right: 3rem;
}

.input-group:not(.has-validation) > .dropdown-toggle:nth-last-child(n+3),
.input-group:not(.has-validation) > .form-floating:not(:last-child) > .form-control,
.input-group:not(.has-validation) > .form-floating:not(:last-child) > .form-select,
.input-group:not(.has-validation) > :not(:last-child):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating) {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.input-group.has-validation > .dropdown-toggle:nth-last-child(n+4),
.input-group.has-validation > .form-floating:nth-last-child(n+3) > .form-control,
.input-group.has-validation > .form-floating:nth-last-child(n+3) > .form-select,
.input-group.has-validation > :nth-last-child(n+3):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating) {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.input-group > .form-floating:not(:first-child) > .form-control,
.input-group > .form-floating:not(:first-child) > .form-select,
.input-group > :not(:first-child):not(.dropdown-menu):not(.form-floating):not(.valid-tooltip):not(.valid-feedback):not(.invalid-tooltip):not(.invalid-feedback) {
  margin-left: -1px;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.valid-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: #198754;
}

.valid-tooltip {
  position: absolute;
  top: 100%;
  z-index: 5;
  display: none;
  max-width: 100%;
  padding: 0.25rem 0.5rem;
  margin-top: 0.1rem;
  font-size: 0.875rem;
  color: #fff;
  background-color: rgba(25, 135, 84, 0.9);
  border-radius: 0.375rem;
}

.is-valid ~ .valid-feedback,
.is-valid ~ .valid-tooltip,
.was-validated :valid ~ .valid-feedback,
.was-validated :valid ~ .valid-tooltip {
  display: block;
}

.form-control.is-valid,
.was-validated .form-control:valid {
  border-color: #198754;
  padding-right: calc(1.5em + 0.75rem);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
  background-repeat: no-repeat;
  background-position: right calc(0.375em + 0.1875rem) center;
  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}

.form-control.is-valid:focus,
.was-validated .form-control:valid:focus {
  border-color: #198754;
  box-shadow: 0 0 0 0.25rem rgba(25, 135, 84, 0.25);
}

.was-validated textarea.form-control:valid,
textarea.form-control.is-valid {
  padding-right: calc(1.5em + 0.75rem);
  background-position: top calc(0.375em + 0.1875rem) right calc(0.375em + 0.1875rem);
}

.form-select.is-valid,
.was-validated .form-select:valid {
  border-color: #198754;
}

.form-select.is-valid:not([multiple]):not([size]),
.form-select.is-valid:not([multiple])[size="1"],
.was-validated .form-select:valid:not([multiple]):not([size]),
.was-validated .form-select:valid:not([multiple])[size="1"] {
  padding-right: 4.125rem;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___}), url(${___CSS_LOADER_URL_REPLACEMENT_7___});
  background-position: right 0.75rem center, center right 2.25rem;
  background-size: 16px 12px, calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}

.form-select.is-valid:focus,
.was-validated .form-select:valid:focus {
  border-color: #198754;
  box-shadow: 0 0 0 0.25rem rgba(25, 135, 84, 0.25);
}

.form-control-color.is-valid,
.was-validated .form-control-color:valid {
  width: calc(3rem + 1.5em + 0.75rem);
}

.form-check-input.is-valid,
.was-validated .form-check-input:valid {
  border-color: #198754;
}

.form-check-input.is-valid:checked,
.was-validated .form-check-input:valid:checked {
  background-color: #198754;
}

.form-check-input.is-valid:focus,
.was-validated .form-check-input:valid:focus {
  box-shadow: 0 0 0 0.25rem rgba(25, 135, 84, 0.25);
}

.form-check-input.is-valid ~ .form-check-label,
.was-validated .form-check-input:valid ~ .form-check-label {
  color: #198754;
}

.form-check-inline .form-check-input ~ .valid-feedback {
  margin-left: 0.5em;
}

.input-group .form-control.is-valid,
.input-group .form-select.is-valid,
.was-validated .input-group .form-control:valid,
.was-validated .input-group .form-select:valid {
  z-index: 1;
}

.input-group .form-control.is-valid:focus,
.input-group .form-select.is-valid:focus,
.was-validated .input-group .form-control:valid:focus,
.was-validated .input-group .form-select:valid:focus {
  z-index: 3;
}

.invalid-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: #dc3545;
}

.invalid-tooltip {
  position: absolute;
  top: 100%;
  z-index: 5;
  display: none;
  max-width: 100%;
  padding: 0.25rem 0.5rem;
  margin-top: 0.1rem;
  font-size: 0.875rem;
  color: #fff;
  background-color: rgba(220, 53, 69, 0.9);
  border-radius: 0.375rem;
}

.is-invalid ~ .invalid-feedback,
.is-invalid ~ .invalid-tooltip,
.was-validated :invalid ~ .invalid-feedback,
.was-validated :invalid ~ .invalid-tooltip {
  display: block;
}

.form-control.is-invalid,
.was-validated .form-control:invalid {
  border-color: #dc3545;
  padding-right: calc(1.5em + 0.75rem);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
  background-repeat: no-repeat;
  background-position: right calc(0.375em + 0.1875rem) center;
  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}

.form-control.is-invalid:focus,
.was-validated .form-control:invalid:focus {
  border-color: #dc3545;
  box-shadow: 0 0 0 0.25rem rgba(220, 53, 69, 0.25);
}

.was-validated textarea.form-control:invalid,
textarea.form-control.is-invalid {
  padding-right: calc(1.5em + 0.75rem);
  background-position: top calc(0.375em + 0.1875rem) right calc(0.375em + 0.1875rem);
}

.form-select.is-invalid,
.was-validated .form-select:invalid {
  border-color: #dc3545;
}

.form-select.is-invalid:not([multiple]):not([size]),
.form-select.is-invalid:not([multiple])[size="1"],
.was-validated .form-select:invalid:not([multiple]):not([size]),
.was-validated .form-select:invalid:not([multiple])[size="1"] {
  padding-right: 4.125rem;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___}), url(${___CSS_LOADER_URL_REPLACEMENT_8___});
  background-position: right 0.75rem center, center right 2.25rem;
  background-size: 16px 12px, calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}

.form-select.is-invalid:focus,
.was-validated .form-select:invalid:focus {
  border-color: #dc3545;
  box-shadow: 0 0 0 0.25rem rgba(220, 53, 69, 0.25);
}

.form-control-color.is-invalid,
.was-validated .form-control-color:invalid {
  width: calc(3rem + 1.5em + 0.75rem);
}

.form-check-input.is-invalid,
.was-validated .form-check-input:invalid {
  border-color: #dc3545;
}

.form-check-input.is-invalid:checked,
.was-validated .form-check-input:invalid:checked {
  background-color: #dc3545;
}

.form-check-input.is-invalid:focus,
.was-validated .form-check-input:invalid:focus {
  box-shadow: 0 0 0 0.25rem rgba(220, 53, 69, 0.25);
}

.form-check-input.is-invalid ~ .form-check-label,
.was-validated .form-check-input:invalid ~ .form-check-label {
  color: #dc3545;
}

.form-check-inline .form-check-input ~ .invalid-feedback {
  margin-left: 0.5em;
}

.input-group .form-control.is-invalid,
.input-group .form-select.is-invalid,
.was-validated .input-group .form-control:invalid,
.was-validated .input-group .form-select:invalid {
  z-index: 2;
}

.input-group .form-control.is-invalid:focus,
.input-group .form-select.is-invalid:focus,
.was-validated .input-group .form-control:invalid:focus,
.was-validated .input-group .form-select:invalid:focus {
  z-index: 3;
}

.btn {
  --bs-btn-padding-x: 0.75rem;
  --bs-btn-padding-y: 0.375rem;
  --bs-btn-font-family: ;
  --bs-btn-font-size: 1rem;
  --bs-btn-font-weight: 400;
  --bs-btn-line-height: 1.5;
  --bs-btn-color: #212529;
  --bs-btn-bg: transparent;
  --bs-btn-border-width: 1px;
  --bs-btn-border-color: transparent;
  --bs-btn-border-radius: 0.375rem;
  --bs-btn-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  --bs-btn-disabled-opacity: 0.65;
  --bs-btn-focus-box-shadow: 0 0 0 0.25rem rgba(var(--bs-btn-focus-shadow-rgb), .5);
  display: inline-block;
  padding: var(--bs-btn-padding-y) var(--bs-btn-padding-x);
  font-family: var(--bs-btn-font-family);
  font-size: var(--bs-btn-font-size);
  font-weight: var(--bs-btn-font-weight);
  line-height: var(--bs-btn-line-height);
  color: var(--bs-btn-color);
  text-align: center;
  text-decoration: none;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
  user-select: none;
  border: var(--bs-btn-border-width) solid var(--bs-btn-border-color);
  border-radius: var(--bs-btn-border-radius);
  background-color: var(--bs-btn-bg);
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

@media (prefers-reduced-motion: reduce) {
  .btn {
    transition: none;
  }
}
.btn:hover {
  color: var(--bs-btn-hover-color);
  background-color: var(--bs-btn-hover-bg);
  border-color: var(--bs-btn-hover-border-color);
}

.btn-check:focus + .btn,
.btn:focus {
  color: var(--bs-btn-hover-color);
  background-color: var(--bs-btn-hover-bg);
  border-color: var(--bs-btn-hover-border-color);
  outline: 0;
  box-shadow: var(--bs-btn-focus-box-shadow);
}

.btn-check:active + .btn,
.btn-check:checked + .btn,
.btn.active,
.btn.show,
.btn:active {
  color: var(--bs-btn-active-color);
  background-color: var(--bs-btn-active-bg);
  border-color: var(--bs-btn-active-border-color);
}

.btn-check:active + .btn:focus,
.btn-check:checked + .btn:focus,
.btn.active:focus,
.btn.show:focus,
.btn:active:focus {
  box-shadow: var(--bs-btn-focus-box-shadow);
}

.btn.disabled,
.btn:disabled,
fieldset:disabled .btn {
  color: var(--bs-btn-disabled-color);
  pointer-events: none;
  background-color: var(--bs-btn-disabled-bg);
  border-color: var(--bs-btn-disabled-border-color);
  opacity: var(--bs-btn-disabled-opacity);
}

.btn-primary {
  --bs-btn-color: #fff;
  --bs-btn-bg: #0d6efd;
  --bs-btn-border-color: #0d6efd;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #0b5ed7;
  --bs-btn-hover-border-color: #0a58ca;
  --bs-btn-focus-shadow-rgb: 49, 132, 253;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #0a58ca;
  --bs-btn-active-border-color: #0a53be;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #0d6efd;
  --bs-btn-disabled-border-color: #0d6efd ;
}

.btn-secondary {
  --bs-btn-color: #fff;
  --bs-btn-bg: #6c757d;
  --bs-btn-border-color: #6c757d;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #5c636a;
  --bs-btn-hover-border-color: #565e64;
  --bs-btn-focus-shadow-rgb: 130, 138, 145;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #565e64;
  --bs-btn-active-border-color: #51585e;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #6c757d;
  --bs-btn-disabled-border-color: #6c757d ;
}

.btn-success {
  --bs-btn-color: #fff;
  --bs-btn-bg: #198754;
  --bs-btn-border-color: #198754;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #157347;
  --bs-btn-hover-border-color: #146c43;
  --bs-btn-focus-shadow-rgb: 60, 153, 110;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #146c43;
  --bs-btn-active-border-color: #13653f;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #198754;
  --bs-btn-disabled-border-color: #198754 ;
}

.btn-info {
  --bs-btn-color: #000;
  --bs-btn-bg: #0dcaf0;
  --bs-btn-border-color: #0dcaf0;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #31d2f2;
  --bs-btn-hover-border-color: #25cff2;
  --bs-btn-focus-shadow-rgb: 11, 172, 204;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #3dd5f3;
  --bs-btn-active-border-color: #25cff2;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #000;
  --bs-btn-disabled-bg: #0dcaf0;
  --bs-btn-disabled-border-color: #0dcaf0 ;
}

.btn-warning {
  --bs-btn-color: #000;
  --bs-btn-bg: #ffc107;
  --bs-btn-border-color: #ffc107;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #ffca2c;
  --bs-btn-hover-border-color: #ffc720;
  --bs-btn-focus-shadow-rgb: 217, 164, 6;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #ffcd39;
  --bs-btn-active-border-color: #ffc720;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #000;
  --bs-btn-disabled-bg: #ffc107;
  --bs-btn-disabled-border-color: #ffc107 ;
}

.btn-danger {
  --bs-btn-color: #fff;
  --bs-btn-bg: #dc3545;
  --bs-btn-border-color: #dc3545;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #bb2d3b;
  --bs-btn-hover-border-color: #b02a37;
  --bs-btn-focus-shadow-rgb: 225, 83, 97;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #b02a37;
  --bs-btn-active-border-color: #a52834;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #dc3545;
  --bs-btn-disabled-border-color: #dc3545 ;
}

.btn-light {
  --bs-btn-color: #000;
  --bs-btn-bg: #f8f9fa;
  --bs-btn-border-color: #f8f9fa;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #d3d4d5;
  --bs-btn-hover-border-color: #c6c7c8;
  --bs-btn-focus-shadow-rgb: 211, 212, 213;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #c6c7c8;
  --bs-btn-active-border-color: #babbbc;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #000;
  --bs-btn-disabled-bg: #f8f9fa;
  --bs-btn-disabled-border-color: #f8f9fa ;
}

.btn-dark {
  --bs-btn-color: #fff;
  --bs-btn-bg: #212529;
  --bs-btn-border-color: #212529;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #424649;
  --bs-btn-hover-border-color: #373b3e;
  --bs-btn-focus-shadow-rgb: 66, 70, 73;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #4d5154;
  --bs-btn-active-border-color: #373b3e;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #212529;
  --bs-btn-disabled-border-color: #212529 ;
}

.btn-outline-primary {
  --bs-btn-color: #0d6efd;
  --bs-btn-border-color: #0d6efd;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #0d6efd;
  --bs-btn-hover-border-color: #0d6efd;
  --bs-btn-focus-shadow-rgb: 13, 110, 253;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #0d6efd;
  --bs-btn-active-border-color: #0d6efd;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #0d6efd;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #0d6efd;
  --bs-gradient: none ;
}

.btn-outline-secondary {
  --bs-btn-color: #6c757d;
  --bs-btn-border-color: #6c757d;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #6c757d;
  --bs-btn-hover-border-color: #6c757d;
  --bs-btn-focus-shadow-rgb: 108, 117, 125;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #6c757d;
  --bs-btn-active-border-color: #6c757d;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #6c757d;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #6c757d;
  --bs-gradient: none ;
}

.btn-outline-success {
  --bs-btn-color: #198754;
  --bs-btn-border-color: #198754;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #198754;
  --bs-btn-hover-border-color: #198754;
  --bs-btn-focus-shadow-rgb: 25, 135, 84;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #198754;
  --bs-btn-active-border-color: #198754;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #198754;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #198754;
  --bs-gradient: none ;
}

.btn-outline-info {
  --bs-btn-color: #0dcaf0;
  --bs-btn-border-color: #0dcaf0;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #0dcaf0;
  --bs-btn-hover-border-color: #0dcaf0;
  --bs-btn-focus-shadow-rgb: 13, 202, 240;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #0dcaf0;
  --bs-btn-active-border-color: #0dcaf0;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #0dcaf0;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #0dcaf0;
  --bs-gradient: none ;
}

.btn-outline-warning {
  --bs-btn-color: #ffc107;
  --bs-btn-border-color: #ffc107;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #ffc107;
  --bs-btn-hover-border-color: #ffc107;
  --bs-btn-focus-shadow-rgb: 255, 193, 7;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #ffc107;
  --bs-btn-active-border-color: #ffc107;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #ffc107;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #ffc107;
  --bs-gradient: none ;
}

.btn-outline-danger {
  --bs-btn-color: #dc3545;
  --bs-btn-border-color: #dc3545;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #dc3545;
  --bs-btn-hover-border-color: #dc3545;
  --bs-btn-focus-shadow-rgb: 220, 53, 69;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #dc3545;
  --bs-btn-active-border-color: #dc3545;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #dc3545;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #dc3545;
  --bs-gradient: none ;
}

.btn-outline-light {
  --bs-btn-color: #f8f9fa;
  --bs-btn-border-color: #f8f9fa;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #f8f9fa;
  --bs-btn-hover-border-color: #f8f9fa;
  --bs-btn-focus-shadow-rgb: 248, 249, 250;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #f8f9fa;
  --bs-btn-active-border-color: #f8f9fa;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #f8f9fa;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #f8f9fa;
  --bs-gradient: none ;
}

.btn-outline-dark {
  --bs-btn-color: #212529;
  --bs-btn-border-color: #212529;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #212529;
  --bs-btn-hover-border-color: #212529;
  --bs-btn-focus-shadow-rgb: 33, 37, 41;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #212529;
  --bs-btn-active-border-color: #212529;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #212529;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #212529;
  --bs-gradient: none ;
}

.btn-link {
  --bs-btn-font-weight: 400;
  --bs-btn-color: var(--bs-link-color);
  --bs-btn-bg: transparent;
  --bs-btn-border-color: transparent;
  --bs-btn-hover-color: var(--bs-link-hover-color);
  --bs-btn-hover-border-color: transparent;
  --bs-btn-active-color: var(--bs-link-hover-color);
  --bs-btn-active-border-color: transparent;
  --bs-btn-disabled-color: #6c757d;
  --bs-btn-disabled-border-color: transparent;
  --bs-btn-box-shadow: none;
  --bs-btn-focus-shadow-rgb: 49, 132, 253;
  text-decoration: underline;
}

.btn-link:focus {
  color: var(--bs-btn-color);
}

.btn-link:hover {
  color: var(--bs-btn-hover-color);
}

.btn-group-lg > .btn,
.btn-lg {
  --bs-btn-padding-y: 0.5rem;
  --bs-btn-padding-x: 1rem;
  --bs-btn-font-size: 1.25rem;
  --bs-btn-border-radius: 0.5rem ;
}

.btn-group-sm > .btn,
.btn-sm {
  --bs-btn-padding-y: 0.25rem;
  --bs-btn-padding-x: 0.5rem;
  --bs-btn-font-size: 0.875rem;
  --bs-btn-border-radius: 0.25rem ;
}

.fade {
  transition: opacity 0.15s linear;
}

@media (prefers-reduced-motion: reduce) {
  .fade {
    transition: none;
  }
}
.fade:not(.show) {
  opacity: 0;
}

.collapse:not(.show) {
  display: none;
}

.collapsing {
  height: 0;
  overflow: hidden;
  transition: height 0.35s ease;
}

@media (prefers-reduced-motion: reduce) {
  .collapsing {
    transition: none;
  }
}
.collapsing.collapse-horizontal {
  width: 0;
  height: auto;
  transition: width 0.35s ease;
}

@media (prefers-reduced-motion: reduce) {
  .collapsing.collapse-horizontal {
    transition: none;
  }
}
.dropdown,
.dropdown-center,
.dropend,
.dropstart,
.dropup,
.dropup-center {
  position: relative;
}

.dropdown-toggle {
  white-space: nowrap;
}

.dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid;
  border-right: 0.3em solid transparent;
  border-bottom: 0;
  border-left: 0.3em solid transparent;
}

.dropdown-toggle:empty::after {
  margin-left: 0;
}

.dropdown-menu {
  --bs-dropdown-min-width: 10rem;
  --bs-dropdown-padding-x: 0;
  --bs-dropdown-padding-y: 0.5rem;
  --bs-dropdown-spacer: 0.125rem;
  --bs-dropdown-font-size: 1rem;
  --bs-dropdown-color: #212529;
  --bs-dropdown-bg: #fff;
  --bs-dropdown-border-color: var(--bs-border-color-translucent);
  --bs-dropdown-border-radius: 0.375rem;
  --bs-dropdown-border-width: 1px;
  --bs-dropdown-inner-border-radius: calc(0.375rem - 1px);
  --bs-dropdown-divider-bg: var(--bs-border-color-translucent);
  --bs-dropdown-divider-margin-y: 0.5rem;
  --bs-dropdown-box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
  --bs-dropdown-link-color: #212529;
  --bs-dropdown-link-hover-color: #1e2125;
  --bs-dropdown-link-hover-bg: #e9ecef;
  --bs-dropdown-link-active-color: #fff;
  --bs-dropdown-link-active-bg: #0d6efd;
  --bs-dropdown-link-disabled-color: #adb5bd;
  --bs-dropdown-item-padding-x: 1rem;
  --bs-dropdown-item-padding-y: 0.25rem;
  --bs-dropdown-header-color: #6c757d;
  --bs-dropdown-header-padding-x: 1rem;
  --bs-dropdown-header-padding-y: 0.5rem;
  position: absolute;
  z-index: 1000;
  display: none;
  min-width: var(--bs-dropdown-min-width);
  padding: var(--bs-dropdown-padding-y) var(--bs-dropdown-padding-x);
  margin: 0;
  font-size: var(--bs-dropdown-font-size);
  color: var(--bs-dropdown-color);
  text-align: left;
  list-style: none;
  background-color: var(--bs-dropdown-bg);
  background-clip: padding-box;
  border: var(--bs-dropdown-border-width) solid var(--bs-dropdown-border-color);
  border-radius: var(--bs-dropdown-border-radius);
}

.dropdown-menu[data-bs-popper] {
  top: 100%;
  left: 0;
  margin-top: var(--bs-dropdown-spacer);
}

.dropdown-menu-start {
  --bs-position: start ;
}

.dropdown-menu-start[data-bs-popper] {
  right: auto;
  left: 0;
}

.dropdown-menu-end {
  --bs-position: end ;
}

.dropdown-menu-end[data-bs-popper] {
  right: 0;
  left: auto;
}

@media (min-width: 576px) {
  .dropdown-menu-sm-start {
    --bs-position: start ;
  }
  .dropdown-menu-sm-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-sm-end {
    --bs-position: end ;
  }
  .dropdown-menu-sm-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 768px) {
  .dropdown-menu-md-start {
    --bs-position: start ;
  }
  .dropdown-menu-md-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-md-end {
    --bs-position: end ;
  }
  .dropdown-menu-md-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 992px) {
  .dropdown-menu-lg-start {
    --bs-position: start ;
  }
  .dropdown-menu-lg-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-lg-end {
    --bs-position: end ;
  }
  .dropdown-menu-lg-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 1200px) {
  .dropdown-menu-xl-start {
    --bs-position: start ;
  }
  .dropdown-menu-xl-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-xl-end {
    --bs-position: end ;
  }
  .dropdown-menu-xl-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 1400px) {
  .dropdown-menu-xxl-start {
    --bs-position: start ;
  }
  .dropdown-menu-xxl-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-xxl-end {
    --bs-position: end ;
  }
  .dropdown-menu-xxl-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
.dropup .dropdown-menu[data-bs-popper] {
  top: auto;
  bottom: 100%;
  margin-top: 0;
  margin-bottom: var(--bs-dropdown-spacer);
}

.dropup .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0;
  border-right: 0.3em solid transparent;
  border-bottom: 0.3em solid;
  border-left: 0.3em solid transparent;
}

.dropup .dropdown-toggle:empty::after {
  margin-left: 0;
}

.dropend .dropdown-menu[data-bs-popper] {
  top: 0;
  right: auto;
  left: 100%;
  margin-top: 0;
  margin-left: var(--bs-dropdown-spacer);
}

.dropend .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid transparent;
  border-right: 0;
  border-bottom: 0.3em solid transparent;
  border-left: 0.3em solid;
}

.dropend .dropdown-toggle:empty::after {
  margin-left: 0;
}

.dropend .dropdown-toggle::after {
  vertical-align: 0;
}

.dropstart .dropdown-menu[data-bs-popper] {
  top: 0;
  right: 100%;
  left: auto;
  margin-top: 0;
  margin-right: var(--bs-dropdown-spacer);
}

.dropstart .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
}

.dropstart .dropdown-toggle::after {
  display: none;
}

.dropstart .dropdown-toggle::before {
  display: inline-block;
  margin-right: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid transparent;
  border-right: 0.3em solid;
  border-bottom: 0.3em solid transparent;
}

.dropstart .dropdown-toggle:empty::after {
  margin-left: 0;
}

.dropstart .dropdown-toggle::before {
  vertical-align: 0;
}

.dropdown-divider {
  height: 0;
  margin: var(--bs-dropdown-divider-margin-y) 0;
  overflow: hidden;
  border-top: 1px solid var(--bs-dropdown-divider-bg);
  opacity: 1;
}

.dropdown-item {
  display: block;
  width: 100%;
  padding: var(--bs-dropdown-item-padding-y) var(--bs-dropdown-item-padding-x);
  clear: both;
  font-weight: 400;
  color: var(--bs-dropdown-link-color);
  text-align: inherit;
  text-decoration: none;
  white-space: nowrap;
  background-color: transparent;
  border: 0;
}

.dropdown-item:focus,
.dropdown-item:hover {
  color: var(--bs-dropdown-link-hover-color);
  background-color: var(--bs-dropdown-link-hover-bg);
}

.dropdown-item.active,
.dropdown-item:active {
  color: var(--bs-dropdown-link-active-color);
  text-decoration: none;
  background-color: var(--bs-dropdown-link-active-bg);
}

.dropdown-item.disabled,
.dropdown-item:disabled {
  color: var(--bs-dropdown-link-disabled-color);
  pointer-events: none;
  background-color: transparent;
}

.dropdown-menu.show {
  display: block;
}

.dropdown-header {
  display: block;
  padding: var(--bs-dropdown-header-padding-y) var(--bs-dropdown-header-padding-x);
  margin-bottom: 0;
  font-size: 0.875rem;
  color: var(--bs-dropdown-header-color);
  white-space: nowrap;
}

.dropdown-item-text {
  display: block;
  padding: var(--bs-dropdown-item-padding-y) var(--bs-dropdown-item-padding-x);
  color: var(--bs-dropdown-link-color);
}

.dropdown-menu-dark {
  --bs-dropdown-color: #dee2e6;
  --bs-dropdown-bg: #343a40;
  --bs-dropdown-border-color: var(--bs-border-color-translucent);
  --bs-dropdown-box-shadow: ;
  --bs-dropdown-link-color: #dee2e6;
  --bs-dropdown-link-hover-color: #fff;
  --bs-dropdown-divider-bg: var(--bs-border-color-translucent);
  --bs-dropdown-link-hover-bg: rgba(255, 255, 255, 0.15);
  --bs-dropdown-link-active-color: #fff;
  --bs-dropdown-link-active-bg: #0d6efd;
  --bs-dropdown-link-disabled-color: #adb5bd;
  --bs-dropdown-header-color: #adb5bd ;
}

.btn-group,
.btn-group-vertical {
  position: relative;
  display: inline-flex;
  vertical-align: middle;
}

.btn-group-vertical > .btn,
.btn-group > .btn {
  position: relative;
  flex: 1 1 auto;
}

.btn-group-vertical > .btn-check:checked + .btn,
.btn-group-vertical > .btn-check:focus + .btn,
.btn-group-vertical > .btn.active,
.btn-group-vertical > .btn:active,
.btn-group-vertical > .btn:focus,
.btn-group-vertical > .btn:hover,
.btn-group > .btn-check:checked + .btn,
.btn-group > .btn-check:focus + .btn,
.btn-group > .btn.active,
.btn-group > .btn:active,
.btn-group > .btn:focus,
.btn-group > .btn:hover {
  z-index: 1;
}

.btn-toolbar {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
}

.btn-toolbar .input-group {
  width: auto;
}

.btn-group {
  border-radius: 0.375rem;
}

.btn-group > .btn-group:not(:first-child),
.btn-group > .btn:not(:first-child) {
  margin-left: -1px;
}

.btn-group > .btn-group:not(:last-child) > .btn,
.btn-group > .btn.dropdown-toggle-split:first-child,
.btn-group > .btn:not(:last-child):not(.dropdown-toggle) {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.btn-group > .btn-group:not(:first-child) > .btn,
.btn-group > .btn:nth-child(n+3),
.btn-group > :not(.btn-check) + .btn {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.dropdown-toggle-split {
  padding-right: 0.5625rem;
  padding-left: 0.5625rem;
}

.dropdown-toggle-split::after,
.dropend .dropdown-toggle-split::after,
.dropup .dropdown-toggle-split::after {
  margin-left: 0;
}

.dropstart .dropdown-toggle-split::before {
  margin-right: 0;
}

.btn-group-sm > .btn + .dropdown-toggle-split,
.btn-sm + .dropdown-toggle-split {
  padding-right: 0.375rem;
  padding-left: 0.375rem;
}

.btn-group-lg > .btn + .dropdown-toggle-split,
.btn-lg + .dropdown-toggle-split {
  padding-right: 0.75rem;
  padding-left: 0.75rem;
}

.btn-group-vertical {
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
}

.btn-group-vertical > .btn,
.btn-group-vertical > .btn-group {
  width: 100%;
}

.btn-group-vertical > .btn-group:not(:first-child),
.btn-group-vertical > .btn:not(:first-child) {
  margin-top: -1px;
}

.btn-group-vertical > .btn-group:not(:last-child) > .btn,
.btn-group-vertical > .btn:not(:last-child):not(.dropdown-toggle) {
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}

.btn-group-vertical > .btn-group:not(:first-child) > .btn,
.btn-group-vertical > .btn ~ .btn {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.nav {
  --bs-nav-link-padding-x: 1rem;
  --bs-nav-link-padding-y: 0.5rem;
  --bs-nav-link-font-weight: ;
  --bs-nav-link-color: var(--bs-link-color);
  --bs-nav-link-hover-color: var(--bs-link-hover-color);
  --bs-nav-link-disabled-color: #6c757d;
  display: flex;
  flex-wrap: wrap;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}

.nav-link {
  display: block;
  padding: var(--bs-nav-link-padding-y) var(--bs-nav-link-padding-x);
  font-size: var(--bs-nav-link-font-size);
  font-weight: var(--bs-nav-link-font-weight);
  color: var(--bs-nav-link-color);
  text-decoration: none;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out;
}

@media (prefers-reduced-motion: reduce) {
  .nav-link {
    transition: none;
  }
}
.nav-link:focus,
.nav-link:hover {
  color: var(--bs-nav-link-hover-color);
}

.nav-link.disabled {
  color: var(--bs-nav-link-disabled-color);
  pointer-events: none;
  cursor: default;
}

.nav-tabs {
  --bs-nav-tabs-border-width: 1px;
  --bs-nav-tabs-border-color: #dee2e6;
  --bs-nav-tabs-border-radius: 0.375rem;
  --bs-nav-tabs-link-hover-border-color: #e9ecef #e9ecef #dee2e6;
  --bs-nav-tabs-link-active-color: #495057;
  --bs-nav-tabs-link-active-bg: #fff;
  --bs-nav-tabs-link-active-border-color: #dee2e6 #dee2e6 #fff;
  border-bottom: var(--bs-nav-tabs-border-width) solid var(--bs-nav-tabs-border-color);
}

.nav-tabs .nav-link {
  margin-bottom: calc(var(--bs-nav-tabs-border-width) * -1);
  background: 0 0;
  border: var(--bs-nav-tabs-border-width) solid transparent;
  border-top-left-radius: var(--bs-nav-tabs-border-radius);
  border-top-right-radius: var(--bs-nav-tabs-border-radius);
}

.nav-tabs .nav-link:focus,
.nav-tabs .nav-link:hover {
  isolation: isolate;
  border-color: var(--bs-nav-tabs-link-hover-border-color);
}

.nav-tabs .nav-link.disabled,
.nav-tabs .nav-link:disabled {
  color: var(--bs-nav-link-disabled-color);
  background-color: transparent;
  border-color: transparent;
}

.nav-tabs .nav-item.show .nav-link,
.nav-tabs .nav-link.active {
  color: var(--bs-nav-tabs-link-active-color);
  background-color: var(--bs-nav-tabs-link-active-bg);
  border-color: var(--bs-nav-tabs-link-active-border-color);
}

.nav-tabs .dropdown-menu {
  margin-top: calc(var(--bs-nav-tabs-border-width) * -1);
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.nav-pills {
  --bs-nav-pills-border-radius: 0.375rem;
  --bs-nav-pills-link-active-color: #fff;
  --bs-nav-pills-link-active-bg: #0d6efd ;
}

.nav-pills .nav-link {
  background: 0 0;
  border: 0;
  border-radius: var(--bs-nav-pills-border-radius);
}

.nav-pills .nav-link:disabled {
  color: var(--bs-nav-link-disabled-color);
  background-color: transparent;
  border-color: transparent;
}

.nav-pills .nav-link.active,
.nav-pills .show > .nav-link {
  color: var(--bs-nav-pills-link-active-color);
  background-color: var(--bs-nav-pills-link-active-bg);
}

.nav-fill .nav-item,
.nav-fill > .nav-link {
  flex: 1 1 auto;
  text-align: center;
}

.nav-justified .nav-item,
.nav-justified > .nav-link {
  flex-basis: 0;
  flex-grow: 1;
  text-align: center;
}

.nav-fill .nav-item .nav-link,
.nav-justified .nav-item .nav-link {
  width: 100%;
}

.tab-content > .tab-pane {
  display: none;
}

.tab-content > .active {
  display: block;
}

.navbar {
  --bs-navbar-padding-x: 0;
  --bs-navbar-padding-y: 0.5rem;
  --bs-navbar-color: rgba(0, 0, 0, 0.55);
  --bs-navbar-hover-color: rgba(0, 0, 0, 0.7);
  --bs-navbar-disabled-color: rgba(0, 0, 0, 0.3);
  --bs-navbar-active-color: rgba(0, 0, 0, 0.9);
  --bs-navbar-brand-padding-y: 0.3125rem;
  --bs-navbar-brand-margin-end: 1rem;
  --bs-navbar-brand-font-size: 1.25rem;
  --bs-navbar-brand-color: rgba(0, 0, 0, 0.9);
  --bs-navbar-brand-hover-color: rgba(0, 0, 0, 0.9);
  --bs-navbar-nav-link-padding-x: 0.5rem;
  --bs-navbar-toggler-padding-y: 0.25rem;
  --bs-navbar-toggler-padding-x: 0.75rem;
  --bs-navbar-toggler-font-size: 1.25rem;
  --bs-navbar-toggler-icon-bg: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
  --bs-navbar-toggler-border-color: rgba(0, 0, 0, 0.1);
  --bs-navbar-toggler-border-radius: 0.375rem;
  --bs-navbar-toggler-focus-width: 0.25rem;
  --bs-navbar-toggler-transition: box-shadow 0.15s ease-in-out;
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  padding: var(--bs-navbar-padding-y) var(--bs-navbar-padding-x);
}

.navbar > .container,
.navbar > .container-fluid,
.navbar > .container-lg,
.navbar > .container-md,
.navbar > .container-sm,
.navbar > .container-xl,
.navbar > .container-xxl {
  display: flex;
  flex-wrap: inherit;
  align-items: center;
  justify-content: space-between;
}

.navbar-brand {
  padding-top: var(--bs-navbar-brand-padding-y);
  padding-bottom: var(--bs-navbar-brand-padding-y);
  margin-right: var(--bs-navbar-brand-margin-end);
  font-size: var(--bs-navbar-brand-font-size);
  color: var(--bs-navbar-brand-color);
  text-decoration: none;
  white-space: nowrap;
}

.navbar-brand:focus,
.navbar-brand:hover {
  color: var(--bs-navbar-brand-hover-color);
}

.navbar-nav {
  --bs-nav-link-padding-x: 0;
  --bs-nav-link-padding-y: 0.5rem;
  --bs-nav-link-font-weight: ;
  --bs-nav-link-color: var(--bs-navbar-color);
  --bs-nav-link-hover-color: var(--bs-navbar-hover-color);
  --bs-nav-link-disabled-color: var(--bs-navbar-disabled-color);
  display: flex;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}

.navbar-nav .nav-link.active,
.navbar-nav .show > .nav-link {
  color: var(--bs-navbar-active-color);
}

.navbar-nav .dropdown-menu {
  position: static;
}

.navbar-text {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  color: var(--bs-navbar-color);
}

.navbar-text a,
.navbar-text a:focus,
.navbar-text a:hover {
  color: var(--bs-navbar-active-color);
}

.navbar-collapse {
  flex-basis: 100%;
  flex-grow: 1;
  align-items: center;
}

.navbar-toggler {
  padding: var(--bs-navbar-toggler-padding-y) var(--bs-navbar-toggler-padding-x);
  font-size: var(--bs-navbar-toggler-font-size);
  line-height: 1;
  color: var(--bs-navbar-color);
  background-color: transparent;
  border: var(--bs-border-width) solid var(--bs-navbar-toggler-border-color);
  border-radius: var(--bs-navbar-toggler-border-radius);
  transition: var(--bs-navbar-toggler-transition);
}

@media (prefers-reduced-motion: reduce) {
  .navbar-toggler {
    transition: none;
  }
}
.navbar-toggler:hover {
  text-decoration: none;
}

.navbar-toggler:focus {
  text-decoration: none;
  outline: 0;
  box-shadow: 0 0 0 var(--bs-navbar-toggler-focus-width);
}

.navbar-toggler-icon {
  display: inline-block;
  width: 1.5em;
  height: 1.5em;
  vertical-align: middle;
  background-image: var(--bs-navbar-toggler-icon-bg);
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100%;
}

.navbar-nav-scroll {
  max-height: var(--bs-scroll-height, 75vh);
  overflow-y: auto;
}

@media (min-width: 576px) {
  .navbar-expand-sm {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-sm .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-sm .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-sm .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }
  .navbar-expand-sm .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-sm .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-sm .navbar-toggler {
    display: none;
  }
  .navbar-expand-sm .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-sm .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-sm .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
@media (min-width: 768px) {
  .navbar-expand-md {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-md .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-md .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-md .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }
  .navbar-expand-md .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-md .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-md .navbar-toggler {
    display: none;
  }
  .navbar-expand-md .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-md .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-md .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
@media (min-width: 992px) {
  .navbar-expand-lg {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-lg .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-lg .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-lg .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }
  .navbar-expand-lg .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-lg .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-lg .navbar-toggler {
    display: none;
  }
  .navbar-expand-lg .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-lg .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-lg .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
@media (min-width: 1200px) {
  .navbar-expand-xl {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-xl .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-xl .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-xl .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }
  .navbar-expand-xl .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-xl .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-xl .navbar-toggler {
    display: none;
  }
  .navbar-expand-xl .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-xl .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-xl .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
@media (min-width: 1400px) {
  .navbar-expand-xxl {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-xxl .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-xxl .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-xxl .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }
  .navbar-expand-xxl .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-xxl .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-xxl .navbar-toggler {
    display: none;
  }
  .navbar-expand-xxl .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-xxl .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-xxl .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
.navbar-expand {
  flex-wrap: nowrap;
  justify-content: flex-start;
}

.navbar-expand .navbar-nav {
  flex-direction: row;
}

.navbar-expand .navbar-nav .dropdown-menu {
  position: absolute;
}

.navbar-expand .navbar-nav .nav-link {
  padding-right: var(--bs-navbar-nav-link-padding-x);
  padding-left: var(--bs-navbar-nav-link-padding-x);
}

.navbar-expand .navbar-nav-scroll {
  overflow: visible;
}

.navbar-expand .navbar-collapse {
  display: flex !important;
  flex-basis: auto;
}

.navbar-expand .navbar-toggler {
  display: none;
}

.navbar-expand .offcanvas {
  position: static;
  z-index: auto;
  flex-grow: 1;
  width: auto !important;
  height: auto !important;
  visibility: visible !important;
  background-color: transparent !important;
  border: 0 !important;
  transform: none !important;
  transition: none;
}

.navbar-expand .offcanvas .offcanvas-header {
  display: none;
}

.navbar-expand .offcanvas .offcanvas-body {
  display: flex;
  flex-grow: 0;
  padding: 0;
  overflow-y: visible;
}

.navbar-dark {
  --bs-navbar-color: rgba(255, 255, 255, 0.55);
  --bs-navbar-hover-color: rgba(255, 255, 255, 0.75);
  --bs-navbar-disabled-color: rgba(255, 255, 255, 0.25);
  --bs-navbar-active-color: #fff;
  --bs-navbar-brand-color: #fff;
  --bs-navbar-brand-hover-color: #fff;
  --bs-navbar-toggler-border-color: rgba(255, 255, 255, 0.1);
  --bs-navbar-toggler-icon-bg: url(${___CSS_LOADER_URL_REPLACEMENT_10___}) ;
}

.card {
  --bs-card-spacer-y: 1rem;
  --bs-card-spacer-x: 1rem;
  --bs-card-title-spacer-y: 0.5rem;
  --bs-card-border-width: 1px;
  --bs-card-border-color: var(--bs-border-color-translucent);
  --bs-card-border-radius: 0.375rem;
  --bs-card-box-shadow: ;
  --bs-card-inner-border-radius: calc(0.375rem - 1px);
  --bs-card-cap-padding-y: 0.5rem;
  --bs-card-cap-padding-x: 1rem;
  --bs-card-cap-bg: rgba(0, 0, 0, 0.03);
  --bs-card-cap-color: ;
  --bs-card-height: ;
  --bs-card-color: ;
  --bs-card-bg: #fff;
  --bs-card-img-overlay-padding: 1rem;
  --bs-card-group-margin: 0.75rem;
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  height: var(--bs-card-height);
  word-wrap: break-word;
  background-color: var(--bs-card-bg);
  background-clip: border-box;
  border: var(--bs-card-border-width) solid var(--bs-card-border-color);
  border-radius: var(--bs-card-border-radius);
}

.card > hr {
  margin-right: 0;
  margin-left: 0;
}

.card > .list-group {
  border-top: inherit;
  border-bottom: inherit;
}

.card > .list-group:first-child {
  border-top-width: 0;
  border-top-left-radius: var(--bs-card-inner-border-radius);
  border-top-right-radius: var(--bs-card-inner-border-radius);
}

.card > .list-group:last-child {
  border-bottom-width: 0;
  border-bottom-right-radius: var(--bs-card-inner-border-radius);
  border-bottom-left-radius: var(--bs-card-inner-border-radius);
}

.card > .card-header + .list-group,
.card > .list-group + .card-footer {
  border-top: 0;
}

.card-body {
  flex: 1 1 auto;
  padding: var(--bs-card-spacer-y) var(--bs-card-spacer-x);
  color: var(--bs-card-color);
}

.card-title {
  margin-bottom: var(--bs-card-title-spacer-y);
}

.card-subtitle {
  margin-top: calc(-0.5 * var(--bs-card-title-spacer-y));
  margin-bottom: 0;
}

.card-text:last-child {
  margin-bottom: 0;
}

.card-link + .card-link {
  margin-left: var(--bs-card-spacer-x);
}

.card-header {
  padding: var(--bs-card-cap-padding-y) var(--bs-card-cap-padding-x);
  margin-bottom: 0;
  color: var(--bs-card-cap-color);
  background-color: var(--bs-card-cap-bg);
  border-bottom: var(--bs-card-border-width) solid var(--bs-card-border-color);
}

.card-header:first-child {
  border-radius: var(--bs-card-inner-border-radius) var(--bs-card-inner-border-radius) 0 0;
}

.card-footer {
  padding: var(--bs-card-cap-padding-y) var(--bs-card-cap-padding-x);
  color: var(--bs-card-cap-color);
  background-color: var(--bs-card-cap-bg);
  border-top: var(--bs-card-border-width) solid var(--bs-card-border-color);
}

.card-footer:last-child {
  border-radius: 0 0 var(--bs-card-inner-border-radius) var(--bs-card-inner-border-radius);
}

.card-header-tabs {
  margin-right: calc(-0.5 * var(--bs-card-cap-padding-x));
  margin-bottom: calc(-1 * var(--bs-card-cap-padding-y));
  margin-left: calc(-0.5 * var(--bs-card-cap-padding-x));
  border-bottom: 0;
}

.card-header-tabs .nav-link.active {
  background-color: var(--bs-card-bg);
  border-bottom-color: var(--bs-card-bg);
}

.card-header-pills {
  margin-right: calc(-0.5 * var(--bs-card-cap-padding-x));
  margin-left: calc(-0.5 * var(--bs-card-cap-padding-x));
}

.card-img-overlay {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  padding: var(--bs-card-img-overlay-padding);
  border-radius: var(--bs-card-inner-border-radius);
}

.card-img,
.card-img-bottom,
.card-img-top {
  width: 100%;
}

.card-img,
.card-img-top {
  border-top-left-radius: var(--bs-card-inner-border-radius);
  border-top-right-radius: var(--bs-card-inner-border-radius);
}

.card-img,
.card-img-bottom {
  border-bottom-right-radius: var(--bs-card-inner-border-radius);
  border-bottom-left-radius: var(--bs-card-inner-border-radius);
}

.card-group > .card {
  margin-bottom: var(--bs-card-group-margin);
}

@media (min-width: 576px) {
  .card-group {
    display: flex;
    flex-flow: row wrap;
  }
  .card-group > .card {
    flex: 1 0;
    margin-bottom: 0;
  }
  .card-group > .card + .card {
    margin-left: 0;
    border-left: 0;
  }
  .card-group > .card:not(:last-child) {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
  .card-group > .card:not(:last-child) .card-header,
  .card-group > .card:not(:last-child) .card-img-top {
    border-top-right-radius: 0;
  }
  .card-group > .card:not(:last-child) .card-footer,
  .card-group > .card:not(:last-child) .card-img-bottom {
    border-bottom-right-radius: 0;
  }
  .card-group > .card:not(:first-child) {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
  .card-group > .card:not(:first-child) .card-header,
  .card-group > .card:not(:first-child) .card-img-top {
    border-top-left-radius: 0;
  }
  .card-group > .card:not(:first-child) .card-footer,
  .card-group > .card:not(:first-child) .card-img-bottom {
    border-bottom-left-radius: 0;
  }
}
.accordion {
  --bs-accordion-color: #000;
  --bs-accordion-bg: #fff;
  --bs-accordion-transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out, border-radius 0.15s ease;
  --bs-accordion-border-color: var(--bs-border-color);
  --bs-accordion-border-width: 1px;
  --bs-accordion-border-radius: 0.375rem;
  --bs-accordion-inner-border-radius: calc(0.375rem - 1px);
  --bs-accordion-btn-padding-x: 1.25rem;
  --bs-accordion-btn-padding-y: 1rem;
  --bs-accordion-btn-color: var(--bs-body-color);
  --bs-accordion-btn-bg: var(--bs-accordion-bg);
  --bs-accordion-btn-icon: url(${___CSS_LOADER_URL_REPLACEMENT_11___});
  --bs-accordion-btn-icon-width: 1.25rem;
  --bs-accordion-btn-icon-transform: rotate(-180deg);
  --bs-accordion-btn-icon-transition: transform 0.2s ease-in-out;
  --bs-accordion-btn-active-icon: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
  --bs-accordion-btn-focus-border-color: #86b7fe;
  --bs-accordion-btn-focus-box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
  --bs-accordion-body-padding-x: 1.25rem;
  --bs-accordion-body-padding-y: 1rem;
  --bs-accordion-active-color: #0c63e4;
  --bs-accordion-active-bg: #e7f1ff ;
}

.accordion-button {
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  padding: var(--bs-accordion-btn-padding-y) var(--bs-accordion-btn-padding-x);
  font-size: 1rem;
  color: var(--bs-accordion-btn-color);
  text-align: left;
  background-color: var(--bs-accordion-btn-bg);
  border: 0;
  border-radius: 0;
  overflow-anchor: none;
  transition: var(--bs-accordion-transition);
}

@media (prefers-reduced-motion: reduce) {
  .accordion-button {
    transition: none;
  }
}
.accordion-button:not(.collapsed) {
  color: var(--bs-accordion-active-color);
  background-color: var(--bs-accordion-active-bg);
  box-shadow: inset 0 calc(var(--bs-accordion-border-width) * -1) 0 var(--bs-accordion-border-color);
}

.accordion-button:not(.collapsed)::after {
  background-image: var(--bs-accordion-btn-active-icon);
  transform: var(--bs-accordion-btn-icon-transform);
}

.accordion-button::after {
  flex-shrink: 0;
  width: var(--bs-accordion-btn-icon-width);
  height: var(--bs-accordion-btn-icon-width);
  margin-left: auto;
  content: "";
  background-image: var(--bs-accordion-btn-icon);
  background-repeat: no-repeat;
  background-size: var(--bs-accordion-btn-icon-width);
  transition: var(--bs-accordion-btn-icon-transition);
}

@media (prefers-reduced-motion: reduce) {
  .accordion-button::after {
    transition: none;
  }
}
.accordion-button:hover {
  z-index: 2;
}

.accordion-button:focus {
  z-index: 3;
  border-color: var(--bs-accordion-btn-focus-border-color);
  outline: 0;
  box-shadow: var(--bs-accordion-btn-focus-box-shadow);
}

.accordion-header {
  margin-bottom: 0;
}

.accordion-item {
  color: var(--bs-accordion-color);
  background-color: var(--bs-accordion-bg);
  border: var(--bs-accordion-border-width) solid var(--bs-accordion-border-color);
}

.accordion-item:first-of-type {
  border-top-left-radius: var(--bs-accordion-border-radius);
  border-top-right-radius: var(--bs-accordion-border-radius);
}

.accordion-item:first-of-type .accordion-button {
  border-top-left-radius: var(--bs-accordion-inner-border-radius);
  border-top-right-radius: var(--bs-accordion-inner-border-radius);
}

.accordion-item:not(:first-of-type) {
  border-top: 0;
}

.accordion-item:last-of-type {
  border-bottom-right-radius: var(--bs-accordion-border-radius);
  border-bottom-left-radius: var(--bs-accordion-border-radius);
}

.accordion-item:last-of-type .accordion-button.collapsed {
  border-bottom-right-radius: var(--bs-accordion-inner-border-radius);
  border-bottom-left-radius: var(--bs-accordion-inner-border-radius);
}

.accordion-item:last-of-type .accordion-collapse {
  border-bottom-right-radius: var(--bs-accordion-border-radius);
  border-bottom-left-radius: var(--bs-accordion-border-radius);
}

.accordion-body {
  padding: var(--bs-accordion-body-padding-y) var(--bs-accordion-body-padding-x);
}

.accordion-flush .accordion-collapse {
  border-width: 0;
}

.accordion-flush .accordion-item {
  border-right: 0;
  border-left: 0;
  border-radius: 0;
}

.accordion-flush .accordion-item:first-child {
  border-top: 0;
}

.accordion-flush .accordion-item:last-child {
  border-bottom: 0;
}

.accordion-flush .accordion-item .accordion-button {
  border-radius: 0;
}

.breadcrumb {
  --bs-breadcrumb-padding-x: 0;
  --bs-breadcrumb-padding-y: 0;
  --bs-breadcrumb-margin-bottom: 1rem;
  --bs-breadcrumb-bg: ;
  --bs-breadcrumb-border-radius: ;
  --bs-breadcrumb-divider-color: #6c757d;
  --bs-breadcrumb-item-padding-x: 0.5rem;
  --bs-breadcrumb-item-active-color: #6c757d;
  display: flex;
  flex-wrap: wrap;
  padding: var(--bs-breadcrumb-padding-y) var(--bs-breadcrumb-padding-x);
  margin-bottom: var(--bs-breadcrumb-margin-bottom);
  font-size: var(--bs-breadcrumb-font-size);
  list-style: none;
  background-color: var(--bs-breadcrumb-bg);
  border-radius: var(--bs-breadcrumb-border-radius);
}

.breadcrumb-item + .breadcrumb-item {
  padding-left: var(--bs-breadcrumb-item-padding-x);
}

.breadcrumb-item + .breadcrumb-item::before {
  float: left;
  padding-right: var(--bs-breadcrumb-item-padding-x);
  color: var(--bs-breadcrumb-divider-color);
  content: var(--bs-breadcrumb-divider, "/");
}

.breadcrumb-item.active {
  color: var(--bs-breadcrumb-item-active-color);
}

.pagination {
  --bs-pagination-padding-x: 0.75rem;
  --bs-pagination-padding-y: 0.375rem;
  --bs-pagination-font-size: 1rem;
  --bs-pagination-color: var(--bs-link-color);
  --bs-pagination-bg: #fff;
  --bs-pagination-border-width: 1px;
  --bs-pagination-border-color: #dee2e6;
  --bs-pagination-border-radius: 0.375rem;
  --bs-pagination-hover-color: var(--bs-link-hover-color);
  --bs-pagination-hover-bg: #e9ecef;
  --bs-pagination-hover-border-color: #dee2e6;
  --bs-pagination-focus-color: var(--bs-link-hover-color);
  --bs-pagination-focus-bg: #e9ecef;
  --bs-pagination-focus-box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
  --bs-pagination-active-color: #fff;
  --bs-pagination-active-bg: #0d6efd;
  --bs-pagination-active-border-color: #0d6efd;
  --bs-pagination-disabled-color: #6c757d;
  --bs-pagination-disabled-bg: #fff;
  --bs-pagination-disabled-border-color: #dee2e6;
  display: flex;
  padding-left: 0;
  list-style: none;
}

.page-link {
  position: relative;
  display: block;
  padding: var(--bs-pagination-padding-y) var(--bs-pagination-padding-x);
  font-size: var(--bs-pagination-font-size);
  color: var(--bs-pagination-color);
  text-decoration: none;
  background-color: var(--bs-pagination-bg);
  border: var(--bs-pagination-border-width) solid var(--bs-pagination-border-color);
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

@media (prefers-reduced-motion: reduce) {
  .page-link {
    transition: none;
  }
}
.page-link:hover {
  z-index: 2;
  color: var(--bs-pagination-hover-color);
  background-color: var(--bs-pagination-hover-bg);
  border-color: var(--bs-pagination-hover-border-color);
}

.page-link:focus {
  z-index: 3;
  color: var(--bs-pagination-focus-color);
  background-color: var(--bs-pagination-focus-bg);
  outline: 0;
  box-shadow: var(--bs-pagination-focus-box-shadow);
}

.active > .page-link,
.page-link.active {
  z-index: 3;
  color: var(--bs-pagination-active-color);
  background-color: var(--bs-pagination-active-bg);
  border-color: var(--bs-pagination-active-border-color);
}

.disabled > .page-link,
.page-link.disabled {
  color: var(--bs-pagination-disabled-color);
  pointer-events: none;
  background-color: var(--bs-pagination-disabled-bg);
  border-color: var(--bs-pagination-disabled-border-color);
}

.page-item:not(:first-child) .page-link {
  margin-left: -1px;
}

.page-item:first-child .page-link {
  border-top-left-radius: var(--bs-pagination-border-radius);
  border-bottom-left-radius: var(--bs-pagination-border-radius);
}

.page-item:last-child .page-link {
  border-top-right-radius: var(--bs-pagination-border-radius);
  border-bottom-right-radius: var(--bs-pagination-border-radius);
}

.pagination-lg {
  --bs-pagination-padding-x: 1.5rem;
  --bs-pagination-padding-y: 0.75rem;
  --bs-pagination-font-size: 1.25rem;
  --bs-pagination-border-radius: 0.5rem ;
}

.pagination-sm {
  --bs-pagination-padding-x: 0.5rem;
  --bs-pagination-padding-y: 0.25rem;
  --bs-pagination-font-size: 0.875rem;
  --bs-pagination-border-radius: 0.25rem ;
}

.badge {
  --bs-badge-padding-x: 0.65em;
  --bs-badge-padding-y: 0.35em;
  --bs-badge-font-size: 0.75em;
  --bs-badge-font-weight: 700;
  --bs-badge-color: #fff;
  --bs-badge-border-radius: 0.375rem;
  display: inline-block;
  padding: var(--bs-badge-padding-y) var(--bs-badge-padding-x);
  font-size: var(--bs-badge-font-size);
  font-weight: var(--bs-badge-font-weight);
  line-height: 1;
  color: var(--bs-badge-color);
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: var(--bs-badge-border-radius);
}

.badge:empty {
  display: none;
}

.btn .badge {
  position: relative;
  top: -1px;
}

.alert {
  --bs-alert-bg: transparent;
  --bs-alert-padding-x: 1rem;
  --bs-alert-padding-y: 1rem;
  --bs-alert-margin-bottom: 1rem;
  --bs-alert-color: inherit;
  --bs-alert-border-color: transparent;
  --bs-alert-border: 1px solid var(--bs-alert-border-color);
  --bs-alert-border-radius: 0.375rem;
  position: relative;
  padding: var(--bs-alert-padding-y) var(--bs-alert-padding-x);
  margin-bottom: var(--bs-alert-margin-bottom);
  color: var(--bs-alert-color);
  background-color: var(--bs-alert-bg);
  border: var(--bs-alert-border);
  border-radius: var(--bs-alert-border-radius);
}

.alert-heading {
  color: inherit;
}

.alert-link {
  font-weight: 700;
}

.alert-dismissible {
  padding-right: 3rem;
}

.alert-dismissible .btn-close {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 2;
  padding: 1.25rem 1rem;
}

.alert-primary {
  --bs-alert-color: #084298;
  --bs-alert-bg: #cfe2ff;
  --bs-alert-border-color: #b6d4fe ;
}

.alert-primary .alert-link {
  color: #06357a;
}

.alert-secondary {
  --bs-alert-color: #41464b;
  --bs-alert-bg: #e2e3e5;
  --bs-alert-border-color: #d3d6d8 ;
}

.alert-secondary .alert-link {
  color: #34383c;
}

.alert-success {
  --bs-alert-color: #0f5132;
  --bs-alert-bg: #d1e7dd;
  --bs-alert-border-color: #badbcc ;
}

.alert-success .alert-link {
  color: #0c4128;
}

.alert-info {
  --bs-alert-color: #055160;
  --bs-alert-bg: #cff4fc;
  --bs-alert-border-color: #b6effb ;
}

.alert-info .alert-link {
  color: #04414d;
}

.alert-warning {
  --bs-alert-color: #664d03;
  --bs-alert-bg: #fff3cd;
  --bs-alert-border-color: #ffecb5 ;
}

.alert-warning .alert-link {
  color: #523e02;
}

.alert-danger {
  --bs-alert-color: #842029;
  --bs-alert-bg: #f8d7da;
  --bs-alert-border-color: #f5c2c7 ;
}

.alert-danger .alert-link {
  color: #6a1a21;
}

.alert-light {
  --bs-alert-color: #636464;
  --bs-alert-bg: #fefefe;
  --bs-alert-border-color: #fdfdfe ;
}

.alert-light .alert-link {
  color: #4f5050;
}

.alert-dark {
  --bs-alert-color: #141619;
  --bs-alert-bg: #d3d3d4;
  --bs-alert-border-color: #bcbebf ;
}

.alert-dark .alert-link {
  color: #101214;
}
@keyframes progress-bar-stripes {
  0% {
    background-position-x: 1rem;
  }
}
.progress {
  --bs-progress-height: 1rem;
  --bs-progress-font-size: 0.75rem;
  --bs-progress-bg: #e9ecef;
  --bs-progress-border-radius: 0.375rem;
  --bs-progress-box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.075);
  --bs-progress-bar-color: #fff;
  --bs-progress-bar-bg: #0d6efd;
  --bs-progress-bar-transition: width 0.6s ease;
  display: flex;
  height: var(--bs-progress-height);
  overflow: hidden;
  font-size: var(--bs-progress-font-size);
  background-color: var(--bs-progress-bg);
  border-radius: var(--bs-progress-border-radius);
}

.progress-bar {
  display: flex;
  flex-direction: column;
  justify-content: center;
  overflow: hidden;
  color: var(--bs-progress-bar-color);
  text-align: center;
  white-space: nowrap;
  background-color: var(--bs-progress-bar-bg);
  transition: var(--bs-progress-bar-transition);
}

@media (prefers-reduced-motion: reduce) {
  .progress-bar {
    transition: none;
  }
}
.progress-bar-striped {
  background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);
  background-size: var(--bs-progress-height) var(--bs-progress-height);
}

.progress-bar-animated {
  animation: 1s linear infinite progress-bar-stripes;
}

@media (prefers-reduced-motion: reduce) {
  .progress-bar-animated {
    animation: none;
  }
}
.list-group {
  --bs-list-group-color: #212529;
  --bs-list-group-bg: #fff;
  --bs-list-group-border-color: rgba(0, 0, 0, 0.125);
  --bs-list-group-border-width: 1px;
  --bs-list-group-border-radius: 0.375rem;
  --bs-list-group-item-padding-x: 1rem;
  --bs-list-group-item-padding-y: 0.5rem;
  --bs-list-group-action-color: #495057;
  --bs-list-group-action-hover-color: #495057;
  --bs-list-group-action-hover-bg: #f8f9fa;
  --bs-list-group-action-active-color: #212529;
  --bs-list-group-action-active-bg: #e9ecef;
  --bs-list-group-disabled-color: #6c757d;
  --bs-list-group-disabled-bg: #fff;
  --bs-list-group-active-color: #fff;
  --bs-list-group-active-bg: #0d6efd;
  --bs-list-group-active-border-color: #0d6efd;
  display: flex;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
  border-radius: var(--bs-list-group-border-radius);
}

.list-group-numbered {
  list-style-type: none;
  counter-reset: section;
}

.list-group-numbered > .list-group-item::before {
  content: counters(section, ".") ". ";
  counter-increment: section;
}

.list-group-item-action {
  width: 100%;
  color: var(--bs-list-group-action-color);
  text-align: inherit;
}

.list-group-item-action:focus,
.list-group-item-action:hover {
  z-index: 1;
  color: var(--bs-list-group-action-hover-color);
  text-decoration: none;
  background-color: var(--bs-list-group-action-hover-bg);
}

.list-group-item-action:active {
  color: var(--bs-list-group-action-active-color);
  background-color: var(--bs-list-group-action-active-bg);
}

.list-group-item {
  position: relative;
  display: block;
  padding: var(--bs-list-group-item-padding-y) var(--bs-list-group-item-padding-x);
  color: var(--bs-list-group-color);
  text-decoration: none;
  background-color: var(--bs-list-group-bg);
  border: var(--bs-list-group-border-width) solid var(--bs-list-group-border-color);
}

.list-group-item:first-child {
  border-top-left-radius: inherit;
  border-top-right-radius: inherit;
}

.list-group-item:last-child {
  border-bottom-right-radius: inherit;
  border-bottom-left-radius: inherit;
}

.list-group-item.disabled,
.list-group-item:disabled {
  color: var(--bs-list-group-disabled-color);
  pointer-events: none;
  background-color: var(--bs-list-group-disabled-bg);
}

.list-group-item.active {
  z-index: 2;
  color: var(--bs-list-group-active-color);
  background-color: var(--bs-list-group-active-bg);
  border-color: var(--bs-list-group-active-border-color);
}

.list-group-item + .list-group-item {
  border-top-width: 0;
}

.list-group-item + .list-group-item.active {
  margin-top: calc(var(--bs-list-group-border-width) * -1);
  border-top-width: var(--bs-list-group-border-width);
}

.list-group-horizontal {
  flex-direction: row;
}

.list-group-horizontal > .list-group-item:first-child {
  border-bottom-left-radius: var(--bs-list-group-border-radius);
  border-top-right-radius: 0;
}

.list-group-horizontal > .list-group-item:last-child {
  border-top-right-radius: var(--bs-list-group-border-radius);
  border-bottom-left-radius: 0;
}

.list-group-horizontal > .list-group-item.active {
  margin-top: 0;
}

.list-group-horizontal > .list-group-item + .list-group-item {
  border-top-width: var(--bs-list-group-border-width);
  border-left-width: 0;
}

.list-group-horizontal > .list-group-item + .list-group-item.active {
  margin-left: calc(var(--bs-list-group-border-width) * -1);
  border-left-width: var(--bs-list-group-border-width);
}

@media (min-width: 576px) {
  .list-group-horizontal-sm {
    flex-direction: row;
  }
  .list-group-horizontal-sm > .list-group-item:first-child {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-sm > .list-group-item:last-child {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-sm > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-sm > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-sm > .list-group-item + .list-group-item.active {
    margin-left: calc(var(--bs-list-group-border-width) * -1);
    border-left-width: var(--bs-list-group-border-width);
  }
}
@media (min-width: 768px) {
  .list-group-horizontal-md {
    flex-direction: row;
  }
  .list-group-horizontal-md > .list-group-item:first-child {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-md > .list-group-item:last-child {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-md > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-md > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-md > .list-group-item + .list-group-item.active {
    margin-left: calc(var(--bs-list-group-border-width) * -1);
    border-left-width: var(--bs-list-group-border-width);
  }
}
@media (min-width: 992px) {
  .list-group-horizontal-lg {
    flex-direction: row;
  }
  .list-group-horizontal-lg > .list-group-item:first-child {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-lg > .list-group-item:last-child {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-lg > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-lg > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-lg > .list-group-item + .list-group-item.active {
    margin-left: calc(var(--bs-list-group-border-width) * -1);
    border-left-width: var(--bs-list-group-border-width);
  }
}
@media (min-width: 1200px) {
  .list-group-horizontal-xl {
    flex-direction: row;
  }
  .list-group-horizontal-xl > .list-group-item:first-child {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-xl > .list-group-item:last-child {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-xl > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-xl > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-xl > .list-group-item + .list-group-item.active {
    margin-left: calc(var(--bs-list-group-border-width) * -1);
    border-left-width: var(--bs-list-group-border-width);
  }
}
@media (min-width: 1400px) {
  .list-group-horizontal-xxl {
    flex-direction: row;
  }
  .list-group-horizontal-xxl > .list-group-item:first-child {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-xxl > .list-group-item:last-child {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-xxl > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-xxl > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-xxl > .list-group-item + .list-group-item.active {
    margin-left: calc(var(--bs-list-group-border-width) * -1);
    border-left-width: var(--bs-list-group-border-width);
  }
}
.list-group-flush {
  border-radius: 0;
}

.list-group-flush > .list-group-item {
  border-width: 0 0 var(--bs-list-group-border-width);
}

.list-group-flush > .list-group-item:last-child {
  border-bottom-width: 0;
}

.list-group-item-primary {
  color: #084298;
  background-color: #cfe2ff;
}

.list-group-item-primary.list-group-item-action:focus,
.list-group-item-primary.list-group-item-action:hover {
  color: #084298;
  background-color: #bacbe6;
}

.list-group-item-primary.list-group-item-action.active {
  color: #fff;
  background-color: #084298;
  border-color: #084298;
}

.list-group-item-secondary {
  color: #41464b;
  background-color: #e2e3e5;
}

.list-group-item-secondary.list-group-item-action:focus,
.list-group-item-secondary.list-group-item-action:hover {
  color: #41464b;
  background-color: #cbccce;
}

.list-group-item-secondary.list-group-item-action.active {
  color: #fff;
  background-color: #41464b;
  border-color: #41464b;
}

.list-group-item-success {
  color: #0f5132;
  background-color: #d1e7dd;
}

.list-group-item-success.list-group-item-action:focus,
.list-group-item-success.list-group-item-action:hover {
  color: #0f5132;
  background-color: #bcd0c7;
}

.list-group-item-success.list-group-item-action.active {
  color: #fff;
  background-color: #0f5132;
  border-color: #0f5132;
}

.list-group-item-info {
  color: #055160;
  background-color: #cff4fc;
}

.list-group-item-info.list-group-item-action:focus,
.list-group-item-info.list-group-item-action:hover {
  color: #055160;
  background-color: #badce3;
}

.list-group-item-info.list-group-item-action.active {
  color: #fff;
  background-color: #055160;
  border-color: #055160;
}

.list-group-item-warning {
  color: #664d03;
  background-color: #fff3cd;
}

.list-group-item-warning.list-group-item-action:focus,
.list-group-item-warning.list-group-item-action:hover {
  color: #664d03;
  background-color: #e6dbb9;
}

.list-group-item-warning.list-group-item-action.active {
  color: #fff;
  background-color: #664d03;
  border-color: #664d03;
}

.list-group-item-danger {
  color: #842029;
  background-color: #f8d7da;
}

.list-group-item-danger.list-group-item-action:focus,
.list-group-item-danger.list-group-item-action:hover {
  color: #842029;
  background-color: #dfc2c4;
}

.list-group-item-danger.list-group-item-action.active {
  color: #fff;
  background-color: #842029;
  border-color: #842029;
}

.list-group-item-light {
  color: #636464;
  background-color: #fefefe;
}

.list-group-item-light.list-group-item-action:focus,
.list-group-item-light.list-group-item-action:hover {
  color: #636464;
  background-color: #e5e5e5;
}

.list-group-item-light.list-group-item-action.active {
  color: #fff;
  background-color: #636464;
  border-color: #636464;
}

.list-group-item-dark {
  color: #141619;
  background-color: #d3d3d4;
}

.list-group-item-dark.list-group-item-action:focus,
.list-group-item-dark.list-group-item-action:hover {
  color: #141619;
  background-color: #bebebf;
}

.list-group-item-dark.list-group-item-action.active {
  color: #fff;
  background-color: #141619;
  border-color: #141619;
}

.btn-close {
  box-sizing: content-box;
  width: 1em;
  height: 1em;
  padding: 0.25em 0.25em;
  color: #000;
  background: transparent url(${___CSS_LOADER_URL_REPLACEMENT_13___}) center/1em auto no-repeat;
  border: 0;
  border-radius: 0.375rem;
  opacity: 0.5;
}

.btn-close:hover {
  color: #000;
  text-decoration: none;
  opacity: 0.75;
}

.btn-close:focus {
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
  opacity: 1;
}

.btn-close.disabled,
.btn-close:disabled {
  pointer-events: none;
  -webkit-user-select: none;
  user-select: none;
  opacity: 0.25;
}

.btn-close-white {
  filter: invert(1) grayscale(100%) brightness(200%);
}

.toast {
  --bs-toast-padding-x: 0.75rem;
  --bs-toast-padding-y: 0.5rem;
  --bs-toast-spacing: 1.5rem;
  --bs-toast-max-width: 350px;
  --bs-toast-font-size: 0.875rem;
  --bs-toast-color: ;
  --bs-toast-bg: rgba(255, 255, 255, 0.85);
  --bs-toast-border-width: 1px;
  --bs-toast-border-color: var(--bs-border-color-translucent);
  --bs-toast-border-radius: 0.375rem;
  --bs-toast-box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
  --bs-toast-header-color: #6c757d;
  --bs-toast-header-bg: rgba(255, 255, 255, 0.85);
  --bs-toast-header-border-color: rgba(0, 0, 0, 0.05);
  width: var(--bs-toast-max-width);
  max-width: 100%;
  font-size: var(--bs-toast-font-size);
  color: var(--bs-toast-color);
  pointer-events: auto;
  background-color: var(--bs-toast-bg);
  background-clip: padding-box;
  border: var(--bs-toast-border-width) solid var(--bs-toast-border-color);
  box-shadow: var(--bs-toast-box-shadow);
  border-radius: var(--bs-toast-border-radius);
}

.toast.showing {
  opacity: 0;
}

.toast:not(.show) {
  display: none;
}

.toast-container {
  position: absolute;
  z-index: 1090;
  width: max-content;
  max-width: 100%;
  pointer-events: none;
}

.toast-container > :not(:last-child) {
  margin-bottom: var(--bs-toast-spacing);
}

.toast-header {
  display: flex;
  align-items: center;
  padding: var(--bs-toast-padding-y) var(--bs-toast-padding-x);
  color: var(--bs-toast-header-color);
  background-color: var(--bs-toast-header-bg);
  background-clip: padding-box;
  border-bottom: var(--bs-toast-border-width) solid var(--bs-toast-header-border-color);
  border-top-left-radius: calc(var(--bs-toast-border-radius) - var(--bs-toast-border-width));
  border-top-right-radius: calc(var(--bs-toast-border-radius) - var(--bs-toast-border-width));
}

.toast-header .btn-close {
  margin-right: calc(var(--bs-toast-padding-x) * -0.5);
  margin-left: var(--bs-toast-padding-x);
}

.toast-body {
  padding: var(--bs-toast-padding-x);
  word-wrap: break-word;
}

.modal {
  --bs-modal-zindex: 1055;
  --bs-modal-width: 500px;
  --bs-modal-padding: 1rem;
  --bs-modal-margin: 0.5rem;
  --bs-modal-color: ;
  --bs-modal-bg: #fff;
  --bs-modal-border-color: var(--bs-border-color-translucent);
  --bs-modal-border-width: 1px;
  --bs-modal-border-radius: 0.5rem;
  --bs-modal-box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
  --bs-modal-inner-border-radius: calc(0.5rem - 1px);
  --bs-modal-header-padding-x: 1rem;
  --bs-modal-header-padding-y: 1rem;
  --bs-modal-header-padding: 1rem 1rem;
  --bs-modal-header-border-color: var(--bs-border-color);
  --bs-modal-header-border-width: 1px;
  --bs-modal-title-line-height: 1.5;
  --bs-modal-footer-gap: 0.5rem;
  --bs-modal-footer-bg: ;
  --bs-modal-footer-border-color: var(--bs-border-color);
  --bs-modal-footer-border-width: 1px;
  position: fixed;
  top: 0;
  left: 0;
  z-index: var(--bs-modal-zindex);
  display: none;
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  outline: 0;
}

.modal-dialog {
  position: relative;
  width: auto;
  margin: var(--bs-modal-margin);
  pointer-events: none;
}

.modal.fade .modal-dialog {
  transition: transform 0.3s ease-out;
  transform: translate(0, -50px);
}

@media (prefers-reduced-motion: reduce) {
  .modal.fade .modal-dialog {
    transition: none;
  }
}
.modal.show .modal-dialog {
  transform: none;
}

.modal.modal-static .modal-dialog {
  transform: scale(1.02);
}

.modal-dialog-scrollable {
  height: calc(100% - var(--bs-modal-margin) * 2);
}

.modal-dialog-scrollable .modal-content {
  max-height: 100%;
  overflow: hidden;
}

.modal-dialog-scrollable .modal-body {
  overflow-y: auto;
}

.modal-dialog-centered {
  display: flex;
  align-items: center;
  min-height: calc(100% - var(--bs-modal-margin) * 2);
}

.modal-content {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  color: var(--bs-modal-color);
  pointer-events: auto;
  background-color: var(--bs-modal-bg);
  background-clip: padding-box;
  border: var(--bs-modal-border-width) solid var(--bs-modal-border-color);
  border-radius: var(--bs-modal-border-radius);
  outline: 0;
}

.modal-backdrop {
  --bs-backdrop-zindex: 1050;
  --bs-backdrop-bg: #000;
  --bs-backdrop-opacity: 0.5;
  position: fixed;
  top: 0;
  left: 0;
  z-index: var(--bs-backdrop-zindex);
  width: 100vw;
  height: 100vh;
  background-color: var(--bs-backdrop-bg);
}

.modal-backdrop.fade {
  opacity: 0;
}

.modal-backdrop.show {
  opacity: var(--bs-backdrop-opacity);
}

.modal-header {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: space-between;
  padding: var(--bs-modal-header-padding);
  border-bottom: var(--bs-modal-header-border-width) solid var(--bs-modal-header-border-color);
  border-top-left-radius: var(--bs-modal-inner-border-radius);
  border-top-right-radius: var(--bs-modal-inner-border-radius);
}

.modal-header .btn-close {
  padding: calc(var(--bs-modal-header-padding-y) * 0.5) calc(var(--bs-modal-header-padding-x) * 0.5);
  margin: calc(var(--bs-modal-header-padding-y) * -0.5) calc(var(--bs-modal-header-padding-x) * -0.5) calc(var(--bs-modal-header-padding-y) * -0.5) auto;
}

.modal-title {
  margin-bottom: 0;
  line-height: var(--bs-modal-title-line-height);
}

.modal-body {
  position: relative;
  flex: 1 1 auto;
  padding: var(--bs-modal-padding);
}

.modal-footer {
  display: flex;
  flex-shrink: 0;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  padding: calc(var(--bs-modal-padding) - var(--bs-modal-footer-gap) * 0.5);
  background-color: var(--bs-modal-footer-bg);
  border-top: var(--bs-modal-footer-border-width) solid var(--bs-modal-footer-border-color);
  border-bottom-right-radius: var(--bs-modal-inner-border-radius);
  border-bottom-left-radius: var(--bs-modal-inner-border-radius);
}

.modal-footer > * {
  margin: calc(var(--bs-modal-footer-gap) * 0.5);
}

@media (min-width: 576px) {
  .modal {
    --bs-modal-margin: 1.75rem;
    --bs-modal-box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) ;
  }
  .modal-dialog {
    max-width: var(--bs-modal-width);
    margin-right: auto;
    margin-left: auto;
  }
  .modal-sm {
    --bs-modal-width: 300px ;
  }
}
@media (min-width: 992px) {
  .modal-lg,
  .modal-xl {
    --bs-modal-width: 800px ;
  }
}
@media (min-width: 1200px) {
  .modal-xl {
    --bs-modal-width: 1140px ;
  }
}
.modal-fullscreen {
  width: 100vw;
  max-width: none;
  height: 100%;
  margin: 0;
}

.modal-fullscreen .modal-content {
  height: 100%;
  border: 0;
  border-radius: 0;
}

.modal-fullscreen .modal-footer,
.modal-fullscreen .modal-header {
  border-radius: 0;
}

.modal-fullscreen .modal-body {
  overflow-y: auto;
}

@media (max-width: 575.98px) {
  .modal-fullscreen-sm-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-sm-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-sm-down .modal-footer,
  .modal-fullscreen-sm-down .modal-header {
    border-radius: 0;
  }
  .modal-fullscreen-sm-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 767.98px) {
  .modal-fullscreen-md-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-md-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-md-down .modal-footer,
  .modal-fullscreen-md-down .modal-header {
    border-radius: 0;
  }
  .modal-fullscreen-md-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 991.98px) {
  .modal-fullscreen-lg-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-lg-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-lg-down .modal-footer,
  .modal-fullscreen-lg-down .modal-header {
    border-radius: 0;
  }
  .modal-fullscreen-lg-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 1199.98px) {
  .modal-fullscreen-xl-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-xl-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-xl-down .modal-footer,
  .modal-fullscreen-xl-down .modal-header {
    border-radius: 0;
  }
  .modal-fullscreen-xl-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 1399.98px) {
  .modal-fullscreen-xxl-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-xxl-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-xxl-down .modal-footer,
  .modal-fullscreen-xxl-down .modal-header {
    border-radius: 0;
  }
  .modal-fullscreen-xxl-down .modal-body {
    overflow-y: auto;
  }
}
.tooltip {
  --bs-tooltip-zindex: 1080;
  --bs-tooltip-max-width: 200px;
  --bs-tooltip-padding-x: 0.5rem;
  --bs-tooltip-padding-y: 0.25rem;
  --bs-tooltip-margin: ;
  --bs-tooltip-font-size: 0.875rem;
  --bs-tooltip-color: #fff;
  --bs-tooltip-bg: #000;
  --bs-tooltip-border-radius: 0.375rem;
  --bs-tooltip-opacity: 0.9;
  --bs-tooltip-arrow-width: 0.8rem;
  --bs-tooltip-arrow-height: 0.4rem;
  z-index: var(--bs-tooltip-zindex);
  display: block;
  padding: var(--bs-tooltip-arrow-height);
  margin: var(--bs-tooltip-margin);
  font-family: var(--bs-font-sans-serif);
  font-style: normal;
  font-weight: 400;
  line-height: 1.5;
  text-align: left;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  white-space: normal;
  word-spacing: normal;
  line-break: auto;
  font-size: var(--bs-tooltip-font-size);
  word-wrap: break-word;
  opacity: 0;
}

.tooltip.show {
  opacity: var(--bs-tooltip-opacity);
}

.tooltip .tooltip-arrow {
  display: block;
  width: var(--bs-tooltip-arrow-width);
  height: var(--bs-tooltip-arrow-height);
}

.tooltip .tooltip-arrow::before {
  position: absolute;
  content: "";
  border-color: transparent;
  border-style: solid;
}

.bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow,
.bs-tooltip-top .tooltip-arrow {
  bottom: 0;
}

.bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow::before,
.bs-tooltip-top .tooltip-arrow::before {
  top: -1px;
  border-width: var(--bs-tooltip-arrow-height) calc(var(--bs-tooltip-arrow-width) * 0.5) 0;
  border-top-color: var(--bs-tooltip-bg);
}

.bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow,
.bs-tooltip-end .tooltip-arrow {
  left: 0;
  width: var(--bs-tooltip-arrow-height);
  height: var(--bs-tooltip-arrow-width);
}

.bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow::before,
.bs-tooltip-end .tooltip-arrow::before {
  right: -1px;
  border-width: calc(var(--bs-tooltip-arrow-width) * 0.5) var(--bs-tooltip-arrow-height) calc(var(--bs-tooltip-arrow-width) * 0.5) 0;
  border-right-color: var(--bs-tooltip-bg);
}

.bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow,
.bs-tooltip-bottom .tooltip-arrow {
  top: 0;
}

.bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow::before,
.bs-tooltip-bottom .tooltip-arrow::before {
  bottom: -1px;
  border-width: 0 calc(var(--bs-tooltip-arrow-width) * 0.5) var(--bs-tooltip-arrow-height);
  border-bottom-color: var(--bs-tooltip-bg);
}

.bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow,
.bs-tooltip-start .tooltip-arrow {
  right: 0;
  width: var(--bs-tooltip-arrow-height);
  height: var(--bs-tooltip-arrow-width);
}

.bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow::before,
.bs-tooltip-start .tooltip-arrow::before {
  left: -1px;
  border-width: calc(var(--bs-tooltip-arrow-width) * 0.5) 0 calc(var(--bs-tooltip-arrow-width) * 0.5) var(--bs-tooltip-arrow-height);
  border-left-color: var(--bs-tooltip-bg);
}

.tooltip-inner {
  max-width: var(--bs-tooltip-max-width);
  padding: var(--bs-tooltip-padding-y) var(--bs-tooltip-padding-x);
  color: var(--bs-tooltip-color);
  text-align: center;
  background-color: var(--bs-tooltip-bg);
  border-radius: var(--bs-tooltip-border-radius);
}

.popover {
  --bs-popover-zindex: 1070;
  --bs-popover-max-width: 276px;
  --bs-popover-font-size: 0.875rem;
  --bs-popover-bg: #fff;
  --bs-popover-border-width: 1px;
  --bs-popover-border-color: var(--bs-border-color-translucent);
  --bs-popover-border-radius: 0.5rem;
  --bs-popover-inner-border-radius: calc(0.5rem - 1px);
  --bs-popover-box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
  --bs-popover-header-padding-x: 1rem;
  --bs-popover-header-padding-y: 0.5rem;
  --bs-popover-header-font-size: 1rem;
  --bs-popover-header-color: var(--bs-heading-color);
  --bs-popover-header-bg: #f0f0f0;
  --bs-popover-body-padding-x: 1rem;
  --bs-popover-body-padding-y: 1rem;
  --bs-popover-body-color: #212529;
  --bs-popover-arrow-width: 1rem;
  --bs-popover-arrow-height: 0.5rem;
  --bs-popover-arrow-border: var(--bs-popover-border-color);
  z-index: var(--bs-popover-zindex);
  display: block;
  max-width: var(--bs-popover-max-width);
  font-family: var(--bs-font-sans-serif);
  font-style: normal;
  font-weight: 400;
  line-height: 1.5;
  text-align: left;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  white-space: normal;
  word-spacing: normal;
  line-break: auto;
  font-size: var(--bs-popover-font-size);
  word-wrap: break-word;
  background-color: var(--bs-popover-bg);
  background-clip: padding-box;
  border: var(--bs-popover-border-width) solid var(--bs-popover-border-color);
  border-radius: var(--bs-popover-border-radius);
}

.popover .popover-arrow {
  display: block;
  width: var(--bs-popover-arrow-width);
  height: var(--bs-popover-arrow-height);
}

.popover .popover-arrow::after,
.popover .popover-arrow::before {
  position: absolute;
  display: block;
  content: "";
  border-color: transparent;
  border-style: solid;
  border-width: 0;
}

.bs-popover-auto[data-popper-placement^=top] > .popover-arrow,
.bs-popover-top > .popover-arrow {
  bottom: calc(var(--bs-popover-arrow-height) * -1 - var(--bs-popover-border-width));
}

.bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after,
.bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before,
.bs-popover-top > .popover-arrow::after,
.bs-popover-top > .popover-arrow::before {
  border-width: var(--bs-popover-arrow-height) calc(var(--bs-popover-arrow-width) * 0.5) 0;
}

.bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before,
.bs-popover-top > .popover-arrow::before {
  bottom: 0;
  border-top-color: var(--bs-popover-arrow-border);
}

.bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after,
.bs-popover-top > .popover-arrow::after {
  bottom: var(--bs-popover-border-width);
  border-top-color: var(--bs-popover-bg);
}

.bs-popover-auto[data-popper-placement^=right] > .popover-arrow,
.bs-popover-end > .popover-arrow {
  left: calc(var(--bs-popover-arrow-height) * -1 - var(--bs-popover-border-width));
  width: var(--bs-popover-arrow-height);
  height: var(--bs-popover-arrow-width);
}

.bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after,
.bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before,
.bs-popover-end > .popover-arrow::after,
.bs-popover-end > .popover-arrow::before {
  border-width: calc(var(--bs-popover-arrow-width) * 0.5) var(--bs-popover-arrow-height) calc(var(--bs-popover-arrow-width) * 0.5) 0;
}

.bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before,
.bs-popover-end > .popover-arrow::before {
  left: 0;
  border-right-color: var(--bs-popover-arrow-border);
}

.bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after,
.bs-popover-end > .popover-arrow::after {
  left: var(--bs-popover-border-width);
  border-right-color: var(--bs-popover-bg);
}

.bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow,
.bs-popover-bottom > .popover-arrow {
  top: calc(var(--bs-popover-arrow-height) * -1 - var(--bs-popover-border-width));
}

.bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after,
.bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before,
.bs-popover-bottom > .popover-arrow::after,
.bs-popover-bottom > .popover-arrow::before {
  border-width: 0 calc(var(--bs-popover-arrow-width) * 0.5) var(--bs-popover-arrow-height);
}

.bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before,
.bs-popover-bottom > .popover-arrow::before {
  top: 0;
  border-bottom-color: var(--bs-popover-arrow-border);
}

.bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after,
.bs-popover-bottom > .popover-arrow::after {
  top: var(--bs-popover-border-width);
  border-bottom-color: var(--bs-popover-bg);
}

.bs-popover-auto[data-popper-placement^=bottom] .popover-header::before,
.bs-popover-bottom .popover-header::before {
  position: absolute;
  top: 0;
  left: 50%;
  display: block;
  width: var(--bs-popover-arrow-width);
  margin-left: calc(var(--bs-popover-arrow-width) * -0.5);
  content: "";
  border-bottom: var(--bs-popover-border-width) solid var(--bs-popover-header-bg);
}

.bs-popover-auto[data-popper-placement^=left] > .popover-arrow,
.bs-popover-start > .popover-arrow {
  right: calc(var(--bs-popover-arrow-height) * -1 - var(--bs-popover-border-width));
  width: var(--bs-popover-arrow-height);
  height: var(--bs-popover-arrow-width);
}

.bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after,
.bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before,
.bs-popover-start > .popover-arrow::after,
.bs-popover-start > .popover-arrow::before {
  border-width: calc(var(--bs-popover-arrow-width) * 0.5) 0 calc(var(--bs-popover-arrow-width) * 0.5) var(--bs-popover-arrow-height);
}

.bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before,
.bs-popover-start > .popover-arrow::before {
  right: 0;
  border-left-color: var(--bs-popover-arrow-border);
}

.bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after,
.bs-popover-start > .popover-arrow::after {
  right: var(--bs-popover-border-width);
  border-left-color: var(--bs-popover-bg);
}

.popover-header {
  padding: var(--bs-popover-header-padding-y) var(--bs-popover-header-padding-x);
  margin-bottom: 0;
  font-size: var(--bs-popover-header-font-size);
  color: var(--bs-popover-header-color);
  background-color: var(--bs-popover-header-bg);
  border-bottom: var(--bs-popover-border-width) solid var(--bs-popover-border-color);
  border-top-left-radius: var(--bs-popover-inner-border-radius);
  border-top-right-radius: var(--bs-popover-inner-border-radius);
}

.popover-header:empty {
  display: none;
}

.popover-body {
  padding: var(--bs-popover-body-padding-y) var(--bs-popover-body-padding-x);
  color: var(--bs-popover-body-color);
}

.carousel {
  position: relative;
}

.carousel.pointer-event {
  touch-action: pan-y;
}

.carousel-inner {
  position: relative;
  width: 100%;
  overflow: hidden;
}

.carousel-inner::after {
  display: block;
  clear: both;
  content: "";
}

.carousel-item {
  position: relative;
  display: none;
  float: left;
  width: 100%;
  margin-right: -100%;
  backface-visibility: hidden;
  transition: transform 0.6s ease-in-out;
}

@media (prefers-reduced-motion: reduce) {
  .carousel-item {
    transition: none;
  }
}
.carousel-item-next,
.carousel-item-prev,
.carousel-item.active {
  display: block;
}

.active.carousel-item-end,
.carousel-item-next:not(.carousel-item-start) {
  transform: translateX(100%);
}

.active.carousel-item-start,
.carousel-item-prev:not(.carousel-item-end) {
  transform: translateX(-100%);
}

.carousel-fade .carousel-item {
  opacity: 0;
  transition-property: opacity;
  transform: none;
}

.carousel-fade .carousel-item-next.carousel-item-start,
.carousel-fade .carousel-item-prev.carousel-item-end,
.carousel-fade .carousel-item.active {
  z-index: 1;
  opacity: 1;
}

.carousel-fade .active.carousel-item-end,
.carousel-fade .active.carousel-item-start {
  z-index: 0;
  opacity: 0;
  transition: opacity 0s 0.6s;
}

@media (prefers-reduced-motion: reduce) {
  .carousel-fade .active.carousel-item-end,
  .carousel-fade .active.carousel-item-start {
    transition: none;
  }
}
.carousel-control-next,
.carousel-control-prev {
  position: absolute;
  top: 0;
  bottom: 0;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 15%;
  padding: 0;
  color: #fff;
  text-align: center;
  background: 0 0;
  border: 0;
  opacity: 0.5;
  transition: opacity 0.15s ease;
}

@media (prefers-reduced-motion: reduce) {
  .carousel-control-next,
  .carousel-control-prev {
    transition: none;
  }
}
.carousel-control-next:focus,
.carousel-control-next:hover,
.carousel-control-prev:focus,
.carousel-control-prev:hover {
  color: #fff;
  text-decoration: none;
  outline: 0;
  opacity: 0.9;
}

.carousel-control-prev {
  left: 0;
}

.carousel-control-next {
  right: 0;
}

.carousel-control-next-icon,
.carousel-control-prev-icon {
  display: inline-block;
  width: 2rem;
  height: 2rem;
  background-repeat: no-repeat;
  background-position: 50%;
  background-size: 100% 100%;
}

.carousel-control-prev-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_14___});
}

.carousel-control-next-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_15___});
}

.carousel-indicators {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 2;
  display: flex;
  justify-content: center;
  padding: 0;
  margin-right: 15%;
  margin-bottom: 1rem;
  margin-left: 15%;
  list-style: none;
}

.carousel-indicators [data-bs-target] {
  box-sizing: content-box;
  flex: 0 1 auto;
  width: 30px;
  height: 3px;
  padding: 0;
  margin-right: 3px;
  margin-left: 3px;
  text-indent: -999px;
  cursor: pointer;
  background-color: #fff;
  background-clip: padding-box;
  border: 0;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  opacity: 0.5;
  transition: opacity 0.6s ease;
}

@media (prefers-reduced-motion: reduce) {
  .carousel-indicators [data-bs-target] {
    transition: none;
  }
}
.carousel-indicators .active {
  opacity: 1;
}

.carousel-caption {
  position: absolute;
  right: 15%;
  bottom: 1.25rem;
  left: 15%;
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
  color: #fff;
  text-align: center;
}

.carousel-dark .carousel-control-next-icon,
.carousel-dark .carousel-control-prev-icon {
  filter: invert(1) grayscale(100);
}

.carousel-dark .carousel-indicators [data-bs-target] {
  background-color: #000;
}

.carousel-dark .carousel-caption {
  color: #000;
}

.spinner-border,
.spinner-grow {
  display: inline-block;
  width: var(--bs-spinner-width);
  height: var(--bs-spinner-height);
  vertical-align: var(--bs-spinner-vertical-align);
  border-radius: 50%;
  animation: var(--bs-spinner-animation-speed) linear infinite var(--bs-spinner-animation-name);
}
@keyframes spinner-border {
  to {
    transform: rotate(360deg);
  }
}
.spinner-border {
  --bs-spinner-width: 2rem;
  --bs-spinner-height: 2rem;
  --bs-spinner-vertical-align: -0.125em;
  --bs-spinner-border-width: 0.25em;
  --bs-spinner-animation-speed: 0.75s;
  --bs-spinner-animation-name: spinner-border;
  border: var(--bs-spinner-border-width) solid currentcolor;
  border-right-color: transparent;
}

.spinner-border-sm {
  --bs-spinner-width: 1rem;
  --bs-spinner-height: 1rem;
  --bs-spinner-border-width: 0.2em ;
}
@keyframes spinner-grow {
  0% {
    transform: scale(0);
  }
  50% {
    opacity: 1;
    transform: none;
  }
}
.spinner-grow {
  --bs-spinner-width: 2rem;
  --bs-spinner-height: 2rem;
  --bs-spinner-vertical-align: -0.125em;
  --bs-spinner-animation-speed: 0.75s;
  --bs-spinner-animation-name: spinner-grow;
  background-color: currentcolor;
  opacity: 0;
}

.spinner-grow-sm {
  --bs-spinner-width: 1rem;
  --bs-spinner-height: 1rem ;
}

@media (prefers-reduced-motion: reduce) {
  .spinner-border,
  .spinner-grow {
    --bs-spinner-animation-speed: 1.5s ;
  }
}
.offcanvas,
.offcanvas-lg,
.offcanvas-md,
.offcanvas-sm,
.offcanvas-xl,
.offcanvas-xxl {
  --bs-offcanvas-width: 400px;
  --bs-offcanvas-height: 30vh;
  --bs-offcanvas-padding-x: 1rem;
  --bs-offcanvas-padding-y: 1rem;
  --bs-offcanvas-color: ;
  --bs-offcanvas-bg: #fff;
  --bs-offcanvas-border-width: 1px;
  --bs-offcanvas-border-color: var(--bs-border-color-translucent);
  --bs-offcanvas-box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075) ;
}

@media (max-width: 575.98px) {
  .offcanvas-sm {
    position: fixed;
    bottom: 0;
    z-index: 1045;
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: transform 0.3s ease-in-out;
  }
}
@media (max-width: 575.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-sm {
    transition: none;
  }
}
@media (max-width: 575.98px) {
  .offcanvas-sm.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }
}
@media (max-width: 575.98px) {
  .offcanvas-sm.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }
}
@media (max-width: 575.98px) {
  .offcanvas-sm.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }
}
@media (max-width: 575.98px) {
  .offcanvas-sm.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }
}
@media (max-width: 575.98px) {
  .offcanvas-sm.show:not(.hiding),
  .offcanvas-sm.showing {
    transform: none;
  }
}
@media (max-width: 575.98px) {
  .offcanvas-sm.hiding,
  .offcanvas-sm.show,
  .offcanvas-sm.showing {
    visibility: visible;
  }
}
@media (min-width: 576px) {
  .offcanvas-sm {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-sm .offcanvas-header {
    display: none;
  }
  .offcanvas-sm .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}
@media (max-width: 767.98px) {
  .offcanvas-md {
    position: fixed;
    bottom: 0;
    z-index: 1045;
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: transform 0.3s ease-in-out;
  }
}
@media (max-width: 767.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-md {
    transition: none;
  }
}
@media (max-width: 767.98px) {
  .offcanvas-md.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }
}
@media (max-width: 767.98px) {
  .offcanvas-md.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }
}
@media (max-width: 767.98px) {
  .offcanvas-md.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }
}
@media (max-width: 767.98px) {
  .offcanvas-md.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }
}
@media (max-width: 767.98px) {
  .offcanvas-md.show:not(.hiding),
  .offcanvas-md.showing {
    transform: none;
  }
}
@media (max-width: 767.98px) {
  .offcanvas-md.hiding,
  .offcanvas-md.show,
  .offcanvas-md.showing {
    visibility: visible;
  }
}
@media (min-width: 768px) {
  .offcanvas-md {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-md .offcanvas-header {
    display: none;
  }
  .offcanvas-md .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}
@media (max-width: 991.98px) {
  .offcanvas-lg {
    position: fixed;
    bottom: 0;
    z-index: 1045;
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: transform 0.3s ease-in-out;
  }
}
@media (max-width: 991.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-lg {
    transition: none;
  }
}
@media (max-width: 991.98px) {
  .offcanvas-lg.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }
}
@media (max-width: 991.98px) {
  .offcanvas-lg.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }
}
@media (max-width: 991.98px) {
  .offcanvas-lg.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }
}
@media (max-width: 991.98px) {
  .offcanvas-lg.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }
}
@media (max-width: 991.98px) {
  .offcanvas-lg.show:not(.hiding),
  .offcanvas-lg.showing {
    transform: none;
  }
}
@media (max-width: 991.98px) {
  .offcanvas-lg.hiding,
  .offcanvas-lg.show,
  .offcanvas-lg.showing {
    visibility: visible;
  }
}
@media (min-width: 992px) {
  .offcanvas-lg {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-lg .offcanvas-header {
    display: none;
  }
  .offcanvas-lg .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}
@media (max-width: 1199.98px) {
  .offcanvas-xl {
    position: fixed;
    bottom: 0;
    z-index: 1045;
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: transform 0.3s ease-in-out;
  }
}
@media (max-width: 1199.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-xl {
    transition: none;
  }
}
@media (max-width: 1199.98px) {
  .offcanvas-xl.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }
}
@media (max-width: 1199.98px) {
  .offcanvas-xl.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }
}
@media (max-width: 1199.98px) {
  .offcanvas-xl.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }
}
@media (max-width: 1199.98px) {
  .offcanvas-xl.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }
}
@media (max-width: 1199.98px) {
  .offcanvas-xl.show:not(.hiding),
  .offcanvas-xl.showing {
    transform: none;
  }
}
@media (max-width: 1199.98px) {
  .offcanvas-xl.hiding,
  .offcanvas-xl.show,
  .offcanvas-xl.showing {
    visibility: visible;
  }
}
@media (min-width: 1200px) {
  .offcanvas-xl {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-xl .offcanvas-header {
    display: none;
  }
  .offcanvas-xl .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}
@media (max-width: 1399.98px) {
  .offcanvas-xxl {
    position: fixed;
    bottom: 0;
    z-index: 1045;
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: transform 0.3s ease-in-out;
  }
}
@media (max-width: 1399.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-xxl {
    transition: none;
  }
}
@media (max-width: 1399.98px) {
  .offcanvas-xxl.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }
}
@media (max-width: 1399.98px) {
  .offcanvas-xxl.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }
}
@media (max-width: 1399.98px) {
  .offcanvas-xxl.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }
}
@media (max-width: 1399.98px) {
  .offcanvas-xxl.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }
}
@media (max-width: 1399.98px) {
  .offcanvas-xxl.show:not(.hiding),
  .offcanvas-xxl.showing {
    transform: none;
  }
}
@media (max-width: 1399.98px) {
  .offcanvas-xxl.hiding,
  .offcanvas-xxl.show,
  .offcanvas-xxl.showing {
    visibility: visible;
  }
}
@media (min-width: 1400px) {
  .offcanvas-xxl {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-xxl .offcanvas-header {
    display: none;
  }
  .offcanvas-xxl .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}
.offcanvas {
  position: fixed;
  bottom: 0;
  z-index: 1045;
  display: flex;
  flex-direction: column;
  max-width: 100%;
  color: var(--bs-offcanvas-color);
  visibility: hidden;
  background-color: var(--bs-offcanvas-bg);
  background-clip: padding-box;
  outline: 0;
  transition: transform 0.3s ease-in-out;
}

@media (prefers-reduced-motion: reduce) {
  .offcanvas {
    transition: none;
  }
}
.offcanvas.offcanvas-start {
  top: 0;
  left: 0;
  width: var(--bs-offcanvas-width);
  border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
  transform: translateX(-100%);
}

.offcanvas.offcanvas-end {
  top: 0;
  right: 0;
  width: var(--bs-offcanvas-width);
  border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
  transform: translateX(100%);
}

.offcanvas.offcanvas-top {
  top: 0;
  right: 0;
  left: 0;
  height: var(--bs-offcanvas-height);
  max-height: 100%;
  border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
  transform: translateY(-100%);
}

.offcanvas.offcanvas-bottom {
  right: 0;
  left: 0;
  height: var(--bs-offcanvas-height);
  max-height: 100%;
  border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
  transform: translateY(100%);
}

.offcanvas.show:not(.hiding),
.offcanvas.showing {
  transform: none;
}

.offcanvas.hiding,
.offcanvas.show,
.offcanvas.showing {
  visibility: visible;
}

.offcanvas-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1040;
  width: 100vw;
  height: 100vh;
  background-color: #000;
}

.offcanvas-backdrop.fade {
  opacity: 0;
}

.offcanvas-backdrop.show {
  opacity: 0.5;
}

.offcanvas-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: var(--bs-offcanvas-padding-y) var(--bs-offcanvas-padding-x);
}

.offcanvas-header .btn-close {
  padding: calc(var(--bs-offcanvas-padding-y) * 0.5) calc(var(--bs-offcanvas-padding-x) * 0.5);
  margin-top: calc(var(--bs-offcanvas-padding-y) * -0.5);
  margin-right: calc(var(--bs-offcanvas-padding-x) * -0.5);
  margin-bottom: calc(var(--bs-offcanvas-padding-y) * -0.5);
}

.offcanvas-title {
  margin-bottom: 0;
  line-height: 1.5;
}

.offcanvas-body {
  flex-grow: 1;
  padding: var(--bs-offcanvas-padding-y) var(--bs-offcanvas-padding-x);
  overflow-y: auto;
}

.placeholder {
  display: inline-block;
  min-height: 1em;
  vertical-align: middle;
  cursor: wait;
  background-color: currentcolor;
  opacity: 0.5;
}

.placeholder.btn::before {
  display: inline-block;
  content: "";
}

.placeholder-xs {
  min-height: 0.6em;
}

.placeholder-sm {
  min-height: 0.8em;
}

.placeholder-lg {
  min-height: 1.2em;
}

.placeholder-glow .placeholder {
  animation: placeholder-glow 2s ease-in-out infinite;
}
@keyframes placeholder-glow {
  50% {
    opacity: 0.2;
  }
}
.placeholder-wave {
  mask-image: linear-gradient(130deg, #000 55%, rgba(0, 0, 0, 0.8) 75%, #000 95%);
  mask-size: 200% 100%;
  animation: placeholder-wave 2s linear infinite;
}
@keyframes placeholder-wave {
  100% {
    mask-position: -200% 0%;
  }
}
.clearfix::after {
  display: block;
  clear: both;
  content: "";
}

.text-bg-primary {
  color: #fff !important;
  background-color: RGBA(13, 110, 253, var(--bs-bg-opacity, 1)) !important;
}

.text-bg-secondary {
  color: #fff !important;
  background-color: RGBA(108, 117, 125, var(--bs-bg-opacity, 1)) !important;
}

.text-bg-success {
  color: #fff !important;
  background-color: RGBA(25, 135, 84, var(--bs-bg-opacity, 1)) !important;
}

.text-bg-info {
  color: #000 !important;
  background-color: RGBA(13, 202, 240, var(--bs-bg-opacity, 1)) !important;
}

.text-bg-warning {
  color: #000 !important;
  background-color: RGBA(255, 193, 7, var(--bs-bg-opacity, 1)) !important;
}

.text-bg-danger {
  color: #fff !important;
  background-color: RGBA(220, 53, 69, var(--bs-bg-opacity, 1)) !important;
}

.text-bg-light {
  color: #000 !important;
  background-color: RGBA(248, 249, 250, var(--bs-bg-opacity, 1)) !important;
}

.text-bg-dark {
  color: #fff !important;
  background-color: RGBA(33, 37, 41, var(--bs-bg-opacity, 1)) !important;
}

.link-primary {
  color: #0d6efd !important;
}

.link-primary:focus,
.link-primary:hover {
  color: #0a58ca !important;
}

.link-secondary {
  color: #6c757d !important;
}

.link-secondary:focus,
.link-secondary:hover {
  color: #565e64 !important;
}

.link-success {
  color: #198754 !important;
}

.link-success:focus,
.link-success:hover {
  color: #146c43 !important;
}

.link-info {
  color: #0dcaf0 !important;
}

.link-info:focus,
.link-info:hover {
  color: #3dd5f3 !important;
}

.link-warning {
  color: #ffc107 !important;
}

.link-warning:focus,
.link-warning:hover {
  color: #ffcd39 !important;
}

.link-danger {
  color: #dc3545 !important;
}

.link-danger:focus,
.link-danger:hover {
  color: #b02a37 !important;
}

.link-light {
  color: #f8f9fa !important;
}

.link-light:focus,
.link-light:hover {
  color: #f9fafb !important;
}

.link-dark {
  color: #212529 !important;
}

.link-dark:focus,
.link-dark:hover {
  color: #1a1e21 !important;
}

.ratio {
  position: relative;
  width: 100%;
}

.ratio::before {
  display: block;
  padding-top: var(--bs-aspect-ratio);
  content: "";
}

.ratio > * {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.ratio-1x1 {
  --bs-aspect-ratio: 100% ;
}

.ratio-4x3 {
  --bs-aspect-ratio: 75% ;
}

.ratio-16x9 {
  --bs-aspect-ratio: 56.25% ;
}

.ratio-21x9 {
  --bs-aspect-ratio: 42.8571428571% ;
}

.fixed-top {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 1030;
}

.fixed-bottom {
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1030;
}

.sticky-top {
  position: sticky;
  top: 0;
  z-index: 1020;
}

.sticky-bottom {
  position: sticky;
  bottom: 0;
  z-index: 1020;
}

@media (min-width: 576px) {
  .sticky-sm-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-sm-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 768px) {
  .sticky-md-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-md-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 992px) {
  .sticky-lg-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-lg-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 1200px) {
  .sticky-xl-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-xl-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 1400px) {
  .sticky-xxl-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-xxl-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
.hstack {
  display: flex;
  flex-direction: row;
  align-items: center;
  align-self: stretch;
}

.vstack {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  align-self: stretch;
}

.visually-hidden,
.visually-hidden-focusable:not(:focus):not(:focus-within) {
  position: absolute !important;
  width: 1px !important;
  height: 1px !important;
  padding: 0 !important;
  margin: -1px !important;
  overflow: hidden !important;
  clip: rect(0, 0, 0, 0) !important;
  white-space: nowrap !important;
  border: 0 !important;
}

.stretched-link::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1;
  content: "";
}

.text-truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.vr {
  display: inline-block;
  align-self: stretch;
  width: 1px;
  min-height: 1em;
  background-color: currentcolor;
  opacity: 0.25;
}

.align-baseline {
  vertical-align: baseline !important;
}

.align-top {
  vertical-align: top !important;
}

.align-middle {
  vertical-align: middle !important;
}

.align-bottom {
  vertical-align: bottom !important;
}

.align-text-bottom {
  vertical-align: text-bottom !important;
}

.align-text-top {
  vertical-align: text-top !important;
}

.float-start {
  float: left !important;
}

.float-end {
  float: right !important;
}

.float-none {
  float: none !important;
}

.opacity-0 {
  opacity: 0 !important;
}

.opacity-25 {
  opacity: 0.25 !important;
}

.opacity-50 {
  opacity: 0.5 !important;
}

.opacity-75 {
  opacity: 0.75 !important;
}

.opacity-100 {
  opacity: 1 !important;
}

.overflow-auto {
  overflow: auto !important;
}

.overflow-hidden {
  overflow: hidden !important;
}

.overflow-visible {
  overflow: visible !important;
}

.overflow-scroll {
  overflow: scroll !important;
}

.d-inline {
  display: inline !important;
}

.d-inline-block {
  display: inline-block !important;
}

.d-block {
  display: block !important;
}

.d-grid {
  display: grid !important;
}

.d-table {
  display: table !important;
}

.d-table-row {
  display: table-row !important;
}

.d-table-cell {
  display: table-cell !important;
}

.d-flex {
  display: flex !important;
}

.d-inline-flex {
  display: inline-flex !important;
}

.d-none {
  display: none !important;
}

.shadow {
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;
}

.shadow-sm {
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075) !important;
}

.shadow-lg {
  box-shadow: 0 1rem 3rem rgba(0, 0, 0, 0.175) !important;
}

.shadow-none {
  box-shadow: none !important;
}

.position-static {
  position: static !important;
}

.position-relative {
  position: relative !important;
}

.position-absolute {
  position: absolute !important;
}

.position-fixed {
  position: fixed !important;
}

.position-sticky {
  position: sticky !important;
}

.top-0 {
  top: 0 !important;
}

.top-50 {
  top: 50% !important;
}

.top-100 {
  top: 100% !important;
}

.bottom-0 {
  bottom: 0 !important;
}

.bottom-50 {
  bottom: 50% !important;
}

.bottom-100 {
  bottom: 100% !important;
}

.start-0 {
  left: 0 !important;
}

.start-50 {
  left: 50% !important;
}

.start-100 {
  left: 100% !important;
}

.end-0 {
  right: 0 !important;
}

.end-50 {
  right: 50% !important;
}

.end-100 {
  right: 100% !important;
}

.translate-middle {
  transform: translate(-50%, -50%) !important;
}

.translate-middle-x {
  transform: translateX(-50%) !important;
}

.translate-middle-y {
  transform: translateY(-50%) !important;
}

.border {
  border: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-0 {
  border: 0 !important;
}

.border-top {
  border-top: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-top-0 {
  border-top: 0 !important;
}

.border-end {
  border-right: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-end-0 {
  border-right: 0 !important;
}

.border-bottom {
  border-bottom: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-bottom-0 {
  border-bottom: 0 !important;
}

.border-start {
  border-left: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-start-0 {
  border-left: 0 !important;
}

.border-primary {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-primary-rgb), var(--bs-border-opacity)) !important;
}

.border-secondary {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-secondary-rgb), var(--bs-border-opacity)) !important;
}

.border-success {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-success-rgb), var(--bs-border-opacity)) !important;
}

.border-info {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-info-rgb), var(--bs-border-opacity)) !important;
}

.border-warning {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-warning-rgb), var(--bs-border-opacity)) !important;
}

.border-danger {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-danger-rgb), var(--bs-border-opacity)) !important;
}

.border-light {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-light-rgb), var(--bs-border-opacity)) !important;
}

.border-dark {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-dark-rgb), var(--bs-border-opacity)) !important;
}

.border-white {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-white-rgb), var(--bs-border-opacity)) !important;
}

.border-1 {
  --bs-border-width: 1px ;
}

.border-2 {
  --bs-border-width: 2px ;
}

.border-3 {
  --bs-border-width: 3px ;
}

.border-4 {
  --bs-border-width: 4px ;
}

.border-5 {
  --bs-border-width: 5px ;
}

.border-opacity-10 {
  --bs-border-opacity: 0.1 ;
}

.border-opacity-25 {
  --bs-border-opacity: 0.25 ;
}

.border-opacity-50 {
  --bs-border-opacity: 0.5 ;
}

.border-opacity-75 {
  --bs-border-opacity: 0.75 ;
}

.border-opacity-100 {
  --bs-border-opacity: 1 ;
}

.w-25 {
  width: 25% !important;
}

.w-50 {
  width: 50% !important;
}

.w-75 {
  width: 75% !important;
}

.w-100 {
  width: 100% !important;
}

.w-auto {
  width: auto !important;
}

.mw-100 {
  max-width: 100% !important;
}

.vw-100 {
  width: 100vw !important;
}

.min-vw-100 {
  min-width: 100vw !important;
}

.h-25 {
  height: 25% !important;
}

.h-50 {
  height: 50% !important;
}

.h-75 {
  height: 75% !important;
}

.h-100 {
  height: 100% !important;
}

.h-auto {
  height: auto !important;
}

.mh-100 {
  max-height: 100% !important;
}

.vh-100 {
  height: 100vh !important;
}

.min-vh-100 {
  min-height: 100vh !important;
}

.flex-fill {
  flex: 1 1 auto !important;
}

.flex-row {
  flex-direction: row !important;
}

.flex-column {
  flex-direction: column !important;
}

.flex-row-reverse {
  flex-direction: row-reverse !important;
}

.flex-column-reverse {
  flex-direction: column-reverse !important;
}

.flex-grow-0 {
  flex-grow: 0 !important;
}

.flex-grow-1 {
  flex-grow: 1 !important;
}

.flex-shrink-0 {
  flex-shrink: 0 !important;
}

.flex-shrink-1 {
  flex-shrink: 1 !important;
}

.flex-wrap {
  flex-wrap: wrap !important;
}

.flex-nowrap {
  flex-wrap: nowrap !important;
}

.flex-wrap-reverse {
  flex-wrap: wrap-reverse !important;
}

.justify-content-start {
  justify-content: flex-start !important;
}

.justify-content-end {
  justify-content: flex-end !important;
}

.justify-content-center {
  justify-content: center !important;
}

.justify-content-between {
  justify-content: space-between !important;
}

.justify-content-around {
  justify-content: space-around !important;
}

.justify-content-evenly {
  justify-content: space-evenly !important;
}

.align-items-start {
  align-items: flex-start !important;
}

.align-items-end {
  align-items: flex-end !important;
}

.align-items-center {
  align-items: center !important;
}

.align-items-baseline {
  align-items: baseline !important;
}

.align-items-stretch {
  align-items: stretch !important;
}

.align-content-start {
  align-content: flex-start !important;
}

.align-content-end {
  align-content: flex-end !important;
}

.align-content-center {
  align-content: center !important;
}

.align-content-between {
  align-content: space-between !important;
}

.align-content-around {
  align-content: space-around !important;
}

.align-content-stretch {
  align-content: stretch !important;
}

.align-self-auto {
  align-self: auto !important;
}

.align-self-start {
  align-self: flex-start !important;
}

.align-self-end {
  align-self: flex-end !important;
}

.align-self-center {
  align-self: center !important;
}

.align-self-baseline {
  align-self: baseline !important;
}

.align-self-stretch {
  align-self: stretch !important;
}

.order-first {
  order: -1 !important;
}

.order-0 {
  order: 0 !important;
}

.order-1 {
  order: 1 !important;
}

.order-2 {
  order: 2 !important;
}

.order-3 {
  order: 3 !important;
}

.order-4 {
  order: 4 !important;
}

.order-5 {
  order: 5 !important;
}

.order-last {
  order: 6 !important;
}

.m-0 {
  margin: 0 !important;
}

.m-1 {
  margin: 0.25rem !important;
}

.m-2 {
  margin: 0.5rem !important;
}

.m-3 {
  margin: 1rem !important;
}

.m-4 {
  margin: 1.5rem !important;
}

.m-5 {
  margin: 3rem !important;
}

.m-auto {
  margin: auto !important;
}

.mx-0 {
  margin-right: 0 !important;
  margin-left: 0 !important;
}

.mx-1 {
  margin-right: 0.25rem !important;
  margin-left: 0.25rem !important;
}

.mx-2 {
  margin-right: 0.5rem !important;
  margin-left: 0.5rem !important;
}

.mx-3 {
  margin-right: 1rem !important;
  margin-left: 1rem !important;
}

.mx-4 {
  margin-right: 1.5rem !important;
  margin-left: 1.5rem !important;
}

.mx-5 {
  margin-right: 3rem !important;
  margin-left: 3rem !important;
}

.mx-auto {
  margin-right: auto !important;
  margin-left: auto !important;
}

.my-0 {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
}

.my-1 {
  margin-top: 0.25rem !important;
  margin-bottom: 0.25rem !important;
}

.my-2 {
  margin-top: 0.5rem !important;
  margin-bottom: 0.5rem !important;
}

.my-3 {
  margin-top: 1rem !important;
  margin-bottom: 1rem !important;
}

.my-4 {
  margin-top: 1.5rem !important;
  margin-bottom: 1.5rem !important;
}

.my-5 {
  margin-top: 3rem !important;
  margin-bottom: 3rem !important;
}

.my-auto {
  margin-top: auto !important;
  margin-bottom: auto !important;
}

.mt-0 {
  margin-top: 0 !important;
}

.mt-1 {
  margin-top: 0.25rem !important;
}

.mt-2 {
  margin-top: 0.5rem !important;
}

.mt-3 {
  margin-top: 1rem !important;
}

.mt-4 {
  margin-top: 1.5rem !important;
}

.mt-5 {
  margin-top: 3rem !important;
}

.mt-auto {
  margin-top: auto !important;
}

.me-0 {
  margin-right: 0 !important;
}

.me-1 {
  margin-right: 0.25rem !important;
}

.me-2 {
  margin-right: 0.5rem !important;
}

.me-3 {
  margin-right: 1rem !important;
}

.me-4 {
  margin-right: 1.5rem !important;
}

.me-5 {
  margin-right: 3rem !important;
}

.me-auto {
  margin-right: auto !important;
}

.mb-0 {
  margin-bottom: 0 !important;
}

.mb-1 {
  margin-bottom: 0.25rem !important;
}

.mb-2 {
  margin-bottom: 0.5rem !important;
}

.mb-3 {
  margin-bottom: 1rem !important;
}

.mb-4 {
  margin-bottom: 1.5rem !important;
}

.mb-5 {
  margin-bottom: 3rem !important;
}

.mb-auto {
  margin-bottom: auto !important;
}

.ms-0 {
  margin-left: 0 !important;
}

.ms-1 {
  margin-left: 0.25rem !important;
}

.ms-2 {
  margin-left: 0.5rem !important;
}

.ms-3 {
  margin-left: 1rem !important;
}

.ms-4 {
  margin-left: 1.5rem !important;
}

.ms-5 {
  margin-left: 3rem !important;
}

.ms-auto {
  margin-left: auto !important;
}

.p-0 {
  padding: 0 !important;
}

.p-1 {
  padding: 0.25rem !important;
}

.p-2 {
  padding: 0.5rem !important;
}

.p-3 {
  padding: 1rem !important;
}

.p-4 {
  padding: 1.5rem !important;
}

.p-5 {
  padding: 3rem !important;
}

.px-0 {
  padding-right: 0 !important;
  padding-left: 0 !important;
}

.px-1 {
  padding-right: 0.25rem !important;
  padding-left: 0.25rem !important;
}

.px-2 {
  padding-right: 0.5rem !important;
  padding-left: 0.5rem !important;
}

.px-3 {
  padding-right: 1rem !important;
  padding-left: 1rem !important;
}

.px-4 {
  padding-right: 1.5rem !important;
  padding-left: 1.5rem !important;
}

.px-5 {
  padding-right: 3rem !important;
  padding-left: 3rem !important;
}

.py-0 {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}

.py-1 {
  padding-top: 0.25rem !important;
  padding-bottom: 0.25rem !important;
}

.py-2 {
  padding-top: 0.5rem !important;
  padding-bottom: 0.5rem !important;
}

.py-3 {
  padding-top: 1rem !important;
  padding-bottom: 1rem !important;
}

.py-4 {
  padding-top: 1.5rem !important;
  padding-bottom: 1.5rem !important;
}

.py-5 {
  padding-top: 3rem !important;
  padding-bottom: 3rem !important;
}

.pt-0 {
  padding-top: 0 !important;
}

.pt-1 {
  padding-top: 0.25rem !important;
}

.pt-2 {
  padding-top: 0.5rem !important;
}

.pt-3 {
  padding-top: 1rem !important;
}

.pt-4 {
  padding-top: 1.5rem !important;
}

.pt-5 {
  padding-top: 3rem !important;
}

.pe-0 {
  padding-right: 0 !important;
}

.pe-1 {
  padding-right: 0.25rem !important;
}

.pe-2 {
  padding-right: 0.5rem !important;
}

.pe-3 {
  padding-right: 1rem !important;
}

.pe-4 {
  padding-right: 1.5rem !important;
}

.pe-5 {
  padding-right: 3rem !important;
}

.pb-0 {
  padding-bottom: 0 !important;
}

.pb-1 {
  padding-bottom: 0.25rem !important;
}

.pb-2 {
  padding-bottom: 0.5rem !important;
}

.pb-3 {
  padding-bottom: 1rem !important;
}

.pb-4 {
  padding-bottom: 1.5rem !important;
}

.pb-5 {
  padding-bottom: 3rem !important;
}

.ps-0 {
  padding-left: 0 !important;
}

.ps-1 {
  padding-left: 0.25rem !important;
}

.ps-2 {
  padding-left: 0.5rem !important;
}

.ps-3 {
  padding-left: 1rem !important;
}

.ps-4 {
  padding-left: 1.5rem !important;
}

.ps-5 {
  padding-left: 3rem !important;
}

.gap-0 {
  gap: 0 !important;
}

.gap-1 {
  gap: 0.25rem !important;
}

.gap-2 {
  gap: 0.5rem !important;
}

.gap-3 {
  gap: 1rem !important;
}

.gap-4 {
  gap: 1.5rem !important;
}

.gap-5 {
  gap: 3rem !important;
}

.font-monospace {
  font-family: var(--bs-font-monospace) !important;
}

.fs-1 {
  font-size: calc(1.375rem + 1.5vw) !important;
}

.fs-2 {
  font-size: calc(1.325rem + 0.9vw) !important;
}

.fs-3 {
  font-size: calc(1.3rem + 0.6vw) !important;
}

.fs-4 {
  font-size: calc(1.275rem + 0.3vw) !important;
}

.fs-5 {
  font-size: 1.25rem !important;
}

.fs-6 {
  font-size: 1rem !important;
}

.fst-italic {
  font-style: italic !important;
}

.fst-normal {
  font-style: normal !important;
}

.fw-light {
  font-weight: 300 !important;
}

.fw-lighter {
  font-weight: lighter !important;
}

.fw-normal {
  font-weight: 400 !important;
}

.fw-bold {
  font-weight: 700 !important;
}

.fw-semibold {
  font-weight: 600 !important;
}

.fw-bolder {
  font-weight: bolder !important;
}

.lh-1 {
  line-height: 1 !important;
}

.lh-sm {
  line-height: 1.25 !important;
}

.lh-base {
  line-height: 1.5 !important;
}

.lh-lg {
  line-height: 2 !important;
}

.text-start {
  text-align: left !important;
}

.text-end {
  text-align: right !important;
}

.text-center {
  text-align: center !important;
}

.text-decoration-none {
  text-decoration: none !important;
}

.text-decoration-underline {
  text-decoration: underline !important;
}

.text-decoration-line-through {
  text-decoration: line-through !important;
}

.text-lowercase {
  text-transform: lowercase !important;
}

.text-uppercase {
  text-transform: uppercase !important;
}

.text-capitalize {
  text-transform: capitalize !important;
}

.text-wrap {
  white-space: normal !important;
}

.text-nowrap {
  white-space: nowrap !important;
}

.text-break {
  word-wrap: break-word !important;
  word-break: break-word !important;
}

.text-primary {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-primary-rgb), var(--bs-text-opacity)) !important;
}

.text-secondary {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-secondary-rgb), var(--bs-text-opacity)) !important;
}

.text-success {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-success-rgb), var(--bs-text-opacity)) !important;
}

.text-info {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-info-rgb), var(--bs-text-opacity)) !important;
}

.text-warning {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-warning-rgb), var(--bs-text-opacity)) !important;
}

.text-danger {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-danger-rgb), var(--bs-text-opacity)) !important;
}

.text-light {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-light-rgb), var(--bs-text-opacity)) !important;
}

.text-dark {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-dark-rgb), var(--bs-text-opacity)) !important;
}

.text-black {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-black-rgb), var(--bs-text-opacity)) !important;
}

.text-white {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-white-rgb), var(--bs-text-opacity)) !important;
}

.text-body {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-body-color-rgb), var(--bs-text-opacity)) !important;
}

.text-muted {
  --bs-text-opacity: 1;
  color: #6c757d !important;
}

.text-black-50 {
  --bs-text-opacity: 1;
  color: rgba(0, 0, 0, 0.5) !important;
}

.text-white-50 {
  --bs-text-opacity: 1;
  color: rgba(255, 255, 255, 0.5) !important;
}

.text-reset {
  --bs-text-opacity: 1;
  color: inherit !important;
}

.text-opacity-25 {
  --bs-text-opacity: 0.25 ;
}

.text-opacity-50 {
  --bs-text-opacity: 0.5 ;
}

.text-opacity-75 {
  --bs-text-opacity: 0.75 ;
}

.text-opacity-100 {
  --bs-text-opacity: 1 ;
}

.bg-primary {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-primary-rgb), var(--bs-bg-opacity)) !important;
}

.bg-secondary {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-secondary-rgb), var(--bs-bg-opacity)) !important;
}

.bg-success {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-success-rgb), var(--bs-bg-opacity)) !important;
}

.bg-info {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-info-rgb), var(--bs-bg-opacity)) !important;
}

.bg-warning {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-warning-rgb), var(--bs-bg-opacity)) !important;
}

.bg-danger {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-danger-rgb), var(--bs-bg-opacity)) !important;
}

.bg-light {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-light-rgb), var(--bs-bg-opacity)) !important;
}

.bg-dark {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-dark-rgb), var(--bs-bg-opacity)) !important;
}

.bg-black {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-black-rgb), var(--bs-bg-opacity)) !important;
}

.bg-white {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-white-rgb), var(--bs-bg-opacity)) !important;
}

.bg-body {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-body-bg-rgb), var(--bs-bg-opacity)) !important;
}

.bg-transparent {
  --bs-bg-opacity: 1;
  background-color: transparent !important;
}

.bg-opacity-10 {
  --bs-bg-opacity: 0.1 ;
}

.bg-opacity-25 {
  --bs-bg-opacity: 0.25 ;
}

.bg-opacity-50 {
  --bs-bg-opacity: 0.5 ;
}

.bg-opacity-75 {
  --bs-bg-opacity: 0.75 ;
}

.bg-opacity-100 {
  --bs-bg-opacity: 1 ;
}

.bg-gradient {
  background-image: var(--bs-gradient) !important;
}

.user-select-all {
  -webkit-user-select: all !important;
  user-select: all !important;
}

.user-select-auto {
  -webkit-user-select: auto !important;
  user-select: auto !important;
}

.user-select-none {
  -webkit-user-select: none !important;
  user-select: none !important;
}

.pe-none {
  pointer-events: none !important;
}

.pe-auto {
  pointer-events: auto !important;
}

.rounded {
  border-radius: var(--bs-border-radius) !important;
}

.rounded-0 {
  border-radius: 0 !important;
}

.rounded-1 {
  border-radius: var(--bs-border-radius-sm) !important;
}

.rounded-2 {
  border-radius: var(--bs-border-radius) !important;
}

.rounded-3 {
  border-radius: var(--bs-border-radius-lg) !important;
}

.rounded-4 {
  border-radius: var(--bs-border-radius-xl) !important;
}

.rounded-5 {
  border-radius: var(--bs-border-radius-2xl) !important;
}

.rounded-circle {
  border-radius: 50% !important;
}

.rounded-pill {
  border-radius: var(--bs-border-radius-pill) !important;
}

.rounded-top {
  border-top-left-radius: var(--bs-border-radius) !important;
  border-top-right-radius: var(--bs-border-radius) !important;
}

.rounded-end {
  border-top-right-radius: var(--bs-border-radius) !important;
  border-bottom-right-radius: var(--bs-border-radius) !important;
}

.rounded-bottom {
  border-bottom-right-radius: var(--bs-border-radius) !important;
  border-bottom-left-radius: var(--bs-border-radius) !important;
}

.rounded-start {
  border-bottom-left-radius: var(--bs-border-radius) !important;
  border-top-left-radius: var(--bs-border-radius) !important;
}

.visible {
  visibility: visible !important;
}

.invisible {
  visibility: hidden !important;
}

@media (min-width: 576px) {
  .float-sm-start {
    float: left !important;
  }
  .float-sm-end {
    float: right !important;
  }
  .float-sm-none {
    float: none !important;
  }
  .d-sm-inline {
    display: inline !important;
  }
  .d-sm-inline-block {
    display: inline-block !important;
  }
  .d-sm-block {
    display: block !important;
  }
  .d-sm-grid {
    display: grid !important;
  }
  .d-sm-table {
    display: table !important;
  }
  .d-sm-table-row {
    display: table-row !important;
  }
  .d-sm-table-cell {
    display: table-cell !important;
  }
  .d-sm-flex {
    display: flex !important;
  }
  .d-sm-inline-flex {
    display: inline-flex !important;
  }
  .d-sm-none {
    display: none !important;
  }
  .flex-sm-fill {
    flex: 1 1 auto !important;
  }
  .flex-sm-row {
    flex-direction: row !important;
  }
  .flex-sm-column {
    flex-direction: column !important;
  }
  .flex-sm-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-sm-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-sm-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-sm-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-sm-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-sm-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-sm-wrap {
    flex-wrap: wrap !important;
  }
  .flex-sm-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-sm-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-sm-start {
    justify-content: flex-start !important;
  }
  .justify-content-sm-end {
    justify-content: flex-end !important;
  }
  .justify-content-sm-center {
    justify-content: center !important;
  }
  .justify-content-sm-between {
    justify-content: space-between !important;
  }
  .justify-content-sm-around {
    justify-content: space-around !important;
  }
  .justify-content-sm-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-sm-start {
    align-items: flex-start !important;
  }
  .align-items-sm-end {
    align-items: flex-end !important;
  }
  .align-items-sm-center {
    align-items: center !important;
  }
  .align-items-sm-baseline {
    align-items: baseline !important;
  }
  .align-items-sm-stretch {
    align-items: stretch !important;
  }
  .align-content-sm-start {
    align-content: flex-start !important;
  }
  .align-content-sm-end {
    align-content: flex-end !important;
  }
  .align-content-sm-center {
    align-content: center !important;
  }
  .align-content-sm-between {
    align-content: space-between !important;
  }
  .align-content-sm-around {
    align-content: space-around !important;
  }
  .align-content-sm-stretch {
    align-content: stretch !important;
  }
  .align-self-sm-auto {
    align-self: auto !important;
  }
  .align-self-sm-start {
    align-self: flex-start !important;
  }
  .align-self-sm-end {
    align-self: flex-end !important;
  }
  .align-self-sm-center {
    align-self: center !important;
  }
  .align-self-sm-baseline {
    align-self: baseline !important;
  }
  .align-self-sm-stretch {
    align-self: stretch !important;
  }
  .order-sm-first {
    order: -1 !important;
  }
  .order-sm-0 {
    order: 0 !important;
  }
  .order-sm-1 {
    order: 1 !important;
  }
  .order-sm-2 {
    order: 2 !important;
  }
  .order-sm-3 {
    order: 3 !important;
  }
  .order-sm-4 {
    order: 4 !important;
  }
  .order-sm-5 {
    order: 5 !important;
  }
  .order-sm-last {
    order: 6 !important;
  }
  .m-sm-0 {
    margin: 0 !important;
  }
  .m-sm-1 {
    margin: 0.25rem !important;
  }
  .m-sm-2 {
    margin: 0.5rem !important;
  }
  .m-sm-3 {
    margin: 1rem !important;
  }
  .m-sm-4 {
    margin: 1.5rem !important;
  }
  .m-sm-5 {
    margin: 3rem !important;
  }
  .m-sm-auto {
    margin: auto !important;
  }
  .mx-sm-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-sm-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-sm-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-sm-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-sm-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-sm-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-sm-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-sm-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-sm-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-sm-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-sm-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-sm-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-sm-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-sm-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-sm-0 {
    margin-top: 0 !important;
  }
  .mt-sm-1 {
    margin-top: 0.25rem !important;
  }
  .mt-sm-2 {
    margin-top: 0.5rem !important;
  }
  .mt-sm-3 {
    margin-top: 1rem !important;
  }
  .mt-sm-4 {
    margin-top: 1.5rem !important;
  }
  .mt-sm-5 {
    margin-top: 3rem !important;
  }
  .mt-sm-auto {
    margin-top: auto !important;
  }
  .me-sm-0 {
    margin-right: 0 !important;
  }
  .me-sm-1 {
    margin-right: 0.25rem !important;
  }
  .me-sm-2 {
    margin-right: 0.5rem !important;
  }
  .me-sm-3 {
    margin-right: 1rem !important;
  }
  .me-sm-4 {
    margin-right: 1.5rem !important;
  }
  .me-sm-5 {
    margin-right: 3rem !important;
  }
  .me-sm-auto {
    margin-right: auto !important;
  }
  .mb-sm-0 {
    margin-bottom: 0 !important;
  }
  .mb-sm-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-sm-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-sm-3 {
    margin-bottom: 1rem !important;
  }
  .mb-sm-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-sm-5 {
    margin-bottom: 3rem !important;
  }
  .mb-sm-auto {
    margin-bottom: auto !important;
  }
  .ms-sm-0 {
    margin-left: 0 !important;
  }
  .ms-sm-1 {
    margin-left: 0.25rem !important;
  }
  .ms-sm-2 {
    margin-left: 0.5rem !important;
  }
  .ms-sm-3 {
    margin-left: 1rem !important;
  }
  .ms-sm-4 {
    margin-left: 1.5rem !important;
  }
  .ms-sm-5 {
    margin-left: 3rem !important;
  }
  .ms-sm-auto {
    margin-left: auto !important;
  }
  .p-sm-0 {
    padding: 0 !important;
  }
  .p-sm-1 {
    padding: 0.25rem !important;
  }
  .p-sm-2 {
    padding: 0.5rem !important;
  }
  .p-sm-3 {
    padding: 1rem !important;
  }
  .p-sm-4 {
    padding: 1.5rem !important;
  }
  .p-sm-5 {
    padding: 3rem !important;
  }
  .px-sm-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-sm-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-sm-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-sm-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-sm-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-sm-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .py-sm-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-sm-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-sm-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-sm-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-sm-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-sm-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .pt-sm-0 {
    padding-top: 0 !important;
  }
  .pt-sm-1 {
    padding-top: 0.25rem !important;
  }
  .pt-sm-2 {
    padding-top: 0.5rem !important;
  }
  .pt-sm-3 {
    padding-top: 1rem !important;
  }
  .pt-sm-4 {
    padding-top: 1.5rem !important;
  }
  .pt-sm-5 {
    padding-top: 3rem !important;
  }
  .pe-sm-0 {
    padding-right: 0 !important;
  }
  .pe-sm-1 {
    padding-right: 0.25rem !important;
  }
  .pe-sm-2 {
    padding-right: 0.5rem !important;
  }
  .pe-sm-3 {
    padding-right: 1rem !important;
  }
  .pe-sm-4 {
    padding-right: 1.5rem !important;
  }
  .pe-sm-5 {
    padding-right: 3rem !important;
  }
  .pb-sm-0 {
    padding-bottom: 0 !important;
  }
  .pb-sm-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-sm-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-sm-3 {
    padding-bottom: 1rem !important;
  }
  .pb-sm-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-sm-5 {
    padding-bottom: 3rem !important;
  }
  .ps-sm-0 {
    padding-left: 0 !important;
  }
  .ps-sm-1 {
    padding-left: 0.25rem !important;
  }
  .ps-sm-2 {
    padding-left: 0.5rem !important;
  }
  .ps-sm-3 {
    padding-left: 1rem !important;
  }
  .ps-sm-4 {
    padding-left: 1.5rem !important;
  }
  .ps-sm-5 {
    padding-left: 3rem !important;
  }
  .gap-sm-0 {
    gap: 0 !important;
  }
  .gap-sm-1 {
    gap: 0.25rem !important;
  }
  .gap-sm-2 {
    gap: 0.5rem !important;
  }
  .gap-sm-3 {
    gap: 1rem !important;
  }
  .gap-sm-4 {
    gap: 1.5rem !important;
  }
  .gap-sm-5 {
    gap: 3rem !important;
  }
  .text-sm-start {
    text-align: left !important;
  }
  .text-sm-end {
    text-align: right !important;
  }
  .text-sm-center {
    text-align: center !important;
  }
}
@media (min-width: 768px) {
  .float-md-start {
    float: left !important;
  }
  .float-md-end {
    float: right !important;
  }
  .float-md-none {
    float: none !important;
  }
  .d-md-inline {
    display: inline !important;
  }
  .d-md-inline-block {
    display: inline-block !important;
  }
  .d-md-block {
    display: block !important;
  }
  .d-md-grid {
    display: grid !important;
  }
  .d-md-table {
    display: table !important;
  }
  .d-md-table-row {
    display: table-row !important;
  }
  .d-md-table-cell {
    display: table-cell !important;
  }
  .d-md-flex {
    display: flex !important;
  }
  .d-md-inline-flex {
    display: inline-flex !important;
  }
  .d-md-none {
    display: none !important;
  }
  .flex-md-fill {
    flex: 1 1 auto !important;
  }
  .flex-md-row {
    flex-direction: row !important;
  }
  .flex-md-column {
    flex-direction: column !important;
  }
  .flex-md-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-md-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-md-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-md-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-md-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-md-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-md-wrap {
    flex-wrap: wrap !important;
  }
  .flex-md-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-md-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-md-start {
    justify-content: flex-start !important;
  }
  .justify-content-md-end {
    justify-content: flex-end !important;
  }
  .justify-content-md-center {
    justify-content: center !important;
  }
  .justify-content-md-between {
    justify-content: space-between !important;
  }
  .justify-content-md-around {
    justify-content: space-around !important;
  }
  .justify-content-md-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-md-start {
    align-items: flex-start !important;
  }
  .align-items-md-end {
    align-items: flex-end !important;
  }
  .align-items-md-center {
    align-items: center !important;
  }
  .align-items-md-baseline {
    align-items: baseline !important;
  }
  .align-items-md-stretch {
    align-items: stretch !important;
  }
  .align-content-md-start {
    align-content: flex-start !important;
  }
  .align-content-md-end {
    align-content: flex-end !important;
  }
  .align-content-md-center {
    align-content: center !important;
  }
  .align-content-md-between {
    align-content: space-between !important;
  }
  .align-content-md-around {
    align-content: space-around !important;
  }
  .align-content-md-stretch {
    align-content: stretch !important;
  }
  .align-self-md-auto {
    align-self: auto !important;
  }
  .align-self-md-start {
    align-self: flex-start !important;
  }
  .align-self-md-end {
    align-self: flex-end !important;
  }
  .align-self-md-center {
    align-self: center !important;
  }
  .align-self-md-baseline {
    align-self: baseline !important;
  }
  .align-self-md-stretch {
    align-self: stretch !important;
  }
  .order-md-first {
    order: -1 !important;
  }
  .order-md-0 {
    order: 0 !important;
  }
  .order-md-1 {
    order: 1 !important;
  }
  .order-md-2 {
    order: 2 !important;
  }
  .order-md-3 {
    order: 3 !important;
  }
  .order-md-4 {
    order: 4 !important;
  }
  .order-md-5 {
    order: 5 !important;
  }
  .order-md-last {
    order: 6 !important;
  }
  .m-md-0 {
    margin: 0 !important;
  }
  .m-md-1 {
    margin: 0.25rem !important;
  }
  .m-md-2 {
    margin: 0.5rem !important;
  }
  .m-md-3 {
    margin: 1rem !important;
  }
  .m-md-4 {
    margin: 1.5rem !important;
  }
  .m-md-5 {
    margin: 3rem !important;
  }
  .m-md-auto {
    margin: auto !important;
  }
  .mx-md-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-md-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-md-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-md-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-md-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-md-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-md-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-md-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-md-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-md-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-md-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-md-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-md-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-md-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-md-0 {
    margin-top: 0 !important;
  }
  .mt-md-1 {
    margin-top: 0.25rem !important;
  }
  .mt-md-2 {
    margin-top: 0.5rem !important;
  }
  .mt-md-3 {
    margin-top: 1rem !important;
  }
  .mt-md-4 {
    margin-top: 1.5rem !important;
  }
  .mt-md-5 {
    margin-top: 3rem !important;
  }
  .mt-md-auto {
    margin-top: auto !important;
  }
  .me-md-0 {
    margin-right: 0 !important;
  }
  .me-md-1 {
    margin-right: 0.25rem !important;
  }
  .me-md-2 {
    margin-right: 0.5rem !important;
  }
  .me-md-3 {
    margin-right: 1rem !important;
  }
  .me-md-4 {
    margin-right: 1.5rem !important;
  }
  .me-md-5 {
    margin-right: 3rem !important;
  }
  .me-md-auto {
    margin-right: auto !important;
  }
  .mb-md-0 {
    margin-bottom: 0 !important;
  }
  .mb-md-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-md-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-md-3 {
    margin-bottom: 1rem !important;
  }
  .mb-md-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-md-5 {
    margin-bottom: 3rem !important;
  }
  .mb-md-auto {
    margin-bottom: auto !important;
  }
  .ms-md-0 {
    margin-left: 0 !important;
  }
  .ms-md-1 {
    margin-left: 0.25rem !important;
  }
  .ms-md-2 {
    margin-left: 0.5rem !important;
  }
  .ms-md-3 {
    margin-left: 1rem !important;
  }
  .ms-md-4 {
    margin-left: 1.5rem !important;
  }
  .ms-md-5 {
    margin-left: 3rem !important;
  }
  .ms-md-auto {
    margin-left: auto !important;
  }
  .p-md-0 {
    padding: 0 !important;
  }
  .p-md-1 {
    padding: 0.25rem !important;
  }
  .p-md-2 {
    padding: 0.5rem !important;
  }
  .p-md-3 {
    padding: 1rem !important;
  }
  .p-md-4 {
    padding: 1.5rem !important;
  }
  .p-md-5 {
    padding: 3rem !important;
  }
  .px-md-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-md-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-md-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-md-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-md-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-md-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .py-md-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-md-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-md-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-md-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-md-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-md-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .pt-md-0 {
    padding-top: 0 !important;
  }
  .pt-md-1 {
    padding-top: 0.25rem !important;
  }
  .pt-md-2 {
    padding-top: 0.5rem !important;
  }
  .pt-md-3 {
    padding-top: 1rem !important;
  }
  .pt-md-4 {
    padding-top: 1.5rem !important;
  }
  .pt-md-5 {
    padding-top: 3rem !important;
  }
  .pe-md-0 {
    padding-right: 0 !important;
  }
  .pe-md-1 {
    padding-right: 0.25rem !important;
  }
  .pe-md-2 {
    padding-right: 0.5rem !important;
  }
  .pe-md-3 {
    padding-right: 1rem !important;
  }
  .pe-md-4 {
    padding-right: 1.5rem !important;
  }
  .pe-md-5 {
    padding-right: 3rem !important;
  }
  .pb-md-0 {
    padding-bottom: 0 !important;
  }
  .pb-md-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-md-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-md-3 {
    padding-bottom: 1rem !important;
  }
  .pb-md-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-md-5 {
    padding-bottom: 3rem !important;
  }
  .ps-md-0 {
    padding-left: 0 !important;
  }
  .ps-md-1 {
    padding-left: 0.25rem !important;
  }
  .ps-md-2 {
    padding-left: 0.5rem !important;
  }
  .ps-md-3 {
    padding-left: 1rem !important;
  }
  .ps-md-4 {
    padding-left: 1.5rem !important;
  }
  .ps-md-5 {
    padding-left: 3rem !important;
  }
  .gap-md-0 {
    gap: 0 !important;
  }
  .gap-md-1 {
    gap: 0.25rem !important;
  }
  .gap-md-2 {
    gap: 0.5rem !important;
  }
  .gap-md-3 {
    gap: 1rem !important;
  }
  .gap-md-4 {
    gap: 1.5rem !important;
  }
  .gap-md-5 {
    gap: 3rem !important;
  }
  .text-md-start {
    text-align: left !important;
  }
  .text-md-end {
    text-align: right !important;
  }
  .text-md-center {
    text-align: center !important;
  }
}
@media (min-width: 992px) {
  .float-lg-start {
    float: left !important;
  }
  .float-lg-end {
    float: right !important;
  }
  .float-lg-none {
    float: none !important;
  }
  .d-lg-inline {
    display: inline !important;
  }
  .d-lg-inline-block {
    display: inline-block !important;
  }
  .d-lg-block {
    display: block !important;
  }
  .d-lg-grid {
    display: grid !important;
  }
  .d-lg-table {
    display: table !important;
  }
  .d-lg-table-row {
    display: table-row !important;
  }
  .d-lg-table-cell {
    display: table-cell !important;
  }
  .d-lg-flex {
    display: flex !important;
  }
  .d-lg-inline-flex {
    display: inline-flex !important;
  }
  .d-lg-none {
    display: none !important;
  }
  .flex-lg-fill {
    flex: 1 1 auto !important;
  }
  .flex-lg-row {
    flex-direction: row !important;
  }
  .flex-lg-column {
    flex-direction: column !important;
  }
  .flex-lg-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-lg-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-lg-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-lg-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-lg-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-lg-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-lg-wrap {
    flex-wrap: wrap !important;
  }
  .flex-lg-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-lg-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-lg-start {
    justify-content: flex-start !important;
  }
  .justify-content-lg-end {
    justify-content: flex-end !important;
  }
  .justify-content-lg-center {
    justify-content: center !important;
  }
  .justify-content-lg-between {
    justify-content: space-between !important;
  }
  .justify-content-lg-around {
    justify-content: space-around !important;
  }
  .justify-content-lg-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-lg-start {
    align-items: flex-start !important;
  }
  .align-items-lg-end {
    align-items: flex-end !important;
  }
  .align-items-lg-center {
    align-items: center !important;
  }
  .align-items-lg-baseline {
    align-items: baseline !important;
  }
  .align-items-lg-stretch {
    align-items: stretch !important;
  }
  .align-content-lg-start {
    align-content: flex-start !important;
  }
  .align-content-lg-end {
    align-content: flex-end !important;
  }
  .align-content-lg-center {
    align-content: center !important;
  }
  .align-content-lg-between {
    align-content: space-between !important;
  }
  .align-content-lg-around {
    align-content: space-around !important;
  }
  .align-content-lg-stretch {
    align-content: stretch !important;
  }
  .align-self-lg-auto {
    align-self: auto !important;
  }
  .align-self-lg-start {
    align-self: flex-start !important;
  }
  .align-self-lg-end {
    align-self: flex-end !important;
  }
  .align-self-lg-center {
    align-self: center !important;
  }
  .align-self-lg-baseline {
    align-self: baseline !important;
  }
  .align-self-lg-stretch {
    align-self: stretch !important;
  }
  .order-lg-first {
    order: -1 !important;
  }
  .order-lg-0 {
    order: 0 !important;
  }
  .order-lg-1 {
    order: 1 !important;
  }
  .order-lg-2 {
    order: 2 !important;
  }
  .order-lg-3 {
    order: 3 !important;
  }
  .order-lg-4 {
    order: 4 !important;
  }
  .order-lg-5 {
    order: 5 !important;
  }
  .order-lg-last {
    order: 6 !important;
  }
  .m-lg-0 {
    margin: 0 !important;
  }
  .m-lg-1 {
    margin: 0.25rem !important;
  }
  .m-lg-2 {
    margin: 0.5rem !important;
  }
  .m-lg-3 {
    margin: 1rem !important;
  }
  .m-lg-4 {
    margin: 1.5rem !important;
  }
  .m-lg-5 {
    margin: 3rem !important;
  }
  .m-lg-auto {
    margin: auto !important;
  }
  .mx-lg-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-lg-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-lg-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-lg-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-lg-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-lg-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-lg-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-lg-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-lg-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-lg-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-lg-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-lg-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-lg-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-lg-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-lg-0 {
    margin-top: 0 !important;
  }
  .mt-lg-1 {
    margin-top: 0.25rem !important;
  }
  .mt-lg-2 {
    margin-top: 0.5rem !important;
  }
  .mt-lg-3 {
    margin-top: 1rem !important;
  }
  .mt-lg-4 {
    margin-top: 1.5rem !important;
  }
  .mt-lg-5 {
    margin-top: 3rem !important;
  }
  .mt-lg-auto {
    margin-top: auto !important;
  }
  .me-lg-0 {
    margin-right: 0 !important;
  }
  .me-lg-1 {
    margin-right: 0.25rem !important;
  }
  .me-lg-2 {
    margin-right: 0.5rem !important;
  }
  .me-lg-3 {
    margin-right: 1rem !important;
  }
  .me-lg-4 {
    margin-right: 1.5rem !important;
  }
  .me-lg-5 {
    margin-right: 3rem !important;
  }
  .me-lg-auto {
    margin-right: auto !important;
  }
  .mb-lg-0 {
    margin-bottom: 0 !important;
  }
  .mb-lg-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-lg-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-lg-3 {
    margin-bottom: 1rem !important;
  }
  .mb-lg-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-lg-5 {
    margin-bottom: 3rem !important;
  }
  .mb-lg-auto {
    margin-bottom: auto !important;
  }
  .ms-lg-0 {
    margin-left: 0 !important;
  }
  .ms-lg-1 {
    margin-left: 0.25rem !important;
  }
  .ms-lg-2 {
    margin-left: 0.5rem !important;
  }
  .ms-lg-3 {
    margin-left: 1rem !important;
  }
  .ms-lg-4 {
    margin-left: 1.5rem !important;
  }
  .ms-lg-5 {
    margin-left: 3rem !important;
  }
  .ms-lg-auto {
    margin-left: auto !important;
  }
  .p-lg-0 {
    padding: 0 !important;
  }
  .p-lg-1 {
    padding: 0.25rem !important;
  }
  .p-lg-2 {
    padding: 0.5rem !important;
  }
  .p-lg-3 {
    padding: 1rem !important;
  }
  .p-lg-4 {
    padding: 1.5rem !important;
  }
  .p-lg-5 {
    padding: 3rem !important;
  }
  .px-lg-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-lg-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-lg-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-lg-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-lg-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-lg-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .py-lg-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-lg-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-lg-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-lg-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-lg-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-lg-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .pt-lg-0 {
    padding-top: 0 !important;
  }
  .pt-lg-1 {
    padding-top: 0.25rem !important;
  }
  .pt-lg-2 {
    padding-top: 0.5rem !important;
  }
  .pt-lg-3 {
    padding-top: 1rem !important;
  }
  .pt-lg-4 {
    padding-top: 1.5rem !important;
  }
  .pt-lg-5 {
    padding-top: 3rem !important;
  }
  .pe-lg-0 {
    padding-right: 0 !important;
  }
  .pe-lg-1 {
    padding-right: 0.25rem !important;
  }
  .pe-lg-2 {
    padding-right: 0.5rem !important;
  }
  .pe-lg-3 {
    padding-right: 1rem !important;
  }
  .pe-lg-4 {
    padding-right: 1.5rem !important;
  }
  .pe-lg-5 {
    padding-right: 3rem !important;
  }
  .pb-lg-0 {
    padding-bottom: 0 !important;
  }
  .pb-lg-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-lg-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-lg-3 {
    padding-bottom: 1rem !important;
  }
  .pb-lg-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-lg-5 {
    padding-bottom: 3rem !important;
  }
  .ps-lg-0 {
    padding-left: 0 !important;
  }
  .ps-lg-1 {
    padding-left: 0.25rem !important;
  }
  .ps-lg-2 {
    padding-left: 0.5rem !important;
  }
  .ps-lg-3 {
    padding-left: 1rem !important;
  }
  .ps-lg-4 {
    padding-left: 1.5rem !important;
  }
  .ps-lg-5 {
    padding-left: 3rem !important;
  }
  .gap-lg-0 {
    gap: 0 !important;
  }
  .gap-lg-1 {
    gap: 0.25rem !important;
  }
  .gap-lg-2 {
    gap: 0.5rem !important;
  }
  .gap-lg-3 {
    gap: 1rem !important;
  }
  .gap-lg-4 {
    gap: 1.5rem !important;
  }
  .gap-lg-5 {
    gap: 3rem !important;
  }
  .text-lg-start {
    text-align: left !important;
  }
  .text-lg-end {
    text-align: right !important;
  }
  .text-lg-center {
    text-align: center !important;
  }
}
@media (min-width: 1200px) {
  .float-xl-start {
    float: left !important;
  }
  .float-xl-end {
    float: right !important;
  }
  .float-xl-none {
    float: none !important;
  }
  .d-xl-inline {
    display: inline !important;
  }
  .d-xl-inline-block {
    display: inline-block !important;
  }
  .d-xl-block {
    display: block !important;
  }
  .d-xl-grid {
    display: grid !important;
  }
  .d-xl-table {
    display: table !important;
  }
  .d-xl-table-row {
    display: table-row !important;
  }
  .d-xl-table-cell {
    display: table-cell !important;
  }
  .d-xl-flex {
    display: flex !important;
  }
  .d-xl-inline-flex {
    display: inline-flex !important;
  }
  .d-xl-none {
    display: none !important;
  }
  .flex-xl-fill {
    flex: 1 1 auto !important;
  }
  .flex-xl-row {
    flex-direction: row !important;
  }
  .flex-xl-column {
    flex-direction: column !important;
  }
  .flex-xl-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-xl-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-xl-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-xl-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-xl-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-xl-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-xl-wrap {
    flex-wrap: wrap !important;
  }
  .flex-xl-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-xl-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-xl-start {
    justify-content: flex-start !important;
  }
  .justify-content-xl-end {
    justify-content: flex-end !important;
  }
  .justify-content-xl-center {
    justify-content: center !important;
  }
  .justify-content-xl-between {
    justify-content: space-between !important;
  }
  .justify-content-xl-around {
    justify-content: space-around !important;
  }
  .justify-content-xl-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-xl-start {
    align-items: flex-start !important;
  }
  .align-items-xl-end {
    align-items: flex-end !important;
  }
  .align-items-xl-center {
    align-items: center !important;
  }
  .align-items-xl-baseline {
    align-items: baseline !important;
  }
  .align-items-xl-stretch {
    align-items: stretch !important;
  }
  .align-content-xl-start {
    align-content: flex-start !important;
  }
  .align-content-xl-end {
    align-content: flex-end !important;
  }
  .align-content-xl-center {
    align-content: center !important;
  }
  .align-content-xl-between {
    align-content: space-between !important;
  }
  .align-content-xl-around {
    align-content: space-around !important;
  }
  .align-content-xl-stretch {
    align-content: stretch !important;
  }
  .align-self-xl-auto {
    align-self: auto !important;
  }
  .align-self-xl-start {
    align-self: flex-start !important;
  }
  .align-self-xl-end {
    align-self: flex-end !important;
  }
  .align-self-xl-center {
    align-self: center !important;
  }
  .align-self-xl-baseline {
    align-self: baseline !important;
  }
  .align-self-xl-stretch {
    align-self: stretch !important;
  }
  .order-xl-first {
    order: -1 !important;
  }
  .order-xl-0 {
    order: 0 !important;
  }
  .order-xl-1 {
    order: 1 !important;
  }
  .order-xl-2 {
    order: 2 !important;
  }
  .order-xl-3 {
    order: 3 !important;
  }
  .order-xl-4 {
    order: 4 !important;
  }
  .order-xl-5 {
    order: 5 !important;
  }
  .order-xl-last {
    order: 6 !important;
  }
  .m-xl-0 {
    margin: 0 !important;
  }
  .m-xl-1 {
    margin: 0.25rem !important;
  }
  .m-xl-2 {
    margin: 0.5rem !important;
  }
  .m-xl-3 {
    margin: 1rem !important;
  }
  .m-xl-4 {
    margin: 1.5rem !important;
  }
  .m-xl-5 {
    margin: 3rem !important;
  }
  .m-xl-auto {
    margin: auto !important;
  }
  .mx-xl-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-xl-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-xl-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-xl-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-xl-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-xl-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-xl-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-xl-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-xl-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-xl-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-xl-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-xl-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-xl-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-xl-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-xl-0 {
    margin-top: 0 !important;
  }
  .mt-xl-1 {
    margin-top: 0.25rem !important;
  }
  .mt-xl-2 {
    margin-top: 0.5rem !important;
  }
  .mt-xl-3 {
    margin-top: 1rem !important;
  }
  .mt-xl-4 {
    margin-top: 1.5rem !important;
  }
  .mt-xl-5 {
    margin-top: 3rem !important;
  }
  .mt-xl-auto {
    margin-top: auto !important;
  }
  .me-xl-0 {
    margin-right: 0 !important;
  }
  .me-xl-1 {
    margin-right: 0.25rem !important;
  }
  .me-xl-2 {
    margin-right: 0.5rem !important;
  }
  .me-xl-3 {
    margin-right: 1rem !important;
  }
  .me-xl-4 {
    margin-right: 1.5rem !important;
  }
  .me-xl-5 {
    margin-right: 3rem !important;
  }
  .me-xl-auto {
    margin-right: auto !important;
  }
  .mb-xl-0 {
    margin-bottom: 0 !important;
  }
  .mb-xl-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-xl-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-xl-3 {
    margin-bottom: 1rem !important;
  }
  .mb-xl-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-xl-5 {
    margin-bottom: 3rem !important;
  }
  .mb-xl-auto {
    margin-bottom: auto !important;
  }
  .ms-xl-0 {
    margin-left: 0 !important;
  }
  .ms-xl-1 {
    margin-left: 0.25rem !important;
  }
  .ms-xl-2 {
    margin-left: 0.5rem !important;
  }
  .ms-xl-3 {
    margin-left: 1rem !important;
  }
  .ms-xl-4 {
    margin-left: 1.5rem !important;
  }
  .ms-xl-5 {
    margin-left: 3rem !important;
  }
  .ms-xl-auto {
    margin-left: auto !important;
  }
  .p-xl-0 {
    padding: 0 !important;
  }
  .p-xl-1 {
    padding: 0.25rem !important;
  }
  .p-xl-2 {
    padding: 0.5rem !important;
  }
  .p-xl-3 {
    padding: 1rem !important;
  }
  .p-xl-4 {
    padding: 1.5rem !important;
  }
  .p-xl-5 {
    padding: 3rem !important;
  }
  .px-xl-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-xl-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-xl-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-xl-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-xl-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-xl-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .py-xl-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-xl-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-xl-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-xl-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-xl-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-xl-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .pt-xl-0 {
    padding-top: 0 !important;
  }
  .pt-xl-1 {
    padding-top: 0.25rem !important;
  }
  .pt-xl-2 {
    padding-top: 0.5rem !important;
  }
  .pt-xl-3 {
    padding-top: 1rem !important;
  }
  .pt-xl-4 {
    padding-top: 1.5rem !important;
  }
  .pt-xl-5 {
    padding-top: 3rem !important;
  }
  .pe-xl-0 {
    padding-right: 0 !important;
  }
  .pe-xl-1 {
    padding-right: 0.25rem !important;
  }
  .pe-xl-2 {
    padding-right: 0.5rem !important;
  }
  .pe-xl-3 {
    padding-right: 1rem !important;
  }
  .pe-xl-4 {
    padding-right: 1.5rem !important;
  }
  .pe-xl-5 {
    padding-right: 3rem !important;
  }
  .pb-xl-0 {
    padding-bottom: 0 !important;
  }
  .pb-xl-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-xl-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-xl-3 {
    padding-bottom: 1rem !important;
  }
  .pb-xl-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-xl-5 {
    padding-bottom: 3rem !important;
  }
  .ps-xl-0 {
    padding-left: 0 !important;
  }
  .ps-xl-1 {
    padding-left: 0.25rem !important;
  }
  .ps-xl-2 {
    padding-left: 0.5rem !important;
  }
  .ps-xl-3 {
    padding-left: 1rem !important;
  }
  .ps-xl-4 {
    padding-left: 1.5rem !important;
  }
  .ps-xl-5 {
    padding-left: 3rem !important;
  }
  .gap-xl-0 {
    gap: 0 !important;
  }
  .gap-xl-1 {
    gap: 0.25rem !important;
  }
  .gap-xl-2 {
    gap: 0.5rem !important;
  }
  .gap-xl-3 {
    gap: 1rem !important;
  }
  .gap-xl-4 {
    gap: 1.5rem !important;
  }
  .gap-xl-5 {
    gap: 3rem !important;
  }
  .text-xl-start {
    text-align: left !important;
  }
  .text-xl-end {
    text-align: right !important;
  }
  .text-xl-center {
    text-align: center !important;
  }
}
@media (min-width: 1400px) {
  .float-xxl-start {
    float: left !important;
  }
  .float-xxl-end {
    float: right !important;
  }
  .float-xxl-none {
    float: none !important;
  }
  .d-xxl-inline {
    display: inline !important;
  }
  .d-xxl-inline-block {
    display: inline-block !important;
  }
  .d-xxl-block {
    display: block !important;
  }
  .d-xxl-grid {
    display: grid !important;
  }
  .d-xxl-table {
    display: table !important;
  }
  .d-xxl-table-row {
    display: table-row !important;
  }
  .d-xxl-table-cell {
    display: table-cell !important;
  }
  .d-xxl-flex {
    display: flex !important;
  }
  .d-xxl-inline-flex {
    display: inline-flex !important;
  }
  .d-xxl-none {
    display: none !important;
  }
  .flex-xxl-fill {
    flex: 1 1 auto !important;
  }
  .flex-xxl-row {
    flex-direction: row !important;
  }
  .flex-xxl-column {
    flex-direction: column !important;
  }
  .flex-xxl-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-xxl-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-xxl-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-xxl-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-xxl-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-xxl-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-xxl-wrap {
    flex-wrap: wrap !important;
  }
  .flex-xxl-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-xxl-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-xxl-start {
    justify-content: flex-start !important;
  }
  .justify-content-xxl-end {
    justify-content: flex-end !important;
  }
  .justify-content-xxl-center {
    justify-content: center !important;
  }
  .justify-content-xxl-between {
    justify-content: space-between !important;
  }
  .justify-content-xxl-around {
    justify-content: space-around !important;
  }
  .justify-content-xxl-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-xxl-start {
    align-items: flex-start !important;
  }
  .align-items-xxl-end {
    align-items: flex-end !important;
  }
  .align-items-xxl-center {
    align-items: center !important;
  }
  .align-items-xxl-baseline {
    align-items: baseline !important;
  }
  .align-items-xxl-stretch {
    align-items: stretch !important;
  }
  .align-content-xxl-start {
    align-content: flex-start !important;
  }
  .align-content-xxl-end {
    align-content: flex-end !important;
  }
  .align-content-xxl-center {
    align-content: center !important;
  }
  .align-content-xxl-between {
    align-content: space-between !important;
  }
  .align-content-xxl-around {
    align-content: space-around !important;
  }
  .align-content-xxl-stretch {
    align-content: stretch !important;
  }
  .align-self-xxl-auto {
    align-self: auto !important;
  }
  .align-self-xxl-start {
    align-self: flex-start !important;
  }
  .align-self-xxl-end {
    align-self: flex-end !important;
  }
  .align-self-xxl-center {
    align-self: center !important;
  }
  .align-self-xxl-baseline {
    align-self: baseline !important;
  }
  .align-self-xxl-stretch {
    align-self: stretch !important;
  }
  .order-xxl-first {
    order: -1 !important;
  }
  .order-xxl-0 {
    order: 0 !important;
  }
  .order-xxl-1 {
    order: 1 !important;
  }
  .order-xxl-2 {
    order: 2 !important;
  }
  .order-xxl-3 {
    order: 3 !important;
  }
  .order-xxl-4 {
    order: 4 !important;
  }
  .order-xxl-5 {
    order: 5 !important;
  }
  .order-xxl-last {
    order: 6 !important;
  }
  .m-xxl-0 {
    margin: 0 !important;
  }
  .m-xxl-1 {
    margin: 0.25rem !important;
  }
  .m-xxl-2 {
    margin: 0.5rem !important;
  }
  .m-xxl-3 {
    margin: 1rem !important;
  }
  .m-xxl-4 {
    margin: 1.5rem !important;
  }
  .m-xxl-5 {
    margin: 3rem !important;
  }
  .m-xxl-auto {
    margin: auto !important;
  }
  .mx-xxl-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-xxl-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-xxl-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-xxl-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-xxl-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-xxl-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-xxl-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-xxl-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-xxl-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-xxl-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-xxl-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-xxl-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-xxl-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-xxl-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-xxl-0 {
    margin-top: 0 !important;
  }
  .mt-xxl-1 {
    margin-top: 0.25rem !important;
  }
  .mt-xxl-2 {
    margin-top: 0.5rem !important;
  }
  .mt-xxl-3 {
    margin-top: 1rem !important;
  }
  .mt-xxl-4 {
    margin-top: 1.5rem !important;
  }
  .mt-xxl-5 {
    margin-top: 3rem !important;
  }
  .mt-xxl-auto {
    margin-top: auto !important;
  }
  .me-xxl-0 {
    margin-right: 0 !important;
  }
  .me-xxl-1 {
    margin-right: 0.25rem !important;
  }
  .me-xxl-2 {
    margin-right: 0.5rem !important;
  }
  .me-xxl-3 {
    margin-right: 1rem !important;
  }
  .me-xxl-4 {
    margin-right: 1.5rem !important;
  }
  .me-xxl-5 {
    margin-right: 3rem !important;
  }
  .me-xxl-auto {
    margin-right: auto !important;
  }
  .mb-xxl-0 {
    margin-bottom: 0 !important;
  }
  .mb-xxl-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-xxl-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-xxl-3 {
    margin-bottom: 1rem !important;
  }
  .mb-xxl-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-xxl-5 {
    margin-bottom: 3rem !important;
  }
  .mb-xxl-auto {
    margin-bottom: auto !important;
  }
  .ms-xxl-0 {
    margin-left: 0 !important;
  }
  .ms-xxl-1 {
    margin-left: 0.25rem !important;
  }
  .ms-xxl-2 {
    margin-left: 0.5rem !important;
  }
  .ms-xxl-3 {
    margin-left: 1rem !important;
  }
  .ms-xxl-4 {
    margin-left: 1.5rem !important;
  }
  .ms-xxl-5 {
    margin-left: 3rem !important;
  }
  .ms-xxl-auto {
    margin-left: auto !important;
  }
  .p-xxl-0 {
    padding: 0 !important;
  }
  .p-xxl-1 {
    padding: 0.25rem !important;
  }
  .p-xxl-2 {
    padding: 0.5rem !important;
  }
  .p-xxl-3 {
    padding: 1rem !important;
  }
  .p-xxl-4 {
    padding: 1.5rem !important;
  }
  .p-xxl-5 {
    padding: 3rem !important;
  }
  .px-xxl-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-xxl-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-xxl-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-xxl-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-xxl-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-xxl-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .py-xxl-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-xxl-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-xxl-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-xxl-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-xxl-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-xxl-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .pt-xxl-0 {
    padding-top: 0 !important;
  }
  .pt-xxl-1 {
    padding-top: 0.25rem !important;
  }
  .pt-xxl-2 {
    padding-top: 0.5rem !important;
  }
  .pt-xxl-3 {
    padding-top: 1rem !important;
  }
  .pt-xxl-4 {
    padding-top: 1.5rem !important;
  }
  .pt-xxl-5 {
    padding-top: 3rem !important;
  }
  .pe-xxl-0 {
    padding-right: 0 !important;
  }
  .pe-xxl-1 {
    padding-right: 0.25rem !important;
  }
  .pe-xxl-2 {
    padding-right: 0.5rem !important;
  }
  .pe-xxl-3 {
    padding-right: 1rem !important;
  }
  .pe-xxl-4 {
    padding-right: 1.5rem !important;
  }
  .pe-xxl-5 {
    padding-right: 3rem !important;
  }
  .pb-xxl-0 {
    padding-bottom: 0 !important;
  }
  .pb-xxl-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-xxl-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-xxl-3 {
    padding-bottom: 1rem !important;
  }
  .pb-xxl-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-xxl-5 {
    padding-bottom: 3rem !important;
  }
  .ps-xxl-0 {
    padding-left: 0 !important;
  }
  .ps-xxl-1 {
    padding-left: 0.25rem !important;
  }
  .ps-xxl-2 {
    padding-left: 0.5rem !important;
  }
  .ps-xxl-3 {
    padding-left: 1rem !important;
  }
  .ps-xxl-4 {
    padding-left: 1.5rem !important;
  }
  .ps-xxl-5 {
    padding-left: 3rem !important;
  }
  .gap-xxl-0 {
    gap: 0 !important;
  }
  .gap-xxl-1 {
    gap: 0.25rem !important;
  }
  .gap-xxl-2 {
    gap: 0.5rem !important;
  }
  .gap-xxl-3 {
    gap: 1rem !important;
  }
  .gap-xxl-4 {
    gap: 1.5rem !important;
  }
  .gap-xxl-5 {
    gap: 3rem !important;
  }
  .text-xxl-start {
    text-align: left !important;
  }
  .text-xxl-end {
    text-align: right !important;
  }
  .text-xxl-center {
    text-align: center !important;
  }
}
@media (min-width: 1200px) {
  .fs-1 {
    font-size: 2.5rem !important;
  }
  .fs-2 {
    font-size: 2rem !important;
  }
  .fs-3 {
    font-size: 1.75rem !important;
  }
  .fs-4 {
    font-size: 1.5rem !important;
  }
}
@media print {
  .d-print-inline {
    display: inline !important;
  }
  .d-print-inline-block {
    display: inline-block !important;
  }
  .d-print-block {
    display: block !important;
  }
  .d-print-grid {
    display: grid !important;
  }
  .d-print-table {
    display: table !important;
  }
  .d-print-table-row {
    display: table-row !important;
  }
  .d-print-table-cell {
    display: table-cell !important;
  }
  .d-print-flex {
    display: flex !important;
  }
  .d-print-inline-flex {
    display: inline-flex !important;
  }
  .d-print-none {
    display: none !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/assets/css/bootstrap.min.css"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;;;;;EAAA;AAMA;EACI,kBAAA;EACA,oBAAA;EACA,oBAAA;EACA,kBAAA;EACA,iBAAA;EACA,oBAAA;EACA,oBAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,uBAAA;EACA,sBAAA;EACA,sBAAA;EACA,sBAAA;EACA,sBAAA;EACA,sBAAA;EACA,sBAAA;EACA,sBAAA;EACA,sBAAA;EACA,sBAAA;EACA,qBAAA;EACA,uBAAA;EACA,qBAAA;EACA,kBAAA;EACA,qBAAA;EACA,oBAAA;EACA,mBAAA;EACA,kBAAA;EACA,8BAAA;EACA,iCAAA;EACA,6BAAA;EACA,2BAAA;EACA,6BAAA;EACA,4BAAA;EACA,6BAAA;EACA,yBAAA;EACA,6BAAA;EACA,uBAAA;EACA,+BAAA;EACA,+BAAA;EACA,qNAAA;EACA,yGAAA;EACA,yFAAA;EACA,gDAAA;EACA,yBAAA;EACA,0BAAA;EACA,0BAAA;EACA,wBAAA;EACA,kBAAA;EACA,sBAAA;EACA,wBAAA;EACA,0BAAA;EACA,mDAAA;EACA,4BAAA;EACA,8BAAA;EACA,6BAAA;EACA,2BAAA;EACA,4BAAA;EACA,8BAAA;EACA,wBAAA;EACA,8BAAA;EACA,wBAAA;EACA,2BAAA;AAEJ;;AACA;;;EAGI,sBAAA;AAEJ;;AACA;EACI;IACI,uBAAA;EAEN;AACF;AACA;EACI,SAAA;EACA,uCAAA;EACA,mCAAA;EACA,uCAAA;EACA,uCAAA;EACA,2BAAA;EACA,qCAAA;EACA,mCAAA;EACA,8BAAA;EACA,wCAAA;AACJ;;AAEA;EACI,cAAA;EACA,cAAA;EACA,SAAA;EACA,qBAAA;EACA,aAAA;AACJ;;AAEA;;;;;;;;;;;;EAYI,aAAA;EACA,qBAAA;EACA,gBAAA;EACA,gBAAA;AACJ;;AAEA;;EAEI,iCAAA;AACJ;;AAEA;EAEI;;IAEI,iBAAA;EAAN;AACF;AAGA;;EAEI,iCAAA;AADJ;;AAIA;EAEI;;IAEI,eAAA;EAFN;AACF;AAKA;;EAEI,+BAAA;AAHJ;;AAMA;EAEI;;IAEI,kBAAA;EAJN;AACF;AAOA;;EAEI,iCAAA;AALJ;;AAQA;EAEI;;IAEI,iBAAA;EANN;AACF;AASA;;EAEI,kBAAA;AAPJ;;AAUA;;EAEI,eAAA;AAPJ;;AAUA;EACI,aAAA;EACA,mBAAA;AAPJ;;AAUA;EACI,yCAAA;EACA,iCAAA;EACA,YAAA;EAEA,8BAAA;AAPJ;;AAUA;EACI,mBAAA;EACA,kBAAA;EACA,oBAAA;AAPJ;;AAUA;;EAEI,kBAAA;AAPJ;;AAUA;;;EAGI,aAAA;EACA,mBAAA;AAPJ;;AAUA;;;;EAII,gBAAA;AAPJ;;AAUA;EACI,gBAAA;AAPJ;;AAUA;EACI,qBAAA;EACA,cAAA;AAPJ;;AAUA;EACI,gBAAA;AAPJ;;AAUA;;EAEI,mBAAA;AAPJ;;AAUA;;EAEI,kBAAA;AAPJ;;AAUA;;EAEI,iBAAA;EACA,wCAAA;AAPJ;;AAUA;;EAEI,kBAAA;EACA,iBAAA;EACA,cAAA;EACA,wBAAA;AAPJ;;AAUA;EACI,eAAA;AAPJ;;AAUA;EACI,WAAA;AAPJ;;AAUA;EACI,2BAAA;EACA,0BAAA;AAPJ;;AAUA;EACI,iCAAA;AAPJ;;AAUA;;EAEI,cAAA;EACA,qBAAA;AAPJ;;AAUA;;;;EAII,qCAAA;EACA,cAAA;AAPJ;;AAUA;EACI,cAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;AAPJ;;AAUA;EACI,kBAAA;EACA,cAAA;EACA,kBAAA;AAPJ;;AAUA;EACI,kBAAA;EACA,2BAAA;EACA,qBAAA;AAPJ;;AAUA;EACI,cAAA;AAPJ;;AAUA;EACI,2BAAA;EACA,kBAAA;EACA,wBAAA;EACA,sCAAA;EACA,sBAAA;AAPJ;;AAUA;EACI,UAAA;EACA,cAAA;AAPJ;;AAUA;EACI,gBAAA;AAPJ;;AAUA;;EAEI,sBAAA;AAPJ;;AAUA;EACI,oBAAA;EACA,yBAAA;AAPJ;;AAUA;EACI,mBAAA;EACA,sBAAA;EACA,cAAA;EACA,gBAAA;AAPJ;;AAUA;EACI,mBAAA;EACA,gCAAA;AAPJ;;AAUA;;;;;;EAMI,qBAAA;EACA,mBAAA;EACA,eAAA;AAPJ;;AAUA;EACI,qBAAA;AAPJ;;AAUA;EACI,gBAAA;AAPJ;;AAUA;EACI,UAAA;AAPJ;;AAUA;;;;;EAKI,SAAA;EACA,oBAAA;EACA,kBAAA;EACA,oBAAA;AAPJ;;AAUA;;EAEI,oBAAA;AAPJ;;AAUA;EACI,eAAA;AAPJ;;AAUA;EACI,iBAAA;AAPJ;;AAUA;EACI,UAAA;AAPJ;;AAUA;EACI,wBAAA;AAPJ;;AAUA;;;;EAII,0BAAA;AAPJ;;AAUA;;;;EAII,eAAA;AAPJ;;AAUA;EACI,UAAA;EACA,kBAAA;AAPJ;;AAUA;EACI,gBAAA;AAPJ;;AAUA;EACI,YAAA;EACA,UAAA;EACA,SAAA;EACA,SAAA;AAPJ;;AAUA;EACI,WAAA;EACA,WAAA;EACA,UAAA;EACA,qBAAA;EACA,iCAAA;EACA,oBAAA;AAPJ;;AAUA;EACI;IACI,iBAAA;EAPN;AACF;AAUA;EACI,WAAA;AARJ;;AAWA;;;;;;;EAOI,UAAA;AARJ;;AAWA;EACI,YAAA;AARJ;;AAWA;EACI,oBAAA;EACA,6BAAA;AARJ;;AAWA;EACI,wBAAA;AARJ;;AAWA;EACI,UAAA;AARJ;;AAgBA;EACI,aAAA;EACA,0BAAA;AARJ;;AAWA;EACI,qBAAA;AARJ;;AAWA;EACI,SAAA;AARJ;;AAWA;EACI,kBAAA;EACA,eAAA;AARJ;;AAWA;EACI,wBAAA;AARJ;;AAWA;EACI,wBAAA;AARJ;;AAWA;EACI,kBAAA;EACA,gBAAA;AARJ;;AAWA;EACI,iCAAA;EACA,gBAAA;EACA,gBAAA;AARJ;;AAWA;EACI;IACI,eAAA;EARN;AACF;AAWA;EACI,iCAAA;EACA,gBAAA;EACA,gBAAA;AATJ;;AAYA;EACI;IACI,iBAAA;EATN;AACF;AAYA;EACI,iCAAA;EACA,gBAAA;EACA,gBAAA;AAVJ;;AAaA;EACI;IACI,eAAA;EAVN;AACF;AAaA;EACI,iCAAA;EACA,gBAAA;EACA,gBAAA;AAXJ;;AAcA;EACI;IACI,iBAAA;EAXN;AACF;AAcA;EACI,iCAAA;EACA,gBAAA;EACA,gBAAA;AAZJ;;AAeA;EACI;IACI,eAAA;EAZN;AACF;AAeA;EACI,iCAAA;EACA,gBAAA;EACA,gBAAA;AAbJ;;AAgBA;EACI;IACI,iBAAA;EAbN;AACF;AAgBA;EACI,eAAA;EACA,gBAAA;AAdJ;;AAiBA;EACI,eAAA;EACA,gBAAA;AAdJ;;AAiBA;EACI,qBAAA;AAdJ;;AAiBA;EACI,oBAAA;AAdJ;;AAiBA;EACI,kBAAA;EACA,yBAAA;AAdJ;;AAiBA;EACI,mBAAA;EACA,kBAAA;AAdJ;;AAiBA;EACI,gBAAA;AAdJ;;AAiBA;EACI,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,cAAA;AAdJ;;AAiBA;EACI,aAAA;AAdJ;;AAiBA;EACI,eAAA;EACA,YAAA;AAdJ;;AAiBA;EACI,gBAAA;EACA,sBAAA;EACA,wCAAA;EACA,uBAAA;EACA,eAAA;EACA,YAAA;AAdJ;;AAiBA;EACI,qBAAA;AAdJ;;AAiBA;EACI,qBAAA;EACA,cAAA;AAdJ;;AAiBA;EACI,kBAAA;EACA,cAAA;AAdJ;;AAiBA;;;;;;;EAOI,qBAAA;EACA,gBAAA;EACA,WAAA;EACA,6CAAA;EACA,4CAAA;EACA,kBAAA;EACA,iBAAA;AAdJ;;AAiBA;EAEI;;IAEI,gBAAA;EAfN;AACF;AAkBA;EAEI;;;IAGI,gBAAA;EAjBN;AACF;AAoBA;EAEI;;;;IAII,gBAAA;EAnBN;AACF;AAsBA;EAEI;;;;;IAKI,iBAAA;EArBN;AACF;AAwBA;EAEI;;;;;;IAMI,iBAAA;EAvBN;AACF;AA0BA;EACI,qBAAA;EACA,gBAAA;EACA,aAAA;EACA,eAAA;EACA,yCAAA;EACA,6CAAA;EACA,4CAAA;AAxBJ;;AA2BA;EACI,cAAA;EACA,WAAA;EACA,eAAA;EACA,6CAAA;EACA,4CAAA;EACA,8BAAA;AAxBJ;;AA2BA;EACI,SAAA;AAxBJ;;AA2BA;EACI,cAAA;EACA,WAAA;AAxBJ;;AA2BA;EACI,cAAA;EACA,WAAA;AAxBJ;;AA2BA;EACI,cAAA;EACA,UAAA;AAxBJ;;AA2BA;EACI,cAAA;EACA,qBAAA;AAxBJ;;AA2BA;EACI,cAAA;EACA,UAAA;AAxBJ;;AA2BA;EACI,cAAA;EACA,UAAA;AAxBJ;;AA2BA;EACI,cAAA;EACA,qBAAA;AAxBJ;;AA2BA;EACI,cAAA;EACA,WAAA;AAxBJ;;AA2BA;EACI,cAAA;EACA,kBAAA;AAxBJ;;AA2BA;EACI,cAAA;EACA,mBAAA;AAxBJ;;AA2BA;EACI,cAAA;EACA,UAAA;AAxBJ;;AA2BA;EACI,cAAA;EACA,mBAAA;AAxBJ;;AA2BA;EACI,cAAA;EACA,mBAAA;AAxBJ;;AA2BA;EACI,cAAA;EACA,UAAA;AAxBJ;;AA2BA;EACI,cAAA;EACA,mBAAA;AAxBJ;;AA2BA;EACI,cAAA;EACA,mBAAA;AAxBJ;;AA2BA;EACI,cAAA;EACA,UAAA;AAxBJ;;AA2BA;EACI,cAAA;EACA,mBAAA;AAxBJ;;AA2BA;EACI,cAAA;EACA,mBAAA;AAxBJ;;AA2BA;EACI,cAAA;EACA,WAAA;AAxBJ;;AA2BA;EACI,wBAAA;AAxBJ;;AA2BA;EACI,yBAAA;AAxBJ;;AA2BA;EACI,gBAAA;AAxBJ;;AA2BA;EACI,yBAAA;AAxBJ;;AA2BA;EACI,yBAAA;AAxBJ;;AA2BA;EACI,gBAAA;AAxBJ;;AA2BA;EACI,yBAAA;AAxBJ;;AA2BA;EACI,yBAAA;AAxBJ;;AA2BA;EACI,gBAAA;AAxBJ;;AA2BA;EACI,yBAAA;AAxBJ;;AA2BA;EACI,yBAAA;AAxBJ;;AA2BA;;EAEI,iBAAA;AAxBJ;;AA2BA;;EAEI,iBAAA;AAxBJ;;AA2BA;;EAEI,uBAAA;AAxBJ;;AA2BA;;EAEI,uBAAA;AAxBJ;;AA2BA;;EAEI,sBAAA;AAxBJ;;AA2BA;;EAEI,sBAAA;AAxBJ;;AA2BA;;EAEI,oBAAA;AAxBJ;;AA2BA;;EAEI,oBAAA;AAxBJ;;AA2BA;;EAEI,sBAAA;AAxBJ;;AA2BA;;EAEI,sBAAA;AAxBJ;;AA2BA;;EAEI,oBAAA;AAxBJ;;AA2BA;;EAEI,oBAAA;AAxBJ;;AA2BA;EACI;IACI,SAAA;EAxBN;EA2BE;IACI,cAAA;IACA,WAAA;EAzBN;EA4BE;IACI,cAAA;IACA,WAAA;EA1BN;EA6BE;IACI,cAAA;IACA,UAAA;EA3BN;EA8BE;IACI,cAAA;IACA,qBAAA;EA5BN;EA+BE;IACI,cAAA;IACA,UAAA;EA7BN;EAgCE;IACI,cAAA;IACA,UAAA;EA9BN;EAiCE;IACI,cAAA;IACA,qBAAA;EA/BN;EAkCE;IACI,cAAA;IACA,WAAA;EAhCN;EAmCE;IACI,cAAA;IACA,kBAAA;EAjCN;EAoCE;IACI,cAAA;IACA,mBAAA;EAlCN;EAqCE;IACI,cAAA;IACA,UAAA;EAnCN;EAsCE;IACI,cAAA;IACA,mBAAA;EApCN;EAuCE;IACI,cAAA;IACA,mBAAA;EArCN;EAwCE;IACI,cAAA;IACA,UAAA;EAtCN;EAyCE;IACI,cAAA;IACA,mBAAA;EAvCN;EA0CE;IACI,cAAA;IACA,mBAAA;EAxCN;EA2CE;IACI,cAAA;IACA,UAAA;EAzCN;EA4CE;IACI,cAAA;IACA,mBAAA;EA1CN;EA6CE;IACI,cAAA;IACA,mBAAA;EA3CN;EA8CE;IACI,cAAA;IACA,WAAA;EA5CN;EA+CE;IACI,cAAA;EA7CN;EAgDE;IACI,wBAAA;EA9CN;EAiDE;IACI,yBAAA;EA/CN;EAkDE;IACI,gBAAA;EAhDN;EAmDE;IACI,yBAAA;EAjDN;EAoDE;IACI,yBAAA;EAlDN;EAqDE;IACI,gBAAA;EAnDN;EAsDE;IACI,yBAAA;EApDN;EAuDE;IACI,yBAAA;EArDN;EAwDE;IACI,gBAAA;EAtDN;EAyDE;IACI,yBAAA;EAvDN;EA0DE;IACI,yBAAA;EAxDN;EA2DE;;IAEI,iBAAA;EAzDN;EA4DE;;IAEI,iBAAA;EA1DN;EA6DE;;IAEI,uBAAA;EA3DN;EA8DE;;IAEI,uBAAA;EA5DN;EA+DE;;IAEI,sBAAA;EA7DN;EAgEE;;IAEI,sBAAA;EA9DN;EAiEE;;IAEI,oBAAA;EA/DN;EAkEE;;IAEI,oBAAA;EAhEN;EAmEE;;IAEI,sBAAA;EAjEN;EAoEE;;IAEI,sBAAA;EAlEN;EAqEE;;IAEI,oBAAA;EAnEN;EAsEE;;IAEI,oBAAA;EApEN;AACF;AAuEA;EACI;IACI,SAAA;EArEN;EAwEE;IACI,cAAA;IACA,WAAA;EAtEN;EAyEE;IACI,cAAA;IACA,WAAA;EAvEN;EA0EE;IACI,cAAA;IACA,UAAA;EAxEN;EA2EE;IACI,cAAA;IACA,qBAAA;EAzEN;EA4EE;IACI,cAAA;IACA,UAAA;EA1EN;EA6EE;IACI,cAAA;IACA,UAAA;EA3EN;EA8EE;IACI,cAAA;IACA,qBAAA;EA5EN;EA+EE;IACI,cAAA;IACA,WAAA;EA7EN;EAgFE;IACI,cAAA;IACA,kBAAA;EA9EN;EAiFE;IACI,cAAA;IACA,mBAAA;EA/EN;EAkFE;IACI,cAAA;IACA,UAAA;EAhFN;EAmFE;IACI,cAAA;IACA,mBAAA;EAjFN;EAoFE;IACI,cAAA;IACA,mBAAA;EAlFN;EAqFE;IACI,cAAA;IACA,UAAA;EAnFN;EAsFE;IACI,cAAA;IACA,mBAAA;EApFN;EAuFE;IACI,cAAA;IACA,mBAAA;EArFN;EAwFE;IACI,cAAA;IACA,UAAA;EAtFN;EAyFE;IACI,cAAA;IACA,mBAAA;EAvFN;EA0FE;IACI,cAAA;IACA,mBAAA;EAxFN;EA2FE;IACI,cAAA;IACA,WAAA;EAzFN;EA4FE;IACI,cAAA;EA1FN;EA6FE;IACI,wBAAA;EA3FN;EA8FE;IACI,yBAAA;EA5FN;EA+FE;IACI,gBAAA;EA7FN;EAgGE;IACI,yBAAA;EA9FN;EAiGE;IACI,yBAAA;EA/FN;EAkGE;IACI,gBAAA;EAhGN;EAmGE;IACI,yBAAA;EAjGN;EAoGE;IACI,yBAAA;EAlGN;EAqGE;IACI,gBAAA;EAnGN;EAsGE;IACI,yBAAA;EApGN;EAuGE;IACI,yBAAA;EArGN;EAwGE;;IAEI,iBAAA;EAtGN;EAyGE;;IAEI,iBAAA;EAvGN;EA0GE;;IAEI,uBAAA;EAxGN;EA2GE;;IAEI,uBAAA;EAzGN;EA4GE;;IAEI,sBAAA;EA1GN;EA6GE;;IAEI,sBAAA;EA3GN;EA8GE;;IAEI,oBAAA;EA5GN;EA+GE;;IAEI,oBAAA;EA7GN;EAgHE;;IAEI,sBAAA;EA9GN;EAiHE;;IAEI,sBAAA;EA/GN;EAkHE;;IAEI,oBAAA;EAhHN;EAmHE;;IAEI,oBAAA;EAjHN;AACF;AAoHA;EACI;IACI,SAAA;EAlHN;EAqHE;IACI,cAAA;IACA,WAAA;EAnHN;EAsHE;IACI,cAAA;IACA,WAAA;EApHN;EAuHE;IACI,cAAA;IACA,UAAA;EArHN;EAwHE;IACI,cAAA;IACA,qBAAA;EAtHN;EAyHE;IACI,cAAA;IACA,UAAA;EAvHN;EA0HE;IACI,cAAA;IACA,UAAA;EAxHN;EA2HE;IACI,cAAA;IACA,qBAAA;EAzHN;EA4HE;IACI,cAAA;IACA,WAAA;EA1HN;EA6HE;IACI,cAAA;IACA,kBAAA;EA3HN;EA8HE;IACI,cAAA;IACA,mBAAA;EA5HN;EA+HE;IACI,cAAA;IACA,UAAA;EA7HN;EAgIE;IACI,cAAA;IACA,mBAAA;EA9HN;EAiIE;IACI,cAAA;IACA,mBAAA;EA/HN;EAkIE;IACI,cAAA;IACA,UAAA;EAhIN;EAmIE;IACI,cAAA;IACA,mBAAA;EAjIN;EAoIE;IACI,cAAA;IACA,mBAAA;EAlIN;EAqIE;IACI,cAAA;IACA,UAAA;EAnIN;EAsIE;IACI,cAAA;IACA,mBAAA;EApIN;EAuIE;IACI,cAAA;IACA,mBAAA;EArIN;EAwIE;IACI,cAAA;IACA,WAAA;EAtIN;EAyIE;IACI,cAAA;EAvIN;EA0IE;IACI,wBAAA;EAxIN;EA2IE;IACI,yBAAA;EAzIN;EA4IE;IACI,gBAAA;EA1IN;EA6IE;IACI,yBAAA;EA3IN;EA8IE;IACI,yBAAA;EA5IN;EA+IE;IACI,gBAAA;EA7IN;EAgJE;IACI,yBAAA;EA9IN;EAiJE;IACI,yBAAA;EA/IN;EAkJE;IACI,gBAAA;EAhJN;EAmJE;IACI,yBAAA;EAjJN;EAoJE;IACI,yBAAA;EAlJN;EAqJE;;IAEI,iBAAA;EAnJN;EAsJE;;IAEI,iBAAA;EApJN;EAuJE;;IAEI,uBAAA;EArJN;EAwJE;;IAEI,uBAAA;EAtJN;EAyJE;;IAEI,sBAAA;EAvJN;EA0JE;;IAEI,sBAAA;EAxJN;EA2JE;;IAEI,oBAAA;EAzJN;EA4JE;;IAEI,oBAAA;EA1JN;EA6JE;;IAEI,sBAAA;EA3JN;EA8JE;;IAEI,sBAAA;EA5JN;EA+JE;;IAEI,oBAAA;EA7JN;EAgKE;;IAEI,oBAAA;EA9JN;AACF;AAiKA;EACI;IACI,SAAA;EA/JN;EAkKE;IACI,cAAA;IACA,WAAA;EAhKN;EAmKE;IACI,cAAA;IACA,WAAA;EAjKN;EAoKE;IACI,cAAA;IACA,UAAA;EAlKN;EAqKE;IACI,cAAA;IACA,qBAAA;EAnKN;EAsKE;IACI,cAAA;IACA,UAAA;EApKN;EAuKE;IACI,cAAA;IACA,UAAA;EArKN;EAwKE;IACI,cAAA;IACA,qBAAA;EAtKN;EAyKE;IACI,cAAA;IACA,WAAA;EAvKN;EA0KE;IACI,cAAA;IACA,kBAAA;EAxKN;EA2KE;IACI,cAAA;IACA,mBAAA;EAzKN;EA4KE;IACI,cAAA;IACA,UAAA;EA1KN;EA6KE;IACI,cAAA;IACA,mBAAA;EA3KN;EA8KE;IACI,cAAA;IACA,mBAAA;EA5KN;EA+KE;IACI,cAAA;IACA,UAAA;EA7KN;EAgLE;IACI,cAAA;IACA,mBAAA;EA9KN;EAiLE;IACI,cAAA;IACA,mBAAA;EA/KN;EAkLE;IACI,cAAA;IACA,UAAA;EAhLN;EAmLE;IACI,cAAA;IACA,mBAAA;EAjLN;EAoLE;IACI,cAAA;IACA,mBAAA;EAlLN;EAqLE;IACI,cAAA;IACA,WAAA;EAnLN;EAsLE;IACI,cAAA;EApLN;EAuLE;IACI,wBAAA;EArLN;EAwLE;IACI,yBAAA;EAtLN;EAyLE;IACI,gBAAA;EAvLN;EA0LE;IACI,yBAAA;EAxLN;EA2LE;IACI,yBAAA;EAzLN;EA4LE;IACI,gBAAA;EA1LN;EA6LE;IACI,yBAAA;EA3LN;EA8LE;IACI,yBAAA;EA5LN;EA+LE;IACI,gBAAA;EA7LN;EAgME;IACI,yBAAA;EA9LN;EAiME;IACI,yBAAA;EA/LN;EAkME;;IAEI,iBAAA;EAhMN;EAmME;;IAEI,iBAAA;EAjMN;EAoME;;IAEI,uBAAA;EAlMN;EAqME;;IAEI,uBAAA;EAnMN;EAsME;;IAEI,sBAAA;EApMN;EAuME;;IAEI,sBAAA;EArMN;EAwME;;IAEI,oBAAA;EAtMN;EAyME;;IAEI,oBAAA;EAvMN;EA0ME;;IAEI,sBAAA;EAxMN;EA2ME;;IAEI,sBAAA;EAzMN;EA4ME;;IAEI,oBAAA;EA1MN;EA6ME;;IAEI,oBAAA;EA3MN;AACF;AA8MA;EACI;IACI,SAAA;EA5MN;EA+ME;IACI,cAAA;IACA,WAAA;EA7MN;EAgNE;IACI,cAAA;IACA,WAAA;EA9MN;EAiNE;IACI,cAAA;IACA,UAAA;EA/MN;EAkNE;IACI,cAAA;IACA,qBAAA;EAhNN;EAmNE;IACI,cAAA;IACA,UAAA;EAjNN;EAoNE;IACI,cAAA;IACA,UAAA;EAlNN;EAqNE;IACI,cAAA;IACA,qBAAA;EAnNN;EAsNE;IACI,cAAA;IACA,WAAA;EApNN;EAuNE;IACI,cAAA;IACA,kBAAA;EArNN;EAwNE;IACI,cAAA;IACA,mBAAA;EAtNN;EAyNE;IACI,cAAA;IACA,UAAA;EAvNN;EA0NE;IACI,cAAA;IACA,mBAAA;EAxNN;EA2NE;IACI,cAAA;IACA,mBAAA;EAzNN;EA4NE;IACI,cAAA;IACA,UAAA;EA1NN;EA6NE;IACI,cAAA;IACA,mBAAA;EA3NN;EA8NE;IACI,cAAA;IACA,mBAAA;EA5NN;EA+NE;IACI,cAAA;IACA,UAAA;EA7NN;EAgOE;IACI,cAAA;IACA,mBAAA;EA9NN;EAiOE;IACI,cAAA;IACA,mBAAA;EA/NN;EAkOE;IACI,cAAA;IACA,WAAA;EAhON;EAmOE;IACI,cAAA;EAjON;EAoOE;IACI,wBAAA;EAlON;EAqOE;IACI,yBAAA;EAnON;EAsOE;IACI,gBAAA;EApON;EAuOE;IACI,yBAAA;EArON;EAwOE;IACI,yBAAA;EAtON;EAyOE;IACI,gBAAA;EAvON;EA0OE;IACI,yBAAA;EAxON;EA2OE;IACI,yBAAA;EAzON;EA4OE;IACI,gBAAA;EA1ON;EA6OE;IACI,yBAAA;EA3ON;EA8OE;IACI,yBAAA;EA5ON;EA+OE;;IAEI,iBAAA;EA7ON;EAgPE;;IAEI,iBAAA;EA9ON;EAiPE;;IAEI,uBAAA;EA/ON;EAkPE;;IAEI,uBAAA;EAhPN;EAmPE;;IAEI,sBAAA;EAjPN;EAoPE;;IAEI,sBAAA;EAlPN;EAqPE;;IAEI,oBAAA;EAnPN;EAsPE;;IAEI,oBAAA;EApPN;EAuPE;;IAEI,sBAAA;EArPN;EAwPE;;IAEI,sBAAA;EAtPN;EAyPE;;IAEI,oBAAA;EAvPN;EA0PE;;IAEI,oBAAA;EAxPN;AACF;AA2PA;EACI,sCAAA;EACA,0BAAA;EACA,+CAAA;EACA,iCAAA;EACA,8CAAA;EACA,0CAAA;EACA,6CAAA;EACA,wCAAA;EACA,4CAAA;EACA,yCAAA;EACA,WAAA;EACA,mBAAA;EACA,4BAAA;EACA,mBAAA;EACA,0CAAA;AAzPJ;;AA4PA;EACI,sBAAA;EACA,oCAAA;EACA,wBAAA;EACA,wDAAA;AAzPJ;;AA4PA;EACI,uBAAA;AAzPJ;;AA4PA;EACI,sBAAA;AAzPJ;;AA4PA;EACI,kCAAA;AAzPJ;;AA4PA;EACI,iBAAA;AAzPJ;;AA4PA;EACI,wBAAA;AAzPJ;;AA4PA;EACI,mBAAA;AAzPJ;;AA4PA;EACI,mBAAA;AAzPJ;;AA4PA;EACI,sBAAA;AAzPJ;;AA4PA;EACI,mBAAA;AAzPJ;;AA4PA;EACI,gDAAA;EACA,oCAAA;AAzPJ;;AA4PA;EACI,gDAAA;EACA,oCAAA;AAzPJ;;AA4PA;EACI,+CAAA;EACA,mCAAA;AAzPJ;;AA4PA;EACI,8CAAA;EACA,kCAAA;AAzPJ;;AA4PA;EACI,sBAAA;EACA,sBAAA;EACA,gCAAA;EACA,8BAAA;EACA,8BAAA;EACA,6BAAA;EACA,6BAAA;EACA,4BAAA;EACA,4BAAA;EACA,4BAAA;EACA,0CAAA;AAzPJ;;AA4PA;EACI,sBAAA;EACA,sBAAA;EACA,gCAAA;EACA,8BAAA;EACA,8BAAA;EACA,6BAAA;EACA,6BAAA;EACA,4BAAA;EACA,4BAAA;EACA,4BAAA;EACA,0CAAA;AAzPJ;;AA4PA;EACI,sBAAA;EACA,sBAAA;EACA,gCAAA;EACA,8BAAA;EACA,8BAAA;EACA,6BAAA;EACA,6BAAA;EACA,4BAAA;EACA,4BAAA;EACA,4BAAA;EACA,0CAAA;AAzPJ;;AA4PA;EACI,sBAAA;EACA,sBAAA;EACA,gCAAA;EACA,8BAAA;EACA,8BAAA;EACA,6BAAA;EACA,6BAAA;EACA,4BAAA;EACA,4BAAA;EACA,4BAAA;EACA,0CAAA;AAzPJ;;AA4PA;EACI,sBAAA;EACA,sBAAA;EACA,gCAAA;EACA,8BAAA;EACA,8BAAA;EACA,6BAAA;EACA,6BAAA;EACA,4BAAA;EACA,4BAAA;EACA,4BAAA;EACA,0CAAA;AAzPJ;;AA4PA;EACI,sBAAA;EACA,sBAAA;EACA,gCAAA;EACA,8BAAA;EACA,8BAAA;EACA,6BAAA;EACA,6BAAA;EACA,4BAAA;EACA,4BAAA;EACA,4BAAA;EACA,0CAAA;AAzPJ;;AA4PA;EACI,sBAAA;EACA,sBAAA;EACA,gCAAA;EACA,8BAAA;EACA,8BAAA;EACA,6BAAA;EACA,6BAAA;EACA,4BAAA;EACA,4BAAA;EACA,4BAAA;EACA,0CAAA;AAzPJ;;AA4PA;EACI,sBAAA;EACA,sBAAA;EACA,gCAAA;EACA,8BAAA;EACA,8BAAA;EACA,6BAAA;EACA,6BAAA;EACA,4BAAA;EACA,4BAAA;EACA,4BAAA;EACA,0CAAA;AAzPJ;;AA4PA;EACI,gBAAA;EACA,iCAAA;AAzPJ;;AA4PA;EACI;IACI,gBAAA;IACA,iCAAA;EAzPN;AACF;AA4PA;EACI;IACI,gBAAA;IACA,iCAAA;EA1PN;AACF;AA6PA;EACI;IACI,gBAAA;IACA,iCAAA;EA3PN;AACF;AA8PA;EACI;IACI,gBAAA;IACA,iCAAA;EA5PN;AACF;AA+PA;EACI;IACI,gBAAA;IACA,iCAAA;EA7PN;AACF;AAgQA;EACI,qBAAA;AA9PJ;;AAiQA;EACI,iCAAA;EACA,oCAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;AA9PJ;;AAiQA;EACI,+BAAA;EACA,kCAAA;EACA,kBAAA;AA9PJ;;AAiQA;EACI,gCAAA;EACA,mCAAA;EACA,mBAAA;AA9PJ;;AAiQA;EACI,mBAAA;EACA,kBAAA;EACA,cAAA;AA9PJ;;AAiQA;EACI,cAAA;EACA,WAAA;EACA,yBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;EACA,sBAAA;EACA,4BAAA;EACA,yBAAA;EAGA,gBAAA;EACA,uBAAA;EACA,wEAAA;AA9PJ;;AAiQA;EACI;IACI,gBAAA;EA9PN;AACF;AAiQA;EACI,gBAAA;AA/PJ;;AAkQA;EACI,eAAA;AA/PJ;;AAkQA;EACI,cAAA;EACA,sBAAA;EACA,qBAAA;EACA,UAAA;EACA,kDAAA;AA/PJ;;AAkQA;EACI,aAAA;AA/PJ;;AAuQA;EACI,cAAA;EACA,UAAA;AA/PJ;;AAkQA;EACI,yBAAA;EACA,UAAA;AA/PJ;;AAmRA;EACI,yBAAA;EACA,0BAAA;EAEA,0BAAA;EACA,cAAA;EACA,yBAAA;EACA,oBAAA;EACA,qBAAA;EACA,mBAAA;EACA,eAAA;EACA,4BAAA;EACA,gBAAA;EACA,qIAAA;AA/PJ;;AAkQA;EAMI;IACI,gBAAA;EAhQN;AACF;;AAuQA;EACI,yBAAA;AAjQJ;;AAoQA;EACI,cAAA;EACA,WAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;EACA,6BAAA;EACA,yBAAA;EACA,mBAAA;AAjQJ;;AAoQA;EACI,UAAA;AAjQJ;;AAoQA;;EAEI,gBAAA;EACA,eAAA;AAjQJ;;AAoQA;EACI,sCAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;AAjQJ;;AA2QA;EACI,uBAAA;EACA,wBAAA;EAEA,yBAAA;AAjQJ;;AAoQA;EACI,oCAAA;EACA,oBAAA;EACA,kBAAA;EACA,qBAAA;AAjQJ;;AA2QA;EACI,oBAAA;EACA,qBAAA;EAEA,uBAAA;AAjQJ;;AAoQA;EACI,uCAAA;AAjQJ;;AAoQA;EACI,sCAAA;AAjQJ;;AAoQA;EACI,oCAAA;AAjQJ;;AAoQA;EACI,WAAA;EACA,mCAAA;EACA,iBAAA;AAjQJ;;AAoQA;EACI,eAAA;AAjQJ;;AAoQA;EACI,oBAAA;EACA,uBAAA;AAjQJ;;AAoQA;EACI,uBAAA;AAjQJ;;AAoQA;EACI,kCAAA;AAjQJ;;AAoQA;EACI,gCAAA;AAjQJ;;AAoQA;EACI,cAAA;EACA,WAAA;EACA,0CAAA;EACA,uCAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;EACA,sBAAA;EACA,yDAAA;EACA,4BAAA;EACA,yCAAA;EACA,0BAAA;EACA,yBAAA;EACA,uBAAA;EACA,wEAAA;EAGA,gBAAA;AAjQJ;;AAoQA;EACI;IACI,gBAAA;EAjQN;AACF;AAoQA;EACI,qBAAA;EACA,UAAA;EACA,kDAAA;AAlQJ;;AAqQA;;EAEI,sBAAA;EACA,sBAAA;AAlQJ;;AAqQA;EACI,yBAAA;AAlQJ;;AAqQA;EACI,kBAAA;EACA,0BAAA;AAlQJ;;AAqQA;EACI,oBAAA;EACA,uBAAA;EACA,oBAAA;EACA,mBAAA;EACA,sBAAA;AAlQJ;;AAqQA;EACI,mBAAA;EACA,sBAAA;EACA,kBAAA;EACA,kBAAA;EACA,qBAAA;AAlQJ;;AAqQA;EACI,cAAA;EACA,kBAAA;EACA,mBAAA;EACA,uBAAA;AAlQJ;;AAqQA;EACI,WAAA;EACA,mBAAA;AAlQJ;;AAqQA;EACI,oBAAA;EACA,eAAA;EACA,iBAAA;AAlQJ;;AAqQA;EACI,YAAA;EACA,oBAAA;EACA,cAAA;AAlQJ;;AAqQA;EACI,UAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,sBAAA;EACA,4BAAA;EACA,2BAAA;EACA,wBAAA;EACA,qCAAA;EAGA,gBAAA;EACA,iCAAA;EAEA,yBAAA;AAlQJ;;AAqQA;EACI,qBAAA;AAlQJ;;AAqQA;EACI,kBAAA;AAlQJ;;AAqQA;EACI,uBAAA;AAlQJ;;AAqQA;EACI,qBAAA;EACA,UAAA;EACA,kDAAA;AAlQJ;;AAqQA;EACI,yBAAA;EACA,qBAAA;AAlQJ;;AAqQA;EACI,yDAAA;AAlQJ;;AAqQA;EACI,yDAAA;AAlQJ;;AAqQA;EACI,yBAAA;EACA,qBAAA;EACA,yDAAA;AAlQJ;;AAqQA;EACI,oBAAA;EACA,YAAA;EACA,YAAA;AAlQJ;;AAqQA;;EAEI,eAAA;EACA,YAAA;AAlQJ;;AAqQA;EACI,mBAAA;AAlQJ;;AAqQA;EACI,UAAA;EACA,mBAAA;EACA,yDAAA;EACA,gCAAA;EACA,kBAAA;EACA,iDAAA;AAlQJ;;AAqQA;EACI;IACI,gBAAA;EAlQN;AACF;AAqQA;EACI,yDAAA;AAnQJ;;AAsQA;EACI,iCAAA;EACA,yDAAA;AAnQJ;;AAsQA;EACI,oBAAA;EACA,eAAA;AAnQJ;;AAsQA;EACI,oBAAA;EACA,cAAA;AAnQJ;;AAsQA;EACI,qBAAA;EACA,kBAAA;AAnQJ;;AAsQA;EACI,kBAAA;EACA,sBAAA;EACA,oBAAA;AAnQJ;;AAsQA;;EAEI,oBAAA;EACA,YAAA;EACA,aAAA;AAnQJ;;AAsQA;EACI,WAAA;EACA,cAAA;EACA,UAAA;EACA,6BAAA;EAGA,gBAAA;AAnQJ;;AAsQA;EACI,UAAA;AAnQJ;;AAsQA;EACI,kEAAA;AAnQJ;;AAsQA;EACI,kEAAA;AAnQJ;;AAsQA;EACI,SAAA;AAnQJ;;AAsQA;EACI,WAAA;EACA,YAAA;EACA,oBAAA;EACA,yBAAA;EACA,SAAA;EACA,mBAAA;EAEA,oHAAA;EAAA,4GAAA;EAEA,gBAAA;AAnQJ;;AAsQA;EACI;IAEI,wBAAA;IAAA,gBAAA;EAnQN;AACF;AAsQA;EACI,yBAAA;AApQJ;;AAuQA;EACI,WAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;EACA,yBAAA;EACA,yBAAA;EACA,mBAAA;AApQJ;;AAuQA;EACI,WAAA;EACA,YAAA;EACA,yBAAA;EACA,SAAA;EACA,mBAAA;EAEA,iHAAA;EAAA,4GAAA;EAEA,gBAAA;AApQJ;;AAuQA;EACI;IAEI,qBAAA;IAAA,gBAAA;EApQN;AACF;AAuQA;EACI,yBAAA;AArQJ;;AAwQA;EACI,WAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;EACA,yBAAA;EACA,yBAAA;EACA,mBAAA;AArQJ;;AAwQA;EACI,oBAAA;AArQJ;;AAwQA;EACI,yBAAA;AArQJ;;AAwQA;EACI,yBAAA;AArQJ;;AAwQA;EACI,kBAAA;AArQJ;;AAwQA;;;EAGI,0BAAA;EACA,iBAAA;AArQJ;;AAwQA;EACI,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,qBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,oBAAA;EACA,6BAAA;EACA,qBAAA;EACA,gEAAA;AArQJ;;AAwQA;EACI;IACI,gBAAA;EArQN;AACF;AAwQA;;EAEI,qBAAA;AAtQJ;;AA8QA;;EAEI,kBAAA;AAtQJ;;AA+QA;;;;EAII,qBAAA;EACA,wBAAA;AAtQJ;;AAyQA;;EAEI,qBAAA;EACA,wBAAA;AAtQJ;;AAyQA;EACI,qBAAA;EACA,wBAAA;AAtQJ;;AA8QA;;;;EAII,aAAA;EACA,8DAAA;AAtQJ;;AAyQA;EACI,aAAA;EACA,8DAAA;AAtQJ;;AAyQA;EACI,mBAAA;AAtQJ;;AAyQA;EACI,kBAAA;EACA,aAAA;EACA,eAAA;EACA,oBAAA;EACA,WAAA;AAtQJ;;AAyQA;;;EAGI,kBAAA;EACA,cAAA;EACA,SAAA;EACA,YAAA;AAtQJ;;AAyQA;;;EAGI,UAAA;AAtQJ;;AAyQA;EACI,kBAAA;EACA,UAAA;AAtQJ;;AAyQA;EACI,UAAA;AAtQJ;;AAyQA;EACI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;EACA,yBAAA;EACA,yBAAA;EACA,uBAAA;AAtQJ;;AAyQA;;;;EAII,oBAAA;EACA,kBAAA;EACA,qBAAA;AAtQJ;;AAyQA;;;;EAII,uBAAA;EACA,mBAAA;EACA,sBAAA;AAtQJ;;AAyQA;;EAEI,mBAAA;AAtQJ;;AAyQA;;;;EAII,0BAAA;EACA,6BAAA;AAtQJ;;AAyQA;;;;EAII,0BAAA;EACA,6BAAA;AAtQJ;;AAyQA;;;EAGI,iBAAA;EACA,yBAAA;EACA,4BAAA;AAtQJ;;AAyQA;EACI,aAAA;EACA,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,cAAA;AAtQJ;;AAyQA;EACI,kBAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,eAAA;EACA,uBAAA;EACA,kBAAA;EACA,mBAAA;EACA,WAAA;EACA,wCAAA;EACA,uBAAA;AAtQJ;;AAyQA;;;;EAII,cAAA;AAtQJ;;AAyQA;;EAEI,qBAAA;EACA,oCAAA;EACA,yDAAA;EACA,4BAAA;EACA,2DAAA;EACA,gEAAA;AAtQJ;;AAyQA;;EAEI,qBAAA;EACA,iDAAA;AAtQJ;;AAyQA;;EAEI,oCAAA;EACA,kFAAA;AAtQJ;;AAyQA;;EAEI,qBAAA;AAtQJ;;AAyQA;;;;EAII,uBAAA;EACA,kGAAA;EACA,+DAAA;EACA,2EAAA;AAtQJ;;AAyQA;;EAEI,qBAAA;EACA,iDAAA;AAtQJ;;AAyQA;;EAEI,mCAAA;AAtQJ;;AAyQA;;EAEI,qBAAA;AAtQJ;;AAyQA;;EAEI,yBAAA;AAtQJ;;AAyQA;;EAEI,iDAAA;AAtQJ;;AAyQA;;EAEI,cAAA;AAtQJ;;AAyQA;EACI,kBAAA;AAtQJ;;AAyQA;;;;EAII,UAAA;AAtQJ;;AAyQA;;;;EAII,UAAA;AAtQJ;;AAyQA;EACI,aAAA;EACA,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,cAAA;AAtQJ;;AAyQA;EACI,kBAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,eAAA;EACA,uBAAA;EACA,kBAAA;EACA,mBAAA;EACA,WAAA;EACA,wCAAA;EACA,uBAAA;AAtQJ;;AAyQA;;;;EAII,cAAA;AAtQJ;;AAyQA;;EAEI,qBAAA;EACA,oCAAA;EACA,yDAAA;EACA,4BAAA;EACA,2DAAA;EACA,gEAAA;AAtQJ;;AAyQA;;EAEI,qBAAA;EACA,iDAAA;AAtQJ;;AAyQA;;EAEI,oCAAA;EACA,kFAAA;AAtQJ;;AAyQA;;EAEI,qBAAA;AAtQJ;;AAyQA;;;;EAII,uBAAA;EACA,kGAAA;EACA,+DAAA;EACA,2EAAA;AAtQJ;;AAyQA;;EAEI,qBAAA;EACA,iDAAA;AAtQJ;;AAyQA;;EAEI,mCAAA;AAtQJ;;AAyQA;;EAEI,qBAAA;AAtQJ;;AAyQA;;EAEI,yBAAA;AAtQJ;;AAyQA;;EAEI,iDAAA;AAtQJ;;AAyQA;;EAEI,cAAA;AAtQJ;;AAyQA;EACI,kBAAA;AAtQJ;;AAyQA;;;;EAII,UAAA;AAtQJ;;AAyQA;;;;EAII,UAAA;AAtQJ;;AAyQA;EACI,2BAAA;EACA,4BAAA;EACA,sBAAA;EACA,wBAAA;EACA,yBAAA;EACA,yBAAA;EACA,uBAAA;EACA,wBAAA;EACA,0BAAA;EACA,kCAAA;EACA,gCAAA;EACA,4FAAA;EACA,+BAAA;EACA,iFAAA;EACA,qBAAA;EACA,wDAAA;EACA,sCAAA;EACA,kCAAA;EACA,sCAAA;EACA,sCAAA;EACA,0BAAA;EACA,kBAAA;EACA,qBAAA;EACA,sBAAA;EACA,eAAA;EACA,yBAAA;EAEA,iBAAA;EACA,mEAAA;EACA,0CAAA;EACA,kCAAA;EACA,qIAAA;AAtQJ;;AAyQA;EACI;IACI,gBAAA;EAtQN;AACF;AAyQA;EACI,gCAAA;EACA,wCAAA;EACA,8CAAA;AAvQJ;;AA0QA;;EAEI,gCAAA;EACA,wCAAA;EACA,8CAAA;EACA,UAAA;EACA,0CAAA;AAvQJ;;AA0QA;;;;;EAKI,iCAAA;EACA,yCAAA;EACA,+CAAA;AAvQJ;;AA0QA;;;;;EAKI,0CAAA;AAvQJ;;AA0QA;;;EAGI,mCAAA;EACA,oBAAA;EACA,2CAAA;EACA,iDAAA;EACA,uCAAA;AAvQJ;;AA0QA;EACI,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,uCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,wCAAA;AAvQJ;;AA0QA;EACI,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,wCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,wCAAA;AAvQJ;;AA0QA;EACI,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,uCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,wCAAA;AAvQJ;;AA0QA;EACI,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,uCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,wCAAA;AAvQJ;;AA0QA;EACI,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,sCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,wCAAA;AAvQJ;;AA0QA;EACI,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,sCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,wCAAA;AAvQJ;;AA0QA;EACI,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,wCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,wCAAA;AAvQJ;;AA0QA;EACI,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,qCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,wCAAA;AAvQJ;;AA0QA;EACI,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,uCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,oBAAA;AAvQJ;;AA0QA;EACI,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,wCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,oBAAA;AAvQJ;;AA0QA;EACI,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,sCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,oBAAA;AAvQJ;;AA0QA;EACI,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,uCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,oBAAA;AAvQJ;;AA0QA;EACI,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,sCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,oBAAA;AAvQJ;;AA0QA;EACI,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,sCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,oBAAA;AAvQJ;;AA0QA;EACI,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,wCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,oBAAA;AAvQJ;;AA0QA;EACI,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,qCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,oBAAA;AAvQJ;;AA0QA;EACI,yBAAA;EACA,oCAAA;EACA,wBAAA;EACA,kCAAA;EACA,gDAAA;EACA,wCAAA;EACA,iDAAA;EACA,yCAAA;EACA,gCAAA;EACA,2CAAA;EACA,yBAAA;EACA,uCAAA;EACA,0BAAA;AAvQJ;;AA0QA;EACI,0BAAA;AAvQJ;;AA0QA;EACI,gCAAA;AAvQJ;;AA0QA;;EAEI,0BAAA;EACA,wBAAA;EACA,2BAAA;EACA,+BAAA;AAvQJ;;AA0QA;;EAEI,2BAAA;EACA,0BAAA;EACA,4BAAA;EACA,gCAAA;AAvQJ;;AA0QA;EACI,gCAAA;AAvQJ;;AA0QA;EACI;IACI,gBAAA;EAvQN;AACF;AA0QA;EACI,UAAA;AAxQJ;;AA2QA;EACI,aAAA;AAxQJ;;AA2QA;EACI,SAAA;EACA,gBAAA;EACA,6BAAA;AAxQJ;;AA2QA;EACI;IACI,gBAAA;EAxQN;AACF;AA2QA;EACI,QAAA;EACA,YAAA;EACA,4BAAA;AAzQJ;;AA4QA;EACI;IACI,gBAAA;EAzQN;AACF;AA4QA;;;;;;EAMI,kBAAA;AA1QJ;;AA6QA;EACI,mBAAA;AA1QJ;;AA6QA;EACI,qBAAA;EACA,oBAAA;EACA,uBAAA;EACA,WAAA;EACA,uBAAA;EACA,qCAAA;EACA,gBAAA;EACA,oCAAA;AA1QJ;;AA6QA;EACI,cAAA;AA1QJ;;AA6QA;EACI,8BAAA;EACA,0BAAA;EACA,+BAAA;EACA,8BAAA;EACA,6BAAA;EACA,4BAAA;EACA,sBAAA;EACA,8DAAA;EACA,qCAAA;EACA,+BAAA;EACA,uDAAA;EACA,4DAAA;EACA,sCAAA;EACA,2DAAA;EACA,iCAAA;EACA,uCAAA;EACA,oCAAA;EACA,qCAAA;EACA,qCAAA;EACA,0CAAA;EACA,kCAAA;EACA,qCAAA;EACA,mCAAA;EACA,oCAAA;EACA,sCAAA;EACA,kBAAA;EACA,aAAA;EACA,aAAA;EACA,uCAAA;EACA,kEAAA;EACA,SAAA;EACA,uCAAA;EACA,+BAAA;EACA,gBAAA;EACA,gBAAA;EACA,uCAAA;EACA,4BAAA;EACA,6EAAA;EACA,+CAAA;AA1QJ;;AA6QA;EACI,SAAA;EACA,OAAA;EACA,qCAAA;AA1QJ;;AA6QA;EACI,qBAAA;AA1QJ;;AA6QA;EACI,WAAA;EACA,OAAA;AA1QJ;;AA6QA;EACI,mBAAA;AA1QJ;;AA6QA;EACI,QAAA;EACA,UAAA;AA1QJ;;AA6QA;EACI;IACI,qBAAA;EA1QN;EA6QE;IACI,WAAA;IACA,OAAA;EA3QN;EA8QE;IACI,mBAAA;EA5QN;EA+QE;IACI,QAAA;IACA,UAAA;EA7QN;AACF;AAgRA;EACI;IACI,qBAAA;EA9QN;EAiRE;IACI,WAAA;IACA,OAAA;EA/QN;EAkRE;IACI,mBAAA;EAhRN;EAmRE;IACI,QAAA;IACA,UAAA;EAjRN;AACF;AAoRA;EACI;IACI,qBAAA;EAlRN;EAqRE;IACI,WAAA;IACA,OAAA;EAnRN;EAsRE;IACI,mBAAA;EApRN;EAuRE;IACI,QAAA;IACA,UAAA;EArRN;AACF;AAwRA;EACI;IACI,qBAAA;EAtRN;EAyRE;IACI,WAAA;IACA,OAAA;EAvRN;EA0RE;IACI,mBAAA;EAxRN;EA2RE;IACI,QAAA;IACA,UAAA;EAzRN;AACF;AA4RA;EACI;IACI,qBAAA;EA1RN;EA6RE;IACI,WAAA;IACA,OAAA;EA3RN;EA8RE;IACI,mBAAA;EA5RN;EA+RE;IACI,QAAA;IACA,UAAA;EA7RN;AACF;AAgSA;EACI,SAAA;EACA,YAAA;EACA,aAAA;EACA,wCAAA;AA9RJ;;AAiSA;EACI,qBAAA;EACA,oBAAA;EACA,uBAAA;EACA,WAAA;EACA,aAAA;EACA,qCAAA;EACA,0BAAA;EACA,oCAAA;AA9RJ;;AAiSA;EACI,cAAA;AA9RJ;;AAiSA;EACI,MAAA;EACA,WAAA;EACA,UAAA;EACA,aAAA;EACA,sCAAA;AA9RJ;;AAiSA;EACI,qBAAA;EACA,oBAAA;EACA,uBAAA;EACA,WAAA;EACA,mCAAA;EACA,eAAA;EACA,sCAAA;EACA,wBAAA;AA9RJ;;AAiSA;EACI,cAAA;AA9RJ;;AAiSA;EACI,iBAAA;AA9RJ;;AAiSA;EACI,MAAA;EACA,WAAA;EACA,UAAA;EACA,aAAA;EACA,uCAAA;AA9RJ;;AAiSA;EACI,qBAAA;EACA,oBAAA;EACA,uBAAA;EACA,WAAA;AA9RJ;;AAiSA;EACI,aAAA;AA9RJ;;AAiSA;EACI,qBAAA;EACA,qBAAA;EACA,uBAAA;EACA,WAAA;EACA,mCAAA;EACA,yBAAA;EACA,sCAAA;AA9RJ;;AAiSA;EACI,cAAA;AA9RJ;;AAiSA;EACI,iBAAA;AA9RJ;;AAiSA;EACI,SAAA;EACA,6CAAA;EACA,gBAAA;EACA,mDAAA;EACA,UAAA;AA9RJ;;AAiSA;EACI,cAAA;EACA,WAAA;EACA,4EAAA;EACA,WAAA;EACA,gBAAA;EACA,oCAAA;EACA,mBAAA;EACA,qBAAA;EACA,mBAAA;EACA,6BAAA;EACA,SAAA;AA9RJ;;AAiSA;;EAEI,0CAAA;EACA,kDAAA;AA9RJ;;AAiSA;;EAEI,2CAAA;EACA,qBAAA;EACA,mDAAA;AA9RJ;;AAiSA;;EAEI,6CAAA;EACA,oBAAA;EACA,6BAAA;AA9RJ;;AAiSA;EACI,cAAA;AA9RJ;;AAiSA;EACI,cAAA;EACA,gFAAA;EACA,gBAAA;EACA,mBAAA;EACA,sCAAA;EACA,mBAAA;AA9RJ;;AAiSA;EACI,cAAA;EACA,4EAAA;EACA,oCAAA;AA9RJ;;AAiSA;EACI,4BAAA;EACA,yBAAA;EACA,8DAAA;EACA,0BAAA;EACA,iCAAA;EACA,oCAAA;EACA,4DAAA;EACA,sDAAA;EACA,qCAAA;EACA,qCAAA;EACA,0CAAA;EACA,oCAAA;AA9RJ;;AAiSA;;EAEI,kBAAA;EACA,oBAAA;EACA,sBAAA;AA9RJ;;AAiSA;;EAEI,kBAAA;EACA,cAAA;AA9RJ;;AAiSA;;;;;;;;;;;;EAYI,UAAA;AA9RJ;;AAiSA;EACI,aAAA;EACA,eAAA;EACA,2BAAA;AA9RJ;;AAiSA;EACI,WAAA;AA9RJ;;AAiSA;EACI,uBAAA;AA9RJ;;AAiSA;;EAEI,iBAAA;AA9RJ;;AAiSA;;;EAGI,0BAAA;EACA,6BAAA;AA9RJ;;AAiSA;;;EAGI,yBAAA;EACA,4BAAA;AA9RJ;;AAiSA;EACI,wBAAA;EACA,uBAAA;AA9RJ;;AAiSA;;;EAGI,cAAA;AA9RJ;;AAiSA;EACI,eAAA;AA9RJ;;AAiSA;;EAEI,uBAAA;EACA,sBAAA;AA9RJ;;AAiSA;;EAEI,sBAAA;EACA,qBAAA;AA9RJ;;AAiSA;EACI,sBAAA;EACA,uBAAA;EACA,uBAAA;AA9RJ;;AAiSA;;EAEI,WAAA;AA9RJ;;AAiSA;;EAEI,gBAAA;AA9RJ;;AAiSA;;EAEI,6BAAA;EACA,4BAAA;AA9RJ;;AAiSA;;EAEI,yBAAA;EACA,0BAAA;AA9RJ;;AAiSA;EACI,6BAAA;EACA,+BAAA;EACA,2BAAA;EACA,yCAAA;EACA,qDAAA;EACA,qCAAA;EACA,aAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AA9RJ;;AAiSA;EACI,cAAA;EACA,kEAAA;EACA,uCAAA;EACA,2CAAA;EACA,+BAAA;EACA,qBAAA;EACA,uGAAA;AA9RJ;;AAiSA;EACI;IACI,gBAAA;EA9RN;AACF;AAiSA;;EAEI,qCAAA;AA/RJ;;AAkSA;EACI,wCAAA;EACA,oBAAA;EACA,eAAA;AA/RJ;;AAkSA;EACI,+BAAA;EACA,mCAAA;EACA,qCAAA;EACA,8DAAA;EACA,wCAAA;EACA,kCAAA;EACA,4DAAA;EACA,oFAAA;AA/RJ;;AAkSA;EACI,yDAAA;EACA,eAAA;EACA,yDAAA;EACA,wDAAA;EACA,yDAAA;AA/RJ;;AAkSA;;EAEI,kBAAA;EACA,wDAAA;AA/RJ;;AAkSA;;EAEI,wCAAA;EACA,6BAAA;EACA,yBAAA;AA/RJ;;AAkSA;;EAEI,2CAAA;EACA,mDAAA;EACA,yDAAA;AA/RJ;;AAkSA;EACI,sDAAA;EACA,yBAAA;EACA,0BAAA;AA/RJ;;AAkSA;EACI,sCAAA;EACA,sCAAA;EACA,uCAAA;AA/RJ;;AAkSA;EACI,eAAA;EACA,SAAA;EACA,gDAAA;AA/RJ;;AAkSA;EACI,wCAAA;EACA,6BAAA;EACA,yBAAA;AA/RJ;;AAkSA;;EAEI,4CAAA;EACA,oDAAA;AA/RJ;;AAkSA;;EAEI,cAAA;EACA,kBAAA;AA/RJ;;AAkSA;;EAEI,aAAA;EACA,YAAA;EACA,kBAAA;AA/RJ;;AAkSA;;EAEI,WAAA;AA/RJ;;AAkSA;EACI,aAAA;AA/RJ;;AAkSA;EACI,cAAA;AA/RJ;;AAkSA;EACI,wBAAA;EACA,6BAAA;EACA,sCAAA;EACA,2CAAA;EACA,8CAAA;EACA,4CAAA;EACA,sCAAA;EACA,kCAAA;EACA,oCAAA;EACA,2CAAA;EACA,iDAAA;EACA,sCAAA;EACA,sCAAA;EACA,sCAAA;EACA,sCAAA;EACA,oEAAA;EACA,oDAAA;EACA,2CAAA;EACA,wCAAA;EACA,4DAAA;EACA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,mBAAA;EACA,8BAAA;EACA,8DAAA;AA/RJ;;AAkSA;;;;;;;EAOI,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,8BAAA;AA/RJ;;AAkSA;EACI,6CAAA;EACA,gDAAA;EACA,+CAAA;EACA,2CAAA;EACA,mCAAA;EACA,qBAAA;EACA,mBAAA;AA/RJ;;AAkSA;;EAEI,yCAAA;AA/RJ;;AAkSA;EACI,0BAAA;EACA,+BAAA;EACA,2BAAA;EACA,2CAAA;EACA,uDAAA;EACA,6DAAA;EACA,aAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AA/RJ;;AAkSA;;EAEI,oCAAA;AA/RJ;;AAkSA;EACI,gBAAA;AA/RJ;;AAkSA;EACI,mBAAA;EACA,sBAAA;EACA,6BAAA;AA/RJ;;AAkSA;;;EAGI,oCAAA;AA/RJ;;AAkSA;EACI,gBAAA;EACA,YAAA;EACA,mBAAA;AA/RJ;;AAkSA;EACI,8EAAA;EACA,6CAAA;EACA,cAAA;EACA,6BAAA;EACA,6BAAA;EACA,0EAAA;EACA,qDAAA;EACA,+CAAA;AA/RJ;;AAkSA;EACI;IACI,gBAAA;EA/RN;AACF;AAkSA;EACI,qBAAA;AAhSJ;;AAmSA;EACI,qBAAA;EACA,UAAA;EACA,sDAAA;AAhSJ;;AAmSA;EACI,qBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,kDAAA;EACA,4BAAA;EACA,2BAAA;EACA,qBAAA;AAhSJ;;AAmSA;EACI,yCAAA;EACA,gBAAA;AAhSJ;;AAmSA;EACI;IACI,iBAAA;IACA,2BAAA;EAhSN;EAmSE;IACI,mBAAA;EAjSN;EAoSE;IACI,kBAAA;EAlSN;EAqSE;IACI,kDAAA;IACA,iDAAA;EAnSN;EAsSE;IACI,iBAAA;EApSN;EAuSE;IACI,wBAAA;IACA,gBAAA;EArSN;EAwSE;IACI,aAAA;EAtSN;EAySE;IACI,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;IACA,gBAAA;EAvSN;EA0SE;IACI,aAAA;EAxSN;EA2SE;IACI,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;EAzSN;AACF;AA4SA;EACI;IACI,iBAAA;IACA,2BAAA;EA1SN;EA6SE;IACI,mBAAA;EA3SN;EA8SE;IACI,kBAAA;EA5SN;EA+SE;IACI,kDAAA;IACA,iDAAA;EA7SN;EAgTE;IACI,iBAAA;EA9SN;EAiTE;IACI,wBAAA;IACA,gBAAA;EA/SN;EAkTE;IACI,aAAA;EAhTN;EAmTE;IACI,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;IACA,gBAAA;EAjTN;EAoTE;IACI,aAAA;EAlTN;EAqTE;IACI,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;EAnTN;AACF;AAsTA;EACI;IACI,iBAAA;IACA,2BAAA;EApTN;EAuTE;IACI,mBAAA;EArTN;EAwTE;IACI,kBAAA;EAtTN;EAyTE;IACI,kDAAA;IACA,iDAAA;EAvTN;EA0TE;IACI,iBAAA;EAxTN;EA2TE;IACI,wBAAA;IACA,gBAAA;EAzTN;EA4TE;IACI,aAAA;EA1TN;EA6TE;IACI,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;IACA,gBAAA;EA3TN;EA8TE;IACI,aAAA;EA5TN;EA+TE;IACI,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;EA7TN;AACF;AAgUA;EACI;IACI,iBAAA;IACA,2BAAA;EA9TN;EAiUE;IACI,mBAAA;EA/TN;EAkUE;IACI,kBAAA;EAhUN;EAmUE;IACI,kDAAA;IACA,iDAAA;EAjUN;EAoUE;IACI,iBAAA;EAlUN;EAqUE;IACI,wBAAA;IACA,gBAAA;EAnUN;EAsUE;IACI,aAAA;EApUN;EAuUE;IACI,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;IACA,gBAAA;EArUN;EAwUE;IACI,aAAA;EAtUN;EAyUE;IACI,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;EAvUN;AACF;AA0UA;EACI;IACI,iBAAA;IACA,2BAAA;EAxUN;EA2UE;IACI,mBAAA;EAzUN;EA4UE;IACI,kBAAA;EA1UN;EA6UE;IACI,kDAAA;IACA,iDAAA;EA3UN;EA8UE;IACI,iBAAA;EA5UN;EA+UE;IACI,wBAAA;IACA,gBAAA;EA7UN;EAgVE;IACI,aAAA;EA9UN;EAiVE;IACI,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;IACA,gBAAA;EA/UN;EAkVE;IACI,aAAA;EAhVN;EAmVE;IACI,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;EAjVN;AACF;AAoVA;EACI,iBAAA;EACA,2BAAA;AAlVJ;;AAqVA;EACI,mBAAA;AAlVJ;;AAqVA;EACI,kBAAA;AAlVJ;;AAqVA;EACI,kDAAA;EACA,iDAAA;AAlVJ;;AAqVA;EACI,iBAAA;AAlVJ;;AAqVA;EACI,wBAAA;EACA,gBAAA;AAlVJ;;AAqVA;EACI,aAAA;AAlVJ;;AAqVA;EACI,gBAAA;EACA,aAAA;EACA,YAAA;EACA,sBAAA;EACA,uBAAA;EACA,8BAAA;EACA,wCAAA;EACA,oBAAA;EACA,0BAAA;EACA,gBAAA;AAlVJ;;AAqVA;EACI,aAAA;AAlVJ;;AAqVA;EACI,aAAA;EACA,YAAA;EACA,UAAA;EACA,mBAAA;AAlVJ;;AAqVA;EACI,4CAAA;EACA,kDAAA;EACA,qDAAA;EACA,8BAAA;EACA,6BAAA;EACA,mCAAA;EACA,0DAAA;EACA,sEAAA;AAlVJ;;AAqVA;EACI,wBAAA;EACA,wBAAA;EACA,gCAAA;EACA,2BAAA;EACA,0DAAA;EACA,iCAAA;EACA,sBAAA;EACA,mDAAA;EACA,+BAAA;EACA,6BAAA;EACA,qCAAA;EACA,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,mCAAA;EACA,+BAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,6BAAA;EACA,qBAAA;EACA,mCAAA;EACA,2BAAA;EACA,qEAAA;EACA,2CAAA;AAlVJ;;AAqVA;EACI,eAAA;EACA,cAAA;AAlVJ;;AAqVA;EACI,mBAAA;EACA,sBAAA;AAlVJ;;AAqVA;EACI,mBAAA;EACA,0DAAA;EACA,2DAAA;AAlVJ;;AAqVA;EACI,sBAAA;EACA,8DAAA;EACA,6DAAA;AAlVJ;;AAqVA;;EAEI,aAAA;AAlVJ;;AAqVA;EACI,cAAA;EACA,wDAAA;EACA,2BAAA;AAlVJ;;AAqVA;EACI,4CAAA;AAlVJ;;AAqVA;EACI,sDAAA;EACA,gBAAA;AAlVJ;;AAqVA;EACI,gBAAA;AAlVJ;;AAqVA;EACI,oCAAA;AAlVJ;;AAqVA;EACI,kEAAA;EACA,gBAAA;EACA,+BAAA;EACA,uCAAA;EACA,4EAAA;AAlVJ;;AAqVA;EACI,wFAAA;AAlVJ;;AAqVA;EACI,kEAAA;EACA,+BAAA;EACA,uCAAA;EACA,yEAAA;AAlVJ;;AAqVA;EACI,wFAAA;AAlVJ;;AAqVA;EACI,uDAAA;EACA,sDAAA;EACA,sDAAA;EACA,gBAAA;AAlVJ;;AAqVA;EACI,mCAAA;EACA,sCAAA;AAlVJ;;AAqVA;EACI,uDAAA;EACA,sDAAA;AAlVJ;;AAqVA;EACI,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,2CAAA;EACA,iDAAA;AAlVJ;;AAqVA;;;EAGI,WAAA;AAlVJ;;AAqVA;;EAEI,0DAAA;EACA,2DAAA;AAlVJ;;AAqVA;;EAEI,8DAAA;EACA,6DAAA;AAlVJ;;AAqVA;EACI,0CAAA;AAlVJ;;AAqVA;EACI;IACI,aAAA;IACA,mBAAA;EAlVN;EAqVE;IACI,SAAA;IACA,gBAAA;EAnVN;EAsVE;IACI,cAAA;IACA,cAAA;EApVN;EAuVE;IACI,0BAAA;IACA,6BAAA;EArVN;EAwVE;;IAEI,0BAAA;EAtVN;EAyVE;;IAEI,6BAAA;EAvVN;EA0VE;IACI,yBAAA;IACA,4BAAA;EAxVN;EA2VE;;IAEI,yBAAA;EAzVN;EA4VE;;IAEI,4BAAA;EA1VN;AACF;AA6VA;EACI,0BAAA;EACA,uBAAA;EACA,8KAAA;EACA,mDAAA;EACA,gCAAA;EACA,sCAAA;EACA,wDAAA;EACA,qCAAA;EACA,kCAAA;EACA,8CAAA;EACA,6CAAA;EACA,iEAAA;EACA,sCAAA;EACA,kDAAA;EACA,8DAAA;EACA,wEAAA;EACA,8CAAA;EACA,2EAAA;EACA,sCAAA;EACA,mCAAA;EACA,oCAAA;EACA,kCAAA;AA3VJ;;AA8VA;EACI,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;EACA,4EAAA;EACA,eAAA;EACA,oCAAA;EACA,gBAAA;EACA,4CAAA;EACA,SAAA;EACA,gBAAA;EACA,qBAAA;EACA,0CAAA;AA3VJ;;AA8VA;EACI;IACI,gBAAA;EA3VN;AACF;AA8VA;EACI,uCAAA;EACA,+CAAA;EACA,kGAAA;AA5VJ;;AA+VA;EACI,qDAAA;EACA,iDAAA;AA5VJ;;AA+VA;EACI,cAAA;EACA,yCAAA;EACA,0CAAA;EACA,iBAAA;EACA,WAAA;EACA,8CAAA;EACA,4BAAA;EACA,mDAAA;EACA,mDAAA;AA5VJ;;AA+VA;EACI;IACI,gBAAA;EA5VN;AACF;AA+VA;EACI,UAAA;AA7VJ;;AAgWA;EACI,UAAA;EACA,wDAAA;EACA,UAAA;EACA,oDAAA;AA7VJ;;AAgWA;EACI,gBAAA;AA7VJ;;AAgWA;EACI,gCAAA;EACA,wCAAA;EACA,+EAAA;AA7VJ;;AAgWA;EACI,yDAAA;EACA,0DAAA;AA7VJ;;AAgWA;EACI,+DAAA;EACA,gEAAA;AA7VJ;;AAgWA;EACI,aAAA;AA7VJ;;AAgWA;EACI,6DAAA;EACA,4DAAA;AA7VJ;;AAgWA;EACI,mEAAA;EACA,kEAAA;AA7VJ;;AAgWA;EACI,6DAAA;EACA,4DAAA;AA7VJ;;AAgWA;EACI,8EAAA;AA7VJ;;AAgWA;EACI,eAAA;AA7VJ;;AAgWA;EACI,eAAA;EACA,cAAA;EACA,gBAAA;AA7VJ;;AAgWA;EACI,aAAA;AA7VJ;;AAgWA;EACI,gBAAA;AA7VJ;;AAgWA;EACI,gBAAA;AA7VJ;;AAgWA;EACI,4BAAA;EACA,4BAAA;EACA,mCAAA;EACA,oBAAA;EACA,+BAAA;EACA,sCAAA;EACA,sCAAA;EACA,0CAAA;EACA,aAAA;EACA,eAAA;EACA,sEAAA;EACA,iDAAA;EACA,yCAAA;EACA,gBAAA;EACA,yCAAA;EACA,iDAAA;AA7VJ;;AAgWA;EACI,iDAAA;AA7VJ;;AAgWA;EACI,WAAA;EACA,kDAAA;EACA,yCAAA;EACA,0CAAA;AA7VJ;;AAgWA;EACI,6CAAA;AA7VJ;;AAgWA;EACI,kCAAA;EACA,mCAAA;EACA,+BAAA;EACA,2CAAA;EACA,wBAAA;EACA,iCAAA;EACA,qCAAA;EACA,uCAAA;EACA,uDAAA;EACA,iCAAA;EACA,2CAAA;EACA,uDAAA;EACA,iCAAA;EACA,wEAAA;EACA,kCAAA;EACA,kCAAA;EACA,4CAAA;EACA,uCAAA;EACA,iCAAA;EACA,8CAAA;EACA,aAAA;EACA,eAAA;EACA,gBAAA;AA7VJ;;AAgWA;EACI,kBAAA;EACA,cAAA;EACA,sEAAA;EACA,yCAAA;EACA,iCAAA;EACA,qBAAA;EACA,yCAAA;EACA,iFAAA;EACA,qIAAA;AA7VJ;;AAgWA;EACI;IACI,gBAAA;EA7VN;AACF;AAgWA;EACI,UAAA;EACA,uCAAA;EACA,+CAAA;EACA,qDAAA;AA9VJ;;AAiWA;EACI,UAAA;EACA,uCAAA;EACA,+CAAA;EACA,UAAA;EACA,iDAAA;AA9VJ;;AAiWA;;EAEI,UAAA;EACA,wCAAA;EACA,gDAAA;EACA,sDAAA;AA9VJ;;AAiWA;;EAEI,0CAAA;EACA,oBAAA;EACA,kDAAA;EACA,wDAAA;AA9VJ;;AAiWA;EACI,iBAAA;AA9VJ;;AAiWA;EACI,0DAAA;EACA,6DAAA;AA9VJ;;AAiWA;EACI,2DAAA;EACA,8DAAA;AA9VJ;;AAiWA;EACI,iCAAA;EACA,kCAAA;EACA,kCAAA;EACA,sCAAA;AA9VJ;;AAiWA;EACI,iCAAA;EACA,kCAAA;EACA,mCAAA;EACA,uCAAA;AA9VJ;;AAiWA;EACI,4BAAA;EACA,4BAAA;EACA,4BAAA;EACA,2BAAA;EACA,sBAAA;EACA,kCAAA;EACA,qBAAA;EACA,4DAAA;EACA,oCAAA;EACA,wCAAA;EACA,cAAA;EACA,4BAAA;EACA,kBAAA;EACA,mBAAA;EACA,wBAAA;EACA,4CAAA;AA9VJ;;AAiWA;EACI,aAAA;AA9VJ;;AAiWA;EACI,kBAAA;EACA,SAAA;AA9VJ;;AAiWA;EACI,0BAAA;EACA,0BAAA;EACA,0BAAA;EACA,8BAAA;EACA,yBAAA;EACA,oCAAA;EACA,yDAAA;EACA,kCAAA;EACA,kBAAA;EACA,4DAAA;EACA,4CAAA;EACA,4BAAA;EACA,oCAAA;EACA,8BAAA;EACA,4CAAA;AA9VJ;;AAiWA;EACI,cAAA;AA9VJ;;AAiWA;EACI,gBAAA;AA9VJ;;AAiWA;EACI,mBAAA;AA9VJ;;AAiWA;EACI,kBAAA;EACA,MAAA;EACA,QAAA;EACA,UAAA;EACA,qBAAA;AA9VJ;;AAiWA;EACI,yBAAA;EACA,sBAAA;EACA,iCAAA;AA9VJ;;AAiWA;EACI,cAAA;AA9VJ;;AAiWA;EACI,yBAAA;EACA,sBAAA;EACA,iCAAA;AA9VJ;;AAiWA;EACI,cAAA;AA9VJ;;AAiWA;EACI,yBAAA;EACA,sBAAA;EACA,iCAAA;AA9VJ;;AAiWA;EACI,cAAA;AA9VJ;;AAiWA;EACI,yBAAA;EACA,sBAAA;EACA,iCAAA;AA9VJ;;AAiWA;EACI,cAAA;AA9VJ;;AAiWA;EACI,yBAAA;EACA,sBAAA;EACA,iCAAA;AA9VJ;;AAiWA;EACI,cAAA;AA9VJ;;AAiWA;EACI,yBAAA;EACA,sBAAA;EACA,iCAAA;AA9VJ;;AAiWA;EACI,cAAA;AA9VJ;;AAiWA;EACI,yBAAA;EACA,sBAAA;EACA,iCAAA;AA9VJ;;AAiWA;EACI,cAAA;AA9VJ;;AAiWA;EACI,yBAAA;EACA,sBAAA;EACA,iCAAA;AA9VJ;;AAiWA;EACI,cAAA;AA9VJ;AAuWA;EACI;IACI,2BAAA;EA/VN;AACF;AAkWA;EACI,0BAAA;EACA,gCAAA;EACA,yBAAA;EACA,qCAAA;EACA,8DAAA;EACA,6BAAA;EACA,6BAAA;EACA,6CAAA;EACA,aAAA;EACA,iCAAA;EACA,gBAAA;EACA,uCAAA;EACA,uCAAA;EACA,+CAAA;AAhWJ;;AAmWA;EACI,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,gBAAA;EACA,mCAAA;EACA,kBAAA;EACA,mBAAA;EACA,2CAAA;EACA,6CAAA;AAhWJ;;AAmWA;EACI;IACI,gBAAA;EAhWN;AACF;AAmWA;EACI,qMAAA;EACA,oEAAA;AAjWJ;;AAoWA;EAEI,kDAAA;AAjWJ;;AAoWA;EACI;IAEI,eAAA;EAjWN;AACF;AAoWA;EACI,8BAAA;EACA,wBAAA;EACA,kDAAA;EACA,iCAAA;EACA,uCAAA;EACA,oCAAA;EACA,sCAAA;EACA,qCAAA;EACA,2CAAA;EACA,wCAAA;EACA,4CAAA;EACA,yCAAA;EACA,uCAAA;EACA,iCAAA;EACA,kCAAA;EACA,kCAAA;EACA,4CAAA;EACA,aAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,iDAAA;AAlWJ;;AAqWA;EACI,qBAAA;EACA,sBAAA;AAlWJ;;AAqWA;EACI,oCAAA;EACA,0BAAA;AAlWJ;;AAqWA;EACI,WAAA;EACA,wCAAA;EACA,mBAAA;AAlWJ;;AAqWA;;EAEI,UAAA;EACA,8CAAA;EACA,qBAAA;EACA,sDAAA;AAlWJ;;AAqWA;EACI,+CAAA;EACA,uDAAA;AAlWJ;;AAqWA;EACI,kBAAA;EACA,cAAA;EACA,gFAAA;EACA,iCAAA;EACA,qBAAA;EACA,yCAAA;EACA,iFAAA;AAlWJ;;AAqWA;EACI,+BAAA;EACA,gCAAA;AAlWJ;;AAqWA;EACI,mCAAA;EACA,kCAAA;AAlWJ;;AAqWA;;EAEI,0CAAA;EACA,oBAAA;EACA,kDAAA;AAlWJ;;AAqWA;EACI,UAAA;EACA,wCAAA;EACA,gDAAA;EACA,sDAAA;AAlWJ;;AAqWA;EACI,mBAAA;AAlWJ;;AAqWA;EACI,wDAAA;EACA,mDAAA;AAlWJ;;AAqWA;EACI,mBAAA;AAlWJ;;AAqWA;EACI,6DAAA;EACA,0BAAA;AAlWJ;;AAqWA;EACI,2DAAA;EACA,4BAAA;AAlWJ;;AAqWA;EACI,aAAA;AAlWJ;;AAqWA;EACI,mDAAA;EACA,oBAAA;AAlWJ;;AAqWA;EACI,yDAAA;EACA,oDAAA;AAlWJ;;AAqWA;EACI;IACI,mBAAA;EAlWN;EAqWE;IACI,6DAAA;IACA,0BAAA;EAnWN;EAsWE;IACI,2DAAA;IACA,4BAAA;EApWN;EAuWE;IACI,aAAA;EArWN;EAwWE;IACI,mDAAA;IACA,oBAAA;EAtWN;EAyWE;IACI,yDAAA;IACA,oDAAA;EAvWN;AACF;AA0WA;EACI;IACI,mBAAA;EAxWN;EA2WE;IACI,6DAAA;IACA,0BAAA;EAzWN;EA4WE;IACI,2DAAA;IACA,4BAAA;EA1WN;EA6WE;IACI,aAAA;EA3WN;EA8WE;IACI,mDAAA;IACA,oBAAA;EA5WN;EA+WE;IACI,yDAAA;IACA,oDAAA;EA7WN;AACF;AAgXA;EACI;IACI,mBAAA;EA9WN;EAiXE;IACI,6DAAA;IACA,0BAAA;EA/WN;EAkXE;IACI,2DAAA;IACA,4BAAA;EAhXN;EAmXE;IACI,aAAA;EAjXN;EAoXE;IACI,mDAAA;IACA,oBAAA;EAlXN;EAqXE;IACI,yDAAA;IACA,oDAAA;EAnXN;AACF;AAsXA;EACI;IACI,mBAAA;EApXN;EAuXE;IACI,6DAAA;IACA,0BAAA;EArXN;EAwXE;IACI,2DAAA;IACA,4BAAA;EAtXN;EAyXE;IACI,aAAA;EAvXN;EA0XE;IACI,mDAAA;IACA,oBAAA;EAxXN;EA2XE;IACI,yDAAA;IACA,oDAAA;EAzXN;AACF;AA4XA;EACI;IACI,mBAAA;EA1XN;EA6XE;IACI,6DAAA;IACA,0BAAA;EA3XN;EA8XE;IACI,2DAAA;IACA,4BAAA;EA5XN;EA+XE;IACI,aAAA;EA7XN;EAgYE;IACI,mDAAA;IACA,oBAAA;EA9XN;EAiYE;IACI,yDAAA;IACA,oDAAA;EA/XN;AACF;AAkYA;EACI,gBAAA;AAhYJ;;AAmYA;EACI,mDAAA;AAhYJ;;AAmYA;EACI,sBAAA;AAhYJ;;AAmYA;EACI,cAAA;EACA,yBAAA;AAhYJ;;AAmYA;;EAEI,cAAA;EACA,yBAAA;AAhYJ;;AAmYA;EACI,WAAA;EACA,yBAAA;EACA,qBAAA;AAhYJ;;AAmYA;EACI,cAAA;EACA,yBAAA;AAhYJ;;AAmYA;;EAEI,cAAA;EACA,yBAAA;AAhYJ;;AAmYA;EACI,WAAA;EACA,yBAAA;EACA,qBAAA;AAhYJ;;AAmYA;EACI,cAAA;EACA,yBAAA;AAhYJ;;AAmYA;;EAEI,cAAA;EACA,yBAAA;AAhYJ;;AAmYA;EACI,WAAA;EACA,yBAAA;EACA,qBAAA;AAhYJ;;AAmYA;EACI,cAAA;EACA,yBAAA;AAhYJ;;AAmYA;;EAEI,cAAA;EACA,yBAAA;AAhYJ;;AAmYA;EACI,WAAA;EACA,yBAAA;EACA,qBAAA;AAhYJ;;AAmYA;EACI,cAAA;EACA,yBAAA;AAhYJ;;AAmYA;;EAEI,cAAA;EACA,yBAAA;AAhYJ;;AAmYA;EACI,WAAA;EACA,yBAAA;EACA,qBAAA;AAhYJ;;AAmYA;EACI,cAAA;EACA,yBAAA;AAhYJ;;AAmYA;;EAEI,cAAA;EACA,yBAAA;AAhYJ;;AAmYA;EACI,WAAA;EACA,yBAAA;EACA,qBAAA;AAhYJ;;AAmYA;EACI,cAAA;EACA,yBAAA;AAhYJ;;AAmYA;;EAEI,cAAA;EACA,yBAAA;AAhYJ;;AAmYA;EACI,WAAA;EACA,yBAAA;EACA,qBAAA;AAhYJ;;AAmYA;EACI,cAAA;EACA,yBAAA;AAhYJ;;AAmYA;;EAEI,cAAA;EACA,yBAAA;AAhYJ;;AAmYA;EACI,WAAA;EACA,yBAAA;EACA,qBAAA;AAhYJ;;AAmYA;EACI,uBAAA;EACA,UAAA;EACA,WAAA;EACA,sBAAA;EACA,WAAA;EACA,0FAAA;EACA,SAAA;EACA,uBAAA;EACA,YAAA;AAhYJ;;AAmYA;EACI,WAAA;EACA,qBAAA;EACA,aAAA;AAhYJ;;AAmYA;EACI,UAAA;EACA,kDAAA;EACA,UAAA;AAhYJ;;AAmYA;;EAEI,oBAAA;EACA,yBAAA;EAEA,iBAAA;EACA,aAAA;AAhYJ;;AAmYA;EACI,kDAAA;AAhYJ;;AAmYA;EACI,6BAAA;EACA,4BAAA;EACA,0BAAA;EACA,2BAAA;EACA,8BAAA;EACA,kBAAA;EACA,wCAAA;EACA,4BAAA;EACA,2DAAA;EACA,kCAAA;EACA,wDAAA;EACA,gCAAA;EACA,+CAAA;EACA,mDAAA;EACA,gCAAA;EACA,eAAA;EACA,oCAAA;EACA,4BAAA;EACA,oBAAA;EACA,oCAAA;EACA,4BAAA;EACA,uEAAA;EACA,sCAAA;EACA,4CAAA;AAhYJ;;AAmYA;EACI,UAAA;AAhYJ;;AAmYA;EACI,aAAA;AAhYJ;;AAmYA;EACI,kBAAA;EACA,aAAA;EAGA,kBAAA;EACA,eAAA;EACA,oBAAA;AAhYJ;;AAmYA;EACI,sCAAA;AAhYJ;;AAmYA;EACI,aAAA;EACA,mBAAA;EACA,4DAAA;EACA,mCAAA;EACA,2CAAA;EACA,4BAAA;EACA,qFAAA;EACA,0FAAA;EACA,2FAAA;AAhYJ;;AAmYA;EACI,oDAAA;EACA,sCAAA;AAhYJ;;AAmYA;EACI,kCAAA;EACA,qBAAA;AAhYJ;;AAmYA;EACI,uBAAA;EACA,uBAAA;EACA,wBAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,2DAAA;EACA,4BAAA;EACA,gCAAA;EACA,8DAAA;EACA,kDAAA;EACA,iCAAA;EACA,iCAAA;EACA,oCAAA;EACA,sDAAA;EACA,mCAAA;EACA,iCAAA;EACA,6BAAA;EACA,sBAAA;EACA,sDAAA;EACA,mCAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,+BAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,UAAA;AAhYJ;;AAmYA;EACI,kBAAA;EACA,WAAA;EACA,8BAAA;EACA,oBAAA;AAhYJ;;AAmYA;EACI,mCAAA;EACA,8BAAA;AAhYJ;;AAmYA;EACI;IACI,gBAAA;EAhYN;AACF;AAmYA;EACI,eAAA;AAjYJ;;AAoYA;EACI,sBAAA;AAjYJ;;AAoYA;EACI,+CAAA;AAjYJ;;AAoYA;EACI,gBAAA;EACA,gBAAA;AAjYJ;;AAoYA;EACI,gBAAA;AAjYJ;;AAoYA;EACI,aAAA;EACA,mBAAA;EACA,mDAAA;AAjYJ;;AAoYA;EACI,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EACA,4BAAA;EACA,oBAAA;EACA,oCAAA;EACA,4BAAA;EACA,uEAAA;EACA,4CAAA;EACA,UAAA;AAjYJ;;AAoYA;EACI,0BAAA;EACA,sBAAA;EACA,0BAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,kCAAA;EACA,YAAA;EACA,aAAA;EACA,uCAAA;AAjYJ;;AAoYA;EACI,UAAA;AAjYJ;;AAoYA;EACI,mCAAA;AAjYJ;;AAoYA;EACI,aAAA;EACA,cAAA;EACA,mBAAA;EACA,8BAAA;EACA,uCAAA;EACA,4FAAA;EACA,2DAAA;EACA,4DAAA;AAjYJ;;AAoYA;EACI,kGAAA;EACA,sJAAA;AAjYJ;;AAoYA;EACI,gBAAA;EACA,8CAAA;AAjYJ;;AAoYA;EACI,kBAAA;EACA,cAAA;EACA,gCAAA;AAjYJ;;AAoYA;EACI,aAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;EACA,yBAAA;EACA,yEAAA;EACA,2CAAA;EACA,yFAAA;EACA,+DAAA;EACA,8DAAA;AAjYJ;;AAoYA;EACI,8CAAA;AAjYJ;;AAoYA;EACI;IACI,0BAAA;IACA,yDAAA;EAjYN;EAoYE;IACI,gCAAA;IACA,kBAAA;IACA,iBAAA;EAlYN;EAqYE;IACI,wBAAA;EAnYN;AACF;AAsYA;EAEI;;IAEI,wBAAA;EArYN;AACF;AAwYA;EACI;IACI,yBAAA;EAtYN;AACF;AAyYA;EACI,YAAA;EACA,eAAA;EACA,YAAA;EACA,SAAA;AAvYJ;;AA0YA;EACI,YAAA;EACA,SAAA;EACA,gBAAA;AAvYJ;;AA0YA;;EAEI,gBAAA;AAvYJ;;AA0YA;EACI,gBAAA;AAvYJ;;AA0YA;EACI;IACI,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;EAvYN;EA0YE;IACI,YAAA;IACA,SAAA;IACA,gBAAA;EAxYN;EA2YE;;IAEI,gBAAA;EAzYN;EA4YE;IACI,gBAAA;EA1YN;AACF;AA6YA;EACI;IACI,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;EA3YN;EA8YE;IACI,YAAA;IACA,SAAA;IACA,gBAAA;EA5YN;EA+YE;;IAEI,gBAAA;EA7YN;EAgZE;IACI,gBAAA;EA9YN;AACF;AAiZA;EACI;IACI,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;EA/YN;EAkZE;IACI,YAAA;IACA,SAAA;IACA,gBAAA;EAhZN;EAmZE;;IAEI,gBAAA;EAjZN;EAoZE;IACI,gBAAA;EAlZN;AACF;AAqZA;EACI;IACI,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;EAnZN;EAsZE;IACI,YAAA;IACA,SAAA;IACA,gBAAA;EApZN;EAuZE;;IAEI,gBAAA;EArZN;EAwZE;IACI,gBAAA;EAtZN;AACF;AAyZA;EACI;IACI,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;EAvZN;EA0ZE;IACI,YAAA;IACA,SAAA;IACA,gBAAA;EAxZN;EA2ZE;;IAEI,gBAAA;EAzZN;EA4ZE;IACI,gBAAA;EA1ZN;AACF;AA6ZA;EACI,yBAAA;EACA,6BAAA;EACA,8BAAA;EACA,+BAAA;EACA,qBAAA;EACA,gCAAA;EACA,wBAAA;EACA,qBAAA;EACA,oCAAA;EACA,yBAAA;EACA,gCAAA;EACA,iCAAA;EACA,iCAAA;EACA,cAAA;EACA,uCAAA;EACA,gCAAA;EACA,sCAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,iBAAA;EACA,oBAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gBAAA;EACA,sCAAA;EACA,qBAAA;EACA,UAAA;AA3ZJ;;AA8ZA;EACI,kCAAA;AA3ZJ;;AA8ZA;EACI,cAAA;EACA,oCAAA;EACA,sCAAA;AA3ZJ;;AA8ZA;EACI,kBAAA;EACA,WAAA;EACA,yBAAA;EACA,mBAAA;AA3ZJ;;AA8ZA;;EAEI,SAAA;AA3ZJ;;AA8ZA;;EAEI,SAAA;EACA,wFAAA;EACA,sCAAA;AA3ZJ;;AA8ZA;;EAEI,OAAA;EACA,qCAAA;EACA,qCAAA;AA3ZJ;;AA8ZA;;EAEI,WAAA;EACA,kIAAA;EACA,wCAAA;AA3ZJ;;AA8ZA;;EAEI,MAAA;AA3ZJ;;AA8ZA;;EAEI,YAAA;EACA,wFAAA;EACA,yCAAA;AA3ZJ;;AA8ZA;;EAEI,QAAA;EACA,qCAAA;EACA,qCAAA;AA3ZJ;;AA8ZA;;EAEI,UAAA;EACA,kIAAA;EACA,uCAAA;AA3ZJ;;AA8ZA;EACI,sCAAA;EACA,gEAAA;EACA,8BAAA;EACA,kBAAA;EACA,sCAAA;EACA,8CAAA;AA3ZJ;;AA8ZA;EACI,yBAAA;EACA,6BAAA;EACA,gCAAA;EACA,qBAAA;EACA,8BAAA;EACA,6DAAA;EACA,kCAAA;EACA,oDAAA;EACA,0DAAA;EACA,mCAAA;EACA,qCAAA;EACA,mCAAA;EACA,kDAAA;EACA,+BAAA;EACA,iCAAA;EACA,iCAAA;EACA,gCAAA;EACA,8BAAA;EACA,iCAAA;EACA,yDAAA;EACA,iCAAA;EACA,cAAA;EACA,sCAAA;EACA,sCAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,iBAAA;EACA,oBAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gBAAA;EACA,sCAAA;EACA,qBAAA;EACA,sCAAA;EACA,4BAAA;EACA,2EAAA;EACA,8CAAA;AA3ZJ;;AA8ZA;EACI,cAAA;EACA,oCAAA;EACA,sCAAA;AA3ZJ;;AA8ZA;;EAEI,kBAAA;EACA,cAAA;EACA,WAAA;EACA,yBAAA;EACA,mBAAA;EACA,eAAA;AA3ZJ;;AA8ZA;;EAEI,kFAAA;AA3ZJ;;AA8ZA;;;;EAII,wFAAA;AA3ZJ;;AA8ZA;;EAEI,SAAA;EACA,gDAAA;AA3ZJ;;AA8ZA;;EAEI,sCAAA;EACA,sCAAA;AA3ZJ;;AA8ZA;;EAEI,gFAAA;EACA,qCAAA;EACA,qCAAA;AA3ZJ;;AA8ZA;;;;EAII,kIAAA;AA3ZJ;;AA8ZA;;EAEI,OAAA;EACA,kDAAA;AA3ZJ;;AA8ZA;;EAEI,oCAAA;EACA,wCAAA;AA3ZJ;;AA8ZA;;EAEI,+EAAA;AA3ZJ;;AA8ZA;;;;EAII,wFAAA;AA3ZJ;;AA8ZA;;EAEI,MAAA;EACA,mDAAA;AA3ZJ;;AA8ZA;;EAEI,mCAAA;EACA,yCAAA;AA3ZJ;;AA8ZA;;EAEI,kBAAA;EACA,MAAA;EACA,SAAA;EACA,cAAA;EACA,oCAAA;EACA,uDAAA;EACA,WAAA;EACA,+EAAA;AA3ZJ;;AA8ZA;;EAEI,iFAAA;EACA,qCAAA;EACA,qCAAA;AA3ZJ;;AA8ZA;;;;EAII,kIAAA;AA3ZJ;;AA8ZA;;EAEI,QAAA;EACA,iDAAA;AA3ZJ;;AA8ZA;;EAEI,qCAAA;EACA,uCAAA;AA3ZJ;;AA8ZA;EACI,8EAAA;EACA,gBAAA;EACA,6CAAA;EACA,qCAAA;EACA,6CAAA;EACA,kFAAA;EACA,6DAAA;EACA,8DAAA;AA3ZJ;;AA8ZA;EACI,aAAA;AA3ZJ;;AA8ZA;EACI,0EAAA;EACA,mCAAA;AA3ZJ;;AA8ZA;EACI,kBAAA;AA3ZJ;;AA8ZA;EACI,mBAAA;AA3ZJ;;AA8ZA;EACI,kBAAA;EACA,WAAA;EACA,gBAAA;AA3ZJ;;AA8ZA;EACI,cAAA;EACA,WAAA;EACA,WAAA;AA3ZJ;;AA8ZA;EACI,kBAAA;EACA,aAAA;EACA,WAAA;EACA,WAAA;EACA,mBAAA;EAEA,2BAAA;EACA,sCAAA;AA3ZJ;;AA8ZA;EACI;IACI,gBAAA;EA3ZN;AACF;AA8ZA;;;EAGI,cAAA;AA5ZJ;;AA+ZA;;EAEI,2BAAA;AA5ZJ;;AA+ZA;;EAEI,4BAAA;AA5ZJ;;AA+ZA;EACI,UAAA;EACA,4BAAA;EACA,eAAA;AA5ZJ;;AA+ZA;;;EAGI,UAAA;EACA,UAAA;AA5ZJ;;AA+ZA;;EAEI,UAAA;EACA,UAAA;EACA,2BAAA;AA5ZJ;;AA+ZA;EAEI;;IAEI,gBAAA;EA7ZN;AACF;AAgaA;;EAEI,kBAAA;EACA,MAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,UAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,eAAA;EACA,SAAA;EACA,YAAA;EACA,8BAAA;AA9ZJ;;AAiaA;EAEI;;IAEI,gBAAA;EA/ZN;AACF;AAkaA;;;;EAII,WAAA;EACA,qBAAA;EACA,UAAA;EACA,YAAA;AAhaJ;;AAmaA;EACI,OAAA;AAhaJ;;AAmaA;EACI,QAAA;AAhaJ;;AAmaA;;EAEI,qBAAA;EACA,WAAA;EACA,YAAA;EACA,4BAAA;EACA,wBAAA;EACA,0BAAA;AAhaJ;;AAmaA;EACI,0DAAA;AAhaJ;;AAmaA;EACI,0DAAA;AAhaJ;;AAmaA;EACI,kBAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;EACA,aAAA;EACA,uBAAA;EACA,UAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;AAhaJ;;AAmaA;EACI,uBAAA;EACA,cAAA;EACA,WAAA;EACA,WAAA;EACA,UAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,sBAAA;EACA,4BAAA;EACA,SAAA;EACA,kCAAA;EACA,qCAAA;EACA,YAAA;EACA,6BAAA;AAhaJ;;AAmaA;EACI;IACI,gBAAA;EAhaN;AACF;AAmaA;EACI,UAAA;AAjaJ;;AAoaA;EACI,kBAAA;EACA,UAAA;EACA,eAAA;EACA,SAAA;EACA,oBAAA;EACA,uBAAA;EACA,WAAA;EACA,kBAAA;AAjaJ;;AAoaA;;EAEI,gCAAA;AAjaJ;;AAoaA;EACI,sBAAA;AAjaJ;;AAoaA;EACI,WAAA;AAjaJ;;AAoaA;;EAEI,qBAAA;EACA,8BAAA;EACA,gCAAA;EACA,gDAAA;EACA,kBAAA;EAEA,6FAAA;AAjaJ;AA0aA;EACI;IACI,yBAAA;EAlaN;AACF;AAqaA;EACI,wBAAA;EACA,yBAAA;EACA,qCAAA;EACA,iCAAA;EACA,mCAAA;EACA,2CAAA;EACA,yDAAA;EACA,+BAAA;AAnaJ;;AAsaA;EACI,wBAAA;EACA,yBAAA;EACA,iCAAA;AAnaJ;AAibA;EACI;IACI,mBAAA;EAraN;EAwaE;IACI,UAAA;IACA,eAAA;EAtaN;AACF;AAyaA;EACI,wBAAA;EACA,yBAAA;EACA,qCAAA;EACA,mCAAA;EACA,yCAAA;EACA,8BAAA;EACA,UAAA;AAvaJ;;AA0aA;EACI,wBAAA;EACA,0BAAA;AAvaJ;;AA0aA;EAEI;;IAEI,mCAAA;EAxaN;AACF;AA2aA;;;;;;EAMI,2BAAA;EACA,2BAAA;EACA,8BAAA;EACA,8BAAA;EACA,sBAAA;EACA,uBAAA;EACA,gCAAA;EACA,+DAAA;EACA,mEAAA;AAzaJ;;AA4aA;EACI;IACI,eAAA;IACA,SAAA;IACA,aAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,gCAAA;IACA,kBAAA;IACA,wCAAA;IACA,4BAAA;IACA,UAAA;IACA,sCAAA;EAzaN;AACF;AA4aA;EACI;IACI,gBAAA;EA1aN;AACF;AA6aA;EACI;IACI,MAAA;IACA,OAAA;IACA,gCAAA;IACA,qFAAA;IACA,4BAAA;EA3aN;AACF;AA8aA;EACI;IACI,MAAA;IACA,QAAA;IACA,gCAAA;IACA,oFAAA;IACA,2BAAA;EA5aN;AACF;AA+aA;EACI;IACI,MAAA;IACA,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,sFAAA;IACA,4BAAA;EA7aN;AACF;AAgbA;EACI;IACI,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,mFAAA;IACA,2BAAA;EA9aN;AACF;AAibA;EAEI;;IAEI,eAAA;EAhbN;AACF;AAmbA;EAEI;;;IAGI,mBAAA;EAlbN;AACF;AAqbA;EACI;IACI,2BAAA;IACA,8BAAA;IACA,wCAAA;EAnbN;EAsbE;IACI,aAAA;EApbN;EAubE;IACI,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IACA,wCAAA;EArbN;AACF;AAwbA;EACI;IACI,eAAA;IACA,SAAA;IACA,aAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,gCAAA;IACA,kBAAA;IACA,wCAAA;IACA,4BAAA;IACA,UAAA;IACA,sCAAA;EAtbN;AACF;AAybA;EACI;IACI,gBAAA;EAvbN;AACF;AA0bA;EACI;IACI,MAAA;IACA,OAAA;IACA,gCAAA;IACA,qFAAA;IACA,4BAAA;EAxbN;AACF;AA2bA;EACI;IACI,MAAA;IACA,QAAA;IACA,gCAAA;IACA,oFAAA;IACA,2BAAA;EAzbN;AACF;AA4bA;EACI;IACI,MAAA;IACA,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,sFAAA;IACA,4BAAA;EA1bN;AACF;AA6bA;EACI;IACI,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,mFAAA;IACA,2BAAA;EA3bN;AACF;AA8bA;EAEI;;IAEI,eAAA;EA7bN;AACF;AAgcA;EAEI;;;IAGI,mBAAA;EA/bN;AACF;AAkcA;EACI;IACI,2BAAA;IACA,8BAAA;IACA,wCAAA;EAhcN;EAmcE;IACI,aAAA;EAjcN;EAocE;IACI,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IACA,wCAAA;EAlcN;AACF;AAqcA;EACI;IACI,eAAA;IACA,SAAA;IACA,aAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,gCAAA;IACA,kBAAA;IACA,wCAAA;IACA,4BAAA;IACA,UAAA;IACA,sCAAA;EAncN;AACF;AAscA;EACI;IACI,gBAAA;EApcN;AACF;AAucA;EACI;IACI,MAAA;IACA,OAAA;IACA,gCAAA;IACA,qFAAA;IACA,4BAAA;EArcN;AACF;AAwcA;EACI;IACI,MAAA;IACA,QAAA;IACA,gCAAA;IACA,oFAAA;IACA,2BAAA;EAtcN;AACF;AAycA;EACI;IACI,MAAA;IACA,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,sFAAA;IACA,4BAAA;EAvcN;AACF;AA0cA;EACI;IACI,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,mFAAA;IACA,2BAAA;EAxcN;AACF;AA2cA;EAEI;;IAEI,eAAA;EA1cN;AACF;AA6cA;EAEI;;;IAGI,mBAAA;EA5cN;AACF;AA+cA;EACI;IACI,2BAAA;IACA,8BAAA;IACA,wCAAA;EA7cN;EAgdE;IACI,aAAA;EA9cN;EAidE;IACI,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IACA,wCAAA;EA/cN;AACF;AAkdA;EACI;IACI,eAAA;IACA,SAAA;IACA,aAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,gCAAA;IACA,kBAAA;IACA,wCAAA;IACA,4BAAA;IACA,UAAA;IACA,sCAAA;EAhdN;AACF;AAmdA;EACI;IACI,gBAAA;EAjdN;AACF;AAodA;EACI;IACI,MAAA;IACA,OAAA;IACA,gCAAA;IACA,qFAAA;IACA,4BAAA;EAldN;AACF;AAqdA;EACI;IACI,MAAA;IACA,QAAA;IACA,gCAAA;IACA,oFAAA;IACA,2BAAA;EAndN;AACF;AAsdA;EACI;IACI,MAAA;IACA,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,sFAAA;IACA,4BAAA;EApdN;AACF;AAudA;EACI;IACI,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,mFAAA;IACA,2BAAA;EArdN;AACF;AAwdA;EAEI;;IAEI,eAAA;EAvdN;AACF;AA0dA;EAEI;;;IAGI,mBAAA;EAzdN;AACF;AA4dA;EACI;IACI,2BAAA;IACA,8BAAA;IACA,wCAAA;EA1dN;EA6dE;IACI,aAAA;EA3dN;EA8dE;IACI,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IACA,wCAAA;EA5dN;AACF;AA+dA;EACI;IACI,eAAA;IACA,SAAA;IACA,aAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,gCAAA;IACA,kBAAA;IACA,wCAAA;IACA,4BAAA;IACA,UAAA;IACA,sCAAA;EA7dN;AACF;AAgeA;EACI;IACI,gBAAA;EA9dN;AACF;AAieA;EACI;IACI,MAAA;IACA,OAAA;IACA,gCAAA;IACA,qFAAA;IACA,4BAAA;EA/dN;AACF;AAkeA;EACI;IACI,MAAA;IACA,QAAA;IACA,gCAAA;IACA,oFAAA;IACA,2BAAA;EAheN;AACF;AAmeA;EACI;IACI,MAAA;IACA,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,sFAAA;IACA,4BAAA;EAjeN;AACF;AAoeA;EACI;IACI,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,mFAAA;IACA,2BAAA;EAleN;AACF;AAqeA;EAEI;;IAEI,eAAA;EApeN;AACF;AAueA;EAEI;;;IAGI,mBAAA;EAteN;AACF;AAyeA;EACI;IACI,2BAAA;IACA,8BAAA;IACA,wCAAA;EAveN;EA0eE;IACI,aAAA;EAxeN;EA2eE;IACI,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IACA,wCAAA;EAzeN;AACF;AA4eA;EACI,eAAA;EACA,SAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,eAAA;EACA,gCAAA;EACA,kBAAA;EACA,wCAAA;EACA,4BAAA;EACA,UAAA;EACA,sCAAA;AA1eJ;;AA6eA;EACI;IACI,gBAAA;EA1eN;AACF;AA6eA;EACI,MAAA;EACA,OAAA;EACA,gCAAA;EACA,qFAAA;EACA,4BAAA;AA3eJ;;AA8eA;EACI,MAAA;EACA,QAAA;EACA,gCAAA;EACA,oFAAA;EACA,2BAAA;AA3eJ;;AA8eA;EACI,MAAA;EACA,QAAA;EACA,OAAA;EACA,kCAAA;EACA,gBAAA;EACA,sFAAA;EACA,4BAAA;AA3eJ;;AA8eA;EACI,QAAA;EACA,OAAA;EACA,kCAAA;EACA,gBAAA;EACA,mFAAA;EACA,2BAAA;AA3eJ;;AA8eA;;EAEI,eAAA;AA3eJ;;AA8eA;;;EAGI,mBAAA;AA3eJ;;AA8eA;EACI,eAAA;EACA,MAAA;EACA,OAAA;EACA,aAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;AA3eJ;;AA8eA;EACI,UAAA;AA3eJ;;AA8eA;EACI,YAAA;AA3eJ;;AA8eA;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,oEAAA;AA3eJ;;AA8eA;EACI,4FAAA;EACA,sDAAA;EACA,wDAAA;EACA,yDAAA;AA3eJ;;AA8eA;EACI,gBAAA;EACA,gBAAA;AA3eJ;;AA8eA;EACI,YAAA;EACA,oEAAA;EACA,gBAAA;AA3eJ;;AA8eA;EACI,qBAAA;EACA,eAAA;EACA,sBAAA;EACA,YAAA;EACA,8BAAA;EACA,YAAA;AA3eJ;;AA8eA;EACI,qBAAA;EACA,WAAA;AA3eJ;;AA8eA;EACI,iBAAA;AA3eJ;;AA8eA;EACI,iBAAA;AA3eJ;;AA8eA;EACI,iBAAA;AA3eJ;;AA8eA;EAEI,mDAAA;AA3eJ;AAofA;EACI;IACI,YAAA;EA5eN;AACF;AA+eA;EAEI,+EAAA;EAEA,oBAAA;EAEA,8CAAA;AA7eJ;AAufA;EACI;IAEI,uBAAA;EA9eN;AACF;AAifA;EACI,cAAA;EACA,WAAA;EACA,WAAA;AA/eJ;;AAkfA;EACI,sBAAA;EACA,wEAAA;AA/eJ;;AAkfA;EACI,sBAAA;EACA,yEAAA;AA/eJ;;AAkfA;EACI,sBAAA;EACA,uEAAA;AA/eJ;;AAkfA;EACI,sBAAA;EACA,wEAAA;AA/eJ;;AAkfA;EACI,sBAAA;EACA,uEAAA;AA/eJ;;AAkfA;EACI,sBAAA;EACA,uEAAA;AA/eJ;;AAkfA;EACI,sBAAA;EACA,yEAAA;AA/eJ;;AAkfA;EACI,sBAAA;EACA,sEAAA;AA/eJ;;AAkfA;EACI,yBAAA;AA/eJ;;AAkfA;;EAEI,yBAAA;AA/eJ;;AAkfA;EACI,yBAAA;AA/eJ;;AAkfA;;EAEI,yBAAA;AA/eJ;;AAkfA;EACI,yBAAA;AA/eJ;;AAkfA;;EAEI,yBAAA;AA/eJ;;AAkfA;EACI,yBAAA;AA/eJ;;AAkfA;;EAEI,yBAAA;AA/eJ;;AAkfA;EACI,yBAAA;AA/eJ;;AAkfA;;EAEI,yBAAA;AA/eJ;;AAkfA;EACI,yBAAA;AA/eJ;;AAkfA;;EAEI,yBAAA;AA/eJ;;AAkfA;EACI,yBAAA;AA/eJ;;AAkfA;;EAEI,yBAAA;AA/eJ;;AAkfA;EACI,yBAAA;AA/eJ;;AAkfA;;EAEI,yBAAA;AA/eJ;;AAkfA;EACI,kBAAA;EACA,WAAA;AA/eJ;;AAkfA;EACI,cAAA;EACA,mCAAA;EACA,WAAA;AA/eJ;;AAkfA;EACI,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;AA/eJ;;AAkfA;EACI,wBAAA;AA/eJ;;AAkfA;EACI,uBAAA;AA/eJ;;AAkfA;EACI,0BAAA;AA/eJ;;AAkfA;EACI,kCAAA;AA/eJ;;AAkfA;EACI,eAAA;EACA,MAAA;EACA,QAAA;EACA,OAAA;EACA,aAAA;AA/eJ;;AAkfA;EACI,eAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,aAAA;AA/eJ;;AAkfA;EAEI,gBAAA;EACA,MAAA;EACA,aAAA;AA/eJ;;AAkfA;EAEI,gBAAA;EACA,SAAA;EACA,aAAA;AA/eJ;;AAkfA;EACI;IAEI,gBAAA;IACA,MAAA;IACA,aAAA;EA/eN;EAkfE;IAEI,gBAAA;IACA,SAAA;IACA,aAAA;EAhfN;AACF;AAmfA;EACI;IAEI,gBAAA;IACA,MAAA;IACA,aAAA;EAjfN;EAofE;IAEI,gBAAA;IACA,SAAA;IACA,aAAA;EAlfN;AACF;AAqfA;EACI;IAEI,gBAAA;IACA,MAAA;IACA,aAAA;EAnfN;EAsfE;IAEI,gBAAA;IACA,SAAA;IACA,aAAA;EApfN;AACF;AAufA;EACI;IAEI,gBAAA;IACA,MAAA;IACA,aAAA;EArfN;EAwfE;IAEI,gBAAA;IACA,SAAA;IACA,aAAA;EAtfN;AACF;AAyfA;EACI;IAEI,gBAAA;IACA,MAAA;IACA,aAAA;EAvfN;EA0fE;IAEI,gBAAA;IACA,SAAA;IACA,aAAA;EAxfN;AACF;AA2fA;EACI,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;AAzfJ;;AA4fA;EACI,aAAA;EACA,cAAA;EACA,sBAAA;EACA,mBAAA;AAzfJ;;AA4fA;;EAEI,6BAAA;EACA,qBAAA;EACA,sBAAA;EACA,qBAAA;EACA,uBAAA;EACA,2BAAA;EACA,iCAAA;EACA,8BAAA;EACA,oBAAA;AAzfJ;;AA4fA;EACI,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;EACA,WAAA;AAzfJ;;AA4fA;EACI,gBAAA;EACA,uBAAA;EACA,mBAAA;AAzfJ;;AA4fA;EACI,qBAAA;EACA,mBAAA;EACA,UAAA;EACA,eAAA;EACA,8BAAA;EACA,aAAA;AAzfJ;;AA4fA;EACI,mCAAA;AAzfJ;;AA4fA;EACI,8BAAA;AAzfJ;;AA4fA;EACI,iCAAA;AAzfJ;;AA4fA;EACI,iCAAA;AAzfJ;;AA4fA;EACI,sCAAA;AAzfJ;;AA4fA;EACI,mCAAA;AAzfJ;;AA4fA;EACI,sBAAA;AAzfJ;;AA4fA;EACI,uBAAA;AAzfJ;;AA4fA;EACI,sBAAA;AAzfJ;;AA4fA;EACI,qBAAA;AAzfJ;;AA4fA;EACI,wBAAA;AAzfJ;;AA4fA;EACI,uBAAA;AAzfJ;;AA4fA;EACI,wBAAA;AAzfJ;;AA4fA;EACI,qBAAA;AAzfJ;;AA4fA;EACI,yBAAA;AAzfJ;;AA4fA;EACI,2BAAA;AAzfJ;;AA4fA;EACI,4BAAA;AAzfJ;;AA4fA;EACI,2BAAA;AAzfJ;;AA4fA;EACI,0BAAA;AAzfJ;;AA4fA;EACI,gCAAA;AAzfJ;;AA4fA;EACI,yBAAA;AAzfJ;;AA4fA;EACI,wBAAA;AAzfJ;;AA4fA;EACI,yBAAA;AAzfJ;;AA4fA;EACI,6BAAA;AAzfJ;;AA4fA;EACI,8BAAA;AAzfJ;;AA4fA;EACI,wBAAA;AAzfJ;;AA4fA;EACI,+BAAA;AAzfJ;;AA4fA;EACI,wBAAA;AAzfJ;;AA4fA;EACI,wDAAA;AAzfJ;;AA4fA;EACI,8DAAA;AAzfJ;;AA4fA;EACI,uDAAA;AAzfJ;;AA4fA;EACI,2BAAA;AAzfJ;;AA4fA;EACI,2BAAA;AAzfJ;;AA4fA;EACI,6BAAA;AAzfJ;;AA4fA;EACI,6BAAA;AAzfJ;;AA4fA;EACI,0BAAA;AAzfJ;;AA4fA;EAEI,2BAAA;AAzfJ;;AA4fA;EACI,iBAAA;AAzfJ;;AA4fA;EACI,mBAAA;AAzfJ;;AA4fA;EACI,oBAAA;AAzfJ;;AA4fA;EACI,oBAAA;AAzfJ;;AA4fA;EACI,sBAAA;AAzfJ;;AA4fA;EACI,uBAAA;AAzfJ;;AA4fA;EACI,kBAAA;AAzfJ;;AA4fA;EACI,oBAAA;AAzfJ;;AA4fA;EACI,qBAAA;AAzfJ;;AA4fA;EACI,mBAAA;AAzfJ;;AA4fA;EACI,qBAAA;AAzfJ;;AA4fA;EACI,sBAAA;AAzfJ;;AA4fA;EACI,2CAAA;AAzfJ;;AA4fA;EACI,sCAAA;AAzfJ;;AA4fA;EACI,sCAAA;AAzfJ;;AA4fA;EACI,uFAAA;AAzfJ;;AA4fA;EACI,oBAAA;AAzfJ;;AA4fA;EACI,2FAAA;AAzfJ;;AA4fA;EACI,wBAAA;AAzfJ;;AA4fA;EACI,6FAAA;AAzfJ;;AA4fA;EACI,0BAAA;AAzfJ;;AA4fA;EACI,8FAAA;AAzfJ;;AA4fA;EACI,2BAAA;AAzfJ;;AA4fA;EACI,4FAAA;AAzfJ;;AA4fA;EACI,yBAAA;AAzfJ;;AA4fA;EACI,sBAAA;EACA,8EAAA;AAzfJ;;AA4fA;EACI,sBAAA;EACA,gFAAA;AAzfJ;;AA4fA;EACI,sBAAA;EACA,8EAAA;AAzfJ;;AA4fA;EACI,sBAAA;EACA,2EAAA;AAzfJ;;AA4fA;EACI,sBAAA;EACA,8EAAA;AAzfJ;;AA4fA;EACI,sBAAA;EACA,6EAAA;AAzfJ;;AA4fA;EACI,sBAAA;EACA,4EAAA;AAzfJ;;AA4fA;EACI,sBAAA;EACA,2EAAA;AAzfJ;;AA4fA;EACI,sBAAA;EACA,4EAAA;AAzfJ;;AA4fA;EACI,uBAAA;AAzfJ;;AA4fA;EACI,uBAAA;AAzfJ;;AA4fA;EACI,uBAAA;AAzfJ;;AA4fA;EACI,uBAAA;AAzfJ;;AA4fA;EACI,uBAAA;AAzfJ;;AA4fA;EACI,yBAAA;AAzfJ;;AA4fA;EACI,0BAAA;AAzfJ;;AA4fA;EACI,yBAAA;AAzfJ;;AA4fA;EACI,0BAAA;AAzfJ;;AA4fA;EACI,uBAAA;AAzfJ;;AA4fA;EACI,qBAAA;AAzfJ;;AA4fA;EACI,qBAAA;AAzfJ;;AA4fA;EACI,qBAAA;AAzfJ;;AA4fA;EACI,sBAAA;AAzfJ;;AA4fA;EACI,sBAAA;AAzfJ;;AA4fA;EACI,0BAAA;AAzfJ;;AA4fA;EACI,uBAAA;AAzfJ;;AA4fA;EACI,2BAAA;AAzfJ;;AA4fA;EACI,sBAAA;AAzfJ;;AA4fA;EACI,sBAAA;AAzfJ;;AA4fA;EACI,sBAAA;AAzfJ;;AA4fA;EACI,uBAAA;AAzfJ;;AA4fA;EACI,uBAAA;AAzfJ;;AA4fA;EACI,2BAAA;AAzfJ;;AA4fA;EACI,wBAAA;AAzfJ;;AA4fA;EACI,4BAAA;AAzfJ;;AA4fA;EACI,yBAAA;AAzfJ;;AA4fA;EACI,8BAAA;AAzfJ;;AA4fA;EACI,iCAAA;AAzfJ;;AA4fA;EACI,sCAAA;AAzfJ;;AA4fA;EACI,yCAAA;AAzfJ;;AA4fA;EACI,uBAAA;AAzfJ;;AA4fA;EACI,uBAAA;AAzfJ;;AA4fA;EACI,yBAAA;AAzfJ;;AA4fA;EACI,yBAAA;AAzfJ;;AA4fA;EACI,0BAAA;AAzfJ;;AA4fA;EACI,4BAAA;AAzfJ;;AA4fA;EACI,kCAAA;AAzfJ;;AA4fA;EACI,sCAAA;AAzfJ;;AA4fA;EACI,oCAAA;AAzfJ;;AA4fA;EACI,kCAAA;AAzfJ;;AA4fA;EACI,yCAAA;AAzfJ;;AA4fA;EACI,wCAAA;AAzfJ;;AA4fA;EACI,wCAAA;AAzfJ;;AA4fA;EACI,kCAAA;AAzfJ;;AA4fA;EACI,gCAAA;AAzfJ;;AA4fA;EACI,8BAAA;AAzfJ;;AA4fA;EACI,gCAAA;AAzfJ;;AA4fA;EACI,+BAAA;AAzfJ;;AA4fA;EACI,oCAAA;AAzfJ;;AA4fA;EACI,kCAAA;AAzfJ;;AA4fA;EACI,gCAAA;AAzfJ;;AA4fA;EACI,uCAAA;AAzfJ;;AA4fA;EACI,sCAAA;AAzfJ;;AA4fA;EACI,iCAAA;AAzfJ;;AA4fA;EACI,2BAAA;AAzfJ;;AA4fA;EACI,iCAAA;AAzfJ;;AA4fA;EACI,+BAAA;AAzfJ;;AA4fA;EACI,6BAAA;AAzfJ;;AA4fA;EACI,+BAAA;AAzfJ;;AA4fA;EACI,8BAAA;AAzfJ;;AA4fA;EACI,oBAAA;AAzfJ;;AA4fA;EACI,mBAAA;AAzfJ;;AA4fA;EACI,mBAAA;AAzfJ;;AA4fA;EACI,mBAAA;AAzfJ;;AA4fA;EACI,mBAAA;AAzfJ;;AA4fA;EACI,mBAAA;AAzfJ;;AA4fA;EACI,mBAAA;AAzfJ;;AA4fA;EACI,mBAAA;AAzfJ;;AA4fA;EACI,oBAAA;AAzfJ;;AA4fA;EACI,0BAAA;AAzfJ;;AA4fA;EACI,yBAAA;AAzfJ;;AA4fA;EACI,uBAAA;AAzfJ;;AA4fA;EACI,yBAAA;AAzfJ;;AA4fA;EACI,uBAAA;AAzfJ;;AA4fA;EACI,uBAAA;AAzfJ;;AA4fA;EACI,0BAAA;EACA,yBAAA;AAzfJ;;AA4fA;EACI,gCAAA;EACA,+BAAA;AAzfJ;;AA4fA;EACI,+BAAA;EACA,8BAAA;AAzfJ;;AA4fA;EACI,6BAAA;EACA,4BAAA;AAzfJ;;AA4fA;EACI,+BAAA;EACA,8BAAA;AAzfJ;;AA4fA;EACI,6BAAA;EACA,4BAAA;AAzfJ;;AA4fA;EACI,6BAAA;EACA,4BAAA;AAzfJ;;AA4fA;EACI,wBAAA;EACA,2BAAA;AAzfJ;;AA4fA;EACI,8BAAA;EACA,iCAAA;AAzfJ;;AA4fA;EACI,6BAAA;EACA,gCAAA;AAzfJ;;AA4fA;EACI,2BAAA;EACA,8BAAA;AAzfJ;;AA4fA;EACI,6BAAA;EACA,gCAAA;AAzfJ;;AA4fA;EACI,2BAAA;EACA,8BAAA;AAzfJ;;AA4fA;EACI,2BAAA;EACA,8BAAA;AAzfJ;;AA4fA;EACI,wBAAA;AAzfJ;;AA4fA;EACI,8BAAA;AAzfJ;;AA4fA;EACI,6BAAA;AAzfJ;;AA4fA;EACI,2BAAA;AAzfJ;;AA4fA;EACI,6BAAA;AAzfJ;;AA4fA;EACI,2BAAA;AAzfJ;;AA4fA;EACI,2BAAA;AAzfJ;;AA4fA;EACI,0BAAA;AAzfJ;;AA4fA;EACI,gCAAA;AAzfJ;;AA4fA;EACI,+BAAA;AAzfJ;;AA4fA;EACI,6BAAA;AAzfJ;;AA4fA;EACI,+BAAA;AAzfJ;;AA4fA;EACI,6BAAA;AAzfJ;;AA4fA;EACI,6BAAA;AAzfJ;;AA4fA;EACI,2BAAA;AAzfJ;;AA4fA;EACI,iCAAA;AAzfJ;;AA4fA;EACI,gCAAA;AAzfJ;;AA4fA;EACI,8BAAA;AAzfJ;;AA4fA;EACI,gCAAA;AAzfJ;;AA4fA;EACI,8BAAA;AAzfJ;;AA4fA;EACI,8BAAA;AAzfJ;;AA4fA;EACI,yBAAA;AAzfJ;;AA4fA;EACI,+BAAA;AAzfJ;;AA4fA;EACI,8BAAA;AAzfJ;;AA4fA;EACI,4BAAA;AAzfJ;;AA4fA;EACI,8BAAA;AAzfJ;;AA4fA;EACI,4BAAA;AAzfJ;;AA4fA;EACI,4BAAA;AAzfJ;;AA4fA;EACI,qBAAA;AAzfJ;;AA4fA;EACI,2BAAA;AAzfJ;;AA4fA;EACI,0BAAA;AAzfJ;;AA4fA;EACI,wBAAA;AAzfJ;;AA4fA;EACI,0BAAA;AAzfJ;;AA4fA;EACI,wBAAA;AAzfJ;;AA4fA;EACI,2BAAA;EACA,0BAAA;AAzfJ;;AA4fA;EACI,iCAAA;EACA,gCAAA;AAzfJ;;AA4fA;EACI,gCAAA;EACA,+BAAA;AAzfJ;;AA4fA;EACI,8BAAA;EACA,6BAAA;AAzfJ;;AA4fA;EACI,gCAAA;EACA,+BAAA;AAzfJ;;AA4fA;EACI,8BAAA;EACA,6BAAA;AAzfJ;;AA4fA;EACI,yBAAA;EACA,4BAAA;AAzfJ;;AA4fA;EACI,+BAAA;EACA,kCAAA;AAzfJ;;AA4fA;EACI,8BAAA;EACA,iCAAA;AAzfJ;;AA4fA;EACI,4BAAA;EACA,+BAAA;AAzfJ;;AA4fA;EACI,8BAAA;EACA,iCAAA;AAzfJ;;AA4fA;EACI,4BAAA;EACA,+BAAA;AAzfJ;;AA4fA;EACI,yBAAA;AAzfJ;;AA4fA;EACI,+BAAA;AAzfJ;;AA4fA;EACI,8BAAA;AAzfJ;;AA4fA;EACI,4BAAA;AAzfJ;;AA4fA;EACI,8BAAA;AAzfJ;;AA4fA;EACI,4BAAA;AAzfJ;;AA4fA;EACI,2BAAA;AAzfJ;;AA4fA;EACI,iCAAA;AAzfJ;;AA4fA;EACI,gCAAA;AAzfJ;;AA4fA;EACI,8BAAA;AAzfJ;;AA4fA;EACI,gCAAA;AAzfJ;;AA4fA;EACI,8BAAA;AAzfJ;;AA4fA;EACI,4BAAA;AAzfJ;;AA4fA;EACI,kCAAA;AAzfJ;;AA4fA;EACI,iCAAA;AAzfJ;;AA4fA;EACI,+BAAA;AAzfJ;;AA4fA;EACI,iCAAA;AAzfJ;;AA4fA;EACI,+BAAA;AAzfJ;;AA4fA;EACI,0BAAA;AAzfJ;;AA4fA;EACI,gCAAA;AAzfJ;;AA4fA;EACI,+BAAA;AAzfJ;;AA4fA;EACI,6BAAA;AAzfJ;;AA4fA;EACI,+BAAA;AAzfJ;;AA4fA;EACI,6BAAA;AAzfJ;;AA4fA;EACI,iBAAA;AAzfJ;;AA4fA;EACI,uBAAA;AAzfJ;;AA4fA;EACI,sBAAA;AAzfJ;;AA4fA;EACI,oBAAA;AAzfJ;;AA4fA;EACI,sBAAA;AAzfJ;;AA4fA;EACI,oBAAA;AAzfJ;;AA4fA;EACI,gDAAA;AAzfJ;;AA4fA;EACI,4CAAA;AAzfJ;;AA4fA;EACI,4CAAA;AAzfJ;;AA4fA;EACI,0CAAA;AAzfJ;;AA4fA;EACI,4CAAA;AAzfJ;;AA4fA;EACI,6BAAA;AAzfJ;;AA4fA;EACI,0BAAA;AAzfJ;;AA4fA;EACI,6BAAA;AAzfJ;;AA4fA;EACI,6BAAA;AAzfJ;;AA4fA;EACI,2BAAA;AAzfJ;;AA4fA;EACI,+BAAA;AAzfJ;;AA4fA;EACI,2BAAA;AAzfJ;;AA4fA;EACI,2BAAA;AAzfJ;;AA4fA;EACI,2BAAA;AAzfJ;;AA4fA;EACI,8BAAA;AAzfJ;;AA4fA;EACI,yBAAA;AAzfJ;;AA4fA;EACI,4BAAA;AAzfJ;;AA4fA;EACI,2BAAA;AAzfJ;;AA4fA;EACI,yBAAA;AAzfJ;;AA4fA;EACI,2BAAA;AAzfJ;;AA4fA;EACI,4BAAA;AAzfJ;;AA4fA;EACI,6BAAA;AAzfJ;;AA4fA;EACI,gCAAA;AAzfJ;;AA4fA;EACI,qCAAA;AAzfJ;;AA4fA;EACI,wCAAA;AAzfJ;;AA4fA;EACI,oCAAA;AAzfJ;;AA4fA;EACI,oCAAA;AAzfJ;;AA4fA;EACI,qCAAA;AAzfJ;;AA4fA;EACI,8BAAA;AAzfJ;;AA4fA;EACI,8BAAA;AAzfJ;;AA4fA;EACI,gCAAA;EACA,iCAAA;AAzfJ;;AA4fA;EACI,oBAAA;EACA,qEAAA;AAzfJ;;AA4fA;EACI,oBAAA;EACA,uEAAA;AAzfJ;;AA4fA;EACI,oBAAA;EACA,qEAAA;AAzfJ;;AA4fA;EACI,oBAAA;EACA,kEAAA;AAzfJ;;AA4fA;EACI,oBAAA;EACA,qEAAA;AAzfJ;;AA4fA;EACI,oBAAA;EACA,oEAAA;AAzfJ;;AA4fA;EACI,oBAAA;EACA,mEAAA;AAzfJ;;AA4fA;EACI,oBAAA;EACA,kEAAA;AAzfJ;;AA4fA;EACI,oBAAA;EACA,mEAAA;AAzfJ;;AA4fA;EACI,oBAAA;EACA,mEAAA;AAzfJ;;AA4fA;EACI,oBAAA;EACA,wEAAA;AAzfJ;;AA4fA;EACI,oBAAA;EACA,yBAAA;AAzfJ;;AA4fA;EACI,oBAAA;EACA,oCAAA;AAzfJ;;AA4fA;EACI,oBAAA;EACA,0CAAA;AAzfJ;;AA4fA;EACI,oBAAA;EACA,yBAAA;AAzfJ;;AA4fA;EACI,wBAAA;AAzfJ;;AA4fA;EACI,uBAAA;AAzfJ;;AA4fA;EACI,wBAAA;AAzfJ;;AA4fA;EACI,qBAAA;AAzfJ;;AA4fA;EACI,kBAAA;EACA,8EAAA;AAzfJ;;AA4fA;EACI,kBAAA;EACA,gFAAA;AAzfJ;;AA4fA;EACI,kBAAA;EACA,8EAAA;AAzfJ;;AA4fA;EACI,kBAAA;EACA,2EAAA;AAzfJ;;AA4fA;EACI,kBAAA;EACA,8EAAA;AAzfJ;;AA4fA;EACI,kBAAA;EACA,6EAAA;AAzfJ;;AA4fA;EACI,kBAAA;EACA,4EAAA;AAzfJ;;AA4fA;EACI,kBAAA;EACA,2EAAA;AAzfJ;;AA4fA;EACI,kBAAA;EACA,4EAAA;AAzfJ;;AA4fA;EACI,kBAAA;EACA,4EAAA;AAzfJ;;AA4fA;EACI,kBAAA;EACA,8EAAA;AAzfJ;;AA4fA;EACI,kBAAA;EACA,wCAAA;AAzfJ;;AA4fA;EACI,qBAAA;AAzfJ;;AA4fA;EACI,sBAAA;AAzfJ;;AA4fA;EACI,qBAAA;AAzfJ;;AA4fA;EACI,sBAAA;AAzfJ;;AA4fA;EACI,mBAAA;AAzfJ;;AA4fA;EACI,+CAAA;AAzfJ;;AA4fA;EACI,mCAAA;EAEA,2BAAA;AAzfJ;;AA4fA;EACI,oCAAA;EAEA,4BAAA;AAzfJ;;AA4fA;EACI,oCAAA;EAEA,4BAAA;AAzfJ;;AA4fA;EACI,+BAAA;AAzfJ;;AA4fA;EACI,+BAAA;AAzfJ;;AA4fA;EACI,iDAAA;AAzfJ;;AA4fA;EACI,2BAAA;AAzfJ;;AA4fA;EACI,oDAAA;AAzfJ;;AA4fA;EACI,iDAAA;AAzfJ;;AA4fA;EACI,oDAAA;AAzfJ;;AA4fA;EACI,oDAAA;AAzfJ;;AA4fA;EACI,qDAAA;AAzfJ;;AA4fA;EACI,6BAAA;AAzfJ;;AA4fA;EACI,sDAAA;AAzfJ;;AA4fA;EACI,0DAAA;EACA,2DAAA;AAzfJ;;AA4fA;EACI,2DAAA;EACA,8DAAA;AAzfJ;;AA4fA;EACI,8DAAA;EACA,6DAAA;AAzfJ;;AA4fA;EACI,6DAAA;EACA,0DAAA;AAzfJ;;AA4fA;EACI,8BAAA;AAzfJ;;AA4fA;EACI,6BAAA;AAzfJ;;AA4fA;EACI;IACI,sBAAA;EAzfN;EA4fE;IACI,uBAAA;EA1fN;EA6fE;IACI,sBAAA;EA3fN;EA8fE;IACI,0BAAA;EA5fN;EA+fE;IACI,gCAAA;EA7fN;EAggBE;IACI,yBAAA;EA9fN;EAigBE;IACI,wBAAA;EA/fN;EAkgBE;IACI,yBAAA;EAhgBN;EAmgBE;IACI,6BAAA;EAjgBN;EAogBE;IACI,8BAAA;EAlgBN;EAqgBE;IACI,wBAAA;EAngBN;EAsgBE;IACI,+BAAA;EApgBN;EAugBE;IACI,wBAAA;EArgBN;EAwgBE;IACI,yBAAA;EAtgBN;EAygBE;IACI,8BAAA;EAvgBN;EA0gBE;IACI,iCAAA;EAxgBN;EA2gBE;IACI,sCAAA;EAzgBN;EA4gBE;IACI,yCAAA;EA1gBN;EA6gBE;IACI,uBAAA;EA3gBN;EA8gBE;IACI,uBAAA;EA5gBN;EA+gBE;IACI,yBAAA;EA7gBN;EAghBE;IACI,yBAAA;EA9gBN;EAihBE;IACI,0BAAA;EA/gBN;EAkhBE;IACI,4BAAA;EAhhBN;EAmhBE;IACI,kCAAA;EAjhBN;EAohBE;IACI,sCAAA;EAlhBN;EAqhBE;IACI,oCAAA;EAnhBN;EAshBE;IACI,kCAAA;EAphBN;EAuhBE;IACI,yCAAA;EArhBN;EAwhBE;IACI,wCAAA;EAthBN;EAyhBE;IACI,wCAAA;EAvhBN;EA0hBE;IACI,kCAAA;EAxhBN;EA2hBE;IACI,gCAAA;EAzhBN;EA4hBE;IACI,8BAAA;EA1hBN;EA6hBE;IACI,gCAAA;EA3hBN;EA8hBE;IACI,+BAAA;EA5hBN;EA+hBE;IACI,oCAAA;EA7hBN;EAgiBE;IACI,kCAAA;EA9hBN;EAiiBE;IACI,gCAAA;EA/hBN;EAkiBE;IACI,uCAAA;EAhiBN;EAmiBE;IACI,sCAAA;EAjiBN;EAoiBE;IACI,iCAAA;EAliBN;EAqiBE;IACI,2BAAA;EAniBN;EAsiBE;IACI,iCAAA;EApiBN;EAuiBE;IACI,+BAAA;EAriBN;EAwiBE;IACI,6BAAA;EAtiBN;EAyiBE;IACI,+BAAA;EAviBN;EA0iBE;IACI,8BAAA;EAxiBN;EA2iBE;IACI,oBAAA;EAziBN;EA4iBE;IACI,mBAAA;EA1iBN;EA6iBE;IACI,mBAAA;EA3iBN;EA8iBE;IACI,mBAAA;EA5iBN;EA+iBE;IACI,mBAAA;EA7iBN;EAgjBE;IACI,mBAAA;EA9iBN;EAijBE;IACI,mBAAA;EA/iBN;EAkjBE;IACI,mBAAA;EAhjBN;EAmjBE;IACI,oBAAA;EAjjBN;EAojBE;IACI,0BAAA;EAljBN;EAqjBE;IACI,yBAAA;EAnjBN;EAsjBE;IACI,uBAAA;EApjBN;EAujBE;IACI,yBAAA;EArjBN;EAwjBE;IACI,uBAAA;EAtjBN;EAyjBE;IACI,uBAAA;EAvjBN;EA0jBE;IACI,0BAAA;IACA,yBAAA;EAxjBN;EA2jBE;IACI,gCAAA;IACA,+BAAA;EAzjBN;EA4jBE;IACI,+BAAA;IACA,8BAAA;EA1jBN;EA6jBE;IACI,6BAAA;IACA,4BAAA;EA3jBN;EA8jBE;IACI,+BAAA;IACA,8BAAA;EA5jBN;EA+jBE;IACI,6BAAA;IACA,4BAAA;EA7jBN;EAgkBE;IACI,6BAAA;IACA,4BAAA;EA9jBN;EAikBE;IACI,wBAAA;IACA,2BAAA;EA/jBN;EAkkBE;IACI,8BAAA;IACA,iCAAA;EAhkBN;EAmkBE;IACI,6BAAA;IACA,gCAAA;EAjkBN;EAokBE;IACI,2BAAA;IACA,8BAAA;EAlkBN;EAqkBE;IACI,6BAAA;IACA,gCAAA;EAnkBN;EAskBE;IACI,2BAAA;IACA,8BAAA;EApkBN;EAukBE;IACI,2BAAA;IACA,8BAAA;EArkBN;EAwkBE;IACI,wBAAA;EAtkBN;EAykBE;IACI,8BAAA;EAvkBN;EA0kBE;IACI,6BAAA;EAxkBN;EA2kBE;IACI,2BAAA;EAzkBN;EA4kBE;IACI,6BAAA;EA1kBN;EA6kBE;IACI,2BAAA;EA3kBN;EA8kBE;IACI,2BAAA;EA5kBN;EA+kBE;IACI,0BAAA;EA7kBN;EAglBE;IACI,gCAAA;EA9kBN;EAilBE;IACI,+BAAA;EA/kBN;EAklBE;IACI,6BAAA;EAhlBN;EAmlBE;IACI,+BAAA;EAjlBN;EAolBE;IACI,6BAAA;EAllBN;EAqlBE;IACI,6BAAA;EAnlBN;EAslBE;IACI,2BAAA;EAplBN;EAulBE;IACI,iCAAA;EArlBN;EAwlBE;IACI,gCAAA;EAtlBN;EAylBE;IACI,8BAAA;EAvlBN;EA0lBE;IACI,gCAAA;EAxlBN;EA2lBE;IACI,8BAAA;EAzlBN;EA4lBE;IACI,8BAAA;EA1lBN;EA6lBE;IACI,yBAAA;EA3lBN;EA8lBE;IACI,+BAAA;EA5lBN;EA+lBE;IACI,8BAAA;EA7lBN;EAgmBE;IACI,4BAAA;EA9lBN;EAimBE;IACI,8BAAA;EA/lBN;EAkmBE;IACI,4BAAA;EAhmBN;EAmmBE;IACI,4BAAA;EAjmBN;EAomBE;IACI,qBAAA;EAlmBN;EAqmBE;IACI,2BAAA;EAnmBN;EAsmBE;IACI,0BAAA;EApmBN;EAumBE;IACI,wBAAA;EArmBN;EAwmBE;IACI,0BAAA;EAtmBN;EAymBE;IACI,wBAAA;EAvmBN;EA0mBE;IACI,2BAAA;IACA,0BAAA;EAxmBN;EA2mBE;IACI,iCAAA;IACA,gCAAA;EAzmBN;EA4mBE;IACI,gCAAA;IACA,+BAAA;EA1mBN;EA6mBE;IACI,8BAAA;IACA,6BAAA;EA3mBN;EA8mBE;IACI,gCAAA;IACA,+BAAA;EA5mBN;EA+mBE;IACI,8BAAA;IACA,6BAAA;EA7mBN;EAgnBE;IACI,yBAAA;IACA,4BAAA;EA9mBN;EAinBE;IACI,+BAAA;IACA,kCAAA;EA/mBN;EAknBE;IACI,8BAAA;IACA,iCAAA;EAhnBN;EAmnBE;IACI,4BAAA;IACA,+BAAA;EAjnBN;EAonBE;IACI,8BAAA;IACA,iCAAA;EAlnBN;EAqnBE;IACI,4BAAA;IACA,+BAAA;EAnnBN;EAsnBE;IACI,yBAAA;EApnBN;EAunBE;IACI,+BAAA;EArnBN;EAwnBE;IACI,8BAAA;EAtnBN;EAynBE;IACI,4BAAA;EAvnBN;EA0nBE;IACI,8BAAA;EAxnBN;EA2nBE;IACI,4BAAA;EAznBN;EA4nBE;IACI,2BAAA;EA1nBN;EA6nBE;IACI,iCAAA;EA3nBN;EA8nBE;IACI,gCAAA;EA5nBN;EA+nBE;IACI,8BAAA;EA7nBN;EAgoBE;IACI,gCAAA;EA9nBN;EAioBE;IACI,8BAAA;EA/nBN;EAkoBE;IACI,4BAAA;EAhoBN;EAmoBE;IACI,kCAAA;EAjoBN;EAooBE;IACI,iCAAA;EAloBN;EAqoBE;IACI,+BAAA;EAnoBN;EAsoBE;IACI,iCAAA;EApoBN;EAuoBE;IACI,+BAAA;EAroBN;EAwoBE;IACI,0BAAA;EAtoBN;EAyoBE;IACI,gCAAA;EAvoBN;EA0oBE;IACI,+BAAA;EAxoBN;EA2oBE;IACI,6BAAA;EAzoBN;EA4oBE;IACI,+BAAA;EA1oBN;EA6oBE;IACI,6BAAA;EA3oBN;EA8oBE;IACI,iBAAA;EA5oBN;EA+oBE;IACI,uBAAA;EA7oBN;EAgpBE;IACI,sBAAA;EA9oBN;EAipBE;IACI,oBAAA;EA/oBN;EAkpBE;IACI,sBAAA;EAhpBN;EAmpBE;IACI,oBAAA;EAjpBN;EAopBE;IACI,2BAAA;EAlpBN;EAqpBE;IACI,4BAAA;EAnpBN;EAspBE;IACI,6BAAA;EAppBN;AACF;AAupBA;EACI;IACI,sBAAA;EArpBN;EAwpBE;IACI,uBAAA;EAtpBN;EAypBE;IACI,sBAAA;EAvpBN;EA0pBE;IACI,0BAAA;EAxpBN;EA2pBE;IACI,gCAAA;EAzpBN;EA4pBE;IACI,yBAAA;EA1pBN;EA6pBE;IACI,wBAAA;EA3pBN;EA8pBE;IACI,yBAAA;EA5pBN;EA+pBE;IACI,6BAAA;EA7pBN;EAgqBE;IACI,8BAAA;EA9pBN;EAiqBE;IACI,wBAAA;EA/pBN;EAkqBE;IACI,+BAAA;EAhqBN;EAmqBE;IACI,wBAAA;EAjqBN;EAoqBE;IACI,yBAAA;EAlqBN;EAqqBE;IACI,8BAAA;EAnqBN;EAsqBE;IACI,iCAAA;EApqBN;EAuqBE;IACI,sCAAA;EArqBN;EAwqBE;IACI,yCAAA;EAtqBN;EAyqBE;IACI,uBAAA;EAvqBN;EA0qBE;IACI,uBAAA;EAxqBN;EA2qBE;IACI,yBAAA;EAzqBN;EA4qBE;IACI,yBAAA;EA1qBN;EA6qBE;IACI,0BAAA;EA3qBN;EA8qBE;IACI,4BAAA;EA5qBN;EA+qBE;IACI,kCAAA;EA7qBN;EAgrBE;IACI,sCAAA;EA9qBN;EAirBE;IACI,oCAAA;EA/qBN;EAkrBE;IACI,kCAAA;EAhrBN;EAmrBE;IACI,yCAAA;EAjrBN;EAorBE;IACI,wCAAA;EAlrBN;EAqrBE;IACI,wCAAA;EAnrBN;EAsrBE;IACI,kCAAA;EAprBN;EAurBE;IACI,gCAAA;EArrBN;EAwrBE;IACI,8BAAA;EAtrBN;EAyrBE;IACI,gCAAA;EAvrBN;EA0rBE;IACI,+BAAA;EAxrBN;EA2rBE;IACI,oCAAA;EAzrBN;EA4rBE;IACI,kCAAA;EA1rBN;EA6rBE;IACI,gCAAA;EA3rBN;EA8rBE;IACI,uCAAA;EA5rBN;EA+rBE;IACI,sCAAA;EA7rBN;EAgsBE;IACI,iCAAA;EA9rBN;EAisBE;IACI,2BAAA;EA/rBN;EAksBE;IACI,iCAAA;EAhsBN;EAmsBE;IACI,+BAAA;EAjsBN;EAosBE;IACI,6BAAA;EAlsBN;EAqsBE;IACI,+BAAA;EAnsBN;EAssBE;IACI,8BAAA;EApsBN;EAusBE;IACI,oBAAA;EArsBN;EAwsBE;IACI,mBAAA;EAtsBN;EAysBE;IACI,mBAAA;EAvsBN;EA0sBE;IACI,mBAAA;EAxsBN;EA2sBE;IACI,mBAAA;EAzsBN;EA4sBE;IACI,mBAAA;EA1sBN;EA6sBE;IACI,mBAAA;EA3sBN;EA8sBE;IACI,mBAAA;EA5sBN;EA+sBE;IACI,oBAAA;EA7sBN;EAgtBE;IACI,0BAAA;EA9sBN;EAitBE;IACI,yBAAA;EA/sBN;EAktBE;IACI,uBAAA;EAhtBN;EAmtBE;IACI,yBAAA;EAjtBN;EAotBE;IACI,uBAAA;EAltBN;EAqtBE;IACI,uBAAA;EAntBN;EAstBE;IACI,0BAAA;IACA,yBAAA;EAptBN;EAutBE;IACI,gCAAA;IACA,+BAAA;EArtBN;EAwtBE;IACI,+BAAA;IACA,8BAAA;EAttBN;EAytBE;IACI,6BAAA;IACA,4BAAA;EAvtBN;EA0tBE;IACI,+BAAA;IACA,8BAAA;EAxtBN;EA2tBE;IACI,6BAAA;IACA,4BAAA;EAztBN;EA4tBE;IACI,6BAAA;IACA,4BAAA;EA1tBN;EA6tBE;IACI,wBAAA;IACA,2BAAA;EA3tBN;EA8tBE;IACI,8BAAA;IACA,iCAAA;EA5tBN;EA+tBE;IACI,6BAAA;IACA,gCAAA;EA7tBN;EAguBE;IACI,2BAAA;IACA,8BAAA;EA9tBN;EAiuBE;IACI,6BAAA;IACA,gCAAA;EA/tBN;EAkuBE;IACI,2BAAA;IACA,8BAAA;EAhuBN;EAmuBE;IACI,2BAAA;IACA,8BAAA;EAjuBN;EAouBE;IACI,wBAAA;EAluBN;EAquBE;IACI,8BAAA;EAnuBN;EAsuBE;IACI,6BAAA;EApuBN;EAuuBE;IACI,2BAAA;EAruBN;EAwuBE;IACI,6BAAA;EAtuBN;EAyuBE;IACI,2BAAA;EAvuBN;EA0uBE;IACI,2BAAA;EAxuBN;EA2uBE;IACI,0BAAA;EAzuBN;EA4uBE;IACI,gCAAA;EA1uBN;EA6uBE;IACI,+BAAA;EA3uBN;EA8uBE;IACI,6BAAA;EA5uBN;EA+uBE;IACI,+BAAA;EA7uBN;EAgvBE;IACI,6BAAA;EA9uBN;EAivBE;IACI,6BAAA;EA/uBN;EAkvBE;IACI,2BAAA;EAhvBN;EAmvBE;IACI,iCAAA;EAjvBN;EAovBE;IACI,gCAAA;EAlvBN;EAqvBE;IACI,8BAAA;EAnvBN;EAsvBE;IACI,gCAAA;EApvBN;EAuvBE;IACI,8BAAA;EArvBN;EAwvBE;IACI,8BAAA;EAtvBN;EAyvBE;IACI,yBAAA;EAvvBN;EA0vBE;IACI,+BAAA;EAxvBN;EA2vBE;IACI,8BAAA;EAzvBN;EA4vBE;IACI,4BAAA;EA1vBN;EA6vBE;IACI,8BAAA;EA3vBN;EA8vBE;IACI,4BAAA;EA5vBN;EA+vBE;IACI,4BAAA;EA7vBN;EAgwBE;IACI,qBAAA;EA9vBN;EAiwBE;IACI,2BAAA;EA/vBN;EAkwBE;IACI,0BAAA;EAhwBN;EAmwBE;IACI,wBAAA;EAjwBN;EAowBE;IACI,0BAAA;EAlwBN;EAqwBE;IACI,wBAAA;EAnwBN;EAswBE;IACI,2BAAA;IACA,0BAAA;EApwBN;EAuwBE;IACI,iCAAA;IACA,gCAAA;EArwBN;EAwwBE;IACI,gCAAA;IACA,+BAAA;EAtwBN;EAywBE;IACI,8BAAA;IACA,6BAAA;EAvwBN;EA0wBE;IACI,gCAAA;IACA,+BAAA;EAxwBN;EA2wBE;IACI,8BAAA;IACA,6BAAA;EAzwBN;EA4wBE;IACI,yBAAA;IACA,4BAAA;EA1wBN;EA6wBE;IACI,+BAAA;IACA,kCAAA;EA3wBN;EA8wBE;IACI,8BAAA;IACA,iCAAA;EA5wBN;EA+wBE;IACI,4BAAA;IACA,+BAAA;EA7wBN;EAgxBE;IACI,8BAAA;IACA,iCAAA;EA9wBN;EAixBE;IACI,4BAAA;IACA,+BAAA;EA/wBN;EAkxBE;IACI,yBAAA;EAhxBN;EAmxBE;IACI,+BAAA;EAjxBN;EAoxBE;IACI,8BAAA;EAlxBN;EAqxBE;IACI,4BAAA;EAnxBN;EAsxBE;IACI,8BAAA;EApxBN;EAuxBE;IACI,4BAAA;EArxBN;EAwxBE;IACI,2BAAA;EAtxBN;EAyxBE;IACI,iCAAA;EAvxBN;EA0xBE;IACI,gCAAA;EAxxBN;EA2xBE;IACI,8BAAA;EAzxBN;EA4xBE;IACI,gCAAA;EA1xBN;EA6xBE;IACI,8BAAA;EA3xBN;EA8xBE;IACI,4BAAA;EA5xBN;EA+xBE;IACI,kCAAA;EA7xBN;EAgyBE;IACI,iCAAA;EA9xBN;EAiyBE;IACI,+BAAA;EA/xBN;EAkyBE;IACI,iCAAA;EAhyBN;EAmyBE;IACI,+BAAA;EAjyBN;EAoyBE;IACI,0BAAA;EAlyBN;EAqyBE;IACI,gCAAA;EAnyBN;EAsyBE;IACI,+BAAA;EApyBN;EAuyBE;IACI,6BAAA;EAryBN;EAwyBE;IACI,+BAAA;EAtyBN;EAyyBE;IACI,6BAAA;EAvyBN;EA0yBE;IACI,iBAAA;EAxyBN;EA2yBE;IACI,uBAAA;EAzyBN;EA4yBE;IACI,sBAAA;EA1yBN;EA6yBE;IACI,oBAAA;EA3yBN;EA8yBE;IACI,sBAAA;EA5yBN;EA+yBE;IACI,oBAAA;EA7yBN;EAgzBE;IACI,2BAAA;EA9yBN;EAizBE;IACI,4BAAA;EA/yBN;EAkzBE;IACI,6BAAA;EAhzBN;AACF;AAmzBA;EACI;IACI,sBAAA;EAjzBN;EAozBE;IACI,uBAAA;EAlzBN;EAqzBE;IACI,sBAAA;EAnzBN;EAszBE;IACI,0BAAA;EApzBN;EAuzBE;IACI,gCAAA;EArzBN;EAwzBE;IACI,yBAAA;EAtzBN;EAyzBE;IACI,wBAAA;EAvzBN;EA0zBE;IACI,yBAAA;EAxzBN;EA2zBE;IACI,6BAAA;EAzzBN;EA4zBE;IACI,8BAAA;EA1zBN;EA6zBE;IACI,wBAAA;EA3zBN;EA8zBE;IACI,+BAAA;EA5zBN;EA+zBE;IACI,wBAAA;EA7zBN;EAg0BE;IACI,yBAAA;EA9zBN;EAi0BE;IACI,8BAAA;EA/zBN;EAk0BE;IACI,iCAAA;EAh0BN;EAm0BE;IACI,sCAAA;EAj0BN;EAo0BE;IACI,yCAAA;EAl0BN;EAq0BE;IACI,uBAAA;EAn0BN;EAs0BE;IACI,uBAAA;EAp0BN;EAu0BE;IACI,yBAAA;EAr0BN;EAw0BE;IACI,yBAAA;EAt0BN;EAy0BE;IACI,0BAAA;EAv0BN;EA00BE;IACI,4BAAA;EAx0BN;EA20BE;IACI,kCAAA;EAz0BN;EA40BE;IACI,sCAAA;EA10BN;EA60BE;IACI,oCAAA;EA30BN;EA80BE;IACI,kCAAA;EA50BN;EA+0BE;IACI,yCAAA;EA70BN;EAg1BE;IACI,wCAAA;EA90BN;EAi1BE;IACI,wCAAA;EA/0BN;EAk1BE;IACI,kCAAA;EAh1BN;EAm1BE;IACI,gCAAA;EAj1BN;EAo1BE;IACI,8BAAA;EAl1BN;EAq1BE;IACI,gCAAA;EAn1BN;EAs1BE;IACI,+BAAA;EAp1BN;EAu1BE;IACI,oCAAA;EAr1BN;EAw1BE;IACI,kCAAA;EAt1BN;EAy1BE;IACI,gCAAA;EAv1BN;EA01BE;IACI,uCAAA;EAx1BN;EA21BE;IACI,sCAAA;EAz1BN;EA41BE;IACI,iCAAA;EA11BN;EA61BE;IACI,2BAAA;EA31BN;EA81BE;IACI,iCAAA;EA51BN;EA+1BE;IACI,+BAAA;EA71BN;EAg2BE;IACI,6BAAA;EA91BN;EAi2BE;IACI,+BAAA;EA/1BN;EAk2BE;IACI,8BAAA;EAh2BN;EAm2BE;IACI,oBAAA;EAj2BN;EAo2BE;IACI,mBAAA;EAl2BN;EAq2BE;IACI,mBAAA;EAn2BN;EAs2BE;IACI,mBAAA;EAp2BN;EAu2BE;IACI,mBAAA;EAr2BN;EAw2BE;IACI,mBAAA;EAt2BN;EAy2BE;IACI,mBAAA;EAv2BN;EA02BE;IACI,mBAAA;EAx2BN;EA22BE;IACI,oBAAA;EAz2BN;EA42BE;IACI,0BAAA;EA12BN;EA62BE;IACI,yBAAA;EA32BN;EA82BE;IACI,uBAAA;EA52BN;EA+2BE;IACI,yBAAA;EA72BN;EAg3BE;IACI,uBAAA;EA92BN;EAi3BE;IACI,uBAAA;EA/2BN;EAk3BE;IACI,0BAAA;IACA,yBAAA;EAh3BN;EAm3BE;IACI,gCAAA;IACA,+BAAA;EAj3BN;EAo3BE;IACI,+BAAA;IACA,8BAAA;EAl3BN;EAq3BE;IACI,6BAAA;IACA,4BAAA;EAn3BN;EAs3BE;IACI,+BAAA;IACA,8BAAA;EAp3BN;EAu3BE;IACI,6BAAA;IACA,4BAAA;EAr3BN;EAw3BE;IACI,6BAAA;IACA,4BAAA;EAt3BN;EAy3BE;IACI,wBAAA;IACA,2BAAA;EAv3BN;EA03BE;IACI,8BAAA;IACA,iCAAA;EAx3BN;EA23BE;IACI,6BAAA;IACA,gCAAA;EAz3BN;EA43BE;IACI,2BAAA;IACA,8BAAA;EA13BN;EA63BE;IACI,6BAAA;IACA,gCAAA;EA33BN;EA83BE;IACI,2BAAA;IACA,8BAAA;EA53BN;EA+3BE;IACI,2BAAA;IACA,8BAAA;EA73BN;EAg4BE;IACI,wBAAA;EA93BN;EAi4BE;IACI,8BAAA;EA/3BN;EAk4BE;IACI,6BAAA;EAh4BN;EAm4BE;IACI,2BAAA;EAj4BN;EAo4BE;IACI,6BAAA;EAl4BN;EAq4BE;IACI,2BAAA;EAn4BN;EAs4BE;IACI,2BAAA;EAp4BN;EAu4BE;IACI,0BAAA;EAr4BN;EAw4BE;IACI,gCAAA;EAt4BN;EAy4BE;IACI,+BAAA;EAv4BN;EA04BE;IACI,6BAAA;EAx4BN;EA24BE;IACI,+BAAA;EAz4BN;EA44BE;IACI,6BAAA;EA14BN;EA64BE;IACI,6BAAA;EA34BN;EA84BE;IACI,2BAAA;EA54BN;EA+4BE;IACI,iCAAA;EA74BN;EAg5BE;IACI,gCAAA;EA94BN;EAi5BE;IACI,8BAAA;EA/4BN;EAk5BE;IACI,gCAAA;EAh5BN;EAm5BE;IACI,8BAAA;EAj5BN;EAo5BE;IACI,8BAAA;EAl5BN;EAq5BE;IACI,yBAAA;EAn5BN;EAs5BE;IACI,+BAAA;EAp5BN;EAu5BE;IACI,8BAAA;EAr5BN;EAw5BE;IACI,4BAAA;EAt5BN;EAy5BE;IACI,8BAAA;EAv5BN;EA05BE;IACI,4BAAA;EAx5BN;EA25BE;IACI,4BAAA;EAz5BN;EA45BE;IACI,qBAAA;EA15BN;EA65BE;IACI,2BAAA;EA35BN;EA85BE;IACI,0BAAA;EA55BN;EA+5BE;IACI,wBAAA;EA75BN;EAg6BE;IACI,0BAAA;EA95BN;EAi6BE;IACI,wBAAA;EA/5BN;EAk6BE;IACI,2BAAA;IACA,0BAAA;EAh6BN;EAm6BE;IACI,iCAAA;IACA,gCAAA;EAj6BN;EAo6BE;IACI,gCAAA;IACA,+BAAA;EAl6BN;EAq6BE;IACI,8BAAA;IACA,6BAAA;EAn6BN;EAs6BE;IACI,gCAAA;IACA,+BAAA;EAp6BN;EAu6BE;IACI,8BAAA;IACA,6BAAA;EAr6BN;EAw6BE;IACI,yBAAA;IACA,4BAAA;EAt6BN;EAy6BE;IACI,+BAAA;IACA,kCAAA;EAv6BN;EA06BE;IACI,8BAAA;IACA,iCAAA;EAx6BN;EA26BE;IACI,4BAAA;IACA,+BAAA;EAz6BN;EA46BE;IACI,8BAAA;IACA,iCAAA;EA16BN;EA66BE;IACI,4BAAA;IACA,+BAAA;EA36BN;EA86BE;IACI,yBAAA;EA56BN;EA+6BE;IACI,+BAAA;EA76BN;EAg7BE;IACI,8BAAA;EA96BN;EAi7BE;IACI,4BAAA;EA/6BN;EAk7BE;IACI,8BAAA;EAh7BN;EAm7BE;IACI,4BAAA;EAj7BN;EAo7BE;IACI,2BAAA;EAl7BN;EAq7BE;IACI,iCAAA;EAn7BN;EAs7BE;IACI,gCAAA;EAp7BN;EAu7BE;IACI,8BAAA;EAr7BN;EAw7BE;IACI,gCAAA;EAt7BN;EAy7BE;IACI,8BAAA;EAv7BN;EA07BE;IACI,4BAAA;EAx7BN;EA27BE;IACI,kCAAA;EAz7BN;EA47BE;IACI,iCAAA;EA17BN;EA67BE;IACI,+BAAA;EA37BN;EA87BE;IACI,iCAAA;EA57BN;EA+7BE;IACI,+BAAA;EA77BN;EAg8BE;IACI,0BAAA;EA97BN;EAi8BE;IACI,gCAAA;EA/7BN;EAk8BE;IACI,+BAAA;EAh8BN;EAm8BE;IACI,6BAAA;EAj8BN;EAo8BE;IACI,+BAAA;EAl8BN;EAq8BE;IACI,6BAAA;EAn8BN;EAs8BE;IACI,iBAAA;EAp8BN;EAu8BE;IACI,uBAAA;EAr8BN;EAw8BE;IACI,sBAAA;EAt8BN;EAy8BE;IACI,oBAAA;EAv8BN;EA08BE;IACI,sBAAA;EAx8BN;EA28BE;IACI,oBAAA;EAz8BN;EA48BE;IACI,2BAAA;EA18BN;EA68BE;IACI,4BAAA;EA38BN;EA88BE;IACI,6BAAA;EA58BN;AACF;AA+8BA;EACI;IACI,sBAAA;EA78BN;EAg9BE;IACI,uBAAA;EA98BN;EAi9BE;IACI,sBAAA;EA/8BN;EAk9BE;IACI,0BAAA;EAh9BN;EAm9BE;IACI,gCAAA;EAj9BN;EAo9BE;IACI,yBAAA;EAl9BN;EAq9BE;IACI,wBAAA;EAn9BN;EAs9BE;IACI,yBAAA;EAp9BN;EAu9BE;IACI,6BAAA;EAr9BN;EAw9BE;IACI,8BAAA;EAt9BN;EAy9BE;IACI,wBAAA;EAv9BN;EA09BE;IACI,+BAAA;EAx9BN;EA29BE;IACI,wBAAA;EAz9BN;EA49BE;IACI,yBAAA;EA19BN;EA69BE;IACI,8BAAA;EA39BN;EA89BE;IACI,iCAAA;EA59BN;EA+9BE;IACI,sCAAA;EA79BN;EAg+BE;IACI,yCAAA;EA99BN;EAi+BE;IACI,uBAAA;EA/9BN;EAk+BE;IACI,uBAAA;EAh+BN;EAm+BE;IACI,yBAAA;EAj+BN;EAo+BE;IACI,yBAAA;EAl+BN;EAq+BE;IACI,0BAAA;EAn+BN;EAs+BE;IACI,4BAAA;EAp+BN;EAu+BE;IACI,kCAAA;EAr+BN;EAw+BE;IACI,sCAAA;EAt+BN;EAy+BE;IACI,oCAAA;EAv+BN;EA0+BE;IACI,kCAAA;EAx+BN;EA2+BE;IACI,yCAAA;EAz+BN;EA4+BE;IACI,wCAAA;EA1+BN;EA6+BE;IACI,wCAAA;EA3+BN;EA8+BE;IACI,kCAAA;EA5+BN;EA++BE;IACI,gCAAA;EA7+BN;EAg/BE;IACI,8BAAA;EA9+BN;EAi/BE;IACI,gCAAA;EA/+BN;EAk/BE;IACI,+BAAA;EAh/BN;EAm/BE;IACI,oCAAA;EAj/BN;EAo/BE;IACI,kCAAA;EAl/BN;EAq/BE;IACI,gCAAA;EAn/BN;EAs/BE;IACI,uCAAA;EAp/BN;EAu/BE;IACI,sCAAA;EAr/BN;EAw/BE;IACI,iCAAA;EAt/BN;EAy/BE;IACI,2BAAA;EAv/BN;EA0/BE;IACI,iCAAA;EAx/BN;EA2/BE;IACI,+BAAA;EAz/BN;EA4/BE;IACI,6BAAA;EA1/BN;EA6/BE;IACI,+BAAA;EA3/BN;EA8/BE;IACI,8BAAA;EA5/BN;EA+/BE;IACI,oBAAA;EA7/BN;EAggCE;IACI,mBAAA;EA9/BN;EAigCE;IACI,mBAAA;EA//BN;EAkgCE;IACI,mBAAA;EAhgCN;EAmgCE;IACI,mBAAA;EAjgCN;EAogCE;IACI,mBAAA;EAlgCN;EAqgCE;IACI,mBAAA;EAngCN;EAsgCE;IACI,mBAAA;EApgCN;EAugCE;IACI,oBAAA;EArgCN;EAwgCE;IACI,0BAAA;EAtgCN;EAygCE;IACI,yBAAA;EAvgCN;EA0gCE;IACI,uBAAA;EAxgCN;EA2gCE;IACI,yBAAA;EAzgCN;EA4gCE;IACI,uBAAA;EA1gCN;EA6gCE;IACI,uBAAA;EA3gCN;EA8gCE;IACI,0BAAA;IACA,yBAAA;EA5gCN;EA+gCE;IACI,gCAAA;IACA,+BAAA;EA7gCN;EAghCE;IACI,+BAAA;IACA,8BAAA;EA9gCN;EAihCE;IACI,6BAAA;IACA,4BAAA;EA/gCN;EAkhCE;IACI,+BAAA;IACA,8BAAA;EAhhCN;EAmhCE;IACI,6BAAA;IACA,4BAAA;EAjhCN;EAohCE;IACI,6BAAA;IACA,4BAAA;EAlhCN;EAqhCE;IACI,wBAAA;IACA,2BAAA;EAnhCN;EAshCE;IACI,8BAAA;IACA,iCAAA;EAphCN;EAuhCE;IACI,6BAAA;IACA,gCAAA;EArhCN;EAwhCE;IACI,2BAAA;IACA,8BAAA;EAthCN;EAyhCE;IACI,6BAAA;IACA,gCAAA;EAvhCN;EA0hCE;IACI,2BAAA;IACA,8BAAA;EAxhCN;EA2hCE;IACI,2BAAA;IACA,8BAAA;EAzhCN;EA4hCE;IACI,wBAAA;EA1hCN;EA6hCE;IACI,8BAAA;EA3hCN;EA8hCE;IACI,6BAAA;EA5hCN;EA+hCE;IACI,2BAAA;EA7hCN;EAgiCE;IACI,6BAAA;EA9hCN;EAiiCE;IACI,2BAAA;EA/hCN;EAkiCE;IACI,2BAAA;EAhiCN;EAmiCE;IACI,0BAAA;EAjiCN;EAoiCE;IACI,gCAAA;EAliCN;EAqiCE;IACI,+BAAA;EAniCN;EAsiCE;IACI,6BAAA;EApiCN;EAuiCE;IACI,+BAAA;EAriCN;EAwiCE;IACI,6BAAA;EAtiCN;EAyiCE;IACI,6BAAA;EAviCN;EA0iCE;IACI,2BAAA;EAxiCN;EA2iCE;IACI,iCAAA;EAziCN;EA4iCE;IACI,gCAAA;EA1iCN;EA6iCE;IACI,8BAAA;EA3iCN;EA8iCE;IACI,gCAAA;EA5iCN;EA+iCE;IACI,8BAAA;EA7iCN;EAgjCE;IACI,8BAAA;EA9iCN;EAijCE;IACI,yBAAA;EA/iCN;EAkjCE;IACI,+BAAA;EAhjCN;EAmjCE;IACI,8BAAA;EAjjCN;EAojCE;IACI,4BAAA;EAljCN;EAqjCE;IACI,8BAAA;EAnjCN;EAsjCE;IACI,4BAAA;EApjCN;EAujCE;IACI,4BAAA;EArjCN;EAwjCE;IACI,qBAAA;EAtjCN;EAyjCE;IACI,2BAAA;EAvjCN;EA0jCE;IACI,0BAAA;EAxjCN;EA2jCE;IACI,wBAAA;EAzjCN;EA4jCE;IACI,0BAAA;EA1jCN;EA6jCE;IACI,wBAAA;EA3jCN;EA8jCE;IACI,2BAAA;IACA,0BAAA;EA5jCN;EA+jCE;IACI,iCAAA;IACA,gCAAA;EA7jCN;EAgkCE;IACI,gCAAA;IACA,+BAAA;EA9jCN;EAikCE;IACI,8BAAA;IACA,6BAAA;EA/jCN;EAkkCE;IACI,gCAAA;IACA,+BAAA;EAhkCN;EAmkCE;IACI,8BAAA;IACA,6BAAA;EAjkCN;EAokCE;IACI,yBAAA;IACA,4BAAA;EAlkCN;EAqkCE;IACI,+BAAA;IACA,kCAAA;EAnkCN;EAskCE;IACI,8BAAA;IACA,iCAAA;EApkCN;EAukCE;IACI,4BAAA;IACA,+BAAA;EArkCN;EAwkCE;IACI,8BAAA;IACA,iCAAA;EAtkCN;EAykCE;IACI,4BAAA;IACA,+BAAA;EAvkCN;EA0kCE;IACI,yBAAA;EAxkCN;EA2kCE;IACI,+BAAA;EAzkCN;EA4kCE;IACI,8BAAA;EA1kCN;EA6kCE;IACI,4BAAA;EA3kCN;EA8kCE;IACI,8BAAA;EA5kCN;EA+kCE;IACI,4BAAA;EA7kCN;EAglCE;IACI,2BAAA;EA9kCN;EAilCE;IACI,iCAAA;EA/kCN;EAklCE;IACI,gCAAA;EAhlCN;EAmlCE;IACI,8BAAA;EAjlCN;EAolCE;IACI,gCAAA;EAllCN;EAqlCE;IACI,8BAAA;EAnlCN;EAslCE;IACI,4BAAA;EAplCN;EAulCE;IACI,kCAAA;EArlCN;EAwlCE;IACI,iCAAA;EAtlCN;EAylCE;IACI,+BAAA;EAvlCN;EA0lCE;IACI,iCAAA;EAxlCN;EA2lCE;IACI,+BAAA;EAzlCN;EA4lCE;IACI,0BAAA;EA1lCN;EA6lCE;IACI,gCAAA;EA3lCN;EA8lCE;IACI,+BAAA;EA5lCN;EA+lCE;IACI,6BAAA;EA7lCN;EAgmCE;IACI,+BAAA;EA9lCN;EAimCE;IACI,6BAAA;EA/lCN;EAkmCE;IACI,iBAAA;EAhmCN;EAmmCE;IACI,uBAAA;EAjmCN;EAomCE;IACI,sBAAA;EAlmCN;EAqmCE;IACI,oBAAA;EAnmCN;EAsmCE;IACI,sBAAA;EApmCN;EAumCE;IACI,oBAAA;EArmCN;EAwmCE;IACI,2BAAA;EAtmCN;EAymCE;IACI,4BAAA;EAvmCN;EA0mCE;IACI,6BAAA;EAxmCN;AACF;AA2mCA;EACI;IACI,sBAAA;EAzmCN;EA4mCE;IACI,uBAAA;EA1mCN;EA6mCE;IACI,sBAAA;EA3mCN;EA8mCE;IACI,0BAAA;EA5mCN;EA+mCE;IACI,gCAAA;EA7mCN;EAgnCE;IACI,yBAAA;EA9mCN;EAinCE;IACI,wBAAA;EA/mCN;EAknCE;IACI,yBAAA;EAhnCN;EAmnCE;IACI,6BAAA;EAjnCN;EAonCE;IACI,8BAAA;EAlnCN;EAqnCE;IACI,wBAAA;EAnnCN;EAsnCE;IACI,+BAAA;EApnCN;EAunCE;IACI,wBAAA;EArnCN;EAwnCE;IACI,yBAAA;EAtnCN;EAynCE;IACI,8BAAA;EAvnCN;EA0nCE;IACI,iCAAA;EAxnCN;EA2nCE;IACI,sCAAA;EAznCN;EA4nCE;IACI,yCAAA;EA1nCN;EA6nCE;IACI,uBAAA;EA3nCN;EA8nCE;IACI,uBAAA;EA5nCN;EA+nCE;IACI,yBAAA;EA7nCN;EAgoCE;IACI,yBAAA;EA9nCN;EAioCE;IACI,0BAAA;EA/nCN;EAkoCE;IACI,4BAAA;EAhoCN;EAmoCE;IACI,kCAAA;EAjoCN;EAooCE;IACI,sCAAA;EAloCN;EAqoCE;IACI,oCAAA;EAnoCN;EAsoCE;IACI,kCAAA;EApoCN;EAuoCE;IACI,yCAAA;EAroCN;EAwoCE;IACI,wCAAA;EAtoCN;EAyoCE;IACI,wCAAA;EAvoCN;EA0oCE;IACI,kCAAA;EAxoCN;EA2oCE;IACI,gCAAA;EAzoCN;EA4oCE;IACI,8BAAA;EA1oCN;EA6oCE;IACI,gCAAA;EA3oCN;EA8oCE;IACI,+BAAA;EA5oCN;EA+oCE;IACI,oCAAA;EA7oCN;EAgpCE;IACI,kCAAA;EA9oCN;EAipCE;IACI,gCAAA;EA/oCN;EAkpCE;IACI,uCAAA;EAhpCN;EAmpCE;IACI,sCAAA;EAjpCN;EAopCE;IACI,iCAAA;EAlpCN;EAqpCE;IACI,2BAAA;EAnpCN;EAspCE;IACI,iCAAA;EAppCN;EAupCE;IACI,+BAAA;EArpCN;EAwpCE;IACI,6BAAA;EAtpCN;EAypCE;IACI,+BAAA;EAvpCN;EA0pCE;IACI,8BAAA;EAxpCN;EA2pCE;IACI,oBAAA;EAzpCN;EA4pCE;IACI,mBAAA;EA1pCN;EA6pCE;IACI,mBAAA;EA3pCN;EA8pCE;IACI,mBAAA;EA5pCN;EA+pCE;IACI,mBAAA;EA7pCN;EAgqCE;IACI,mBAAA;EA9pCN;EAiqCE;IACI,mBAAA;EA/pCN;EAkqCE;IACI,mBAAA;EAhqCN;EAmqCE;IACI,oBAAA;EAjqCN;EAoqCE;IACI,0BAAA;EAlqCN;EAqqCE;IACI,yBAAA;EAnqCN;EAsqCE;IACI,uBAAA;EApqCN;EAuqCE;IACI,yBAAA;EArqCN;EAwqCE;IACI,uBAAA;EAtqCN;EAyqCE;IACI,uBAAA;EAvqCN;EA0qCE;IACI,0BAAA;IACA,yBAAA;EAxqCN;EA2qCE;IACI,gCAAA;IACA,+BAAA;EAzqCN;EA4qCE;IACI,+BAAA;IACA,8BAAA;EA1qCN;EA6qCE;IACI,6BAAA;IACA,4BAAA;EA3qCN;EA8qCE;IACI,+BAAA;IACA,8BAAA;EA5qCN;EA+qCE;IACI,6BAAA;IACA,4BAAA;EA7qCN;EAgrCE;IACI,6BAAA;IACA,4BAAA;EA9qCN;EAirCE;IACI,wBAAA;IACA,2BAAA;EA/qCN;EAkrCE;IACI,8BAAA;IACA,iCAAA;EAhrCN;EAmrCE;IACI,6BAAA;IACA,gCAAA;EAjrCN;EAorCE;IACI,2BAAA;IACA,8BAAA;EAlrCN;EAqrCE;IACI,6BAAA;IACA,gCAAA;EAnrCN;EAsrCE;IACI,2BAAA;IACA,8BAAA;EAprCN;EAurCE;IACI,2BAAA;IACA,8BAAA;EArrCN;EAwrCE;IACI,wBAAA;EAtrCN;EAyrCE;IACI,8BAAA;EAvrCN;EA0rCE;IACI,6BAAA;EAxrCN;EA2rCE;IACI,2BAAA;EAzrCN;EA4rCE;IACI,6BAAA;EA1rCN;EA6rCE;IACI,2BAAA;EA3rCN;EA8rCE;IACI,2BAAA;EA5rCN;EA+rCE;IACI,0BAAA;EA7rCN;EAgsCE;IACI,gCAAA;EA9rCN;EAisCE;IACI,+BAAA;EA/rCN;EAksCE;IACI,6BAAA;EAhsCN;EAmsCE;IACI,+BAAA;EAjsCN;EAosCE;IACI,6BAAA;EAlsCN;EAqsCE;IACI,6BAAA;EAnsCN;EAssCE;IACI,2BAAA;EApsCN;EAusCE;IACI,iCAAA;EArsCN;EAwsCE;IACI,gCAAA;EAtsCN;EAysCE;IACI,8BAAA;EAvsCN;EA0sCE;IACI,gCAAA;EAxsCN;EA2sCE;IACI,8BAAA;EAzsCN;EA4sCE;IACI,8BAAA;EA1sCN;EA6sCE;IACI,yBAAA;EA3sCN;EA8sCE;IACI,+BAAA;EA5sCN;EA+sCE;IACI,8BAAA;EA7sCN;EAgtCE;IACI,4BAAA;EA9sCN;EAitCE;IACI,8BAAA;EA/sCN;EAktCE;IACI,4BAAA;EAhtCN;EAmtCE;IACI,4BAAA;EAjtCN;EAotCE;IACI,qBAAA;EAltCN;EAqtCE;IACI,2BAAA;EAntCN;EAstCE;IACI,0BAAA;EAptCN;EAutCE;IACI,wBAAA;EArtCN;EAwtCE;IACI,0BAAA;EAttCN;EAytCE;IACI,wBAAA;EAvtCN;EA0tCE;IACI,2BAAA;IACA,0BAAA;EAxtCN;EA2tCE;IACI,iCAAA;IACA,gCAAA;EAztCN;EA4tCE;IACI,gCAAA;IACA,+BAAA;EA1tCN;EA6tCE;IACI,8BAAA;IACA,6BAAA;EA3tCN;EA8tCE;IACI,gCAAA;IACA,+BAAA;EA5tCN;EA+tCE;IACI,8BAAA;IACA,6BAAA;EA7tCN;EAguCE;IACI,yBAAA;IACA,4BAAA;EA9tCN;EAiuCE;IACI,+BAAA;IACA,kCAAA;EA/tCN;EAkuCE;IACI,8BAAA;IACA,iCAAA;EAhuCN;EAmuCE;IACI,4BAAA;IACA,+BAAA;EAjuCN;EAouCE;IACI,8BAAA;IACA,iCAAA;EAluCN;EAquCE;IACI,4BAAA;IACA,+BAAA;EAnuCN;EAsuCE;IACI,yBAAA;EApuCN;EAuuCE;IACI,+BAAA;EAruCN;EAwuCE;IACI,8BAAA;EAtuCN;EAyuCE;IACI,4BAAA;EAvuCN;EA0uCE;IACI,8BAAA;EAxuCN;EA2uCE;IACI,4BAAA;EAzuCN;EA4uCE;IACI,2BAAA;EA1uCN;EA6uCE;IACI,iCAAA;EA3uCN;EA8uCE;IACI,gCAAA;EA5uCN;EA+uCE;IACI,8BAAA;EA7uCN;EAgvCE;IACI,gCAAA;EA9uCN;EAivCE;IACI,8BAAA;EA/uCN;EAkvCE;IACI,4BAAA;EAhvCN;EAmvCE;IACI,kCAAA;EAjvCN;EAovCE;IACI,iCAAA;EAlvCN;EAqvCE;IACI,+BAAA;EAnvCN;EAsvCE;IACI,iCAAA;EApvCN;EAuvCE;IACI,+BAAA;EArvCN;EAwvCE;IACI,0BAAA;EAtvCN;EAyvCE;IACI,gCAAA;EAvvCN;EA0vCE;IACI,+BAAA;EAxvCN;EA2vCE;IACI,6BAAA;EAzvCN;EA4vCE;IACI,+BAAA;EA1vCN;EA6vCE;IACI,6BAAA;EA3vCN;EA8vCE;IACI,iBAAA;EA5vCN;EA+vCE;IACI,uBAAA;EA7vCN;EAgwCE;IACI,sBAAA;EA9vCN;EAiwCE;IACI,oBAAA;EA/vCN;EAkwCE;IACI,sBAAA;EAhwCN;EAmwCE;IACI,oBAAA;EAjwCN;EAowCE;IACI,2BAAA;EAlwCN;EAqwCE;IACI,4BAAA;EAnwCN;EAswCE;IACI,6BAAA;EApwCN;AACF;AAuwCA;EACI;IACI,4BAAA;EArwCN;EAwwCE;IACI,0BAAA;EAtwCN;EAywCE;IACI,6BAAA;EAvwCN;EA0wCE;IACI,4BAAA;EAxwCN;AACF;AA2wCA;EACI;IACI,0BAAA;EAzwCN;EA4wCE;IACI,gCAAA;EA1wCN;EA6wCE;IACI,yBAAA;EA3wCN;EA8wCE;IACI,wBAAA;EA5wCN;EA+wCE;IACI,yBAAA;EA7wCN;EAgxCE;IACI,6BAAA;EA9wCN;EAixCE;IACI,8BAAA;EA/wCN;EAkxCE;IACI,wBAAA;EAhxCN;EAmxCE;IACI,+BAAA;EAjxCN;EAoxCE;IACI,wBAAA;EAlxCN;AACF","sourcesContent":["/*!\r\n * Bootstrap  v5.2.0 (https://getbootstrap.com/)\r\n * Copyright 2011-2022 The Bootstrap Authors\r\n * Copyright 2011-2022 Twitter, Inc.\r\n * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)\r\n */\r\n:root {\r\n    --bs-blue: #0d6efd;\r\n    --bs-indigo: #6610f2;\r\n    --bs-purple: #6f42c1;\r\n    --bs-pink: #d63384;\r\n    --bs-red: #dc3545;\r\n    --bs-orange: #fd7e14;\r\n    --bs-yellow: #ffc107;\r\n    --bs-green: #198754;\r\n    --bs-teal: #20c997;\r\n    --bs-cyan: #0dcaf0;\r\n    --bs-black: #000;\r\n    --bs-white: #fff;\r\n    --bs-gray: #6c757d;\r\n    --bs-gray-dark: #343a40;\r\n    --bs-gray-100: #f8f9fa;\r\n    --bs-gray-200: #e9ecef;\r\n    --bs-gray-300: #dee2e6;\r\n    --bs-gray-400: #ced4da;\r\n    --bs-gray-500: #adb5bd;\r\n    --bs-gray-600: #6c757d;\r\n    --bs-gray-700: #495057;\r\n    --bs-gray-800: #343a40;\r\n    --bs-gray-900: #212529;\r\n    --bs-primary: #0d6efd;\r\n    --bs-secondary: #6c757d;\r\n    --bs-success: #198754;\r\n    --bs-info: #0dcaf0;\r\n    --bs-warning: #ffc107;\r\n    --bs-danger: #dc3545;\r\n    --bs-light: #f8f9fa;\r\n    --bs-dark: #212529;\r\n    --bs-primary-rgb: 13, 110, 253;\r\n    --bs-secondary-rgb: 108, 117, 125;\r\n    --bs-success-rgb: 25, 135, 84;\r\n    --bs-info-rgb: 13, 202, 240;\r\n    --bs-warning-rgb: 255, 193, 7;\r\n    --bs-danger-rgb: 220, 53, 69;\r\n    --bs-light-rgb: 248, 249, 250;\r\n    --bs-dark-rgb: 33, 37, 41;\r\n    --bs-white-rgb: 255, 255, 255;\r\n    --bs-black-rgb: 0, 0, 0;\r\n    --bs-body-color-rgb: 33, 37, 41;\r\n    --bs-body-bg-rgb: 255, 255, 255;\r\n    --bs-font-sans-serif: system-ui, -apple-system, \"Segoe UI\", Roboto, \"Helvetica Neue\", \"Noto Sans\", \"Liberation Sans\", Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\r\n    --bs-font-monospace: SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace;\r\n    --bs-gradient: linear-gradient(180deg, rgba(255, 255, 255, 0.15), rgba(255, 255, 255, 0));\r\n    --bs-body-font-family: var(--bs-font-sans-serif);\r\n    --bs-body-font-size: 1rem;\r\n    --bs-body-font-weight: 400;\r\n    --bs-body-line-height: 1.5;\r\n    --bs-body-color: #212529;\r\n    --bs-body-bg: #fff;\r\n    --bs-border-width: 1px;\r\n    --bs-border-style: solid;\r\n    --bs-border-color: #dee2e6;\r\n    --bs-border-color-translucent: rgba(0, 0, 0, 0.175);\r\n    --bs-border-radius: 0.375rem;\r\n    --bs-border-radius-sm: 0.25rem;\r\n    --bs-border-radius-lg: 0.5rem;\r\n    --bs-border-radius-xl: 1rem;\r\n    --bs-border-radius-2xl: 2rem;\r\n    --bs-border-radius-pill: 50rem;\r\n    --bs-link-color: #0d6efd;\r\n    --bs-link-hover-color: #0a58ca;\r\n    --bs-code-color: #d63384;\r\n    --bs-highlight-bg: #fff3cd\r\n}\r\n\r\n*,\r\n::after,\r\n::before {\r\n    box-sizing: border-box\r\n}\r\n\r\n@media (prefers-reduced-motion:no-preference) {\r\n    :root {\r\n        scroll-behavior: smooth\r\n    }\r\n}\r\n\r\nbody {\r\n    margin: 0;\r\n    font-family: var(--bs-body-font-family);\r\n    font-size: var(--bs-body-font-size);\r\n    font-weight: var(--bs-body-font-weight);\r\n    line-height: var(--bs-body-line-height);\r\n    color: var(--bs-body-color);\r\n    text-align: var(--bs-body-text-align);\r\n    background-color: var(--bs-body-bg);\r\n    -webkit-text-size-adjust: 100%;\r\n    -webkit-tap-highlight-color: transparent\r\n}\r\n\r\nhr {\r\n    margin: 1rem 0;\r\n    color: inherit;\r\n    border: 0;\r\n    border-top: 1px solid;\r\n    opacity: .25\r\n}\r\n\r\n.h1,\r\n.h2,\r\n.h3,\r\n.h4,\r\n.h5,\r\n.h6,\r\nh1,\r\nh2,\r\nh3,\r\nh4,\r\nh5,\r\nh6 {\r\n    margin-top: 0;\r\n    margin-bottom: .5rem;\r\n    font-weight: 500;\r\n    line-height: 1.2\r\n}\r\n\r\n.h1,\r\nh1 {\r\n    font-size: calc(1.375rem + 1.5vw)\r\n}\r\n\r\n@media (min-width:1200px) {\r\n\r\n    .h1,\r\n    h1 {\r\n        font-size: 2.5rem\r\n    }\r\n}\r\n\r\n.h2,\r\nh2 {\r\n    font-size: calc(1.325rem + .9vw)\r\n}\r\n\r\n@media (min-width:1200px) {\r\n\r\n    .h2,\r\n    h2 {\r\n        font-size: 2rem\r\n    }\r\n}\r\n\r\n.h3,\r\nh3 {\r\n    font-size: calc(1.3rem + .6vw)\r\n}\r\n\r\n@media (min-width:1200px) {\r\n\r\n    .h3,\r\n    h3 {\r\n        font-size: 1.75rem\r\n    }\r\n}\r\n\r\n.h4,\r\nh4 {\r\n    font-size: calc(1.275rem + .3vw)\r\n}\r\n\r\n@media (min-width:1200px) {\r\n\r\n    .h4,\r\n    h4 {\r\n        font-size: 1.5rem\r\n    }\r\n}\r\n\r\n.h5,\r\nh5 {\r\n    font-size: 1.25rem\r\n}\r\n\r\n.h6,\r\nh6 {\r\n    font-size: 1rem\r\n}\r\n\r\np {\r\n    margin-top: 0;\r\n    margin-bottom: 1rem\r\n}\r\n\r\nabbr[title] {\r\n    -webkit-text-decoration: underline dotted;\r\n    text-decoration: underline dotted;\r\n    cursor: help;\r\n    -webkit-text-decoration-skip-ink: none;\r\n    text-decoration-skip-ink: none\r\n}\r\n\r\naddress {\r\n    margin-bottom: 1rem;\r\n    font-style: normal;\r\n    line-height: inherit\r\n}\r\n\r\nol,\r\nul {\r\n    padding-left: 2rem\r\n}\r\n\r\ndl,\r\nol,\r\nul {\r\n    margin-top: 0;\r\n    margin-bottom: 1rem\r\n}\r\n\r\nol ol,\r\nol ul,\r\nul ol,\r\nul ul {\r\n    margin-bottom: 0\r\n}\r\n\r\ndt {\r\n    font-weight: 700\r\n}\r\n\r\ndd {\r\n    margin-bottom: .5rem;\r\n    margin-left: 0\r\n}\r\n\r\nblockquote {\r\n    margin: 0 0 1rem\r\n}\r\n\r\nb,\r\nstrong {\r\n    font-weight: bolder\r\n}\r\n\r\n.small,\r\nsmall {\r\n    font-size: .875em\r\n}\r\n\r\n.mark,\r\nmark {\r\n    padding: .1875em;\r\n    background-color: var(--bs-highlight-bg)\r\n}\r\n\r\nsub,\r\nsup {\r\n    position: relative;\r\n    font-size: .75em;\r\n    line-height: 0;\r\n    vertical-align: baseline\r\n}\r\n\r\nsub {\r\n    bottom: -.25em\r\n}\r\n\r\nsup {\r\n    top: -.5em\r\n}\r\n\r\na {\r\n    color: var(--bs-link-color);\r\n    text-decoration: underline\r\n}\r\n\r\na:hover {\r\n    color: var(--bs-link-hover-color)\r\n}\r\n\r\na:not([href]):not([class]),\r\na:not([href]):not([class]):hover {\r\n    color: inherit;\r\n    text-decoration: none\r\n}\r\n\r\ncode,\r\nkbd,\r\npre,\r\nsamp {\r\n    font-family: var(--bs-font-monospace);\r\n    font-size: 1em\r\n}\r\n\r\npre {\r\n    display: block;\r\n    margin-top: 0;\r\n    margin-bottom: 1rem;\r\n    overflow: auto;\r\n    font-size: .875em\r\n}\r\n\r\npre code {\r\n    font-size: inherit;\r\n    color: inherit;\r\n    word-break: normal\r\n}\r\n\r\ncode {\r\n    font-size: .875em;\r\n    color: var(--bs-code-color);\r\n    word-wrap: break-word\r\n}\r\n\r\na>code {\r\n    color: inherit\r\n}\r\n\r\nkbd {\r\n    padding: .1875rem .375rem;\r\n    font-size: .875em;\r\n    color: var(--bs-body-bg);\r\n    background-color: var(--bs-body-color);\r\n    border-radius: .25rem\r\n}\r\n\r\nkbd kbd {\r\n    padding: 0;\r\n    font-size: 1em\r\n}\r\n\r\nfigure {\r\n    margin: 0 0 1rem\r\n}\r\n\r\nimg,\r\nsvg {\r\n    vertical-align: middle\r\n}\r\n\r\ntable {\r\n    caption-side: bottom;\r\n    border-collapse: collapse\r\n}\r\n\r\ncaption {\r\n    padding-top: .5rem;\r\n    padding-bottom: .5rem;\r\n    color: #6c757d;\r\n    text-align: left\r\n}\r\n\r\nth {\r\n    text-align: inherit;\r\n    text-align: -webkit-match-parent\r\n}\r\n\r\ntbody,\r\ntd,\r\ntfoot,\r\nth,\r\nthead,\r\ntr {\r\n    border-color: inherit;\r\n    border-style: solid;\r\n    border-width: 0\r\n}\r\n\r\nlabel {\r\n    display: inline-block\r\n}\r\n\r\nbutton {\r\n    border-radius: 0\r\n}\r\n\r\nbutton:focus:not(:focus-visible) {\r\n    outline: 0\r\n}\r\n\r\nbutton,\r\ninput,\r\noptgroup,\r\nselect,\r\ntextarea {\r\n    margin: 0;\r\n    font-family: inherit;\r\n    font-size: inherit;\r\n    line-height: inherit\r\n}\r\n\r\nbutton,\r\nselect {\r\n    text-transform: none\r\n}\r\n\r\n[role=button] {\r\n    cursor: pointer\r\n}\r\n\r\nselect {\r\n    word-wrap: normal\r\n}\r\n\r\nselect:disabled {\r\n    opacity: 1\r\n}\r\n\r\n[list]:not([type=date]):not([type=datetime-local]):not([type=month]):not([type=week]):not([type=time])::-webkit-calendar-picker-indicator {\r\n    display: none !important\r\n}\r\n\r\n[type=button],\r\n[type=reset],\r\n[type=submit],\r\nbutton {\r\n    -webkit-appearance: button\r\n}\r\n\r\n[type=button]:not(:disabled),\r\n[type=reset]:not(:disabled),\r\n[type=submit]:not(:disabled),\r\nbutton:not(:disabled) {\r\n    cursor: pointer\r\n}\r\n\r\n::-moz-focus-inner {\r\n    padding: 0;\r\n    border-style: none\r\n}\r\n\r\ntextarea {\r\n    resize: vertical\r\n}\r\n\r\nfieldset {\r\n    min-width: 0;\r\n    padding: 0;\r\n    margin: 0;\r\n    border: 0\r\n}\r\n\r\nlegend {\r\n    float: left;\r\n    width: 100%;\r\n    padding: 0;\r\n    margin-bottom: .5rem;\r\n    font-size: calc(1.275rem + .3vw);\r\n    line-height: inherit\r\n}\r\n\r\n@media (min-width:1200px) {\r\n    legend {\r\n        font-size: 1.5rem\r\n    }\r\n}\r\n\r\nlegend+* {\r\n    clear: left\r\n}\r\n\r\n::-webkit-datetime-edit-day-field,\r\n::-webkit-datetime-edit-fields-wrapper,\r\n::-webkit-datetime-edit-hour-field,\r\n::-webkit-datetime-edit-minute,\r\n::-webkit-datetime-edit-month-field,\r\n::-webkit-datetime-edit-text,\r\n::-webkit-datetime-edit-year-field {\r\n    padding: 0\r\n}\r\n\r\n::-webkit-inner-spin-button {\r\n    height: auto\r\n}\r\n\r\n[type=search] {\r\n    outline-offset: -2px;\r\n    -webkit-appearance: textfield\r\n}\r\n\r\n::-webkit-search-decoration {\r\n    -webkit-appearance: none\r\n}\r\n\r\n::-webkit-color-swatch-wrapper {\r\n    padding: 0\r\n}\r\n\r\n::-webkit-file-upload-button {\r\n    font: inherit;\r\n    -webkit-appearance: button\r\n}\r\n\r\n::file-selector-button {\r\n    font: inherit;\r\n    -webkit-appearance: button\r\n}\r\n\r\noutput {\r\n    display: inline-block\r\n}\r\n\r\niframe {\r\n    border: 0\r\n}\r\n\r\nsummary {\r\n    display: list-item;\r\n    cursor: pointer\r\n}\r\n\r\nprogress {\r\n    vertical-align: baseline\r\n}\r\n\r\n[hidden] {\r\n    display: none !important\r\n}\r\n\r\n.lead {\r\n    font-size: 1.25rem;\r\n    font-weight: 300\r\n}\r\n\r\n.display-1 {\r\n    font-size: calc(1.625rem + 4.5vw);\r\n    font-weight: 300;\r\n    line-height: 1.2\r\n}\r\n\r\n@media (min-width:1200px) {\r\n    .display-1 {\r\n        font-size: 5rem\r\n    }\r\n}\r\n\r\n.display-2 {\r\n    font-size: calc(1.575rem + 3.9vw);\r\n    font-weight: 300;\r\n    line-height: 1.2\r\n}\r\n\r\n@media (min-width:1200px) {\r\n    .display-2 {\r\n        font-size: 4.5rem\r\n    }\r\n}\r\n\r\n.display-3 {\r\n    font-size: calc(1.525rem + 3.3vw);\r\n    font-weight: 300;\r\n    line-height: 1.2\r\n}\r\n\r\n@media (min-width:1200px) {\r\n    .display-3 {\r\n        font-size: 4rem\r\n    }\r\n}\r\n\r\n.display-4 {\r\n    font-size: calc(1.475rem + 2.7vw);\r\n    font-weight: 300;\r\n    line-height: 1.2\r\n}\r\n\r\n@media (min-width:1200px) {\r\n    .display-4 {\r\n        font-size: 3.5rem\r\n    }\r\n}\r\n\r\n.display-5 {\r\n    font-size: calc(1.425rem + 2.1vw);\r\n    font-weight: 300;\r\n    line-height: 1.2\r\n}\r\n\r\n@media (min-width:1200px) {\r\n    .display-5 {\r\n        font-size: 3rem\r\n    }\r\n}\r\n\r\n.display-6 {\r\n    font-size: calc(1.375rem + 1.5vw);\r\n    font-weight: 300;\r\n    line-height: 1.2\r\n}\r\n\r\n@media (min-width:1200px) {\r\n    .display-6 {\r\n        font-size: 2.5rem\r\n    }\r\n}\r\n\r\n.list-unstyled {\r\n    padding-left: 0;\r\n    list-style: none\r\n}\r\n\r\n.list-inline {\r\n    padding-left: 0;\r\n    list-style: none\r\n}\r\n\r\n.list-inline-item {\r\n    display: inline-block\r\n}\r\n\r\n.list-inline-item:not(:last-child) {\r\n    margin-right: .5rem\r\n}\r\n\r\n.initialism {\r\n    font-size: .875em;\r\n    text-transform: uppercase\r\n}\r\n\r\n.blockquote {\r\n    margin-bottom: 1rem;\r\n    font-size: 1.25rem\r\n}\r\n\r\n.blockquote>:last-child {\r\n    margin-bottom: 0\r\n}\r\n\r\n.blockquote-footer {\r\n    margin-top: -1rem;\r\n    margin-bottom: 1rem;\r\n    font-size: .875em;\r\n    color: #6c757d\r\n}\r\n\r\n.blockquote-footer::before {\r\n    content: \"— \"\r\n}\r\n\r\n.img-fluid {\r\n    max-width: 100%;\r\n    height: auto\r\n}\r\n\r\n.img-thumbnail {\r\n    padding: .25rem;\r\n    background-color: #fff;\r\n    border: 1px solid var(--bs-border-color);\r\n    border-radius: .375rem;\r\n    max-width: 100%;\r\n    height: auto\r\n}\r\n\r\n.figure {\r\n    display: inline-block\r\n}\r\n\r\n.figure-img {\r\n    margin-bottom: .5rem;\r\n    line-height: 1\r\n}\r\n\r\n.figure-caption {\r\n    font-size: .875em;\r\n    color: #6c757d\r\n}\r\n\r\n.container,\r\n.container-fluid,\r\n.container-lg,\r\n.container-md,\r\n.container-sm,\r\n.container-xl,\r\n.container-xxl {\r\n    --bs-gutter-x: 1.5rem;\r\n    --bs-gutter-y: 0;\r\n    width: 100%;\r\n    padding-right: calc(var(--bs-gutter-x) * .5);\r\n    padding-left: calc(var(--bs-gutter-x) * .5);\r\n    margin-right: auto;\r\n    margin-left: auto\r\n}\r\n\r\n@media (min-width:576px) {\r\n\r\n    .container,\r\n    .container-sm {\r\n        max-width: 540px\r\n    }\r\n}\r\n\r\n@media (min-width:768px) {\r\n\r\n    .container,\r\n    .container-md,\r\n    .container-sm {\r\n        max-width: 720px\r\n    }\r\n}\r\n\r\n@media (min-width:992px) {\r\n\r\n    .container,\r\n    .container-lg,\r\n    .container-md,\r\n    .container-sm {\r\n        max-width: 960px\r\n    }\r\n}\r\n\r\n@media (min-width:1200px) {\r\n\r\n    .container,\r\n    .container-lg,\r\n    .container-md,\r\n    .container-sm,\r\n    .container-xl {\r\n        max-width: 1140px\r\n    }\r\n}\r\n\r\n@media (min-width:1400px) {\r\n\r\n    .container,\r\n    .container-lg,\r\n    .container-md,\r\n    .container-sm,\r\n    .container-xl,\r\n    .container-xxl {\r\n        max-width: 1320px\r\n    }\r\n}\r\n\r\n.row {\r\n    --bs-gutter-x: 1.5rem;\r\n    --bs-gutter-y: 0;\r\n    display: flex;\r\n    flex-wrap: wrap;\r\n    margin-top: calc(-1 * var(--bs-gutter-y));\r\n    margin-right: calc(-.5 * var(--bs-gutter-x));\r\n    margin-left: calc(-.5 * var(--bs-gutter-x))\r\n}\r\n\r\n.row>* {\r\n    flex-shrink: 0;\r\n    width: 100%;\r\n    max-width: 100%;\r\n    padding-right: calc(var(--bs-gutter-x) * .5);\r\n    padding-left: calc(var(--bs-gutter-x) * .5);\r\n    margin-top: var(--bs-gutter-y)\r\n}\r\n\r\n.col {\r\n    flex: 1 0 0%\r\n}\r\n\r\n.row-cols-auto>* {\r\n    flex: 0 0 auto;\r\n    width: auto\r\n}\r\n\r\n.row-cols-1>* {\r\n    flex: 0 0 auto;\r\n    width: 100%\r\n}\r\n\r\n.row-cols-2>* {\r\n    flex: 0 0 auto;\r\n    width: 50%\r\n}\r\n\r\n.row-cols-3>* {\r\n    flex: 0 0 auto;\r\n    width: 33.3333333333%\r\n}\r\n\r\n.row-cols-4>* {\r\n    flex: 0 0 auto;\r\n    width: 25%\r\n}\r\n\r\n.row-cols-5>* {\r\n    flex: 0 0 auto;\r\n    width: 20%\r\n}\r\n\r\n.row-cols-6>* {\r\n    flex: 0 0 auto;\r\n    width: 16.6666666667%\r\n}\r\n\r\n.col-auto {\r\n    flex: 0 0 auto;\r\n    width: auto\r\n}\r\n\r\n.col-1 {\r\n    flex: 0 0 auto;\r\n    width: 8.33333333%\r\n}\r\n\r\n.col-2 {\r\n    flex: 0 0 auto;\r\n    width: 16.66666667%\r\n}\r\n\r\n.col-3 {\r\n    flex: 0 0 auto;\r\n    width: 25%\r\n}\r\n\r\n.col-4 {\r\n    flex: 0 0 auto;\r\n    width: 33.33333333%\r\n}\r\n\r\n.col-5 {\r\n    flex: 0 0 auto;\r\n    width: 41.66666667%\r\n}\r\n\r\n.col-6 {\r\n    flex: 0 0 auto;\r\n    width: 50%\r\n}\r\n\r\n.col-7 {\r\n    flex: 0 0 auto;\r\n    width: 58.33333333%\r\n}\r\n\r\n.col-8 {\r\n    flex: 0 0 auto;\r\n    width: 66.66666667%\r\n}\r\n\r\n.col-9 {\r\n    flex: 0 0 auto;\r\n    width: 75%\r\n}\r\n\r\n.col-10 {\r\n    flex: 0 0 auto;\r\n    width: 83.33333333%\r\n}\r\n\r\n.col-11 {\r\n    flex: 0 0 auto;\r\n    width: 91.66666667%\r\n}\r\n\r\n.col-12 {\r\n    flex: 0 0 auto;\r\n    width: 100%\r\n}\r\n\r\n.offset-1 {\r\n    margin-left: 8.33333333%\r\n}\r\n\r\n.offset-2 {\r\n    margin-left: 16.66666667%\r\n}\r\n\r\n.offset-3 {\r\n    margin-left: 25%\r\n}\r\n\r\n.offset-4 {\r\n    margin-left: 33.33333333%\r\n}\r\n\r\n.offset-5 {\r\n    margin-left: 41.66666667%\r\n}\r\n\r\n.offset-6 {\r\n    margin-left: 50%\r\n}\r\n\r\n.offset-7 {\r\n    margin-left: 58.33333333%\r\n}\r\n\r\n.offset-8 {\r\n    margin-left: 66.66666667%\r\n}\r\n\r\n.offset-9 {\r\n    margin-left: 75%\r\n}\r\n\r\n.offset-10 {\r\n    margin-left: 83.33333333%\r\n}\r\n\r\n.offset-11 {\r\n    margin-left: 91.66666667%\r\n}\r\n\r\n.g-0,\r\n.gx-0 {\r\n    --bs-gutter-x: 0\r\n}\r\n\r\n.g-0,\r\n.gy-0 {\r\n    --bs-gutter-y: 0\r\n}\r\n\r\n.g-1,\r\n.gx-1 {\r\n    --bs-gutter-x: 0.25rem\r\n}\r\n\r\n.g-1,\r\n.gy-1 {\r\n    --bs-gutter-y: 0.25rem\r\n}\r\n\r\n.g-2,\r\n.gx-2 {\r\n    --bs-gutter-x: 0.5rem\r\n}\r\n\r\n.g-2,\r\n.gy-2 {\r\n    --bs-gutter-y: 0.5rem\r\n}\r\n\r\n.g-3,\r\n.gx-3 {\r\n    --bs-gutter-x: 1rem\r\n}\r\n\r\n.g-3,\r\n.gy-3 {\r\n    --bs-gutter-y: 1rem\r\n}\r\n\r\n.g-4,\r\n.gx-4 {\r\n    --bs-gutter-x: 1.5rem\r\n}\r\n\r\n.g-4,\r\n.gy-4 {\r\n    --bs-gutter-y: 1.5rem\r\n}\r\n\r\n.g-5,\r\n.gx-5 {\r\n    --bs-gutter-x: 3rem\r\n}\r\n\r\n.g-5,\r\n.gy-5 {\r\n    --bs-gutter-y: 3rem\r\n}\r\n\r\n@media (min-width:576px) {\r\n    .col-sm {\r\n        flex: 1 0 0%\r\n    }\r\n\r\n    .row-cols-sm-auto>* {\r\n        flex: 0 0 auto;\r\n        width: auto\r\n    }\r\n\r\n    .row-cols-sm-1>* {\r\n        flex: 0 0 auto;\r\n        width: 100%\r\n    }\r\n\r\n    .row-cols-sm-2>* {\r\n        flex: 0 0 auto;\r\n        width: 50%\r\n    }\r\n\r\n    .row-cols-sm-3>* {\r\n        flex: 0 0 auto;\r\n        width: 33.3333333333%\r\n    }\r\n\r\n    .row-cols-sm-4>* {\r\n        flex: 0 0 auto;\r\n        width: 25%\r\n    }\r\n\r\n    .row-cols-sm-5>* {\r\n        flex: 0 0 auto;\r\n        width: 20%\r\n    }\r\n\r\n    .row-cols-sm-6>* {\r\n        flex: 0 0 auto;\r\n        width: 16.6666666667%\r\n    }\r\n\r\n    .col-sm-auto {\r\n        flex: 0 0 auto;\r\n        width: auto\r\n    }\r\n\r\n    .col-sm-1 {\r\n        flex: 0 0 auto;\r\n        width: 8.33333333%\r\n    }\r\n\r\n    .col-sm-2 {\r\n        flex: 0 0 auto;\r\n        width: 16.66666667%\r\n    }\r\n\r\n    .col-sm-3 {\r\n        flex: 0 0 auto;\r\n        width: 25%\r\n    }\r\n\r\n    .col-sm-4 {\r\n        flex: 0 0 auto;\r\n        width: 33.33333333%\r\n    }\r\n\r\n    .col-sm-5 {\r\n        flex: 0 0 auto;\r\n        width: 41.66666667%\r\n    }\r\n\r\n    .col-sm-6 {\r\n        flex: 0 0 auto;\r\n        width: 50%\r\n    }\r\n\r\n    .col-sm-7 {\r\n        flex: 0 0 auto;\r\n        width: 58.33333333%\r\n    }\r\n\r\n    .col-sm-8 {\r\n        flex: 0 0 auto;\r\n        width: 66.66666667%\r\n    }\r\n\r\n    .col-sm-9 {\r\n        flex: 0 0 auto;\r\n        width: 75%\r\n    }\r\n\r\n    .col-sm-10 {\r\n        flex: 0 0 auto;\r\n        width: 83.33333333%\r\n    }\r\n\r\n    .col-sm-11 {\r\n        flex: 0 0 auto;\r\n        width: 91.66666667%\r\n    }\r\n\r\n    .col-sm-12 {\r\n        flex: 0 0 auto;\r\n        width: 100%\r\n    }\r\n\r\n    .offset-sm-0 {\r\n        margin-left: 0\r\n    }\r\n\r\n    .offset-sm-1 {\r\n        margin-left: 8.33333333%\r\n    }\r\n\r\n    .offset-sm-2 {\r\n        margin-left: 16.66666667%\r\n    }\r\n\r\n    .offset-sm-3 {\r\n        margin-left: 25%\r\n    }\r\n\r\n    .offset-sm-4 {\r\n        margin-left: 33.33333333%\r\n    }\r\n\r\n    .offset-sm-5 {\r\n        margin-left: 41.66666667%\r\n    }\r\n\r\n    .offset-sm-6 {\r\n        margin-left: 50%\r\n    }\r\n\r\n    .offset-sm-7 {\r\n        margin-left: 58.33333333%\r\n    }\r\n\r\n    .offset-sm-8 {\r\n        margin-left: 66.66666667%\r\n    }\r\n\r\n    .offset-sm-9 {\r\n        margin-left: 75%\r\n    }\r\n\r\n    .offset-sm-10 {\r\n        margin-left: 83.33333333%\r\n    }\r\n\r\n    .offset-sm-11 {\r\n        margin-left: 91.66666667%\r\n    }\r\n\r\n    .g-sm-0,\r\n    .gx-sm-0 {\r\n        --bs-gutter-x: 0\r\n    }\r\n\r\n    .g-sm-0,\r\n    .gy-sm-0 {\r\n        --bs-gutter-y: 0\r\n    }\r\n\r\n    .g-sm-1,\r\n    .gx-sm-1 {\r\n        --bs-gutter-x: 0.25rem\r\n    }\r\n\r\n    .g-sm-1,\r\n    .gy-sm-1 {\r\n        --bs-gutter-y: 0.25rem\r\n    }\r\n\r\n    .g-sm-2,\r\n    .gx-sm-2 {\r\n        --bs-gutter-x: 0.5rem\r\n    }\r\n\r\n    .g-sm-2,\r\n    .gy-sm-2 {\r\n        --bs-gutter-y: 0.5rem\r\n    }\r\n\r\n    .g-sm-3,\r\n    .gx-sm-3 {\r\n        --bs-gutter-x: 1rem\r\n    }\r\n\r\n    .g-sm-3,\r\n    .gy-sm-3 {\r\n        --bs-gutter-y: 1rem\r\n    }\r\n\r\n    .g-sm-4,\r\n    .gx-sm-4 {\r\n        --bs-gutter-x: 1.5rem\r\n    }\r\n\r\n    .g-sm-4,\r\n    .gy-sm-4 {\r\n        --bs-gutter-y: 1.5rem\r\n    }\r\n\r\n    .g-sm-5,\r\n    .gx-sm-5 {\r\n        --bs-gutter-x: 3rem\r\n    }\r\n\r\n    .g-sm-5,\r\n    .gy-sm-5 {\r\n        --bs-gutter-y: 3rem\r\n    }\r\n}\r\n\r\n@media (min-width:768px) {\r\n    .col-md {\r\n        flex: 1 0 0%\r\n    }\r\n\r\n    .row-cols-md-auto>* {\r\n        flex: 0 0 auto;\r\n        width: auto\r\n    }\r\n\r\n    .row-cols-md-1>* {\r\n        flex: 0 0 auto;\r\n        width: 100%\r\n    }\r\n\r\n    .row-cols-md-2>* {\r\n        flex: 0 0 auto;\r\n        width: 50%\r\n    }\r\n\r\n    .row-cols-md-3>* {\r\n        flex: 0 0 auto;\r\n        width: 33.3333333333%\r\n    }\r\n\r\n    .row-cols-md-4>* {\r\n        flex: 0 0 auto;\r\n        width: 25%\r\n    }\r\n\r\n    .row-cols-md-5>* {\r\n        flex: 0 0 auto;\r\n        width: 20%\r\n    }\r\n\r\n    .row-cols-md-6>* {\r\n        flex: 0 0 auto;\r\n        width: 16.6666666667%\r\n    }\r\n\r\n    .col-md-auto {\r\n        flex: 0 0 auto;\r\n        width: auto\r\n    }\r\n\r\n    .col-md-1 {\r\n        flex: 0 0 auto;\r\n        width: 8.33333333%\r\n    }\r\n\r\n    .col-md-2 {\r\n        flex: 0 0 auto;\r\n        width: 16.66666667%\r\n    }\r\n\r\n    .col-md-3 {\r\n        flex: 0 0 auto;\r\n        width: 25%\r\n    }\r\n\r\n    .col-md-4 {\r\n        flex: 0 0 auto;\r\n        width: 33.33333333%\r\n    }\r\n\r\n    .col-md-5 {\r\n        flex: 0 0 auto;\r\n        width: 41.66666667%\r\n    }\r\n\r\n    .col-md-6 {\r\n        flex: 0 0 auto;\r\n        width: 50%\r\n    }\r\n\r\n    .col-md-7 {\r\n        flex: 0 0 auto;\r\n        width: 58.33333333%\r\n    }\r\n\r\n    .col-md-8 {\r\n        flex: 0 0 auto;\r\n        width: 66.66666667%\r\n    }\r\n\r\n    .col-md-9 {\r\n        flex: 0 0 auto;\r\n        width: 75%\r\n    }\r\n\r\n    .col-md-10 {\r\n        flex: 0 0 auto;\r\n        width: 83.33333333%\r\n    }\r\n\r\n    .col-md-11 {\r\n        flex: 0 0 auto;\r\n        width: 91.66666667%\r\n    }\r\n\r\n    .col-md-12 {\r\n        flex: 0 0 auto;\r\n        width: 100%\r\n    }\r\n\r\n    .offset-md-0 {\r\n        margin-left: 0\r\n    }\r\n\r\n    .offset-md-1 {\r\n        margin-left: 8.33333333%\r\n    }\r\n\r\n    .offset-md-2 {\r\n        margin-left: 16.66666667%\r\n    }\r\n\r\n    .offset-md-3 {\r\n        margin-left: 25%\r\n    }\r\n\r\n    .offset-md-4 {\r\n        margin-left: 33.33333333%\r\n    }\r\n\r\n    .offset-md-5 {\r\n        margin-left: 41.66666667%\r\n    }\r\n\r\n    .offset-md-6 {\r\n        margin-left: 50%\r\n    }\r\n\r\n    .offset-md-7 {\r\n        margin-left: 58.33333333%\r\n    }\r\n\r\n    .offset-md-8 {\r\n        margin-left: 66.66666667%\r\n    }\r\n\r\n    .offset-md-9 {\r\n        margin-left: 75%\r\n    }\r\n\r\n    .offset-md-10 {\r\n        margin-left: 83.33333333%\r\n    }\r\n\r\n    .offset-md-11 {\r\n        margin-left: 91.66666667%\r\n    }\r\n\r\n    .g-md-0,\r\n    .gx-md-0 {\r\n        --bs-gutter-x: 0\r\n    }\r\n\r\n    .g-md-0,\r\n    .gy-md-0 {\r\n        --bs-gutter-y: 0\r\n    }\r\n\r\n    .g-md-1,\r\n    .gx-md-1 {\r\n        --bs-gutter-x: 0.25rem\r\n    }\r\n\r\n    .g-md-1,\r\n    .gy-md-1 {\r\n        --bs-gutter-y: 0.25rem\r\n    }\r\n\r\n    .g-md-2,\r\n    .gx-md-2 {\r\n        --bs-gutter-x: 0.5rem\r\n    }\r\n\r\n    .g-md-2,\r\n    .gy-md-2 {\r\n        --bs-gutter-y: 0.5rem\r\n    }\r\n\r\n    .g-md-3,\r\n    .gx-md-3 {\r\n        --bs-gutter-x: 1rem\r\n    }\r\n\r\n    .g-md-3,\r\n    .gy-md-3 {\r\n        --bs-gutter-y: 1rem\r\n    }\r\n\r\n    .g-md-4,\r\n    .gx-md-4 {\r\n        --bs-gutter-x: 1.5rem\r\n    }\r\n\r\n    .g-md-4,\r\n    .gy-md-4 {\r\n        --bs-gutter-y: 1.5rem\r\n    }\r\n\r\n    .g-md-5,\r\n    .gx-md-5 {\r\n        --bs-gutter-x: 3rem\r\n    }\r\n\r\n    .g-md-5,\r\n    .gy-md-5 {\r\n        --bs-gutter-y: 3rem\r\n    }\r\n}\r\n\r\n@media (min-width:992px) {\r\n    .col-lg {\r\n        flex: 1 0 0%\r\n    }\r\n\r\n    .row-cols-lg-auto>* {\r\n        flex: 0 0 auto;\r\n        width: auto\r\n    }\r\n\r\n    .row-cols-lg-1>* {\r\n        flex: 0 0 auto;\r\n        width: 100%\r\n    }\r\n\r\n    .row-cols-lg-2>* {\r\n        flex: 0 0 auto;\r\n        width: 50%\r\n    }\r\n\r\n    .row-cols-lg-3>* {\r\n        flex: 0 0 auto;\r\n        width: 33.3333333333%\r\n    }\r\n\r\n    .row-cols-lg-4>* {\r\n        flex: 0 0 auto;\r\n        width: 25%\r\n    }\r\n\r\n    .row-cols-lg-5>* {\r\n        flex: 0 0 auto;\r\n        width: 20%\r\n    }\r\n\r\n    .row-cols-lg-6>* {\r\n        flex: 0 0 auto;\r\n        width: 16.6666666667%\r\n    }\r\n\r\n    .col-lg-auto {\r\n        flex: 0 0 auto;\r\n        width: auto\r\n    }\r\n\r\n    .col-lg-1 {\r\n        flex: 0 0 auto;\r\n        width: 8.33333333%\r\n    }\r\n\r\n    .col-lg-2 {\r\n        flex: 0 0 auto;\r\n        width: 16.66666667%\r\n    }\r\n\r\n    .col-lg-3 {\r\n        flex: 0 0 auto;\r\n        width: 25%\r\n    }\r\n\r\n    .col-lg-4 {\r\n        flex: 0 0 auto;\r\n        width: 33.33333333%\r\n    }\r\n\r\n    .col-lg-5 {\r\n        flex: 0 0 auto;\r\n        width: 41.66666667%\r\n    }\r\n\r\n    .col-lg-6 {\r\n        flex: 0 0 auto;\r\n        width: 50%\r\n    }\r\n\r\n    .col-lg-7 {\r\n        flex: 0 0 auto;\r\n        width: 58.33333333%\r\n    }\r\n\r\n    .col-lg-8 {\r\n        flex: 0 0 auto;\r\n        width: 66.66666667%\r\n    }\r\n\r\n    .col-lg-9 {\r\n        flex: 0 0 auto;\r\n        width: 75%\r\n    }\r\n\r\n    .col-lg-10 {\r\n        flex: 0 0 auto;\r\n        width: 83.33333333%\r\n    }\r\n\r\n    .col-lg-11 {\r\n        flex: 0 0 auto;\r\n        width: 91.66666667%\r\n    }\r\n\r\n    .col-lg-12 {\r\n        flex: 0 0 auto;\r\n        width: 100%\r\n    }\r\n\r\n    .offset-lg-0 {\r\n        margin-left: 0\r\n    }\r\n\r\n    .offset-lg-1 {\r\n        margin-left: 8.33333333%\r\n    }\r\n\r\n    .offset-lg-2 {\r\n        margin-left: 16.66666667%\r\n    }\r\n\r\n    .offset-lg-3 {\r\n        margin-left: 25%\r\n    }\r\n\r\n    .offset-lg-4 {\r\n        margin-left: 33.33333333%\r\n    }\r\n\r\n    .offset-lg-5 {\r\n        margin-left: 41.66666667%\r\n    }\r\n\r\n    .offset-lg-6 {\r\n        margin-left: 50%\r\n    }\r\n\r\n    .offset-lg-7 {\r\n        margin-left: 58.33333333%\r\n    }\r\n\r\n    .offset-lg-8 {\r\n        margin-left: 66.66666667%\r\n    }\r\n\r\n    .offset-lg-9 {\r\n        margin-left: 75%\r\n    }\r\n\r\n    .offset-lg-10 {\r\n        margin-left: 83.33333333%\r\n    }\r\n\r\n    .offset-lg-11 {\r\n        margin-left: 91.66666667%\r\n    }\r\n\r\n    .g-lg-0,\r\n    .gx-lg-0 {\r\n        --bs-gutter-x: 0\r\n    }\r\n\r\n    .g-lg-0,\r\n    .gy-lg-0 {\r\n        --bs-gutter-y: 0\r\n    }\r\n\r\n    .g-lg-1,\r\n    .gx-lg-1 {\r\n        --bs-gutter-x: 0.25rem\r\n    }\r\n\r\n    .g-lg-1,\r\n    .gy-lg-1 {\r\n        --bs-gutter-y: 0.25rem\r\n    }\r\n\r\n    .g-lg-2,\r\n    .gx-lg-2 {\r\n        --bs-gutter-x: 0.5rem\r\n    }\r\n\r\n    .g-lg-2,\r\n    .gy-lg-2 {\r\n        --bs-gutter-y: 0.5rem\r\n    }\r\n\r\n    .g-lg-3,\r\n    .gx-lg-3 {\r\n        --bs-gutter-x: 1rem\r\n    }\r\n\r\n    .g-lg-3,\r\n    .gy-lg-3 {\r\n        --bs-gutter-y: 1rem\r\n    }\r\n\r\n    .g-lg-4,\r\n    .gx-lg-4 {\r\n        --bs-gutter-x: 1.5rem\r\n    }\r\n\r\n    .g-lg-4,\r\n    .gy-lg-4 {\r\n        --bs-gutter-y: 1.5rem\r\n    }\r\n\r\n    .g-lg-5,\r\n    .gx-lg-5 {\r\n        --bs-gutter-x: 3rem\r\n    }\r\n\r\n    .g-lg-5,\r\n    .gy-lg-5 {\r\n        --bs-gutter-y: 3rem\r\n    }\r\n}\r\n\r\n@media (min-width:1200px) {\r\n    .col-xl {\r\n        flex: 1 0 0%\r\n    }\r\n\r\n    .row-cols-xl-auto>* {\r\n        flex: 0 0 auto;\r\n        width: auto\r\n    }\r\n\r\n    .row-cols-xl-1>* {\r\n        flex: 0 0 auto;\r\n        width: 100%\r\n    }\r\n\r\n    .row-cols-xl-2>* {\r\n        flex: 0 0 auto;\r\n        width: 50%\r\n    }\r\n\r\n    .row-cols-xl-3>* {\r\n        flex: 0 0 auto;\r\n        width: 33.3333333333%\r\n    }\r\n\r\n    .row-cols-xl-4>* {\r\n        flex: 0 0 auto;\r\n        width: 25%\r\n    }\r\n\r\n    .row-cols-xl-5>* {\r\n        flex: 0 0 auto;\r\n        width: 20%\r\n    }\r\n\r\n    .row-cols-xl-6>* {\r\n        flex: 0 0 auto;\r\n        width: 16.6666666667%\r\n    }\r\n\r\n    .col-xl-auto {\r\n        flex: 0 0 auto;\r\n        width: auto\r\n    }\r\n\r\n    .col-xl-1 {\r\n        flex: 0 0 auto;\r\n        width: 8.33333333%\r\n    }\r\n\r\n    .col-xl-2 {\r\n        flex: 0 0 auto;\r\n        width: 16.66666667%\r\n    }\r\n\r\n    .col-xl-3 {\r\n        flex: 0 0 auto;\r\n        width: 25%\r\n    }\r\n\r\n    .col-xl-4 {\r\n        flex: 0 0 auto;\r\n        width: 33.33333333%\r\n    }\r\n\r\n    .col-xl-5 {\r\n        flex: 0 0 auto;\r\n        width: 41.66666667%\r\n    }\r\n\r\n    .col-xl-6 {\r\n        flex: 0 0 auto;\r\n        width: 50%\r\n    }\r\n\r\n    .col-xl-7 {\r\n        flex: 0 0 auto;\r\n        width: 58.33333333%\r\n    }\r\n\r\n    .col-xl-8 {\r\n        flex: 0 0 auto;\r\n        width: 66.66666667%\r\n    }\r\n\r\n    .col-xl-9 {\r\n        flex: 0 0 auto;\r\n        width: 75%\r\n    }\r\n\r\n    .col-xl-10 {\r\n        flex: 0 0 auto;\r\n        width: 83.33333333%\r\n    }\r\n\r\n    .col-xl-11 {\r\n        flex: 0 0 auto;\r\n        width: 91.66666667%\r\n    }\r\n\r\n    .col-xl-12 {\r\n        flex: 0 0 auto;\r\n        width: 100%\r\n    }\r\n\r\n    .offset-xl-0 {\r\n        margin-left: 0\r\n    }\r\n\r\n    .offset-xl-1 {\r\n        margin-left: 8.33333333%\r\n    }\r\n\r\n    .offset-xl-2 {\r\n        margin-left: 16.66666667%\r\n    }\r\n\r\n    .offset-xl-3 {\r\n        margin-left: 25%\r\n    }\r\n\r\n    .offset-xl-4 {\r\n        margin-left: 33.33333333%\r\n    }\r\n\r\n    .offset-xl-5 {\r\n        margin-left: 41.66666667%\r\n    }\r\n\r\n    .offset-xl-6 {\r\n        margin-left: 50%\r\n    }\r\n\r\n    .offset-xl-7 {\r\n        margin-left: 58.33333333%\r\n    }\r\n\r\n    .offset-xl-8 {\r\n        margin-left: 66.66666667%\r\n    }\r\n\r\n    .offset-xl-9 {\r\n        margin-left: 75%\r\n    }\r\n\r\n    .offset-xl-10 {\r\n        margin-left: 83.33333333%\r\n    }\r\n\r\n    .offset-xl-11 {\r\n        margin-left: 91.66666667%\r\n    }\r\n\r\n    .g-xl-0,\r\n    .gx-xl-0 {\r\n        --bs-gutter-x: 0\r\n    }\r\n\r\n    .g-xl-0,\r\n    .gy-xl-0 {\r\n        --bs-gutter-y: 0\r\n    }\r\n\r\n    .g-xl-1,\r\n    .gx-xl-1 {\r\n        --bs-gutter-x: 0.25rem\r\n    }\r\n\r\n    .g-xl-1,\r\n    .gy-xl-1 {\r\n        --bs-gutter-y: 0.25rem\r\n    }\r\n\r\n    .g-xl-2,\r\n    .gx-xl-2 {\r\n        --bs-gutter-x: 0.5rem\r\n    }\r\n\r\n    .g-xl-2,\r\n    .gy-xl-2 {\r\n        --bs-gutter-y: 0.5rem\r\n    }\r\n\r\n    .g-xl-3,\r\n    .gx-xl-3 {\r\n        --bs-gutter-x: 1rem\r\n    }\r\n\r\n    .g-xl-3,\r\n    .gy-xl-3 {\r\n        --bs-gutter-y: 1rem\r\n    }\r\n\r\n    .g-xl-4,\r\n    .gx-xl-4 {\r\n        --bs-gutter-x: 1.5rem\r\n    }\r\n\r\n    .g-xl-4,\r\n    .gy-xl-4 {\r\n        --bs-gutter-y: 1.5rem\r\n    }\r\n\r\n    .g-xl-5,\r\n    .gx-xl-5 {\r\n        --bs-gutter-x: 3rem\r\n    }\r\n\r\n    .g-xl-5,\r\n    .gy-xl-5 {\r\n        --bs-gutter-y: 3rem\r\n    }\r\n}\r\n\r\n@media (min-width:1400px) {\r\n    .col-xxl {\r\n        flex: 1 0 0%\r\n    }\r\n\r\n    .row-cols-xxl-auto>* {\r\n        flex: 0 0 auto;\r\n        width: auto\r\n    }\r\n\r\n    .row-cols-xxl-1>* {\r\n        flex: 0 0 auto;\r\n        width: 100%\r\n    }\r\n\r\n    .row-cols-xxl-2>* {\r\n        flex: 0 0 auto;\r\n        width: 50%\r\n    }\r\n\r\n    .row-cols-xxl-3>* {\r\n        flex: 0 0 auto;\r\n        width: 33.3333333333%\r\n    }\r\n\r\n    .row-cols-xxl-4>* {\r\n        flex: 0 0 auto;\r\n        width: 25%\r\n    }\r\n\r\n    .row-cols-xxl-5>* {\r\n        flex: 0 0 auto;\r\n        width: 20%\r\n    }\r\n\r\n    .row-cols-xxl-6>* {\r\n        flex: 0 0 auto;\r\n        width: 16.6666666667%\r\n    }\r\n\r\n    .col-xxl-auto {\r\n        flex: 0 0 auto;\r\n        width: auto\r\n    }\r\n\r\n    .col-xxl-1 {\r\n        flex: 0 0 auto;\r\n        width: 8.33333333%\r\n    }\r\n\r\n    .col-xxl-2 {\r\n        flex: 0 0 auto;\r\n        width: 16.66666667%\r\n    }\r\n\r\n    .col-xxl-3 {\r\n        flex: 0 0 auto;\r\n        width: 25%\r\n    }\r\n\r\n    .col-xxl-4 {\r\n        flex: 0 0 auto;\r\n        width: 33.33333333%\r\n    }\r\n\r\n    .col-xxl-5 {\r\n        flex: 0 0 auto;\r\n        width: 41.66666667%\r\n    }\r\n\r\n    .col-xxl-6 {\r\n        flex: 0 0 auto;\r\n        width: 50%\r\n    }\r\n\r\n    .col-xxl-7 {\r\n        flex: 0 0 auto;\r\n        width: 58.33333333%\r\n    }\r\n\r\n    .col-xxl-8 {\r\n        flex: 0 0 auto;\r\n        width: 66.66666667%\r\n    }\r\n\r\n    .col-xxl-9 {\r\n        flex: 0 0 auto;\r\n        width: 75%\r\n    }\r\n\r\n    .col-xxl-10 {\r\n        flex: 0 0 auto;\r\n        width: 83.33333333%\r\n    }\r\n\r\n    .col-xxl-11 {\r\n        flex: 0 0 auto;\r\n        width: 91.66666667%\r\n    }\r\n\r\n    .col-xxl-12 {\r\n        flex: 0 0 auto;\r\n        width: 100%\r\n    }\r\n\r\n    .offset-xxl-0 {\r\n        margin-left: 0\r\n    }\r\n\r\n    .offset-xxl-1 {\r\n        margin-left: 8.33333333%\r\n    }\r\n\r\n    .offset-xxl-2 {\r\n        margin-left: 16.66666667%\r\n    }\r\n\r\n    .offset-xxl-3 {\r\n        margin-left: 25%\r\n    }\r\n\r\n    .offset-xxl-4 {\r\n        margin-left: 33.33333333%\r\n    }\r\n\r\n    .offset-xxl-5 {\r\n        margin-left: 41.66666667%\r\n    }\r\n\r\n    .offset-xxl-6 {\r\n        margin-left: 50%\r\n    }\r\n\r\n    .offset-xxl-7 {\r\n        margin-left: 58.33333333%\r\n    }\r\n\r\n    .offset-xxl-8 {\r\n        margin-left: 66.66666667%\r\n    }\r\n\r\n    .offset-xxl-9 {\r\n        margin-left: 75%\r\n    }\r\n\r\n    .offset-xxl-10 {\r\n        margin-left: 83.33333333%\r\n    }\r\n\r\n    .offset-xxl-11 {\r\n        margin-left: 91.66666667%\r\n    }\r\n\r\n    .g-xxl-0,\r\n    .gx-xxl-0 {\r\n        --bs-gutter-x: 0\r\n    }\r\n\r\n    .g-xxl-0,\r\n    .gy-xxl-0 {\r\n        --bs-gutter-y: 0\r\n    }\r\n\r\n    .g-xxl-1,\r\n    .gx-xxl-1 {\r\n        --bs-gutter-x: 0.25rem\r\n    }\r\n\r\n    .g-xxl-1,\r\n    .gy-xxl-1 {\r\n        --bs-gutter-y: 0.25rem\r\n    }\r\n\r\n    .g-xxl-2,\r\n    .gx-xxl-2 {\r\n        --bs-gutter-x: 0.5rem\r\n    }\r\n\r\n    .g-xxl-2,\r\n    .gy-xxl-2 {\r\n        --bs-gutter-y: 0.5rem\r\n    }\r\n\r\n    .g-xxl-3,\r\n    .gx-xxl-3 {\r\n        --bs-gutter-x: 1rem\r\n    }\r\n\r\n    .g-xxl-3,\r\n    .gy-xxl-3 {\r\n        --bs-gutter-y: 1rem\r\n    }\r\n\r\n    .g-xxl-4,\r\n    .gx-xxl-4 {\r\n        --bs-gutter-x: 1.5rem\r\n    }\r\n\r\n    .g-xxl-4,\r\n    .gy-xxl-4 {\r\n        --bs-gutter-y: 1.5rem\r\n    }\r\n\r\n    .g-xxl-5,\r\n    .gx-xxl-5 {\r\n        --bs-gutter-x: 3rem\r\n    }\r\n\r\n    .g-xxl-5,\r\n    .gy-xxl-5 {\r\n        --bs-gutter-y: 3rem\r\n    }\r\n}\r\n\r\n.table {\r\n    --bs-table-color: var(--bs-body-color);\r\n    --bs-table-bg: transparent;\r\n    --bs-table-border-color: var(--bs-border-color);\r\n    --bs-table-accent-bg: transparent;\r\n    --bs-table-striped-color: var(--bs-body-color);\r\n    --bs-table-striped-bg: rgba(0, 0, 0, 0.05);\r\n    --bs-table-active-color: var(--bs-body-color);\r\n    --bs-table-active-bg: rgba(0, 0, 0, 0.1);\r\n    --bs-table-hover-color: var(--bs-body-color);\r\n    --bs-table-hover-bg: rgba(0, 0, 0, 0.075);\r\n    width: 100%;\r\n    margin-bottom: 1rem;\r\n    color: var(--bs-table-color);\r\n    vertical-align: top;\r\n    border-color: var(--bs-table-border-color)\r\n}\r\n\r\n.table>:not(caption)>*>* {\r\n    padding: .5rem .5rem;\r\n    background-color: var(--bs-table-bg);\r\n    border-bottom-width: 1px;\r\n    box-shadow: inset 0 0 0 9999px var(--bs-table-accent-bg)\r\n}\r\n\r\n.table>tbody {\r\n    vertical-align: inherit\r\n}\r\n\r\n.table>thead {\r\n    vertical-align: bottom\r\n}\r\n\r\n.table-group-divider {\r\n    border-top: 2px solid currentcolor\r\n}\r\n\r\n.caption-top {\r\n    caption-side: top\r\n}\r\n\r\n.table-sm>:not(caption)>*>* {\r\n    padding: .25rem .25rem\r\n}\r\n\r\n.table-bordered>:not(caption)>* {\r\n    border-width: 1px 0\r\n}\r\n\r\n.table-bordered>:not(caption)>*>* {\r\n    border-width: 0 1px\r\n}\r\n\r\n.table-borderless>:not(caption)>*>* {\r\n    border-bottom-width: 0\r\n}\r\n\r\n.table-borderless>:not(:first-child) {\r\n    border-top-width: 0\r\n}\r\n\r\n.table-striped>tbody>tr:nth-of-type(odd)>* {\r\n    --bs-table-accent-bg: var(--bs-table-striped-bg);\r\n    color: var(--bs-table-striped-color)\r\n}\r\n\r\n.table-striped-columns>:not(caption)>tr>:nth-child(2n) {\r\n    --bs-table-accent-bg: var(--bs-table-striped-bg);\r\n    color: var(--bs-table-striped-color)\r\n}\r\n\r\n.table-active {\r\n    --bs-table-accent-bg: var(--bs-table-active-bg);\r\n    color: var(--bs-table-active-color)\r\n}\r\n\r\n.table-hover>tbody>tr:hover>* {\r\n    --bs-table-accent-bg: var(--bs-table-hover-bg);\r\n    color: var(--bs-table-hover-color)\r\n}\r\n\r\n.table-primary {\r\n    --bs-table-color: #000;\r\n    --bs-table-bg: #cfe2ff;\r\n    --bs-table-border-color: #bacbe6;\r\n    --bs-table-striped-bg: #c5d7f2;\r\n    --bs-table-striped-color: #000;\r\n    --bs-table-active-bg: #bacbe6;\r\n    --bs-table-active-color: #000;\r\n    --bs-table-hover-bg: #bfd1ec;\r\n    --bs-table-hover-color: #000;\r\n    color: var(--bs-table-color);\r\n    border-color: var(--bs-table-border-color)\r\n}\r\n\r\n.table-secondary {\r\n    --bs-table-color: #000;\r\n    --bs-table-bg: #e2e3e5;\r\n    --bs-table-border-color: #cbccce;\r\n    --bs-table-striped-bg: #d7d8da;\r\n    --bs-table-striped-color: #000;\r\n    --bs-table-active-bg: #cbccce;\r\n    --bs-table-active-color: #000;\r\n    --bs-table-hover-bg: #d1d2d4;\r\n    --bs-table-hover-color: #000;\r\n    color: var(--bs-table-color);\r\n    border-color: var(--bs-table-border-color)\r\n}\r\n\r\n.table-success {\r\n    --bs-table-color: #000;\r\n    --bs-table-bg: #d1e7dd;\r\n    --bs-table-border-color: #bcd0c7;\r\n    --bs-table-striped-bg: #c7dbd2;\r\n    --bs-table-striped-color: #000;\r\n    --bs-table-active-bg: #bcd0c7;\r\n    --bs-table-active-color: #000;\r\n    --bs-table-hover-bg: #c1d6cc;\r\n    --bs-table-hover-color: #000;\r\n    color: var(--bs-table-color);\r\n    border-color: var(--bs-table-border-color)\r\n}\r\n\r\n.table-info {\r\n    --bs-table-color: #000;\r\n    --bs-table-bg: #cff4fc;\r\n    --bs-table-border-color: #badce3;\r\n    --bs-table-striped-bg: #c5e8ef;\r\n    --bs-table-striped-color: #000;\r\n    --bs-table-active-bg: #badce3;\r\n    --bs-table-active-color: #000;\r\n    --bs-table-hover-bg: #bfe2e9;\r\n    --bs-table-hover-color: #000;\r\n    color: var(--bs-table-color);\r\n    border-color: var(--bs-table-border-color)\r\n}\r\n\r\n.table-warning {\r\n    --bs-table-color: #000;\r\n    --bs-table-bg: #fff3cd;\r\n    --bs-table-border-color: #e6dbb9;\r\n    --bs-table-striped-bg: #f2e7c3;\r\n    --bs-table-striped-color: #000;\r\n    --bs-table-active-bg: #e6dbb9;\r\n    --bs-table-active-color: #000;\r\n    --bs-table-hover-bg: #ece1be;\r\n    --bs-table-hover-color: #000;\r\n    color: var(--bs-table-color);\r\n    border-color: var(--bs-table-border-color)\r\n}\r\n\r\n.table-danger {\r\n    --bs-table-color: #000;\r\n    --bs-table-bg: #f8d7da;\r\n    --bs-table-border-color: #dfc2c4;\r\n    --bs-table-striped-bg: #eccccf;\r\n    --bs-table-striped-color: #000;\r\n    --bs-table-active-bg: #dfc2c4;\r\n    --bs-table-active-color: #000;\r\n    --bs-table-hover-bg: #e5c7ca;\r\n    --bs-table-hover-color: #000;\r\n    color: var(--bs-table-color);\r\n    border-color: var(--bs-table-border-color)\r\n}\r\n\r\n.table-light {\r\n    --bs-table-color: #000;\r\n    --bs-table-bg: #f8f9fa;\r\n    --bs-table-border-color: #dfe0e1;\r\n    --bs-table-striped-bg: #ecedee;\r\n    --bs-table-striped-color: #000;\r\n    --bs-table-active-bg: #dfe0e1;\r\n    --bs-table-active-color: #000;\r\n    --bs-table-hover-bg: #e5e6e7;\r\n    --bs-table-hover-color: #000;\r\n    color: var(--bs-table-color);\r\n    border-color: var(--bs-table-border-color)\r\n}\r\n\r\n.table-dark {\r\n    --bs-table-color: #fff;\r\n    --bs-table-bg: #212529;\r\n    --bs-table-border-color: #373b3e;\r\n    --bs-table-striped-bg: #2c3034;\r\n    --bs-table-striped-color: #fff;\r\n    --bs-table-active-bg: #373b3e;\r\n    --bs-table-active-color: #fff;\r\n    --bs-table-hover-bg: #323539;\r\n    --bs-table-hover-color: #fff;\r\n    color: var(--bs-table-color);\r\n    border-color: var(--bs-table-border-color)\r\n}\r\n\r\n.table-responsive {\r\n    overflow-x: auto;\r\n    -webkit-overflow-scrolling: touch\r\n}\r\n\r\n@media (max-width:575.98px) {\r\n    .table-responsive-sm {\r\n        overflow-x: auto;\r\n        -webkit-overflow-scrolling: touch\r\n    }\r\n}\r\n\r\n@media (max-width:767.98px) {\r\n    .table-responsive-md {\r\n        overflow-x: auto;\r\n        -webkit-overflow-scrolling: touch\r\n    }\r\n}\r\n\r\n@media (max-width:991.98px) {\r\n    .table-responsive-lg {\r\n        overflow-x: auto;\r\n        -webkit-overflow-scrolling: touch\r\n    }\r\n}\r\n\r\n@media (max-width:1199.98px) {\r\n    .table-responsive-xl {\r\n        overflow-x: auto;\r\n        -webkit-overflow-scrolling: touch\r\n    }\r\n}\r\n\r\n@media (max-width:1399.98px) {\r\n    .table-responsive-xxl {\r\n        overflow-x: auto;\r\n        -webkit-overflow-scrolling: touch\r\n    }\r\n}\r\n\r\n.form-label {\r\n    margin-bottom: .5rem\r\n}\r\n\r\n.col-form-label {\r\n    padding-top: calc(.375rem + 1px);\r\n    padding-bottom: calc(.375rem + 1px);\r\n    margin-bottom: 0;\r\n    font-size: inherit;\r\n    line-height: 1.5\r\n}\r\n\r\n.col-form-label-lg {\r\n    padding-top: calc(.5rem + 1px);\r\n    padding-bottom: calc(.5rem + 1px);\r\n    font-size: 1.25rem\r\n}\r\n\r\n.col-form-label-sm {\r\n    padding-top: calc(.25rem + 1px);\r\n    padding-bottom: calc(.25rem + 1px);\r\n    font-size: .875rem\r\n}\r\n\r\n.form-text {\r\n    margin-top: .25rem;\r\n    font-size: .875em;\r\n    color: #6c757d\r\n}\r\n\r\n.form-control {\r\n    display: block;\r\n    width: 100%;\r\n    padding: .375rem .75rem;\r\n    font-size: 1rem;\r\n    font-weight: 400;\r\n    line-height: 1.5;\r\n    color: #212529;\r\n    background-color: #fff;\r\n    background-clip: padding-box;\r\n    border: 1px solid #ced4da;\r\n    -webkit-appearance: none;\r\n    -moz-appearance: none;\r\n    appearance: none;\r\n    border-radius: .375rem;\r\n    transition: border-color .15s ease-in-out, box-shadow .15s ease-in-out\r\n}\r\n\r\n@media (prefers-reduced-motion:reduce) {\r\n    .form-control {\r\n        transition: none\r\n    }\r\n}\r\n\r\n.form-control[type=file] {\r\n    overflow: hidden\r\n}\r\n\r\n.form-control[type=file]:not(:disabled):not([readonly]) {\r\n    cursor: pointer\r\n}\r\n\r\n.form-control:focus {\r\n    color: #212529;\r\n    background-color: #fff;\r\n    border-color: #86b7fe;\r\n    outline: 0;\r\n    box-shadow: 0 0 0 .25rem rgba(13, 110, 253, .25)\r\n}\r\n\r\n.form-control::-webkit-date-and-time-value {\r\n    height: 1.5em\r\n}\r\n\r\n.form-control::-moz-placeholder {\r\n    color: #6c757d;\r\n    opacity: 1\r\n}\r\n\r\n.form-control::placeholder {\r\n    color: #6c757d;\r\n    opacity: 1\r\n}\r\n\r\n.form-control:disabled {\r\n    background-color: #e9ecef;\r\n    opacity: 1\r\n}\r\n\r\n.form-control::-webkit-file-upload-button {\r\n    padding: .375rem .75rem;\r\n    margin: -.375rem -.75rem;\r\n    -webkit-margin-end: .75rem;\r\n    margin-inline-end: .75rem;\r\n    color: #212529;\r\n    background-color: #e9ecef;\r\n    pointer-events: none;\r\n    border-color: inherit;\r\n    border-style: solid;\r\n    border-width: 0;\r\n    border-inline-end-width: 1px;\r\n    border-radius: 0;\r\n    -webkit-transition: color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out;\r\n    transition: color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out\r\n}\r\n\r\n.form-control::file-selector-button {\r\n    padding: .375rem .75rem;\r\n    margin: -.375rem -.75rem;\r\n    -webkit-margin-end: .75rem;\r\n    margin-inline-end: .75rem;\r\n    color: #212529;\r\n    background-color: #e9ecef;\r\n    pointer-events: none;\r\n    border-color: inherit;\r\n    border-style: solid;\r\n    border-width: 0;\r\n    border-inline-end-width: 1px;\r\n    border-radius: 0;\r\n    transition: color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out\r\n}\r\n\r\n@media (prefers-reduced-motion:reduce) {\r\n    .form-control::-webkit-file-upload-button {\r\n        -webkit-transition: none;\r\n        transition: none\r\n    }\r\n\r\n    .form-control::file-selector-button {\r\n        transition: none\r\n    }\r\n}\r\n\r\n.form-control:hover:not(:disabled):not([readonly])::-webkit-file-upload-button {\r\n    background-color: #dde0e3\r\n}\r\n\r\n.form-control:hover:not(:disabled):not([readonly])::file-selector-button {\r\n    background-color: #dde0e3\r\n}\r\n\r\n.form-control-plaintext {\r\n    display: block;\r\n    width: 100%;\r\n    padding: .375rem 0;\r\n    margin-bottom: 0;\r\n    line-height: 1.5;\r\n    color: #212529;\r\n    background-color: transparent;\r\n    border: solid transparent;\r\n    border-width: 1px 0\r\n}\r\n\r\n.form-control-plaintext:focus {\r\n    outline: 0\r\n}\r\n\r\n.form-control-plaintext.form-control-lg,\r\n.form-control-plaintext.form-control-sm {\r\n    padding-right: 0;\r\n    padding-left: 0\r\n}\r\n\r\n.form-control-sm {\r\n    min-height: calc(1.5em + .5rem + 2px);\r\n    padding: .25rem .5rem;\r\n    font-size: .875rem;\r\n    border-radius: .25rem\r\n}\r\n\r\n.form-control-sm::-webkit-file-upload-button {\r\n    padding: .25rem .5rem;\r\n    margin: -.25rem -.5rem;\r\n    -webkit-margin-end: .5rem;\r\n    margin-inline-end: .5rem\r\n}\r\n\r\n.form-control-sm::file-selector-button {\r\n    padding: .25rem .5rem;\r\n    margin: -.25rem -.5rem;\r\n    -webkit-margin-end: .5rem;\r\n    margin-inline-end: .5rem\r\n}\r\n\r\n.form-control-lg {\r\n    min-height: calc(1.5em + 1rem + 2px);\r\n    padding: .5rem 1rem;\r\n    font-size: 1.25rem;\r\n    border-radius: .5rem\r\n}\r\n\r\n.form-control-lg::-webkit-file-upload-button {\r\n    padding: .5rem 1rem;\r\n    margin: -.5rem -1rem;\r\n    -webkit-margin-end: 1rem;\r\n    margin-inline-end: 1rem\r\n}\r\n\r\n.form-control-lg::file-selector-button {\r\n    padding: .5rem 1rem;\r\n    margin: -.5rem -1rem;\r\n    -webkit-margin-end: 1rem;\r\n    margin-inline-end: 1rem\r\n}\r\n\r\ntextarea.form-control {\r\n    min-height: calc(1.5em + .75rem + 2px)\r\n}\r\n\r\ntextarea.form-control-sm {\r\n    min-height: calc(1.5em + .5rem + 2px)\r\n}\r\n\r\ntextarea.form-control-lg {\r\n    min-height: calc(1.5em + 1rem + 2px)\r\n}\r\n\r\n.form-control-color {\r\n    width: 3rem;\r\n    height: calc(1.5em + .75rem + 2px);\r\n    padding: .375rem\r\n}\r\n\r\n.form-control-color:not(:disabled):not([readonly]) {\r\n    cursor: pointer\r\n}\r\n\r\n.form-control-color::-moz-color-swatch {\r\n    border: 0 !important;\r\n    border-radius: .375rem\r\n}\r\n\r\n.form-control-color::-webkit-color-swatch {\r\n    border-radius: .375rem\r\n}\r\n\r\n.form-control-color.form-control-sm {\r\n    height: calc(1.5em + .5rem + 2px)\r\n}\r\n\r\n.form-control-color.form-control-lg {\r\n    height: calc(1.5em + 1rem + 2px)\r\n}\r\n\r\n.form-select {\r\n    display: block;\r\n    width: 100%;\r\n    padding: .375rem 2.25rem .375rem .75rem;\r\n    -moz-padding-start: calc(0.75rem - 3px);\r\n    font-size: 1rem;\r\n    font-weight: 400;\r\n    line-height: 1.5;\r\n    color: #212529;\r\n    background-color: #fff;\r\n    background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%23343a40' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='m2 5 6 6 6-6'/%3e%3c/svg%3e\");\r\n    background-repeat: no-repeat;\r\n    background-position: right .75rem center;\r\n    background-size: 16px 12px;\r\n    border: 1px solid #ced4da;\r\n    border-radius: .375rem;\r\n    transition: border-color .15s ease-in-out, box-shadow .15s ease-in-out;\r\n    -webkit-appearance: none;\r\n    -moz-appearance: none;\r\n    appearance: none\r\n}\r\n\r\n@media (prefers-reduced-motion:reduce) {\r\n    .form-select {\r\n        transition: none\r\n    }\r\n}\r\n\r\n.form-select:focus {\r\n    border-color: #86b7fe;\r\n    outline: 0;\r\n    box-shadow: 0 0 0 .25rem rgba(13, 110, 253, .25)\r\n}\r\n\r\n.form-select[multiple],\r\n.form-select[size]:not([size=\"1\"]) {\r\n    padding-right: .75rem;\r\n    background-image: none\r\n}\r\n\r\n.form-select:disabled {\r\n    background-color: #e9ecef\r\n}\r\n\r\n.form-select:-moz-focusring {\r\n    color: transparent;\r\n    text-shadow: 0 0 0 #212529\r\n}\r\n\r\n.form-select-sm {\r\n    padding-top: .25rem;\r\n    padding-bottom: .25rem;\r\n    padding-left: .5rem;\r\n    font-size: .875rem;\r\n    border-radius: .25rem\r\n}\r\n\r\n.form-select-lg {\r\n    padding-top: .5rem;\r\n    padding-bottom: .5rem;\r\n    padding-left: 1rem;\r\n    font-size: 1.25rem;\r\n    border-radius: .5rem\r\n}\r\n\r\n.form-check {\r\n    display: block;\r\n    min-height: 1.5rem;\r\n    padding-left: 1.5em;\r\n    margin-bottom: .125rem\r\n}\r\n\r\n.form-check .form-check-input {\r\n    float: left;\r\n    margin-left: -1.5em\r\n}\r\n\r\n.form-check-reverse {\r\n    padding-right: 1.5em;\r\n    padding-left: 0;\r\n    text-align: right\r\n}\r\n\r\n.form-check-reverse .form-check-input {\r\n    float: right;\r\n    margin-right: -1.5em;\r\n    margin-left: 0\r\n}\r\n\r\n.form-check-input {\r\n    width: 1em;\r\n    height: 1em;\r\n    margin-top: .25em;\r\n    vertical-align: top;\r\n    background-color: #fff;\r\n    background-repeat: no-repeat;\r\n    background-position: center;\r\n    background-size: contain;\r\n    border: 1px solid rgba(0, 0, 0, .25);\r\n    -webkit-appearance: none;\r\n    -moz-appearance: none;\r\n    appearance: none;\r\n    -webkit-print-color-adjust: exact;\r\n    color-adjust: exact;\r\n    print-color-adjust: exact\r\n}\r\n\r\n.form-check-input[type=checkbox] {\r\n    border-radius: .25em\r\n}\r\n\r\n.form-check-input[type=radio] {\r\n    border-radius: 50%\r\n}\r\n\r\n.form-check-input:active {\r\n    filter: brightness(90%)\r\n}\r\n\r\n.form-check-input:focus {\r\n    border-color: #86b7fe;\r\n    outline: 0;\r\n    box-shadow: 0 0 0 .25rem rgba(13, 110, 253, .25)\r\n}\r\n\r\n.form-check-input:checked {\r\n    background-color: #0d6efd;\r\n    border-color: #0d6efd\r\n}\r\n\r\n.form-check-input:checked[type=checkbox] {\r\n    background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'%3e%3cpath fill='none' stroke='%23fff' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='m6 10 3 3 6-6'/%3e%3c/svg%3e\")\r\n}\r\n\r\n.form-check-input:checked[type=radio] {\r\n    background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='2' fill='%23fff'/%3e%3c/svg%3e\")\r\n}\r\n\r\n.form-check-input[type=checkbox]:indeterminate {\r\n    background-color: #0d6efd;\r\n    border-color: #0d6efd;\r\n    background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'%3e%3cpath fill='none' stroke='%23fff' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M6 10h8'/%3e%3c/svg%3e\")\r\n}\r\n\r\n.form-check-input:disabled {\r\n    pointer-events: none;\r\n    filter: none;\r\n    opacity: .5\r\n}\r\n\r\n.form-check-input:disabled~.form-check-label,\r\n.form-check-input[disabled]~.form-check-label {\r\n    cursor: default;\r\n    opacity: .5\r\n}\r\n\r\n.form-switch {\r\n    padding-left: 2.5em\r\n}\r\n\r\n.form-switch .form-check-input {\r\n    width: 2em;\r\n    margin-left: -2.5em;\r\n    background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='rgba%280, 0, 0, 0.25%29'/%3e%3c/svg%3e\");\r\n    background-position: left center;\r\n    border-radius: 2em;\r\n    transition: background-position .15s ease-in-out\r\n}\r\n\r\n@media (prefers-reduced-motion:reduce) {\r\n    .form-switch .form-check-input {\r\n        transition: none\r\n    }\r\n}\r\n\r\n.form-switch .form-check-input:focus {\r\n    background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='%2386b7fe'/%3e%3c/svg%3e\")\r\n}\r\n\r\n.form-switch .form-check-input:checked {\r\n    background-position: right center;\r\n    background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='%23fff'/%3e%3c/svg%3e\")\r\n}\r\n\r\n.form-switch.form-check-reverse {\r\n    padding-right: 2.5em;\r\n    padding-left: 0\r\n}\r\n\r\n.form-switch.form-check-reverse .form-check-input {\r\n    margin-right: -2.5em;\r\n    margin-left: 0\r\n}\r\n\r\n.form-check-inline {\r\n    display: inline-block;\r\n    margin-right: 1rem\r\n}\r\n\r\n.btn-check {\r\n    position: absolute;\r\n    clip: rect(0, 0, 0, 0);\r\n    pointer-events: none\r\n}\r\n\r\n.btn-check:disabled+.btn,\r\n.btn-check[disabled]+.btn {\r\n    pointer-events: none;\r\n    filter: none;\r\n    opacity: .65\r\n}\r\n\r\n.form-range {\r\n    width: 100%;\r\n    height: 1.5rem;\r\n    padding: 0;\r\n    background-color: transparent;\r\n    -webkit-appearance: none;\r\n    -moz-appearance: none;\r\n    appearance: none\r\n}\r\n\r\n.form-range:focus {\r\n    outline: 0\r\n}\r\n\r\n.form-range:focus::-webkit-slider-thumb {\r\n    box-shadow: 0 0 0 1px #fff, 0 0 0 .25rem rgba(13, 110, 253, .25)\r\n}\r\n\r\n.form-range:focus::-moz-range-thumb {\r\n    box-shadow: 0 0 0 1px #fff, 0 0 0 .25rem rgba(13, 110, 253, .25)\r\n}\r\n\r\n.form-range::-moz-focus-outer {\r\n    border: 0\r\n}\r\n\r\n.form-range::-webkit-slider-thumb {\r\n    width: 1rem;\r\n    height: 1rem;\r\n    margin-top: -.25rem;\r\n    background-color: #0d6efd;\r\n    border: 0;\r\n    border-radius: 1rem;\r\n    -webkit-transition: background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out;\r\n    transition: background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out;\r\n    -webkit-appearance: none;\r\n    appearance: none\r\n}\r\n\r\n@media (prefers-reduced-motion:reduce) {\r\n    .form-range::-webkit-slider-thumb {\r\n        -webkit-transition: none;\r\n        transition: none\r\n    }\r\n}\r\n\r\n.form-range::-webkit-slider-thumb:active {\r\n    background-color: #b6d4fe\r\n}\r\n\r\n.form-range::-webkit-slider-runnable-track {\r\n    width: 100%;\r\n    height: .5rem;\r\n    color: transparent;\r\n    cursor: pointer;\r\n    background-color: #dee2e6;\r\n    border-color: transparent;\r\n    border-radius: 1rem\r\n}\r\n\r\n.form-range::-moz-range-thumb {\r\n    width: 1rem;\r\n    height: 1rem;\r\n    background-color: #0d6efd;\r\n    border: 0;\r\n    border-radius: 1rem;\r\n    -moz-transition: background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out;\r\n    transition: background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out;\r\n    -moz-appearance: none;\r\n    appearance: none\r\n}\r\n\r\n@media (prefers-reduced-motion:reduce) {\r\n    .form-range::-moz-range-thumb {\r\n        -moz-transition: none;\r\n        transition: none\r\n    }\r\n}\r\n\r\n.form-range::-moz-range-thumb:active {\r\n    background-color: #b6d4fe\r\n}\r\n\r\n.form-range::-moz-range-track {\r\n    width: 100%;\r\n    height: .5rem;\r\n    color: transparent;\r\n    cursor: pointer;\r\n    background-color: #dee2e6;\r\n    border-color: transparent;\r\n    border-radius: 1rem\r\n}\r\n\r\n.form-range:disabled {\r\n    pointer-events: none\r\n}\r\n\r\n.form-range:disabled::-webkit-slider-thumb {\r\n    background-color: #adb5bd\r\n}\r\n\r\n.form-range:disabled::-moz-range-thumb {\r\n    background-color: #adb5bd\r\n}\r\n\r\n.form-floating {\r\n    position: relative\r\n}\r\n\r\n.form-floating>.form-control,\r\n.form-floating>.form-control-plaintext,\r\n.form-floating>.form-select {\r\n    height: calc(3.5rem + 2px);\r\n    line-height: 1.25\r\n}\r\n\r\n.form-floating>label {\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    width: 100%;\r\n    height: 100%;\r\n    padding: 1rem .75rem;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n    white-space: nowrap;\r\n    pointer-events: none;\r\n    border: 1px solid transparent;\r\n    transform-origin: 0 0;\r\n    transition: opacity .1s ease-in-out, transform .1s ease-in-out\r\n}\r\n\r\n@media (prefers-reduced-motion:reduce) {\r\n    .form-floating>label {\r\n        transition: none\r\n    }\r\n}\r\n\r\n.form-floating>.form-control,\r\n.form-floating>.form-control-plaintext {\r\n    padding: 1rem .75rem\r\n}\r\n\r\n.form-floating>.form-control-plaintext::-moz-placeholder,\r\n.form-floating>.form-control::-moz-placeholder {\r\n    color: transparent\r\n}\r\n\r\n.form-floating>.form-control-plaintext::placeholder,\r\n.form-floating>.form-control::placeholder {\r\n    color: transparent\r\n}\r\n\r\n.form-floating>.form-control-plaintext:not(:-moz-placeholder-shown),\r\n.form-floating>.form-control:not(:-moz-placeholder-shown) {\r\n    padding-top: 1.625rem;\r\n    padding-bottom: .625rem\r\n}\r\n\r\n.form-floating>.form-control-plaintext:focus,\r\n.form-floating>.form-control-plaintext:not(:placeholder-shown),\r\n.form-floating>.form-control:focus,\r\n.form-floating>.form-control:not(:placeholder-shown) {\r\n    padding-top: 1.625rem;\r\n    padding-bottom: .625rem\r\n}\r\n\r\n.form-floating>.form-control-plaintext:-webkit-autofill,\r\n.form-floating>.form-control:-webkit-autofill {\r\n    padding-top: 1.625rem;\r\n    padding-bottom: .625rem\r\n}\r\n\r\n.form-floating>.form-select {\r\n    padding-top: 1.625rem;\r\n    padding-bottom: .625rem\r\n}\r\n\r\n.form-floating>.form-control:not(:-moz-placeholder-shown)~label {\r\n    opacity: .65;\r\n    transform: scale(.85) translateY(-.5rem) translateX(.15rem)\r\n}\r\n\r\n.form-floating>.form-control-plaintext~label,\r\n.form-floating>.form-control:focus~label,\r\n.form-floating>.form-control:not(:placeholder-shown)~label,\r\n.form-floating>.form-select~label {\r\n    opacity: .65;\r\n    transform: scale(.85) translateY(-.5rem) translateX(.15rem)\r\n}\r\n\r\n.form-floating>.form-control:-webkit-autofill~label {\r\n    opacity: .65;\r\n    transform: scale(.85) translateY(-.5rem) translateX(.15rem)\r\n}\r\n\r\n.form-floating>.form-control-plaintext~label {\r\n    border-width: 1px 0\r\n}\r\n\r\n.input-group {\r\n    position: relative;\r\n    display: flex;\r\n    flex-wrap: wrap;\r\n    align-items: stretch;\r\n    width: 100%\r\n}\r\n\r\n.input-group>.form-control,\r\n.input-group>.form-floating,\r\n.input-group>.form-select {\r\n    position: relative;\r\n    flex: 1 1 auto;\r\n    width: 1%;\r\n    min-width: 0\r\n}\r\n\r\n.input-group>.form-control:focus,\r\n.input-group>.form-floating:focus-within,\r\n.input-group>.form-select:focus {\r\n    z-index: 3\r\n}\r\n\r\n.input-group .btn {\r\n    position: relative;\r\n    z-index: 2\r\n}\r\n\r\n.input-group .btn:focus {\r\n    z-index: 3\r\n}\r\n\r\n.input-group-text {\r\n    display: flex;\r\n    align-items: center;\r\n    padding: .375rem .75rem;\r\n    font-size: 1rem;\r\n    font-weight: 400;\r\n    line-height: 1.5;\r\n    color: #212529;\r\n    text-align: center;\r\n    white-space: nowrap;\r\n    background-color: #e9ecef;\r\n    border: 1px solid #ced4da;\r\n    border-radius: .375rem\r\n}\r\n\r\n.input-group-lg>.btn,\r\n.input-group-lg>.form-control,\r\n.input-group-lg>.form-select,\r\n.input-group-lg>.input-group-text {\r\n    padding: .5rem 1rem;\r\n    font-size: 1.25rem;\r\n    border-radius: .5rem\r\n}\r\n\r\n.input-group-sm>.btn,\r\n.input-group-sm>.form-control,\r\n.input-group-sm>.form-select,\r\n.input-group-sm>.input-group-text {\r\n    padding: .25rem .5rem;\r\n    font-size: .875rem;\r\n    border-radius: .25rem\r\n}\r\n\r\n.input-group-lg>.form-select,\r\n.input-group-sm>.form-select {\r\n    padding-right: 3rem\r\n}\r\n\r\n.input-group:not(.has-validation)>.dropdown-toggle:nth-last-child(n+3),\r\n.input-group:not(.has-validation)>.form-floating:not(:last-child)>.form-control,\r\n.input-group:not(.has-validation)>.form-floating:not(:last-child)>.form-select,\r\n.input-group:not(.has-validation)>:not(:last-child):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating) {\r\n    border-top-right-radius: 0;\r\n    border-bottom-right-radius: 0\r\n}\r\n\r\n.input-group.has-validation>.dropdown-toggle:nth-last-child(n+4),\r\n.input-group.has-validation>.form-floating:nth-last-child(n+3)>.form-control,\r\n.input-group.has-validation>.form-floating:nth-last-child(n+3)>.form-select,\r\n.input-group.has-validation>:nth-last-child(n+3):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating) {\r\n    border-top-right-radius: 0;\r\n    border-bottom-right-radius: 0\r\n}\r\n\r\n.input-group>.form-floating:not(:first-child)>.form-control,\r\n.input-group>.form-floating:not(:first-child)>.form-select,\r\n.input-group>:not(:first-child):not(.dropdown-menu):not(.form-floating):not(.valid-tooltip):not(.valid-feedback):not(.invalid-tooltip):not(.invalid-feedback) {\r\n    margin-left: -1px;\r\n    border-top-left-radius: 0;\r\n    border-bottom-left-radius: 0\r\n}\r\n\r\n.valid-feedback {\r\n    display: none;\r\n    width: 100%;\r\n    margin-top: .25rem;\r\n    font-size: .875em;\r\n    color: #198754\r\n}\r\n\r\n.valid-tooltip {\r\n    position: absolute;\r\n    top: 100%;\r\n    z-index: 5;\r\n    display: none;\r\n    max-width: 100%;\r\n    padding: .25rem .5rem;\r\n    margin-top: .1rem;\r\n    font-size: .875rem;\r\n    color: #fff;\r\n    background-color: rgba(25, 135, 84, .9);\r\n    border-radius: .375rem\r\n}\r\n\r\n.is-valid~.valid-feedback,\r\n.is-valid~.valid-tooltip,\r\n.was-validated :valid~.valid-feedback,\r\n.was-validated :valid~.valid-tooltip {\r\n    display: block\r\n}\r\n\r\n.form-control.is-valid,\r\n.was-validated .form-control:valid {\r\n    border-color: #198754;\r\n    padding-right: calc(1.5em + .75rem);\r\n    background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3e%3cpath fill='%23198754' d='M2.3 6.73.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3e%3c/svg%3e\");\r\n    background-repeat: no-repeat;\r\n    background-position: right calc(.375em + .1875rem) center;\r\n    background-size: calc(.75em + .375rem) calc(.75em + .375rem)\r\n}\r\n\r\n.form-control.is-valid:focus,\r\n.was-validated .form-control:valid:focus {\r\n    border-color: #198754;\r\n    box-shadow: 0 0 0 .25rem rgba(25, 135, 84, .25)\r\n}\r\n\r\n.was-validated textarea.form-control:valid,\r\ntextarea.form-control.is-valid {\r\n    padding-right: calc(1.5em + .75rem);\r\n    background-position: top calc(.375em + .1875rem) right calc(.375em + .1875rem)\r\n}\r\n\r\n.form-select.is-valid,\r\n.was-validated .form-select:valid {\r\n    border-color: #198754\r\n}\r\n\r\n.form-select.is-valid:not([multiple]):not([size]),\r\n.form-select.is-valid:not([multiple])[size=\"1\"],\r\n.was-validated .form-select:valid:not([multiple]):not([size]),\r\n.was-validated .form-select:valid:not([multiple])[size=\"1\"] {\r\n    padding-right: 4.125rem;\r\n    background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%23343a40' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='m2 5 6 6 6-6'/%3e%3c/svg%3e\"), url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3e%3cpath fill='%23198754' d='M2.3 6.73.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3e%3c/svg%3e\");\r\n    background-position: right .75rem center, center right 2.25rem;\r\n    background-size: 16px 12px, calc(.75em + .375rem) calc(.75em + .375rem)\r\n}\r\n\r\n.form-select.is-valid:focus,\r\n.was-validated .form-select:valid:focus {\r\n    border-color: #198754;\r\n    box-shadow: 0 0 0 .25rem rgba(25, 135, 84, .25)\r\n}\r\n\r\n.form-control-color.is-valid,\r\n.was-validated .form-control-color:valid {\r\n    width: calc(3rem + calc(1.5em + .75rem))\r\n}\r\n\r\n.form-check-input.is-valid,\r\n.was-validated .form-check-input:valid {\r\n    border-color: #198754\r\n}\r\n\r\n.form-check-input.is-valid:checked,\r\n.was-validated .form-check-input:valid:checked {\r\n    background-color: #198754\r\n}\r\n\r\n.form-check-input.is-valid:focus,\r\n.was-validated .form-check-input:valid:focus {\r\n    box-shadow: 0 0 0 .25rem rgba(25, 135, 84, .25)\r\n}\r\n\r\n.form-check-input.is-valid~.form-check-label,\r\n.was-validated .form-check-input:valid~.form-check-label {\r\n    color: #198754\r\n}\r\n\r\n.form-check-inline .form-check-input~.valid-feedback {\r\n    margin-left: .5em\r\n}\r\n\r\n.input-group .form-control.is-valid,\r\n.input-group .form-select.is-valid,\r\n.was-validated .input-group .form-control:valid,\r\n.was-validated .input-group .form-select:valid {\r\n    z-index: 1\r\n}\r\n\r\n.input-group .form-control.is-valid:focus,\r\n.input-group .form-select.is-valid:focus,\r\n.was-validated .input-group .form-control:valid:focus,\r\n.was-validated .input-group .form-select:valid:focus {\r\n    z-index: 3\r\n}\r\n\r\n.invalid-feedback {\r\n    display: none;\r\n    width: 100%;\r\n    margin-top: .25rem;\r\n    font-size: .875em;\r\n    color: #dc3545\r\n}\r\n\r\n.invalid-tooltip {\r\n    position: absolute;\r\n    top: 100%;\r\n    z-index: 5;\r\n    display: none;\r\n    max-width: 100%;\r\n    padding: .25rem .5rem;\r\n    margin-top: .1rem;\r\n    font-size: .875rem;\r\n    color: #fff;\r\n    background-color: rgba(220, 53, 69, .9);\r\n    border-radius: .375rem\r\n}\r\n\r\n.is-invalid~.invalid-feedback,\r\n.is-invalid~.invalid-tooltip,\r\n.was-validated :invalid~.invalid-feedback,\r\n.was-validated :invalid~.invalid-tooltip {\r\n    display: block\r\n}\r\n\r\n.form-control.is-invalid,\r\n.was-validated .form-control:invalid {\r\n    border-color: #dc3545;\r\n    padding-right: calc(1.5em + .75rem);\r\n    background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='%23dc3545'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23dc3545' stroke='none'/%3e%3c/svg%3e\");\r\n    background-repeat: no-repeat;\r\n    background-position: right calc(.375em + .1875rem) center;\r\n    background-size: calc(.75em + .375rem) calc(.75em + .375rem)\r\n}\r\n\r\n.form-control.is-invalid:focus,\r\n.was-validated .form-control:invalid:focus {\r\n    border-color: #dc3545;\r\n    box-shadow: 0 0 0 .25rem rgba(220, 53, 69, .25)\r\n}\r\n\r\n.was-validated textarea.form-control:invalid,\r\ntextarea.form-control.is-invalid {\r\n    padding-right: calc(1.5em + .75rem);\r\n    background-position: top calc(.375em + .1875rem) right calc(.375em + .1875rem)\r\n}\r\n\r\n.form-select.is-invalid,\r\n.was-validated .form-select:invalid {\r\n    border-color: #dc3545\r\n}\r\n\r\n.form-select.is-invalid:not([multiple]):not([size]),\r\n.form-select.is-invalid:not([multiple])[size=\"1\"],\r\n.was-validated .form-select:invalid:not([multiple]):not([size]),\r\n.was-validated .form-select:invalid:not([multiple])[size=\"1\"] {\r\n    padding-right: 4.125rem;\r\n    background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%23343a40' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='m2 5 6 6 6-6'/%3e%3c/svg%3e\"), url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='%23dc3545'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23dc3545' stroke='none'/%3e%3c/svg%3e\");\r\n    background-position: right .75rem center, center right 2.25rem;\r\n    background-size: 16px 12px, calc(.75em + .375rem) calc(.75em + .375rem)\r\n}\r\n\r\n.form-select.is-invalid:focus,\r\n.was-validated .form-select:invalid:focus {\r\n    border-color: #dc3545;\r\n    box-shadow: 0 0 0 .25rem rgba(220, 53, 69, .25)\r\n}\r\n\r\n.form-control-color.is-invalid,\r\n.was-validated .form-control-color:invalid {\r\n    width: calc(3rem + calc(1.5em + .75rem))\r\n}\r\n\r\n.form-check-input.is-invalid,\r\n.was-validated .form-check-input:invalid {\r\n    border-color: #dc3545\r\n}\r\n\r\n.form-check-input.is-invalid:checked,\r\n.was-validated .form-check-input:invalid:checked {\r\n    background-color: #dc3545\r\n}\r\n\r\n.form-check-input.is-invalid:focus,\r\n.was-validated .form-check-input:invalid:focus {\r\n    box-shadow: 0 0 0 .25rem rgba(220, 53, 69, .25)\r\n}\r\n\r\n.form-check-input.is-invalid~.form-check-label,\r\n.was-validated .form-check-input:invalid~.form-check-label {\r\n    color: #dc3545\r\n}\r\n\r\n.form-check-inline .form-check-input~.invalid-feedback {\r\n    margin-left: .5em\r\n}\r\n\r\n.input-group .form-control.is-invalid,\r\n.input-group .form-select.is-invalid,\r\n.was-validated .input-group .form-control:invalid,\r\n.was-validated .input-group .form-select:invalid {\r\n    z-index: 2\r\n}\r\n\r\n.input-group .form-control.is-invalid:focus,\r\n.input-group .form-select.is-invalid:focus,\r\n.was-validated .input-group .form-control:invalid:focus,\r\n.was-validated .input-group .form-select:invalid:focus {\r\n    z-index: 3\r\n}\r\n\r\n.btn {\r\n    --bs-btn-padding-x: 0.75rem;\r\n    --bs-btn-padding-y: 0.375rem;\r\n    --bs-btn-font-family: ;\r\n    --bs-btn-font-size: 1rem;\r\n    --bs-btn-font-weight: 400;\r\n    --bs-btn-line-height: 1.5;\r\n    --bs-btn-color: #212529;\r\n    --bs-btn-bg: transparent;\r\n    --bs-btn-border-width: 1px;\r\n    --bs-btn-border-color: transparent;\r\n    --bs-btn-border-radius: 0.375rem;\r\n    --bs-btn-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);\r\n    --bs-btn-disabled-opacity: 0.65;\r\n    --bs-btn-focus-box-shadow: 0 0 0 0.25rem rgba(var(--bs-btn-focus-shadow-rgb), .5);\r\n    display: inline-block;\r\n    padding: var(--bs-btn-padding-y) var(--bs-btn-padding-x);\r\n    font-family: var(--bs-btn-font-family);\r\n    font-size: var(--bs-btn-font-size);\r\n    font-weight: var(--bs-btn-font-weight);\r\n    line-height: var(--bs-btn-line-height);\r\n    color: var(--bs-btn-color);\r\n    text-align: center;\r\n    text-decoration: none;\r\n    vertical-align: middle;\r\n    cursor: pointer;\r\n    -webkit-user-select: none;\r\n    -moz-user-select: none;\r\n    user-select: none;\r\n    border: var(--bs-btn-border-width) solid var(--bs-btn-border-color);\r\n    border-radius: var(--bs-btn-border-radius);\r\n    background-color: var(--bs-btn-bg);\r\n    transition: color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out\r\n}\r\n\r\n@media (prefers-reduced-motion:reduce) {\r\n    .btn {\r\n        transition: none\r\n    }\r\n}\r\n\r\n.btn:hover {\r\n    color: var(--bs-btn-hover-color);\r\n    background-color: var(--bs-btn-hover-bg);\r\n    border-color: var(--bs-btn-hover-border-color)\r\n}\r\n\r\n.btn-check:focus+.btn,\r\n.btn:focus {\r\n    color: var(--bs-btn-hover-color);\r\n    background-color: var(--bs-btn-hover-bg);\r\n    border-color: var(--bs-btn-hover-border-color);\r\n    outline: 0;\r\n    box-shadow: var(--bs-btn-focus-box-shadow)\r\n}\r\n\r\n.btn-check:active+.btn,\r\n.btn-check:checked+.btn,\r\n.btn.active,\r\n.btn.show,\r\n.btn:active {\r\n    color: var(--bs-btn-active-color);\r\n    background-color: var(--bs-btn-active-bg);\r\n    border-color: var(--bs-btn-active-border-color)\r\n}\r\n\r\n.btn-check:active+.btn:focus,\r\n.btn-check:checked+.btn:focus,\r\n.btn.active:focus,\r\n.btn.show:focus,\r\n.btn:active:focus {\r\n    box-shadow: var(--bs-btn-focus-box-shadow)\r\n}\r\n\r\n.btn.disabled,\r\n.btn:disabled,\r\nfieldset:disabled .btn {\r\n    color: var(--bs-btn-disabled-color);\r\n    pointer-events: none;\r\n    background-color: var(--bs-btn-disabled-bg);\r\n    border-color: var(--bs-btn-disabled-border-color);\r\n    opacity: var(--bs-btn-disabled-opacity)\r\n}\r\n\r\n.btn-primary {\r\n    --bs-btn-color: #fff;\r\n    --bs-btn-bg: #0d6efd;\r\n    --bs-btn-border-color: #0d6efd;\r\n    --bs-btn-hover-color: #fff;\r\n    --bs-btn-hover-bg: #0b5ed7;\r\n    --bs-btn-hover-border-color: #0a58ca;\r\n    --bs-btn-focus-shadow-rgb: 49, 132, 253;\r\n    --bs-btn-active-color: #fff;\r\n    --bs-btn-active-bg: #0a58ca;\r\n    --bs-btn-active-border-color: #0a53be;\r\n    --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\r\n    --bs-btn-disabled-color: #fff;\r\n    --bs-btn-disabled-bg: #0d6efd;\r\n    --bs-btn-disabled-border-color: #0d6efd\r\n}\r\n\r\n.btn-secondary {\r\n    --bs-btn-color: #fff;\r\n    --bs-btn-bg: #6c757d;\r\n    --bs-btn-border-color: #6c757d;\r\n    --bs-btn-hover-color: #fff;\r\n    --bs-btn-hover-bg: #5c636a;\r\n    --bs-btn-hover-border-color: #565e64;\r\n    --bs-btn-focus-shadow-rgb: 130, 138, 145;\r\n    --bs-btn-active-color: #fff;\r\n    --bs-btn-active-bg: #565e64;\r\n    --bs-btn-active-border-color: #51585e;\r\n    --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\r\n    --bs-btn-disabled-color: #fff;\r\n    --bs-btn-disabled-bg: #6c757d;\r\n    --bs-btn-disabled-border-color: #6c757d\r\n}\r\n\r\n.btn-success {\r\n    --bs-btn-color: #fff;\r\n    --bs-btn-bg: #198754;\r\n    --bs-btn-border-color: #198754;\r\n    --bs-btn-hover-color: #fff;\r\n    --bs-btn-hover-bg: #157347;\r\n    --bs-btn-hover-border-color: #146c43;\r\n    --bs-btn-focus-shadow-rgb: 60, 153, 110;\r\n    --bs-btn-active-color: #fff;\r\n    --bs-btn-active-bg: #146c43;\r\n    --bs-btn-active-border-color: #13653f;\r\n    --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\r\n    --bs-btn-disabled-color: #fff;\r\n    --bs-btn-disabled-bg: #198754;\r\n    --bs-btn-disabled-border-color: #198754\r\n}\r\n\r\n.btn-info {\r\n    --bs-btn-color: #000;\r\n    --bs-btn-bg: #0dcaf0;\r\n    --bs-btn-border-color: #0dcaf0;\r\n    --bs-btn-hover-color: #000;\r\n    --bs-btn-hover-bg: #31d2f2;\r\n    --bs-btn-hover-border-color: #25cff2;\r\n    --bs-btn-focus-shadow-rgb: 11, 172, 204;\r\n    --bs-btn-active-color: #000;\r\n    --bs-btn-active-bg: #3dd5f3;\r\n    --bs-btn-active-border-color: #25cff2;\r\n    --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\r\n    --bs-btn-disabled-color: #000;\r\n    --bs-btn-disabled-bg: #0dcaf0;\r\n    --bs-btn-disabled-border-color: #0dcaf0\r\n}\r\n\r\n.btn-warning {\r\n    --bs-btn-color: #000;\r\n    --bs-btn-bg: #ffc107;\r\n    --bs-btn-border-color: #ffc107;\r\n    --bs-btn-hover-color: #000;\r\n    --bs-btn-hover-bg: #ffca2c;\r\n    --bs-btn-hover-border-color: #ffc720;\r\n    --bs-btn-focus-shadow-rgb: 217, 164, 6;\r\n    --bs-btn-active-color: #000;\r\n    --bs-btn-active-bg: #ffcd39;\r\n    --bs-btn-active-border-color: #ffc720;\r\n    --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\r\n    --bs-btn-disabled-color: #000;\r\n    --bs-btn-disabled-bg: #ffc107;\r\n    --bs-btn-disabled-border-color: #ffc107\r\n}\r\n\r\n.btn-danger {\r\n    --bs-btn-color: #fff;\r\n    --bs-btn-bg: #dc3545;\r\n    --bs-btn-border-color: #dc3545;\r\n    --bs-btn-hover-color: #fff;\r\n    --bs-btn-hover-bg: #bb2d3b;\r\n    --bs-btn-hover-border-color: #b02a37;\r\n    --bs-btn-focus-shadow-rgb: 225, 83, 97;\r\n    --bs-btn-active-color: #fff;\r\n    --bs-btn-active-bg: #b02a37;\r\n    --bs-btn-active-border-color: #a52834;\r\n    --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\r\n    --bs-btn-disabled-color: #fff;\r\n    --bs-btn-disabled-bg: #dc3545;\r\n    --bs-btn-disabled-border-color: #dc3545\r\n}\r\n\r\n.btn-light {\r\n    --bs-btn-color: #000;\r\n    --bs-btn-bg: #f8f9fa;\r\n    --bs-btn-border-color: #f8f9fa;\r\n    --bs-btn-hover-color: #000;\r\n    --bs-btn-hover-bg: #d3d4d5;\r\n    --bs-btn-hover-border-color: #c6c7c8;\r\n    --bs-btn-focus-shadow-rgb: 211, 212, 213;\r\n    --bs-btn-active-color: #000;\r\n    --bs-btn-active-bg: #c6c7c8;\r\n    --bs-btn-active-border-color: #babbbc;\r\n    --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\r\n    --bs-btn-disabled-color: #000;\r\n    --bs-btn-disabled-bg: #f8f9fa;\r\n    --bs-btn-disabled-border-color: #f8f9fa\r\n}\r\n\r\n.btn-dark {\r\n    --bs-btn-color: #fff;\r\n    --bs-btn-bg: #212529;\r\n    --bs-btn-border-color: #212529;\r\n    --bs-btn-hover-color: #fff;\r\n    --bs-btn-hover-bg: #424649;\r\n    --bs-btn-hover-border-color: #373b3e;\r\n    --bs-btn-focus-shadow-rgb: 66, 70, 73;\r\n    --bs-btn-active-color: #fff;\r\n    --bs-btn-active-bg: #4d5154;\r\n    --bs-btn-active-border-color: #373b3e;\r\n    --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\r\n    --bs-btn-disabled-color: #fff;\r\n    --bs-btn-disabled-bg: #212529;\r\n    --bs-btn-disabled-border-color: #212529\r\n}\r\n\r\n.btn-outline-primary {\r\n    --bs-btn-color: #0d6efd;\r\n    --bs-btn-border-color: #0d6efd;\r\n    --bs-btn-hover-color: #fff;\r\n    --bs-btn-hover-bg: #0d6efd;\r\n    --bs-btn-hover-border-color: #0d6efd;\r\n    --bs-btn-focus-shadow-rgb: 13, 110, 253;\r\n    --bs-btn-active-color: #fff;\r\n    --bs-btn-active-bg: #0d6efd;\r\n    --bs-btn-active-border-color: #0d6efd;\r\n    --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\r\n    --bs-btn-disabled-color: #0d6efd;\r\n    --bs-btn-disabled-bg: transparent;\r\n    --bs-btn-disabled-border-color: #0d6efd;\r\n    --bs-gradient: none\r\n}\r\n\r\n.btn-outline-secondary {\r\n    --bs-btn-color: #6c757d;\r\n    --bs-btn-border-color: #6c757d;\r\n    --bs-btn-hover-color: #fff;\r\n    --bs-btn-hover-bg: #6c757d;\r\n    --bs-btn-hover-border-color: #6c757d;\r\n    --bs-btn-focus-shadow-rgb: 108, 117, 125;\r\n    --bs-btn-active-color: #fff;\r\n    --bs-btn-active-bg: #6c757d;\r\n    --bs-btn-active-border-color: #6c757d;\r\n    --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\r\n    --bs-btn-disabled-color: #6c757d;\r\n    --bs-btn-disabled-bg: transparent;\r\n    --bs-btn-disabled-border-color: #6c757d;\r\n    --bs-gradient: none\r\n}\r\n\r\n.btn-outline-success {\r\n    --bs-btn-color: #198754;\r\n    --bs-btn-border-color: #198754;\r\n    --bs-btn-hover-color: #fff;\r\n    --bs-btn-hover-bg: #198754;\r\n    --bs-btn-hover-border-color: #198754;\r\n    --bs-btn-focus-shadow-rgb: 25, 135, 84;\r\n    --bs-btn-active-color: #fff;\r\n    --bs-btn-active-bg: #198754;\r\n    --bs-btn-active-border-color: #198754;\r\n    --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\r\n    --bs-btn-disabled-color: #198754;\r\n    --bs-btn-disabled-bg: transparent;\r\n    --bs-btn-disabled-border-color: #198754;\r\n    --bs-gradient: none\r\n}\r\n\r\n.btn-outline-info {\r\n    --bs-btn-color: #0dcaf0;\r\n    --bs-btn-border-color: #0dcaf0;\r\n    --bs-btn-hover-color: #000;\r\n    --bs-btn-hover-bg: #0dcaf0;\r\n    --bs-btn-hover-border-color: #0dcaf0;\r\n    --bs-btn-focus-shadow-rgb: 13, 202, 240;\r\n    --bs-btn-active-color: #000;\r\n    --bs-btn-active-bg: #0dcaf0;\r\n    --bs-btn-active-border-color: #0dcaf0;\r\n    --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\r\n    --bs-btn-disabled-color: #0dcaf0;\r\n    --bs-btn-disabled-bg: transparent;\r\n    --bs-btn-disabled-border-color: #0dcaf0;\r\n    --bs-gradient: none\r\n}\r\n\r\n.btn-outline-warning {\r\n    --bs-btn-color: #ffc107;\r\n    --bs-btn-border-color: #ffc107;\r\n    --bs-btn-hover-color: #000;\r\n    --bs-btn-hover-bg: #ffc107;\r\n    --bs-btn-hover-border-color: #ffc107;\r\n    --bs-btn-focus-shadow-rgb: 255, 193, 7;\r\n    --bs-btn-active-color: #000;\r\n    --bs-btn-active-bg: #ffc107;\r\n    --bs-btn-active-border-color: #ffc107;\r\n    --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\r\n    --bs-btn-disabled-color: #ffc107;\r\n    --bs-btn-disabled-bg: transparent;\r\n    --bs-btn-disabled-border-color: #ffc107;\r\n    --bs-gradient: none\r\n}\r\n\r\n.btn-outline-danger {\r\n    --bs-btn-color: #dc3545;\r\n    --bs-btn-border-color: #dc3545;\r\n    --bs-btn-hover-color: #fff;\r\n    --bs-btn-hover-bg: #dc3545;\r\n    --bs-btn-hover-border-color: #dc3545;\r\n    --bs-btn-focus-shadow-rgb: 220, 53, 69;\r\n    --bs-btn-active-color: #fff;\r\n    --bs-btn-active-bg: #dc3545;\r\n    --bs-btn-active-border-color: #dc3545;\r\n    --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\r\n    --bs-btn-disabled-color: #dc3545;\r\n    --bs-btn-disabled-bg: transparent;\r\n    --bs-btn-disabled-border-color: #dc3545;\r\n    --bs-gradient: none\r\n}\r\n\r\n.btn-outline-light {\r\n    --bs-btn-color: #f8f9fa;\r\n    --bs-btn-border-color: #f8f9fa;\r\n    --bs-btn-hover-color: #000;\r\n    --bs-btn-hover-bg: #f8f9fa;\r\n    --bs-btn-hover-border-color: #f8f9fa;\r\n    --bs-btn-focus-shadow-rgb: 248, 249, 250;\r\n    --bs-btn-active-color: #000;\r\n    --bs-btn-active-bg: #f8f9fa;\r\n    --bs-btn-active-border-color: #f8f9fa;\r\n    --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\r\n    --bs-btn-disabled-color: #f8f9fa;\r\n    --bs-btn-disabled-bg: transparent;\r\n    --bs-btn-disabled-border-color: #f8f9fa;\r\n    --bs-gradient: none\r\n}\r\n\r\n.btn-outline-dark {\r\n    --bs-btn-color: #212529;\r\n    --bs-btn-border-color: #212529;\r\n    --bs-btn-hover-color: #fff;\r\n    --bs-btn-hover-bg: #212529;\r\n    --bs-btn-hover-border-color: #212529;\r\n    --bs-btn-focus-shadow-rgb: 33, 37, 41;\r\n    --bs-btn-active-color: #fff;\r\n    --bs-btn-active-bg: #212529;\r\n    --bs-btn-active-border-color: #212529;\r\n    --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\r\n    --bs-btn-disabled-color: #212529;\r\n    --bs-btn-disabled-bg: transparent;\r\n    --bs-btn-disabled-border-color: #212529;\r\n    --bs-gradient: none\r\n}\r\n\r\n.btn-link {\r\n    --bs-btn-font-weight: 400;\r\n    --bs-btn-color: var(--bs-link-color);\r\n    --bs-btn-bg: transparent;\r\n    --bs-btn-border-color: transparent;\r\n    --bs-btn-hover-color: var(--bs-link-hover-color);\r\n    --bs-btn-hover-border-color: transparent;\r\n    --bs-btn-active-color: var(--bs-link-hover-color);\r\n    --bs-btn-active-border-color: transparent;\r\n    --bs-btn-disabled-color: #6c757d;\r\n    --bs-btn-disabled-border-color: transparent;\r\n    --bs-btn-box-shadow: none;\r\n    --bs-btn-focus-shadow-rgb: 49, 132, 253;\r\n    text-decoration: underline\r\n}\r\n\r\n.btn-link:focus {\r\n    color: var(--bs-btn-color)\r\n}\r\n\r\n.btn-link:hover {\r\n    color: var(--bs-btn-hover-color)\r\n}\r\n\r\n.btn-group-lg>.btn,\r\n.btn-lg {\r\n    --bs-btn-padding-y: 0.5rem;\r\n    --bs-btn-padding-x: 1rem;\r\n    --bs-btn-font-size: 1.25rem;\r\n    --bs-btn-border-radius: 0.5rem\r\n}\r\n\r\n.btn-group-sm>.btn,\r\n.btn-sm {\r\n    --bs-btn-padding-y: 0.25rem;\r\n    --bs-btn-padding-x: 0.5rem;\r\n    --bs-btn-font-size: 0.875rem;\r\n    --bs-btn-border-radius: 0.25rem\r\n}\r\n\r\n.fade {\r\n    transition: opacity .15s linear\r\n}\r\n\r\n@media (prefers-reduced-motion:reduce) {\r\n    .fade {\r\n        transition: none\r\n    }\r\n}\r\n\r\n.fade:not(.show) {\r\n    opacity: 0\r\n}\r\n\r\n.collapse:not(.show) {\r\n    display: none\r\n}\r\n\r\n.collapsing {\r\n    height: 0;\r\n    overflow: hidden;\r\n    transition: height .35s ease\r\n}\r\n\r\n@media (prefers-reduced-motion:reduce) {\r\n    .collapsing {\r\n        transition: none\r\n    }\r\n}\r\n\r\n.collapsing.collapse-horizontal {\r\n    width: 0;\r\n    height: auto;\r\n    transition: width .35s ease\r\n}\r\n\r\n@media (prefers-reduced-motion:reduce) {\r\n    .collapsing.collapse-horizontal {\r\n        transition: none\r\n    }\r\n}\r\n\r\n.dropdown,\r\n.dropdown-center,\r\n.dropend,\r\n.dropstart,\r\n.dropup,\r\n.dropup-center {\r\n    position: relative\r\n}\r\n\r\n.dropdown-toggle {\r\n    white-space: nowrap\r\n}\r\n\r\n.dropdown-toggle::after {\r\n    display: inline-block;\r\n    margin-left: .255em;\r\n    vertical-align: .255em;\r\n    content: \"\";\r\n    border-top: .3em solid;\r\n    border-right: .3em solid transparent;\r\n    border-bottom: 0;\r\n    border-left: .3em solid transparent\r\n}\r\n\r\n.dropdown-toggle:empty::after {\r\n    margin-left: 0\r\n}\r\n\r\n.dropdown-menu {\r\n    --bs-dropdown-min-width: 10rem;\r\n    --bs-dropdown-padding-x: 0;\r\n    --bs-dropdown-padding-y: 0.5rem;\r\n    --bs-dropdown-spacer: 0.125rem;\r\n    --bs-dropdown-font-size: 1rem;\r\n    --bs-dropdown-color: #212529;\r\n    --bs-dropdown-bg: #fff;\r\n    --bs-dropdown-border-color: var(--bs-border-color-translucent);\r\n    --bs-dropdown-border-radius: 0.375rem;\r\n    --bs-dropdown-border-width: 1px;\r\n    --bs-dropdown-inner-border-radius: calc(0.375rem - 1px);\r\n    --bs-dropdown-divider-bg: var(--bs-border-color-translucent);\r\n    --bs-dropdown-divider-margin-y: 0.5rem;\r\n    --bs-dropdown-box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);\r\n    --bs-dropdown-link-color: #212529;\r\n    --bs-dropdown-link-hover-color: #1e2125;\r\n    --bs-dropdown-link-hover-bg: #e9ecef;\r\n    --bs-dropdown-link-active-color: #fff;\r\n    --bs-dropdown-link-active-bg: #0d6efd;\r\n    --bs-dropdown-link-disabled-color: #adb5bd;\r\n    --bs-dropdown-item-padding-x: 1rem;\r\n    --bs-dropdown-item-padding-y: 0.25rem;\r\n    --bs-dropdown-header-color: #6c757d;\r\n    --bs-dropdown-header-padding-x: 1rem;\r\n    --bs-dropdown-header-padding-y: 0.5rem;\r\n    position: absolute;\r\n    z-index: 1000;\r\n    display: none;\r\n    min-width: var(--bs-dropdown-min-width);\r\n    padding: var(--bs-dropdown-padding-y) var(--bs-dropdown-padding-x);\r\n    margin: 0;\r\n    font-size: var(--bs-dropdown-font-size);\r\n    color: var(--bs-dropdown-color);\r\n    text-align: left;\r\n    list-style: none;\r\n    background-color: var(--bs-dropdown-bg);\r\n    background-clip: padding-box;\r\n    border: var(--bs-dropdown-border-width) solid var(--bs-dropdown-border-color);\r\n    border-radius: var(--bs-dropdown-border-radius)\r\n}\r\n\r\n.dropdown-menu[data-bs-popper] {\r\n    top: 100%;\r\n    left: 0;\r\n    margin-top: var(--bs-dropdown-spacer)\r\n}\r\n\r\n.dropdown-menu-start {\r\n    --bs-position: start\r\n}\r\n\r\n.dropdown-menu-start[data-bs-popper] {\r\n    right: auto;\r\n    left: 0\r\n}\r\n\r\n.dropdown-menu-end {\r\n    --bs-position: end\r\n}\r\n\r\n.dropdown-menu-end[data-bs-popper] {\r\n    right: 0;\r\n    left: auto\r\n}\r\n\r\n@media (min-width:576px) {\r\n    .dropdown-menu-sm-start {\r\n        --bs-position: start\r\n    }\r\n\r\n    .dropdown-menu-sm-start[data-bs-popper] {\r\n        right: auto;\r\n        left: 0\r\n    }\r\n\r\n    .dropdown-menu-sm-end {\r\n        --bs-position: end\r\n    }\r\n\r\n    .dropdown-menu-sm-end[data-bs-popper] {\r\n        right: 0;\r\n        left: auto\r\n    }\r\n}\r\n\r\n@media (min-width:768px) {\r\n    .dropdown-menu-md-start {\r\n        --bs-position: start\r\n    }\r\n\r\n    .dropdown-menu-md-start[data-bs-popper] {\r\n        right: auto;\r\n        left: 0\r\n    }\r\n\r\n    .dropdown-menu-md-end {\r\n        --bs-position: end\r\n    }\r\n\r\n    .dropdown-menu-md-end[data-bs-popper] {\r\n        right: 0;\r\n        left: auto\r\n    }\r\n}\r\n\r\n@media (min-width:992px) {\r\n    .dropdown-menu-lg-start {\r\n        --bs-position: start\r\n    }\r\n\r\n    .dropdown-menu-lg-start[data-bs-popper] {\r\n        right: auto;\r\n        left: 0\r\n    }\r\n\r\n    .dropdown-menu-lg-end {\r\n        --bs-position: end\r\n    }\r\n\r\n    .dropdown-menu-lg-end[data-bs-popper] {\r\n        right: 0;\r\n        left: auto\r\n    }\r\n}\r\n\r\n@media (min-width:1200px) {\r\n    .dropdown-menu-xl-start {\r\n        --bs-position: start\r\n    }\r\n\r\n    .dropdown-menu-xl-start[data-bs-popper] {\r\n        right: auto;\r\n        left: 0\r\n    }\r\n\r\n    .dropdown-menu-xl-end {\r\n        --bs-position: end\r\n    }\r\n\r\n    .dropdown-menu-xl-end[data-bs-popper] {\r\n        right: 0;\r\n        left: auto\r\n    }\r\n}\r\n\r\n@media (min-width:1400px) {\r\n    .dropdown-menu-xxl-start {\r\n        --bs-position: start\r\n    }\r\n\r\n    .dropdown-menu-xxl-start[data-bs-popper] {\r\n        right: auto;\r\n        left: 0\r\n    }\r\n\r\n    .dropdown-menu-xxl-end {\r\n        --bs-position: end\r\n    }\r\n\r\n    .dropdown-menu-xxl-end[data-bs-popper] {\r\n        right: 0;\r\n        left: auto\r\n    }\r\n}\r\n\r\n.dropup .dropdown-menu[data-bs-popper] {\r\n    top: auto;\r\n    bottom: 100%;\r\n    margin-top: 0;\r\n    margin-bottom: var(--bs-dropdown-spacer)\r\n}\r\n\r\n.dropup .dropdown-toggle::after {\r\n    display: inline-block;\r\n    margin-left: .255em;\r\n    vertical-align: .255em;\r\n    content: \"\";\r\n    border-top: 0;\r\n    border-right: .3em solid transparent;\r\n    border-bottom: .3em solid;\r\n    border-left: .3em solid transparent\r\n}\r\n\r\n.dropup .dropdown-toggle:empty::after {\r\n    margin-left: 0\r\n}\r\n\r\n.dropend .dropdown-menu[data-bs-popper] {\r\n    top: 0;\r\n    right: auto;\r\n    left: 100%;\r\n    margin-top: 0;\r\n    margin-left: var(--bs-dropdown-spacer)\r\n}\r\n\r\n.dropend .dropdown-toggle::after {\r\n    display: inline-block;\r\n    margin-left: .255em;\r\n    vertical-align: .255em;\r\n    content: \"\";\r\n    border-top: .3em solid transparent;\r\n    border-right: 0;\r\n    border-bottom: .3em solid transparent;\r\n    border-left: .3em solid\r\n}\r\n\r\n.dropend .dropdown-toggle:empty::after {\r\n    margin-left: 0\r\n}\r\n\r\n.dropend .dropdown-toggle::after {\r\n    vertical-align: 0\r\n}\r\n\r\n.dropstart .dropdown-menu[data-bs-popper] {\r\n    top: 0;\r\n    right: 100%;\r\n    left: auto;\r\n    margin-top: 0;\r\n    margin-right: var(--bs-dropdown-spacer)\r\n}\r\n\r\n.dropstart .dropdown-toggle::after {\r\n    display: inline-block;\r\n    margin-left: .255em;\r\n    vertical-align: .255em;\r\n    content: \"\"\r\n}\r\n\r\n.dropstart .dropdown-toggle::after {\r\n    display: none\r\n}\r\n\r\n.dropstart .dropdown-toggle::before {\r\n    display: inline-block;\r\n    margin-right: .255em;\r\n    vertical-align: .255em;\r\n    content: \"\";\r\n    border-top: .3em solid transparent;\r\n    border-right: .3em solid;\r\n    border-bottom: .3em solid transparent\r\n}\r\n\r\n.dropstart .dropdown-toggle:empty::after {\r\n    margin-left: 0\r\n}\r\n\r\n.dropstart .dropdown-toggle::before {\r\n    vertical-align: 0\r\n}\r\n\r\n.dropdown-divider {\r\n    height: 0;\r\n    margin: var(--bs-dropdown-divider-margin-y) 0;\r\n    overflow: hidden;\r\n    border-top: 1px solid var(--bs-dropdown-divider-bg);\r\n    opacity: 1\r\n}\r\n\r\n.dropdown-item {\r\n    display: block;\r\n    width: 100%;\r\n    padding: var(--bs-dropdown-item-padding-y) var(--bs-dropdown-item-padding-x);\r\n    clear: both;\r\n    font-weight: 400;\r\n    color: var(--bs-dropdown-link-color);\r\n    text-align: inherit;\r\n    text-decoration: none;\r\n    white-space: nowrap;\r\n    background-color: transparent;\r\n    border: 0\r\n}\r\n\r\n.dropdown-item:focus,\r\n.dropdown-item:hover {\r\n    color: var(--bs-dropdown-link-hover-color);\r\n    background-color: var(--bs-dropdown-link-hover-bg)\r\n}\r\n\r\n.dropdown-item.active,\r\n.dropdown-item:active {\r\n    color: var(--bs-dropdown-link-active-color);\r\n    text-decoration: none;\r\n    background-color: var(--bs-dropdown-link-active-bg)\r\n}\r\n\r\n.dropdown-item.disabled,\r\n.dropdown-item:disabled {\r\n    color: var(--bs-dropdown-link-disabled-color);\r\n    pointer-events: none;\r\n    background-color: transparent\r\n}\r\n\r\n.dropdown-menu.show {\r\n    display: block\r\n}\r\n\r\n.dropdown-header {\r\n    display: block;\r\n    padding: var(--bs-dropdown-header-padding-y) var(--bs-dropdown-header-padding-x);\r\n    margin-bottom: 0;\r\n    font-size: .875rem;\r\n    color: var(--bs-dropdown-header-color);\r\n    white-space: nowrap\r\n}\r\n\r\n.dropdown-item-text {\r\n    display: block;\r\n    padding: var(--bs-dropdown-item-padding-y) var(--bs-dropdown-item-padding-x);\r\n    color: var(--bs-dropdown-link-color)\r\n}\r\n\r\n.dropdown-menu-dark {\r\n    --bs-dropdown-color: #dee2e6;\r\n    --bs-dropdown-bg: #343a40;\r\n    --bs-dropdown-border-color: var(--bs-border-color-translucent);\r\n    --bs-dropdown-box-shadow: ;\r\n    --bs-dropdown-link-color: #dee2e6;\r\n    --bs-dropdown-link-hover-color: #fff;\r\n    --bs-dropdown-divider-bg: var(--bs-border-color-translucent);\r\n    --bs-dropdown-link-hover-bg: rgba(255, 255, 255, 0.15);\r\n    --bs-dropdown-link-active-color: #fff;\r\n    --bs-dropdown-link-active-bg: #0d6efd;\r\n    --bs-dropdown-link-disabled-color: #adb5bd;\r\n    --bs-dropdown-header-color: #adb5bd\r\n}\r\n\r\n.btn-group,\r\n.btn-group-vertical {\r\n    position: relative;\r\n    display: inline-flex;\r\n    vertical-align: middle\r\n}\r\n\r\n.btn-group-vertical>.btn,\r\n.btn-group>.btn {\r\n    position: relative;\r\n    flex: 1 1 auto\r\n}\r\n\r\n.btn-group-vertical>.btn-check:checked+.btn,\r\n.btn-group-vertical>.btn-check:focus+.btn,\r\n.btn-group-vertical>.btn.active,\r\n.btn-group-vertical>.btn:active,\r\n.btn-group-vertical>.btn:focus,\r\n.btn-group-vertical>.btn:hover,\r\n.btn-group>.btn-check:checked+.btn,\r\n.btn-group>.btn-check:focus+.btn,\r\n.btn-group>.btn.active,\r\n.btn-group>.btn:active,\r\n.btn-group>.btn:focus,\r\n.btn-group>.btn:hover {\r\n    z-index: 1\r\n}\r\n\r\n.btn-toolbar {\r\n    display: flex;\r\n    flex-wrap: wrap;\r\n    justify-content: flex-start\r\n}\r\n\r\n.btn-toolbar .input-group {\r\n    width: auto\r\n}\r\n\r\n.btn-group {\r\n    border-radius: .375rem\r\n}\r\n\r\n.btn-group>.btn-group:not(:first-child),\r\n.btn-group>.btn:not(:first-child) {\r\n    margin-left: -1px\r\n}\r\n\r\n.btn-group>.btn-group:not(:last-child)>.btn,\r\n.btn-group>.btn.dropdown-toggle-split:first-child,\r\n.btn-group>.btn:not(:last-child):not(.dropdown-toggle) {\r\n    border-top-right-radius: 0;\r\n    border-bottom-right-radius: 0\r\n}\r\n\r\n.btn-group>.btn-group:not(:first-child)>.btn,\r\n.btn-group>.btn:nth-child(n+3),\r\n.btn-group>:not(.btn-check)+.btn {\r\n    border-top-left-radius: 0;\r\n    border-bottom-left-radius: 0\r\n}\r\n\r\n.dropdown-toggle-split {\r\n    padding-right: .5625rem;\r\n    padding-left: .5625rem\r\n}\r\n\r\n.dropdown-toggle-split::after,\r\n.dropend .dropdown-toggle-split::after,\r\n.dropup .dropdown-toggle-split::after {\r\n    margin-left: 0\r\n}\r\n\r\n.dropstart .dropdown-toggle-split::before {\r\n    margin-right: 0\r\n}\r\n\r\n.btn-group-sm>.btn+.dropdown-toggle-split,\r\n.btn-sm+.dropdown-toggle-split {\r\n    padding-right: .375rem;\r\n    padding-left: .375rem\r\n}\r\n\r\n.btn-group-lg>.btn+.dropdown-toggle-split,\r\n.btn-lg+.dropdown-toggle-split {\r\n    padding-right: .75rem;\r\n    padding-left: .75rem\r\n}\r\n\r\n.btn-group-vertical {\r\n    flex-direction: column;\r\n    align-items: flex-start;\r\n    justify-content: center\r\n}\r\n\r\n.btn-group-vertical>.btn,\r\n.btn-group-vertical>.btn-group {\r\n    width: 100%\r\n}\r\n\r\n.btn-group-vertical>.btn-group:not(:first-child),\r\n.btn-group-vertical>.btn:not(:first-child) {\r\n    margin-top: -1px\r\n}\r\n\r\n.btn-group-vertical>.btn-group:not(:last-child)>.btn,\r\n.btn-group-vertical>.btn:not(:last-child):not(.dropdown-toggle) {\r\n    border-bottom-right-radius: 0;\r\n    border-bottom-left-radius: 0\r\n}\r\n\r\n.btn-group-vertical>.btn-group:not(:first-child)>.btn,\r\n.btn-group-vertical>.btn~.btn {\r\n    border-top-left-radius: 0;\r\n    border-top-right-radius: 0\r\n}\r\n\r\n.nav {\r\n    --bs-nav-link-padding-x: 1rem;\r\n    --bs-nav-link-padding-y: 0.5rem;\r\n    --bs-nav-link-font-weight: ;\r\n    --bs-nav-link-color: var(--bs-link-color);\r\n    --bs-nav-link-hover-color: var(--bs-link-hover-color);\r\n    --bs-nav-link-disabled-color: #6c757d;\r\n    display: flex;\r\n    flex-wrap: wrap;\r\n    padding-left: 0;\r\n    margin-bottom: 0;\r\n    list-style: none\r\n}\r\n\r\n.nav-link {\r\n    display: block;\r\n    padding: var(--bs-nav-link-padding-y) var(--bs-nav-link-padding-x);\r\n    font-size: var(--bs-nav-link-font-size);\r\n    font-weight: var(--bs-nav-link-font-weight);\r\n    color: var(--bs-nav-link-color);\r\n    text-decoration: none;\r\n    transition: color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out\r\n}\r\n\r\n@media (prefers-reduced-motion:reduce) {\r\n    .nav-link {\r\n        transition: none\r\n    }\r\n}\r\n\r\n.nav-link:focus,\r\n.nav-link:hover {\r\n    color: var(--bs-nav-link-hover-color)\r\n}\r\n\r\n.nav-link.disabled {\r\n    color: var(--bs-nav-link-disabled-color);\r\n    pointer-events: none;\r\n    cursor: default\r\n}\r\n\r\n.nav-tabs {\r\n    --bs-nav-tabs-border-width: 1px;\r\n    --bs-nav-tabs-border-color: #dee2e6;\r\n    --bs-nav-tabs-border-radius: 0.375rem;\r\n    --bs-nav-tabs-link-hover-border-color: #e9ecef #e9ecef #dee2e6;\r\n    --bs-nav-tabs-link-active-color: #495057;\r\n    --bs-nav-tabs-link-active-bg: #fff;\r\n    --bs-nav-tabs-link-active-border-color: #dee2e6 #dee2e6 #fff;\r\n    border-bottom: var(--bs-nav-tabs-border-width) solid var(--bs-nav-tabs-border-color)\r\n}\r\n\r\n.nav-tabs .nav-link {\r\n    margin-bottom: calc(var(--bs-nav-tabs-border-width) * -1);\r\n    background: 0 0;\r\n    border: var(--bs-nav-tabs-border-width) solid transparent;\r\n    border-top-left-radius: var(--bs-nav-tabs-border-radius);\r\n    border-top-right-radius: var(--bs-nav-tabs-border-radius)\r\n}\r\n\r\n.nav-tabs .nav-link:focus,\r\n.nav-tabs .nav-link:hover {\r\n    isolation: isolate;\r\n    border-color: var(--bs-nav-tabs-link-hover-border-color)\r\n}\r\n\r\n.nav-tabs .nav-link.disabled,\r\n.nav-tabs .nav-link:disabled {\r\n    color: var(--bs-nav-link-disabled-color);\r\n    background-color: transparent;\r\n    border-color: transparent\r\n}\r\n\r\n.nav-tabs .nav-item.show .nav-link,\r\n.nav-tabs .nav-link.active {\r\n    color: var(--bs-nav-tabs-link-active-color);\r\n    background-color: var(--bs-nav-tabs-link-active-bg);\r\n    border-color: var(--bs-nav-tabs-link-active-border-color)\r\n}\r\n\r\n.nav-tabs .dropdown-menu {\r\n    margin-top: calc(var(--bs-nav-tabs-border-width) * -1);\r\n    border-top-left-radius: 0;\r\n    border-top-right-radius: 0\r\n}\r\n\r\n.nav-pills {\r\n    --bs-nav-pills-border-radius: 0.375rem;\r\n    --bs-nav-pills-link-active-color: #fff;\r\n    --bs-nav-pills-link-active-bg: #0d6efd\r\n}\r\n\r\n.nav-pills .nav-link {\r\n    background: 0 0;\r\n    border: 0;\r\n    border-radius: var(--bs-nav-pills-border-radius)\r\n}\r\n\r\n.nav-pills .nav-link:disabled {\r\n    color: var(--bs-nav-link-disabled-color);\r\n    background-color: transparent;\r\n    border-color: transparent\r\n}\r\n\r\n.nav-pills .nav-link.active,\r\n.nav-pills .show>.nav-link {\r\n    color: var(--bs-nav-pills-link-active-color);\r\n    background-color: var(--bs-nav-pills-link-active-bg)\r\n}\r\n\r\n.nav-fill .nav-item,\r\n.nav-fill>.nav-link {\r\n    flex: 1 1 auto;\r\n    text-align: center\r\n}\r\n\r\n.nav-justified .nav-item,\r\n.nav-justified>.nav-link {\r\n    flex-basis: 0;\r\n    flex-grow: 1;\r\n    text-align: center\r\n}\r\n\r\n.nav-fill .nav-item .nav-link,\r\n.nav-justified .nav-item .nav-link {\r\n    width: 100%\r\n}\r\n\r\n.tab-content>.tab-pane {\r\n    display: none\r\n}\r\n\r\n.tab-content>.active {\r\n    display: block\r\n}\r\n\r\n.navbar {\r\n    --bs-navbar-padding-x: 0;\r\n    --bs-navbar-padding-y: 0.5rem;\r\n    --bs-navbar-color: rgba(0, 0, 0, 0.55);\r\n    --bs-navbar-hover-color: rgba(0, 0, 0, 0.7);\r\n    --bs-navbar-disabled-color: rgba(0, 0, 0, 0.3);\r\n    --bs-navbar-active-color: rgba(0, 0, 0, 0.9);\r\n    --bs-navbar-brand-padding-y: 0.3125rem;\r\n    --bs-navbar-brand-margin-end: 1rem;\r\n    --bs-navbar-brand-font-size: 1.25rem;\r\n    --bs-navbar-brand-color: rgba(0, 0, 0, 0.9);\r\n    --bs-navbar-brand-hover-color: rgba(0, 0, 0, 0.9);\r\n    --bs-navbar-nav-link-padding-x: 0.5rem;\r\n    --bs-navbar-toggler-padding-y: 0.25rem;\r\n    --bs-navbar-toggler-padding-x: 0.75rem;\r\n    --bs-navbar-toggler-font-size: 1.25rem;\r\n    --bs-navbar-toggler-icon-bg: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'%3e%3cpath stroke='rgba%280, 0, 0, 0.55%29' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e\");\r\n    --bs-navbar-toggler-border-color: rgba(0, 0, 0, 0.1);\r\n    --bs-navbar-toggler-border-radius: 0.375rem;\r\n    --bs-navbar-toggler-focus-width: 0.25rem;\r\n    --bs-navbar-toggler-transition: box-shadow 0.15s ease-in-out;\r\n    position: relative;\r\n    display: flex;\r\n    flex-wrap: wrap;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n    padding: var(--bs-navbar-padding-y) var(--bs-navbar-padding-x)\r\n}\r\n\r\n.navbar>.container,\r\n.navbar>.container-fluid,\r\n.navbar>.container-lg,\r\n.navbar>.container-md,\r\n.navbar>.container-sm,\r\n.navbar>.container-xl,\r\n.navbar>.container-xxl {\r\n    display: flex;\r\n    flex-wrap: inherit;\r\n    align-items: center;\r\n    justify-content: space-between\r\n}\r\n\r\n.navbar-brand {\r\n    padding-top: var(--bs-navbar-brand-padding-y);\r\n    padding-bottom: var(--bs-navbar-brand-padding-y);\r\n    margin-right: var(--bs-navbar-brand-margin-end);\r\n    font-size: var(--bs-navbar-brand-font-size);\r\n    color: var(--bs-navbar-brand-color);\r\n    text-decoration: none;\r\n    white-space: nowrap\r\n}\r\n\r\n.navbar-brand:focus,\r\n.navbar-brand:hover {\r\n    color: var(--bs-navbar-brand-hover-color)\r\n}\r\n\r\n.navbar-nav {\r\n    --bs-nav-link-padding-x: 0;\r\n    --bs-nav-link-padding-y: 0.5rem;\r\n    --bs-nav-link-font-weight: ;\r\n    --bs-nav-link-color: var(--bs-navbar-color);\r\n    --bs-nav-link-hover-color: var(--bs-navbar-hover-color);\r\n    --bs-nav-link-disabled-color: var(--bs-navbar-disabled-color);\r\n    display: flex;\r\n    flex-direction: column;\r\n    padding-left: 0;\r\n    margin-bottom: 0;\r\n    list-style: none\r\n}\r\n\r\n.navbar-nav .nav-link.active,\r\n.navbar-nav .show>.nav-link {\r\n    color: var(--bs-navbar-active-color)\r\n}\r\n\r\n.navbar-nav .dropdown-menu {\r\n    position: static\r\n}\r\n\r\n.navbar-text {\r\n    padding-top: .5rem;\r\n    padding-bottom: .5rem;\r\n    color: var(--bs-navbar-color)\r\n}\r\n\r\n.navbar-text a,\r\n.navbar-text a:focus,\r\n.navbar-text a:hover {\r\n    color: var(--bs-navbar-active-color)\r\n}\r\n\r\n.navbar-collapse {\r\n    flex-basis: 100%;\r\n    flex-grow: 1;\r\n    align-items: center\r\n}\r\n\r\n.navbar-toggler {\r\n    padding: var(--bs-navbar-toggler-padding-y) var(--bs-navbar-toggler-padding-x);\r\n    font-size: var(--bs-navbar-toggler-font-size);\r\n    line-height: 1;\r\n    color: var(--bs-navbar-color);\r\n    background-color: transparent;\r\n    border: var(--bs-border-width) solid var(--bs-navbar-toggler-border-color);\r\n    border-radius: var(--bs-navbar-toggler-border-radius);\r\n    transition: var(--bs-navbar-toggler-transition)\r\n}\r\n\r\n@media (prefers-reduced-motion:reduce) {\r\n    .navbar-toggler {\r\n        transition: none\r\n    }\r\n}\r\n\r\n.navbar-toggler:hover {\r\n    text-decoration: none\r\n}\r\n\r\n.navbar-toggler:focus {\r\n    text-decoration: none;\r\n    outline: 0;\r\n    box-shadow: 0 0 0 var(--bs-navbar-toggler-focus-width)\r\n}\r\n\r\n.navbar-toggler-icon {\r\n    display: inline-block;\r\n    width: 1.5em;\r\n    height: 1.5em;\r\n    vertical-align: middle;\r\n    background-image: var(--bs-navbar-toggler-icon-bg);\r\n    background-repeat: no-repeat;\r\n    background-position: center;\r\n    background-size: 100%\r\n}\r\n\r\n.navbar-nav-scroll {\r\n    max-height: var(--bs-scroll-height, 75vh);\r\n    overflow-y: auto\r\n}\r\n\r\n@media (min-width:576px) {\r\n    .navbar-expand-sm {\r\n        flex-wrap: nowrap;\r\n        justify-content: flex-start\r\n    }\r\n\r\n    .navbar-expand-sm .navbar-nav {\r\n        flex-direction: row\r\n    }\r\n\r\n    .navbar-expand-sm .navbar-nav .dropdown-menu {\r\n        position: absolute\r\n    }\r\n\r\n    .navbar-expand-sm .navbar-nav .nav-link {\r\n        padding-right: var(--bs-navbar-nav-link-padding-x);\r\n        padding-left: var(--bs-navbar-nav-link-padding-x)\r\n    }\r\n\r\n    .navbar-expand-sm .navbar-nav-scroll {\r\n        overflow: visible\r\n    }\r\n\r\n    .navbar-expand-sm .navbar-collapse {\r\n        display: flex !important;\r\n        flex-basis: auto\r\n    }\r\n\r\n    .navbar-expand-sm .navbar-toggler {\r\n        display: none\r\n    }\r\n\r\n    .navbar-expand-sm .offcanvas {\r\n        position: static;\r\n        z-index: auto;\r\n        flex-grow: 1;\r\n        width: auto !important;\r\n        height: auto !important;\r\n        visibility: visible !important;\r\n        background-color: transparent !important;\r\n        border: 0 !important;\r\n        transform: none !important;\r\n        transition: none\r\n    }\r\n\r\n    .navbar-expand-sm .offcanvas .offcanvas-header {\r\n        display: none\r\n    }\r\n\r\n    .navbar-expand-sm .offcanvas .offcanvas-body {\r\n        display: flex;\r\n        flex-grow: 0;\r\n        padding: 0;\r\n        overflow-y: visible\r\n    }\r\n}\r\n\r\n@media (min-width:768px) {\r\n    .navbar-expand-md {\r\n        flex-wrap: nowrap;\r\n        justify-content: flex-start\r\n    }\r\n\r\n    .navbar-expand-md .navbar-nav {\r\n        flex-direction: row\r\n    }\r\n\r\n    .navbar-expand-md .navbar-nav .dropdown-menu {\r\n        position: absolute\r\n    }\r\n\r\n    .navbar-expand-md .navbar-nav .nav-link {\r\n        padding-right: var(--bs-navbar-nav-link-padding-x);\r\n        padding-left: var(--bs-navbar-nav-link-padding-x)\r\n    }\r\n\r\n    .navbar-expand-md .navbar-nav-scroll {\r\n        overflow: visible\r\n    }\r\n\r\n    .navbar-expand-md .navbar-collapse {\r\n        display: flex !important;\r\n        flex-basis: auto\r\n    }\r\n\r\n    .navbar-expand-md .navbar-toggler {\r\n        display: none\r\n    }\r\n\r\n    .navbar-expand-md .offcanvas {\r\n        position: static;\r\n        z-index: auto;\r\n        flex-grow: 1;\r\n        width: auto !important;\r\n        height: auto !important;\r\n        visibility: visible !important;\r\n        background-color: transparent !important;\r\n        border: 0 !important;\r\n        transform: none !important;\r\n        transition: none\r\n    }\r\n\r\n    .navbar-expand-md .offcanvas .offcanvas-header {\r\n        display: none\r\n    }\r\n\r\n    .navbar-expand-md .offcanvas .offcanvas-body {\r\n        display: flex;\r\n        flex-grow: 0;\r\n        padding: 0;\r\n        overflow-y: visible\r\n    }\r\n}\r\n\r\n@media (min-width:992px) {\r\n    .navbar-expand-lg {\r\n        flex-wrap: nowrap;\r\n        justify-content: flex-start\r\n    }\r\n\r\n    .navbar-expand-lg .navbar-nav {\r\n        flex-direction: row\r\n    }\r\n\r\n    .navbar-expand-lg .navbar-nav .dropdown-menu {\r\n        position: absolute\r\n    }\r\n\r\n    .navbar-expand-lg .navbar-nav .nav-link {\r\n        padding-right: var(--bs-navbar-nav-link-padding-x);\r\n        padding-left: var(--bs-navbar-nav-link-padding-x)\r\n    }\r\n\r\n    .navbar-expand-lg .navbar-nav-scroll {\r\n        overflow: visible\r\n    }\r\n\r\n    .navbar-expand-lg .navbar-collapse {\r\n        display: flex !important;\r\n        flex-basis: auto\r\n    }\r\n\r\n    .navbar-expand-lg .navbar-toggler {\r\n        display: none\r\n    }\r\n\r\n    .navbar-expand-lg .offcanvas {\r\n        position: static;\r\n        z-index: auto;\r\n        flex-grow: 1;\r\n        width: auto !important;\r\n        height: auto !important;\r\n        visibility: visible !important;\r\n        background-color: transparent !important;\r\n        border: 0 !important;\r\n        transform: none !important;\r\n        transition: none\r\n    }\r\n\r\n    .navbar-expand-lg .offcanvas .offcanvas-header {\r\n        display: none\r\n    }\r\n\r\n    .navbar-expand-lg .offcanvas .offcanvas-body {\r\n        display: flex;\r\n        flex-grow: 0;\r\n        padding: 0;\r\n        overflow-y: visible\r\n    }\r\n}\r\n\r\n@media (min-width:1200px) {\r\n    .navbar-expand-xl {\r\n        flex-wrap: nowrap;\r\n        justify-content: flex-start\r\n    }\r\n\r\n    .navbar-expand-xl .navbar-nav {\r\n        flex-direction: row\r\n    }\r\n\r\n    .navbar-expand-xl .navbar-nav .dropdown-menu {\r\n        position: absolute\r\n    }\r\n\r\n    .navbar-expand-xl .navbar-nav .nav-link {\r\n        padding-right: var(--bs-navbar-nav-link-padding-x);\r\n        padding-left: var(--bs-navbar-nav-link-padding-x)\r\n    }\r\n\r\n    .navbar-expand-xl .navbar-nav-scroll {\r\n        overflow: visible\r\n    }\r\n\r\n    .navbar-expand-xl .navbar-collapse {\r\n        display: flex !important;\r\n        flex-basis: auto\r\n    }\r\n\r\n    .navbar-expand-xl .navbar-toggler {\r\n        display: none\r\n    }\r\n\r\n    .navbar-expand-xl .offcanvas {\r\n        position: static;\r\n        z-index: auto;\r\n        flex-grow: 1;\r\n        width: auto !important;\r\n        height: auto !important;\r\n        visibility: visible !important;\r\n        background-color: transparent !important;\r\n        border: 0 !important;\r\n        transform: none !important;\r\n        transition: none\r\n    }\r\n\r\n    .navbar-expand-xl .offcanvas .offcanvas-header {\r\n        display: none\r\n    }\r\n\r\n    .navbar-expand-xl .offcanvas .offcanvas-body {\r\n        display: flex;\r\n        flex-grow: 0;\r\n        padding: 0;\r\n        overflow-y: visible\r\n    }\r\n}\r\n\r\n@media (min-width:1400px) {\r\n    .navbar-expand-xxl {\r\n        flex-wrap: nowrap;\r\n        justify-content: flex-start\r\n    }\r\n\r\n    .navbar-expand-xxl .navbar-nav {\r\n        flex-direction: row\r\n    }\r\n\r\n    .navbar-expand-xxl .navbar-nav .dropdown-menu {\r\n        position: absolute\r\n    }\r\n\r\n    .navbar-expand-xxl .navbar-nav .nav-link {\r\n        padding-right: var(--bs-navbar-nav-link-padding-x);\r\n        padding-left: var(--bs-navbar-nav-link-padding-x)\r\n    }\r\n\r\n    .navbar-expand-xxl .navbar-nav-scroll {\r\n        overflow: visible\r\n    }\r\n\r\n    .navbar-expand-xxl .navbar-collapse {\r\n        display: flex !important;\r\n        flex-basis: auto\r\n    }\r\n\r\n    .navbar-expand-xxl .navbar-toggler {\r\n        display: none\r\n    }\r\n\r\n    .navbar-expand-xxl .offcanvas {\r\n        position: static;\r\n        z-index: auto;\r\n        flex-grow: 1;\r\n        width: auto !important;\r\n        height: auto !important;\r\n        visibility: visible !important;\r\n        background-color: transparent !important;\r\n        border: 0 !important;\r\n        transform: none !important;\r\n        transition: none\r\n    }\r\n\r\n    .navbar-expand-xxl .offcanvas .offcanvas-header {\r\n        display: none\r\n    }\r\n\r\n    .navbar-expand-xxl .offcanvas .offcanvas-body {\r\n        display: flex;\r\n        flex-grow: 0;\r\n        padding: 0;\r\n        overflow-y: visible\r\n    }\r\n}\r\n\r\n.navbar-expand {\r\n    flex-wrap: nowrap;\r\n    justify-content: flex-start\r\n}\r\n\r\n.navbar-expand .navbar-nav {\r\n    flex-direction: row\r\n}\r\n\r\n.navbar-expand .navbar-nav .dropdown-menu {\r\n    position: absolute\r\n}\r\n\r\n.navbar-expand .navbar-nav .nav-link {\r\n    padding-right: var(--bs-navbar-nav-link-padding-x);\r\n    padding-left: var(--bs-navbar-nav-link-padding-x)\r\n}\r\n\r\n.navbar-expand .navbar-nav-scroll {\r\n    overflow: visible\r\n}\r\n\r\n.navbar-expand .navbar-collapse {\r\n    display: flex !important;\r\n    flex-basis: auto\r\n}\r\n\r\n.navbar-expand .navbar-toggler {\r\n    display: none\r\n}\r\n\r\n.navbar-expand .offcanvas {\r\n    position: static;\r\n    z-index: auto;\r\n    flex-grow: 1;\r\n    width: auto !important;\r\n    height: auto !important;\r\n    visibility: visible !important;\r\n    background-color: transparent !important;\r\n    border: 0 !important;\r\n    transform: none !important;\r\n    transition: none\r\n}\r\n\r\n.navbar-expand .offcanvas .offcanvas-header {\r\n    display: none\r\n}\r\n\r\n.navbar-expand .offcanvas .offcanvas-body {\r\n    display: flex;\r\n    flex-grow: 0;\r\n    padding: 0;\r\n    overflow-y: visible\r\n}\r\n\r\n.navbar-dark {\r\n    --bs-navbar-color: rgba(255, 255, 255, 0.55);\r\n    --bs-navbar-hover-color: rgba(255, 255, 255, 0.75);\r\n    --bs-navbar-disabled-color: rgba(255, 255, 255, 0.25);\r\n    --bs-navbar-active-color: #fff;\r\n    --bs-navbar-brand-color: #fff;\r\n    --bs-navbar-brand-hover-color: #fff;\r\n    --bs-navbar-toggler-border-color: rgba(255, 255, 255, 0.1);\r\n    --bs-navbar-toggler-icon-bg: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'%3e%3cpath stroke='rgba%28255, 255, 255, 0.55%29' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e\")\r\n}\r\n\r\n.card {\r\n    --bs-card-spacer-y: 1rem;\r\n    --bs-card-spacer-x: 1rem;\r\n    --bs-card-title-spacer-y: 0.5rem;\r\n    --bs-card-border-width: 1px;\r\n    --bs-card-border-color: var(--bs-border-color-translucent);\r\n    --bs-card-border-radius: 0.375rem;\r\n    --bs-card-box-shadow: ;\r\n    --bs-card-inner-border-radius: calc(0.375rem - 1px);\r\n    --bs-card-cap-padding-y: 0.5rem;\r\n    --bs-card-cap-padding-x: 1rem;\r\n    --bs-card-cap-bg: rgba(0, 0, 0, 0.03);\r\n    --bs-card-cap-color: ;\r\n    --bs-card-height: ;\r\n    --bs-card-color: ;\r\n    --bs-card-bg: #fff;\r\n    --bs-card-img-overlay-padding: 1rem;\r\n    --bs-card-group-margin: 0.75rem;\r\n    position: relative;\r\n    display: flex;\r\n    flex-direction: column;\r\n    min-width: 0;\r\n    height: var(--bs-card-height);\r\n    word-wrap: break-word;\r\n    background-color: var(--bs-card-bg);\r\n    background-clip: border-box;\r\n    border: var(--bs-card-border-width) solid var(--bs-card-border-color);\r\n    border-radius: var(--bs-card-border-radius)\r\n}\r\n\r\n.card>hr {\r\n    margin-right: 0;\r\n    margin-left: 0\r\n}\r\n\r\n.card>.list-group {\r\n    border-top: inherit;\r\n    border-bottom: inherit\r\n}\r\n\r\n.card>.list-group:first-child {\r\n    border-top-width: 0;\r\n    border-top-left-radius: var(--bs-card-inner-border-radius);\r\n    border-top-right-radius: var(--bs-card-inner-border-radius)\r\n}\r\n\r\n.card>.list-group:last-child {\r\n    border-bottom-width: 0;\r\n    border-bottom-right-radius: var(--bs-card-inner-border-radius);\r\n    border-bottom-left-radius: var(--bs-card-inner-border-radius)\r\n}\r\n\r\n.card>.card-header+.list-group,\r\n.card>.list-group+.card-footer {\r\n    border-top: 0\r\n}\r\n\r\n.card-body {\r\n    flex: 1 1 auto;\r\n    padding: var(--bs-card-spacer-y) var(--bs-card-spacer-x);\r\n    color: var(--bs-card-color)\r\n}\r\n\r\n.card-title {\r\n    margin-bottom: var(--bs-card-title-spacer-y)\r\n}\r\n\r\n.card-subtitle {\r\n    margin-top: calc(-.5 * var(--bs-card-title-spacer-y));\r\n    margin-bottom: 0\r\n}\r\n\r\n.card-text:last-child {\r\n    margin-bottom: 0\r\n}\r\n\r\n.card-link+.card-link {\r\n    margin-left: var(--bs-card-spacer-x)\r\n}\r\n\r\n.card-header {\r\n    padding: var(--bs-card-cap-padding-y) var(--bs-card-cap-padding-x);\r\n    margin-bottom: 0;\r\n    color: var(--bs-card-cap-color);\r\n    background-color: var(--bs-card-cap-bg);\r\n    border-bottom: var(--bs-card-border-width) solid var(--bs-card-border-color)\r\n}\r\n\r\n.card-header:first-child {\r\n    border-radius: var(--bs-card-inner-border-radius) var(--bs-card-inner-border-radius) 0 0\r\n}\r\n\r\n.card-footer {\r\n    padding: var(--bs-card-cap-padding-y) var(--bs-card-cap-padding-x);\r\n    color: var(--bs-card-cap-color);\r\n    background-color: var(--bs-card-cap-bg);\r\n    border-top: var(--bs-card-border-width) solid var(--bs-card-border-color)\r\n}\r\n\r\n.card-footer:last-child {\r\n    border-radius: 0 0 var(--bs-card-inner-border-radius) var(--bs-card-inner-border-radius)\r\n}\r\n\r\n.card-header-tabs {\r\n    margin-right: calc(-.5 * var(--bs-card-cap-padding-x));\r\n    margin-bottom: calc(-1 * var(--bs-card-cap-padding-y));\r\n    margin-left: calc(-.5 * var(--bs-card-cap-padding-x));\r\n    border-bottom: 0\r\n}\r\n\r\n.card-header-tabs .nav-link.active {\r\n    background-color: var(--bs-card-bg);\r\n    border-bottom-color: var(--bs-card-bg)\r\n}\r\n\r\n.card-header-pills {\r\n    margin-right: calc(-.5 * var(--bs-card-cap-padding-x));\r\n    margin-left: calc(-.5 * var(--bs-card-cap-padding-x))\r\n}\r\n\r\n.card-img-overlay {\r\n    position: absolute;\r\n    top: 0;\r\n    right: 0;\r\n    bottom: 0;\r\n    left: 0;\r\n    padding: var(--bs-card-img-overlay-padding);\r\n    border-radius: var(--bs-card-inner-border-radius)\r\n}\r\n\r\n.card-img,\r\n.card-img-bottom,\r\n.card-img-top {\r\n    width: 100%\r\n}\r\n\r\n.card-img,\r\n.card-img-top {\r\n    border-top-left-radius: var(--bs-card-inner-border-radius);\r\n    border-top-right-radius: var(--bs-card-inner-border-radius)\r\n}\r\n\r\n.card-img,\r\n.card-img-bottom {\r\n    border-bottom-right-radius: var(--bs-card-inner-border-radius);\r\n    border-bottom-left-radius: var(--bs-card-inner-border-radius)\r\n}\r\n\r\n.card-group>.card {\r\n    margin-bottom: var(--bs-card-group-margin)\r\n}\r\n\r\n@media (min-width:576px) {\r\n    .card-group {\r\n        display: flex;\r\n        flex-flow: row wrap\r\n    }\r\n\r\n    .card-group>.card {\r\n        flex: 1 0 0%;\r\n        margin-bottom: 0\r\n    }\r\n\r\n    .card-group>.card+.card {\r\n        margin-left: 0;\r\n        border-left: 0\r\n    }\r\n\r\n    .card-group>.card:not(:last-child) {\r\n        border-top-right-radius: 0;\r\n        border-bottom-right-radius: 0\r\n    }\r\n\r\n    .card-group>.card:not(:last-child) .card-header,\r\n    .card-group>.card:not(:last-child) .card-img-top {\r\n        border-top-right-radius: 0\r\n    }\r\n\r\n    .card-group>.card:not(:last-child) .card-footer,\r\n    .card-group>.card:not(:last-child) .card-img-bottom {\r\n        border-bottom-right-radius: 0\r\n    }\r\n\r\n    .card-group>.card:not(:first-child) {\r\n        border-top-left-radius: 0;\r\n        border-bottom-left-radius: 0\r\n    }\r\n\r\n    .card-group>.card:not(:first-child) .card-header,\r\n    .card-group>.card:not(:first-child) .card-img-top {\r\n        border-top-left-radius: 0\r\n    }\r\n\r\n    .card-group>.card:not(:first-child) .card-footer,\r\n    .card-group>.card:not(:first-child) .card-img-bottom {\r\n        border-bottom-left-radius: 0\r\n    }\r\n}\r\n\r\n.accordion {\r\n    --bs-accordion-color: #000;\r\n    --bs-accordion-bg: #fff;\r\n    --bs-accordion-transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out, border-radius 0.15s ease;\r\n    --bs-accordion-border-color: var(--bs-border-color);\r\n    --bs-accordion-border-width: 1px;\r\n    --bs-accordion-border-radius: 0.375rem;\r\n    --bs-accordion-inner-border-radius: calc(0.375rem - 1px);\r\n    --bs-accordion-btn-padding-x: 1.25rem;\r\n    --bs-accordion-btn-padding-y: 1rem;\r\n    --bs-accordion-btn-color: var(--bs-body-color);\r\n    --bs-accordion-btn-bg: var(--bs-accordion-bg);\r\n    --bs-accordion-btn-icon: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='var%28--bs-body-color%29'%3e%3cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e\");\r\n    --bs-accordion-btn-icon-width: 1.25rem;\r\n    --bs-accordion-btn-icon-transform: rotate(-180deg);\r\n    --bs-accordion-btn-icon-transition: transform 0.2s ease-in-out;\r\n    --bs-accordion-btn-active-icon: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%230c63e4'%3e%3cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e\");\r\n    --bs-accordion-btn-focus-border-color: #86b7fe;\r\n    --bs-accordion-btn-focus-box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);\r\n    --bs-accordion-body-padding-x: 1.25rem;\r\n    --bs-accordion-body-padding-y: 1rem;\r\n    --bs-accordion-active-color: #0c63e4;\r\n    --bs-accordion-active-bg: #e7f1ff\r\n}\r\n\r\n.accordion-button {\r\n    position: relative;\r\n    display: flex;\r\n    align-items: center;\r\n    width: 100%;\r\n    padding: var(--bs-accordion-btn-padding-y) var(--bs-accordion-btn-padding-x);\r\n    font-size: 1rem;\r\n    color: var(--bs-accordion-btn-color);\r\n    text-align: left;\r\n    background-color: var(--bs-accordion-btn-bg);\r\n    border: 0;\r\n    border-radius: 0;\r\n    overflow-anchor: none;\r\n    transition: var(--bs-accordion-transition)\r\n}\r\n\r\n@media (prefers-reduced-motion:reduce) {\r\n    .accordion-button {\r\n        transition: none\r\n    }\r\n}\r\n\r\n.accordion-button:not(.collapsed) {\r\n    color: var(--bs-accordion-active-color);\r\n    background-color: var(--bs-accordion-active-bg);\r\n    box-shadow: inset 0 calc(var(--bs-accordion-border-width) * -1) 0 var(--bs-accordion-border-color)\r\n}\r\n\r\n.accordion-button:not(.collapsed)::after {\r\n    background-image: var(--bs-accordion-btn-active-icon);\r\n    transform: var(--bs-accordion-btn-icon-transform)\r\n}\r\n\r\n.accordion-button::after {\r\n    flex-shrink: 0;\r\n    width: var(--bs-accordion-btn-icon-width);\r\n    height: var(--bs-accordion-btn-icon-width);\r\n    margin-left: auto;\r\n    content: \"\";\r\n    background-image: var(--bs-accordion-btn-icon);\r\n    background-repeat: no-repeat;\r\n    background-size: var(--bs-accordion-btn-icon-width);\r\n    transition: var(--bs-accordion-btn-icon-transition)\r\n}\r\n\r\n@media (prefers-reduced-motion:reduce) {\r\n    .accordion-button::after {\r\n        transition: none\r\n    }\r\n}\r\n\r\n.accordion-button:hover {\r\n    z-index: 2\r\n}\r\n\r\n.accordion-button:focus {\r\n    z-index: 3;\r\n    border-color: var(--bs-accordion-btn-focus-border-color);\r\n    outline: 0;\r\n    box-shadow: var(--bs-accordion-btn-focus-box-shadow)\r\n}\r\n\r\n.accordion-header {\r\n    margin-bottom: 0\r\n}\r\n\r\n.accordion-item {\r\n    color: var(--bs-accordion-color);\r\n    background-color: var(--bs-accordion-bg);\r\n    border: var(--bs-accordion-border-width) solid var(--bs-accordion-border-color)\r\n}\r\n\r\n.accordion-item:first-of-type {\r\n    border-top-left-radius: var(--bs-accordion-border-radius);\r\n    border-top-right-radius: var(--bs-accordion-border-radius)\r\n}\r\n\r\n.accordion-item:first-of-type .accordion-button {\r\n    border-top-left-radius: var(--bs-accordion-inner-border-radius);\r\n    border-top-right-radius: var(--bs-accordion-inner-border-radius)\r\n}\r\n\r\n.accordion-item:not(:first-of-type) {\r\n    border-top: 0\r\n}\r\n\r\n.accordion-item:last-of-type {\r\n    border-bottom-right-radius: var(--bs-accordion-border-radius);\r\n    border-bottom-left-radius: var(--bs-accordion-border-radius)\r\n}\r\n\r\n.accordion-item:last-of-type .accordion-button.collapsed {\r\n    border-bottom-right-radius: var(--bs-accordion-inner-border-radius);\r\n    border-bottom-left-radius: var(--bs-accordion-inner-border-radius)\r\n}\r\n\r\n.accordion-item:last-of-type .accordion-collapse {\r\n    border-bottom-right-radius: var(--bs-accordion-border-radius);\r\n    border-bottom-left-radius: var(--bs-accordion-border-radius)\r\n}\r\n\r\n.accordion-body {\r\n    padding: var(--bs-accordion-body-padding-y) var(--bs-accordion-body-padding-x)\r\n}\r\n\r\n.accordion-flush .accordion-collapse {\r\n    border-width: 0\r\n}\r\n\r\n.accordion-flush .accordion-item {\r\n    border-right: 0;\r\n    border-left: 0;\r\n    border-radius: 0\r\n}\r\n\r\n.accordion-flush .accordion-item:first-child {\r\n    border-top: 0\r\n}\r\n\r\n.accordion-flush .accordion-item:last-child {\r\n    border-bottom: 0\r\n}\r\n\r\n.accordion-flush .accordion-item .accordion-button {\r\n    border-radius: 0\r\n}\r\n\r\n.breadcrumb {\r\n    --bs-breadcrumb-padding-x: 0;\r\n    --bs-breadcrumb-padding-y: 0;\r\n    --bs-breadcrumb-margin-bottom: 1rem;\r\n    --bs-breadcrumb-bg: ;\r\n    --bs-breadcrumb-border-radius: ;\r\n    --bs-breadcrumb-divider-color: #6c757d;\r\n    --bs-breadcrumb-item-padding-x: 0.5rem;\r\n    --bs-breadcrumb-item-active-color: #6c757d;\r\n    display: flex;\r\n    flex-wrap: wrap;\r\n    padding: var(--bs-breadcrumb-padding-y) var(--bs-breadcrumb-padding-x);\r\n    margin-bottom: var(--bs-breadcrumb-margin-bottom);\r\n    font-size: var(--bs-breadcrumb-font-size);\r\n    list-style: none;\r\n    background-color: var(--bs-breadcrumb-bg);\r\n    border-radius: var(--bs-breadcrumb-border-radius)\r\n}\r\n\r\n.breadcrumb-item+.breadcrumb-item {\r\n    padding-left: var(--bs-breadcrumb-item-padding-x)\r\n}\r\n\r\n.breadcrumb-item+.breadcrumb-item::before {\r\n    float: left;\r\n    padding-right: var(--bs-breadcrumb-item-padding-x);\r\n    color: var(--bs-breadcrumb-divider-color);\r\n    content: var(--bs-breadcrumb-divider, \"/\")\r\n}\r\n\r\n.breadcrumb-item.active {\r\n    color: var(--bs-breadcrumb-item-active-color)\r\n}\r\n\r\n.pagination {\r\n    --bs-pagination-padding-x: 0.75rem;\r\n    --bs-pagination-padding-y: 0.375rem;\r\n    --bs-pagination-font-size: 1rem;\r\n    --bs-pagination-color: var(--bs-link-color);\r\n    --bs-pagination-bg: #fff;\r\n    --bs-pagination-border-width: 1px;\r\n    --bs-pagination-border-color: #dee2e6;\r\n    --bs-pagination-border-radius: 0.375rem;\r\n    --bs-pagination-hover-color: var(--bs-link-hover-color);\r\n    --bs-pagination-hover-bg: #e9ecef;\r\n    --bs-pagination-hover-border-color: #dee2e6;\r\n    --bs-pagination-focus-color: var(--bs-link-hover-color);\r\n    --bs-pagination-focus-bg: #e9ecef;\r\n    --bs-pagination-focus-box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);\r\n    --bs-pagination-active-color: #fff;\r\n    --bs-pagination-active-bg: #0d6efd;\r\n    --bs-pagination-active-border-color: #0d6efd;\r\n    --bs-pagination-disabled-color: #6c757d;\r\n    --bs-pagination-disabled-bg: #fff;\r\n    --bs-pagination-disabled-border-color: #dee2e6;\r\n    display: flex;\r\n    padding-left: 0;\r\n    list-style: none\r\n}\r\n\r\n.page-link {\r\n    position: relative;\r\n    display: block;\r\n    padding: var(--bs-pagination-padding-y) var(--bs-pagination-padding-x);\r\n    font-size: var(--bs-pagination-font-size);\r\n    color: var(--bs-pagination-color);\r\n    text-decoration: none;\r\n    background-color: var(--bs-pagination-bg);\r\n    border: var(--bs-pagination-border-width) solid var(--bs-pagination-border-color);\r\n    transition: color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out\r\n}\r\n\r\n@media (prefers-reduced-motion:reduce) {\r\n    .page-link {\r\n        transition: none\r\n    }\r\n}\r\n\r\n.page-link:hover {\r\n    z-index: 2;\r\n    color: var(--bs-pagination-hover-color);\r\n    background-color: var(--bs-pagination-hover-bg);\r\n    border-color: var(--bs-pagination-hover-border-color)\r\n}\r\n\r\n.page-link:focus {\r\n    z-index: 3;\r\n    color: var(--bs-pagination-focus-color);\r\n    background-color: var(--bs-pagination-focus-bg);\r\n    outline: 0;\r\n    box-shadow: var(--bs-pagination-focus-box-shadow)\r\n}\r\n\r\n.active>.page-link,\r\n.page-link.active {\r\n    z-index: 3;\r\n    color: var(--bs-pagination-active-color);\r\n    background-color: var(--bs-pagination-active-bg);\r\n    border-color: var(--bs-pagination-active-border-color)\r\n}\r\n\r\n.disabled>.page-link,\r\n.page-link.disabled {\r\n    color: var(--bs-pagination-disabled-color);\r\n    pointer-events: none;\r\n    background-color: var(--bs-pagination-disabled-bg);\r\n    border-color: var(--bs-pagination-disabled-border-color)\r\n}\r\n\r\n.page-item:not(:first-child) .page-link {\r\n    margin-left: -1px\r\n}\r\n\r\n.page-item:first-child .page-link {\r\n    border-top-left-radius: var(--bs-pagination-border-radius);\r\n    border-bottom-left-radius: var(--bs-pagination-border-radius)\r\n}\r\n\r\n.page-item:last-child .page-link {\r\n    border-top-right-radius: var(--bs-pagination-border-radius);\r\n    border-bottom-right-radius: var(--bs-pagination-border-radius)\r\n}\r\n\r\n.pagination-lg {\r\n    --bs-pagination-padding-x: 1.5rem;\r\n    --bs-pagination-padding-y: 0.75rem;\r\n    --bs-pagination-font-size: 1.25rem;\r\n    --bs-pagination-border-radius: 0.5rem\r\n}\r\n\r\n.pagination-sm {\r\n    --bs-pagination-padding-x: 0.5rem;\r\n    --bs-pagination-padding-y: 0.25rem;\r\n    --bs-pagination-font-size: 0.875rem;\r\n    --bs-pagination-border-radius: 0.25rem\r\n}\r\n\r\n.badge {\r\n    --bs-badge-padding-x: 0.65em;\r\n    --bs-badge-padding-y: 0.35em;\r\n    --bs-badge-font-size: 0.75em;\r\n    --bs-badge-font-weight: 700;\r\n    --bs-badge-color: #fff;\r\n    --bs-badge-border-radius: 0.375rem;\r\n    display: inline-block;\r\n    padding: var(--bs-badge-padding-y) var(--bs-badge-padding-x);\r\n    font-size: var(--bs-badge-font-size);\r\n    font-weight: var(--bs-badge-font-weight);\r\n    line-height: 1;\r\n    color: var(--bs-badge-color);\r\n    text-align: center;\r\n    white-space: nowrap;\r\n    vertical-align: baseline;\r\n    border-radius: var(--bs-badge-border-radius)\r\n}\r\n\r\n.badge:empty {\r\n    display: none\r\n}\r\n\r\n.btn .badge {\r\n    position: relative;\r\n    top: -1px\r\n}\r\n\r\n.alert {\r\n    --bs-alert-bg: transparent;\r\n    --bs-alert-padding-x: 1rem;\r\n    --bs-alert-padding-y: 1rem;\r\n    --bs-alert-margin-bottom: 1rem;\r\n    --bs-alert-color: inherit;\r\n    --bs-alert-border-color: transparent;\r\n    --bs-alert-border: 1px solid var(--bs-alert-border-color);\r\n    --bs-alert-border-radius: 0.375rem;\r\n    position: relative;\r\n    padding: var(--bs-alert-padding-y) var(--bs-alert-padding-x);\r\n    margin-bottom: var(--bs-alert-margin-bottom);\r\n    color: var(--bs-alert-color);\r\n    background-color: var(--bs-alert-bg);\r\n    border: var(--bs-alert-border);\r\n    border-radius: var(--bs-alert-border-radius)\r\n}\r\n\r\n.alert-heading {\r\n    color: inherit\r\n}\r\n\r\n.alert-link {\r\n    font-weight: 700\r\n}\r\n\r\n.alert-dismissible {\r\n    padding-right: 3rem\r\n}\r\n\r\n.alert-dismissible .btn-close {\r\n    position: absolute;\r\n    top: 0;\r\n    right: 0;\r\n    z-index: 2;\r\n    padding: 1.25rem 1rem\r\n}\r\n\r\n.alert-primary {\r\n    --bs-alert-color: #084298;\r\n    --bs-alert-bg: #cfe2ff;\r\n    --bs-alert-border-color: #b6d4fe\r\n}\r\n\r\n.alert-primary .alert-link {\r\n    color: #06357a\r\n}\r\n\r\n.alert-secondary {\r\n    --bs-alert-color: #41464b;\r\n    --bs-alert-bg: #e2e3e5;\r\n    --bs-alert-border-color: #d3d6d8\r\n}\r\n\r\n.alert-secondary .alert-link {\r\n    color: #34383c\r\n}\r\n\r\n.alert-success {\r\n    --bs-alert-color: #0f5132;\r\n    --bs-alert-bg: #d1e7dd;\r\n    --bs-alert-border-color: #badbcc\r\n}\r\n\r\n.alert-success .alert-link {\r\n    color: #0c4128\r\n}\r\n\r\n.alert-info {\r\n    --bs-alert-color: #055160;\r\n    --bs-alert-bg: #cff4fc;\r\n    --bs-alert-border-color: #b6effb\r\n}\r\n\r\n.alert-info .alert-link {\r\n    color: #04414d\r\n}\r\n\r\n.alert-warning {\r\n    --bs-alert-color: #664d03;\r\n    --bs-alert-bg: #fff3cd;\r\n    --bs-alert-border-color: #ffecb5\r\n}\r\n\r\n.alert-warning .alert-link {\r\n    color: #523e02\r\n}\r\n\r\n.alert-danger {\r\n    --bs-alert-color: #842029;\r\n    --bs-alert-bg: #f8d7da;\r\n    --bs-alert-border-color: #f5c2c7\r\n}\r\n\r\n.alert-danger .alert-link {\r\n    color: #6a1a21\r\n}\r\n\r\n.alert-light {\r\n    --bs-alert-color: #636464;\r\n    --bs-alert-bg: #fefefe;\r\n    --bs-alert-border-color: #fdfdfe\r\n}\r\n\r\n.alert-light .alert-link {\r\n    color: #4f5050\r\n}\r\n\r\n.alert-dark {\r\n    --bs-alert-color: #141619;\r\n    --bs-alert-bg: #d3d3d4;\r\n    --bs-alert-border-color: #bcbebf\r\n}\r\n\r\n.alert-dark .alert-link {\r\n    color: #101214\r\n}\r\n\r\n@-webkit-keyframes progress-bar-stripes {\r\n    0% {\r\n        background-position-x: 1rem\r\n    }\r\n}\r\n\r\n@keyframes progress-bar-stripes {\r\n    0% {\r\n        background-position-x: 1rem\r\n    }\r\n}\r\n\r\n.progress {\r\n    --bs-progress-height: 1rem;\r\n    --bs-progress-font-size: 0.75rem;\r\n    --bs-progress-bg: #e9ecef;\r\n    --bs-progress-border-radius: 0.375rem;\r\n    --bs-progress-box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.075);\r\n    --bs-progress-bar-color: #fff;\r\n    --bs-progress-bar-bg: #0d6efd;\r\n    --bs-progress-bar-transition: width 0.6s ease;\r\n    display: flex;\r\n    height: var(--bs-progress-height);\r\n    overflow: hidden;\r\n    font-size: var(--bs-progress-font-size);\r\n    background-color: var(--bs-progress-bg);\r\n    border-radius: var(--bs-progress-border-radius)\r\n}\r\n\r\n.progress-bar {\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: center;\r\n    overflow: hidden;\r\n    color: var(--bs-progress-bar-color);\r\n    text-align: center;\r\n    white-space: nowrap;\r\n    background-color: var(--bs-progress-bar-bg);\r\n    transition: var(--bs-progress-bar-transition)\r\n}\r\n\r\n@media (prefers-reduced-motion:reduce) {\r\n    .progress-bar {\r\n        transition: none\r\n    }\r\n}\r\n\r\n.progress-bar-striped {\r\n    background-image: linear-gradient(45deg, rgba(255, 255, 255, .15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, .15) 50%, rgba(255, 255, 255, .15) 75%, transparent 75%, transparent);\r\n    background-size: var(--bs-progress-height) var(--bs-progress-height)\r\n}\r\n\r\n.progress-bar-animated {\r\n    -webkit-animation: 1s linear infinite progress-bar-stripes;\r\n    animation: 1s linear infinite progress-bar-stripes\r\n}\r\n\r\n@media (prefers-reduced-motion:reduce) {\r\n    .progress-bar-animated {\r\n        -webkit-animation: none;\r\n        animation: none\r\n    }\r\n}\r\n\r\n.list-group {\r\n    --bs-list-group-color: #212529;\r\n    --bs-list-group-bg: #fff;\r\n    --bs-list-group-border-color: rgba(0, 0, 0, 0.125);\r\n    --bs-list-group-border-width: 1px;\r\n    --bs-list-group-border-radius: 0.375rem;\r\n    --bs-list-group-item-padding-x: 1rem;\r\n    --bs-list-group-item-padding-y: 0.5rem;\r\n    --bs-list-group-action-color: #495057;\r\n    --bs-list-group-action-hover-color: #495057;\r\n    --bs-list-group-action-hover-bg: #f8f9fa;\r\n    --bs-list-group-action-active-color: #212529;\r\n    --bs-list-group-action-active-bg: #e9ecef;\r\n    --bs-list-group-disabled-color: #6c757d;\r\n    --bs-list-group-disabled-bg: #fff;\r\n    --bs-list-group-active-color: #fff;\r\n    --bs-list-group-active-bg: #0d6efd;\r\n    --bs-list-group-active-border-color: #0d6efd;\r\n    display: flex;\r\n    flex-direction: column;\r\n    padding-left: 0;\r\n    margin-bottom: 0;\r\n    border-radius: var(--bs-list-group-border-radius)\r\n}\r\n\r\n.list-group-numbered {\r\n    list-style-type: none;\r\n    counter-reset: section\r\n}\r\n\r\n.list-group-numbered>.list-group-item::before {\r\n    content: counters(section, \".\") \". \";\r\n    counter-increment: section\r\n}\r\n\r\n.list-group-item-action {\r\n    width: 100%;\r\n    color: var(--bs-list-group-action-color);\r\n    text-align: inherit\r\n}\r\n\r\n.list-group-item-action:focus,\r\n.list-group-item-action:hover {\r\n    z-index: 1;\r\n    color: var(--bs-list-group-action-hover-color);\r\n    text-decoration: none;\r\n    background-color: var(--bs-list-group-action-hover-bg)\r\n}\r\n\r\n.list-group-item-action:active {\r\n    color: var(--bs-list-group-action-active-color);\r\n    background-color: var(--bs-list-group-action-active-bg)\r\n}\r\n\r\n.list-group-item {\r\n    position: relative;\r\n    display: block;\r\n    padding: var(--bs-list-group-item-padding-y) var(--bs-list-group-item-padding-x);\r\n    color: var(--bs-list-group-color);\r\n    text-decoration: none;\r\n    background-color: var(--bs-list-group-bg);\r\n    border: var(--bs-list-group-border-width) solid var(--bs-list-group-border-color)\r\n}\r\n\r\n.list-group-item:first-child {\r\n    border-top-left-radius: inherit;\r\n    border-top-right-radius: inherit\r\n}\r\n\r\n.list-group-item:last-child {\r\n    border-bottom-right-radius: inherit;\r\n    border-bottom-left-radius: inherit\r\n}\r\n\r\n.list-group-item.disabled,\r\n.list-group-item:disabled {\r\n    color: var(--bs-list-group-disabled-color);\r\n    pointer-events: none;\r\n    background-color: var(--bs-list-group-disabled-bg)\r\n}\r\n\r\n.list-group-item.active {\r\n    z-index: 2;\r\n    color: var(--bs-list-group-active-color);\r\n    background-color: var(--bs-list-group-active-bg);\r\n    border-color: var(--bs-list-group-active-border-color)\r\n}\r\n\r\n.list-group-item+.list-group-item {\r\n    border-top-width: 0\r\n}\r\n\r\n.list-group-item+.list-group-item.active {\r\n    margin-top: calc(var(--bs-list-group-border-width) * -1);\r\n    border-top-width: var(--bs-list-group-border-width)\r\n}\r\n\r\n.list-group-horizontal {\r\n    flex-direction: row\r\n}\r\n\r\n.list-group-horizontal>.list-group-item:first-child {\r\n    border-bottom-left-radius: var(--bs-list-group-border-radius);\r\n    border-top-right-radius: 0\r\n}\r\n\r\n.list-group-horizontal>.list-group-item:last-child {\r\n    border-top-right-radius: var(--bs-list-group-border-radius);\r\n    border-bottom-left-radius: 0\r\n}\r\n\r\n.list-group-horizontal>.list-group-item.active {\r\n    margin-top: 0\r\n}\r\n\r\n.list-group-horizontal>.list-group-item+.list-group-item {\r\n    border-top-width: var(--bs-list-group-border-width);\r\n    border-left-width: 0\r\n}\r\n\r\n.list-group-horizontal>.list-group-item+.list-group-item.active {\r\n    margin-left: calc(var(--bs-list-group-border-width) * -1);\r\n    border-left-width: var(--bs-list-group-border-width)\r\n}\r\n\r\n@media (min-width:576px) {\r\n    .list-group-horizontal-sm {\r\n        flex-direction: row\r\n    }\r\n\r\n    .list-group-horizontal-sm>.list-group-item:first-child {\r\n        border-bottom-left-radius: var(--bs-list-group-border-radius);\r\n        border-top-right-radius: 0\r\n    }\r\n\r\n    .list-group-horizontal-sm>.list-group-item:last-child {\r\n        border-top-right-radius: var(--bs-list-group-border-radius);\r\n        border-bottom-left-radius: 0\r\n    }\r\n\r\n    .list-group-horizontal-sm>.list-group-item.active {\r\n        margin-top: 0\r\n    }\r\n\r\n    .list-group-horizontal-sm>.list-group-item+.list-group-item {\r\n        border-top-width: var(--bs-list-group-border-width);\r\n        border-left-width: 0\r\n    }\r\n\r\n    .list-group-horizontal-sm>.list-group-item+.list-group-item.active {\r\n        margin-left: calc(var(--bs-list-group-border-width) * -1);\r\n        border-left-width: var(--bs-list-group-border-width)\r\n    }\r\n}\r\n\r\n@media (min-width:768px) {\r\n    .list-group-horizontal-md {\r\n        flex-direction: row\r\n    }\r\n\r\n    .list-group-horizontal-md>.list-group-item:first-child {\r\n        border-bottom-left-radius: var(--bs-list-group-border-radius);\r\n        border-top-right-radius: 0\r\n    }\r\n\r\n    .list-group-horizontal-md>.list-group-item:last-child {\r\n        border-top-right-radius: var(--bs-list-group-border-radius);\r\n        border-bottom-left-radius: 0\r\n    }\r\n\r\n    .list-group-horizontal-md>.list-group-item.active {\r\n        margin-top: 0\r\n    }\r\n\r\n    .list-group-horizontal-md>.list-group-item+.list-group-item {\r\n        border-top-width: var(--bs-list-group-border-width);\r\n        border-left-width: 0\r\n    }\r\n\r\n    .list-group-horizontal-md>.list-group-item+.list-group-item.active {\r\n        margin-left: calc(var(--bs-list-group-border-width) * -1);\r\n        border-left-width: var(--bs-list-group-border-width)\r\n    }\r\n}\r\n\r\n@media (min-width:992px) {\r\n    .list-group-horizontal-lg {\r\n        flex-direction: row\r\n    }\r\n\r\n    .list-group-horizontal-lg>.list-group-item:first-child {\r\n        border-bottom-left-radius: var(--bs-list-group-border-radius);\r\n        border-top-right-radius: 0\r\n    }\r\n\r\n    .list-group-horizontal-lg>.list-group-item:last-child {\r\n        border-top-right-radius: var(--bs-list-group-border-radius);\r\n        border-bottom-left-radius: 0\r\n    }\r\n\r\n    .list-group-horizontal-lg>.list-group-item.active {\r\n        margin-top: 0\r\n    }\r\n\r\n    .list-group-horizontal-lg>.list-group-item+.list-group-item {\r\n        border-top-width: var(--bs-list-group-border-width);\r\n        border-left-width: 0\r\n    }\r\n\r\n    .list-group-horizontal-lg>.list-group-item+.list-group-item.active {\r\n        margin-left: calc(var(--bs-list-group-border-width) * -1);\r\n        border-left-width: var(--bs-list-group-border-width)\r\n    }\r\n}\r\n\r\n@media (min-width:1200px) {\r\n    .list-group-horizontal-xl {\r\n        flex-direction: row\r\n    }\r\n\r\n    .list-group-horizontal-xl>.list-group-item:first-child {\r\n        border-bottom-left-radius: var(--bs-list-group-border-radius);\r\n        border-top-right-radius: 0\r\n    }\r\n\r\n    .list-group-horizontal-xl>.list-group-item:last-child {\r\n        border-top-right-radius: var(--bs-list-group-border-radius);\r\n        border-bottom-left-radius: 0\r\n    }\r\n\r\n    .list-group-horizontal-xl>.list-group-item.active {\r\n        margin-top: 0\r\n    }\r\n\r\n    .list-group-horizontal-xl>.list-group-item+.list-group-item {\r\n        border-top-width: var(--bs-list-group-border-width);\r\n        border-left-width: 0\r\n    }\r\n\r\n    .list-group-horizontal-xl>.list-group-item+.list-group-item.active {\r\n        margin-left: calc(var(--bs-list-group-border-width) * -1);\r\n        border-left-width: var(--bs-list-group-border-width)\r\n    }\r\n}\r\n\r\n@media (min-width:1400px) {\r\n    .list-group-horizontal-xxl {\r\n        flex-direction: row\r\n    }\r\n\r\n    .list-group-horizontal-xxl>.list-group-item:first-child {\r\n        border-bottom-left-radius: var(--bs-list-group-border-radius);\r\n        border-top-right-radius: 0\r\n    }\r\n\r\n    .list-group-horizontal-xxl>.list-group-item:last-child {\r\n        border-top-right-radius: var(--bs-list-group-border-radius);\r\n        border-bottom-left-radius: 0\r\n    }\r\n\r\n    .list-group-horizontal-xxl>.list-group-item.active {\r\n        margin-top: 0\r\n    }\r\n\r\n    .list-group-horizontal-xxl>.list-group-item+.list-group-item {\r\n        border-top-width: var(--bs-list-group-border-width);\r\n        border-left-width: 0\r\n    }\r\n\r\n    .list-group-horizontal-xxl>.list-group-item+.list-group-item.active {\r\n        margin-left: calc(var(--bs-list-group-border-width) * -1);\r\n        border-left-width: var(--bs-list-group-border-width)\r\n    }\r\n}\r\n\r\n.list-group-flush {\r\n    border-radius: 0\r\n}\r\n\r\n.list-group-flush>.list-group-item {\r\n    border-width: 0 0 var(--bs-list-group-border-width)\r\n}\r\n\r\n.list-group-flush>.list-group-item:last-child {\r\n    border-bottom-width: 0\r\n}\r\n\r\n.list-group-item-primary {\r\n    color: #084298;\r\n    background-color: #cfe2ff\r\n}\r\n\r\n.list-group-item-primary.list-group-item-action:focus,\r\n.list-group-item-primary.list-group-item-action:hover {\r\n    color: #084298;\r\n    background-color: #bacbe6\r\n}\r\n\r\n.list-group-item-primary.list-group-item-action.active {\r\n    color: #fff;\r\n    background-color: #084298;\r\n    border-color: #084298\r\n}\r\n\r\n.list-group-item-secondary {\r\n    color: #41464b;\r\n    background-color: #e2e3e5\r\n}\r\n\r\n.list-group-item-secondary.list-group-item-action:focus,\r\n.list-group-item-secondary.list-group-item-action:hover {\r\n    color: #41464b;\r\n    background-color: #cbccce\r\n}\r\n\r\n.list-group-item-secondary.list-group-item-action.active {\r\n    color: #fff;\r\n    background-color: #41464b;\r\n    border-color: #41464b\r\n}\r\n\r\n.list-group-item-success {\r\n    color: #0f5132;\r\n    background-color: #d1e7dd\r\n}\r\n\r\n.list-group-item-success.list-group-item-action:focus,\r\n.list-group-item-success.list-group-item-action:hover {\r\n    color: #0f5132;\r\n    background-color: #bcd0c7\r\n}\r\n\r\n.list-group-item-success.list-group-item-action.active {\r\n    color: #fff;\r\n    background-color: #0f5132;\r\n    border-color: #0f5132\r\n}\r\n\r\n.list-group-item-info {\r\n    color: #055160;\r\n    background-color: #cff4fc\r\n}\r\n\r\n.list-group-item-info.list-group-item-action:focus,\r\n.list-group-item-info.list-group-item-action:hover {\r\n    color: #055160;\r\n    background-color: #badce3\r\n}\r\n\r\n.list-group-item-info.list-group-item-action.active {\r\n    color: #fff;\r\n    background-color: #055160;\r\n    border-color: #055160\r\n}\r\n\r\n.list-group-item-warning {\r\n    color: #664d03;\r\n    background-color: #fff3cd\r\n}\r\n\r\n.list-group-item-warning.list-group-item-action:focus,\r\n.list-group-item-warning.list-group-item-action:hover {\r\n    color: #664d03;\r\n    background-color: #e6dbb9\r\n}\r\n\r\n.list-group-item-warning.list-group-item-action.active {\r\n    color: #fff;\r\n    background-color: #664d03;\r\n    border-color: #664d03\r\n}\r\n\r\n.list-group-item-danger {\r\n    color: #842029;\r\n    background-color: #f8d7da\r\n}\r\n\r\n.list-group-item-danger.list-group-item-action:focus,\r\n.list-group-item-danger.list-group-item-action:hover {\r\n    color: #842029;\r\n    background-color: #dfc2c4\r\n}\r\n\r\n.list-group-item-danger.list-group-item-action.active {\r\n    color: #fff;\r\n    background-color: #842029;\r\n    border-color: #842029\r\n}\r\n\r\n.list-group-item-light {\r\n    color: #636464;\r\n    background-color: #fefefe\r\n}\r\n\r\n.list-group-item-light.list-group-item-action:focus,\r\n.list-group-item-light.list-group-item-action:hover {\r\n    color: #636464;\r\n    background-color: #e5e5e5\r\n}\r\n\r\n.list-group-item-light.list-group-item-action.active {\r\n    color: #fff;\r\n    background-color: #636464;\r\n    border-color: #636464\r\n}\r\n\r\n.list-group-item-dark {\r\n    color: #141619;\r\n    background-color: #d3d3d4\r\n}\r\n\r\n.list-group-item-dark.list-group-item-action:focus,\r\n.list-group-item-dark.list-group-item-action:hover {\r\n    color: #141619;\r\n    background-color: #bebebf\r\n}\r\n\r\n.list-group-item-dark.list-group-item-action.active {\r\n    color: #fff;\r\n    background-color: #141619;\r\n    border-color: #141619\r\n}\r\n\r\n.btn-close {\r\n    box-sizing: content-box;\r\n    width: 1em;\r\n    height: 1em;\r\n    padding: .25em .25em;\r\n    color: #000;\r\n    background: transparent url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23000'%3e%3cpath d='M.293.293a1 1 0 0 1 1.414 0L8 6.586 14.293.293a1 1 0 1 1 1.414 1.414L9.414 8l6.293 6.293a1 1 0 0 1-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 0 1-1.414-1.414L6.586 8 .293 1.707a1 1 0 0 1 0-1.414z'/%3e%3c/svg%3e\") center/1em auto no-repeat;\r\n    border: 0;\r\n    border-radius: .375rem;\r\n    opacity: .5\r\n}\r\n\r\n.btn-close:hover {\r\n    color: #000;\r\n    text-decoration: none;\r\n    opacity: .75\r\n}\r\n\r\n.btn-close:focus {\r\n    outline: 0;\r\n    box-shadow: 0 0 0 .25rem rgba(13, 110, 253, .25);\r\n    opacity: 1\r\n}\r\n\r\n.btn-close.disabled,\r\n.btn-close:disabled {\r\n    pointer-events: none;\r\n    -webkit-user-select: none;\r\n    -moz-user-select: none;\r\n    user-select: none;\r\n    opacity: .25\r\n}\r\n\r\n.btn-close-white {\r\n    filter: invert(1) grayscale(100%) brightness(200%)\r\n}\r\n\r\n.toast {\r\n    --bs-toast-padding-x: 0.75rem;\r\n    --bs-toast-padding-y: 0.5rem;\r\n    --bs-toast-spacing: 1.5rem;\r\n    --bs-toast-max-width: 350px;\r\n    --bs-toast-font-size: 0.875rem;\r\n    --bs-toast-color: ;\r\n    --bs-toast-bg: rgba(255, 255, 255, 0.85);\r\n    --bs-toast-border-width: 1px;\r\n    --bs-toast-border-color: var(--bs-border-color-translucent);\r\n    --bs-toast-border-radius: 0.375rem;\r\n    --bs-toast-box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);\r\n    --bs-toast-header-color: #6c757d;\r\n    --bs-toast-header-bg: rgba(255, 255, 255, 0.85);\r\n    --bs-toast-header-border-color: rgba(0, 0, 0, 0.05);\r\n    width: var(--bs-toast-max-width);\r\n    max-width: 100%;\r\n    font-size: var(--bs-toast-font-size);\r\n    color: var(--bs-toast-color);\r\n    pointer-events: auto;\r\n    background-color: var(--bs-toast-bg);\r\n    background-clip: padding-box;\r\n    border: var(--bs-toast-border-width) solid var(--bs-toast-border-color);\r\n    box-shadow: var(--bs-toast-box-shadow);\r\n    border-radius: var(--bs-toast-border-radius)\r\n}\r\n\r\n.toast.showing {\r\n    opacity: 0\r\n}\r\n\r\n.toast:not(.show) {\r\n    display: none\r\n}\r\n\r\n.toast-container {\r\n    position: absolute;\r\n    z-index: 1090;\r\n    width: -webkit-max-content;\r\n    width: -moz-max-content;\r\n    width: max-content;\r\n    max-width: 100%;\r\n    pointer-events: none\r\n}\r\n\r\n.toast-container>:not(:last-child) {\r\n    margin-bottom: var(--bs-toast-spacing)\r\n}\r\n\r\n.toast-header {\r\n    display: flex;\r\n    align-items: center;\r\n    padding: var(--bs-toast-padding-y) var(--bs-toast-padding-x);\r\n    color: var(--bs-toast-header-color);\r\n    background-color: var(--bs-toast-header-bg);\r\n    background-clip: padding-box;\r\n    border-bottom: var(--bs-toast-border-width) solid var(--bs-toast-header-border-color);\r\n    border-top-left-radius: calc(var(--bs-toast-border-radius) - var(--bs-toast-border-width));\r\n    border-top-right-radius: calc(var(--bs-toast-border-radius) - var(--bs-toast-border-width))\r\n}\r\n\r\n.toast-header .btn-close {\r\n    margin-right: calc(var(--bs-toast-padding-x) * -.5);\r\n    margin-left: var(--bs-toast-padding-x)\r\n}\r\n\r\n.toast-body {\r\n    padding: var(--bs-toast-padding-x);\r\n    word-wrap: break-word\r\n}\r\n\r\n.modal {\r\n    --bs-modal-zindex: 1055;\r\n    --bs-modal-width: 500px;\r\n    --bs-modal-padding: 1rem;\r\n    --bs-modal-margin: 0.5rem;\r\n    --bs-modal-color: ;\r\n    --bs-modal-bg: #fff;\r\n    --bs-modal-border-color: var(--bs-border-color-translucent);\r\n    --bs-modal-border-width: 1px;\r\n    --bs-modal-border-radius: 0.5rem;\r\n    --bs-modal-box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);\r\n    --bs-modal-inner-border-radius: calc(0.5rem - 1px);\r\n    --bs-modal-header-padding-x: 1rem;\r\n    --bs-modal-header-padding-y: 1rem;\r\n    --bs-modal-header-padding: 1rem 1rem;\r\n    --bs-modal-header-border-color: var(--bs-border-color);\r\n    --bs-modal-header-border-width: 1px;\r\n    --bs-modal-title-line-height: 1.5;\r\n    --bs-modal-footer-gap: 0.5rem;\r\n    --bs-modal-footer-bg: ;\r\n    --bs-modal-footer-border-color: var(--bs-border-color);\r\n    --bs-modal-footer-border-width: 1px;\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n    z-index: var(--bs-modal-zindex);\r\n    display: none;\r\n    width: 100%;\r\n    height: 100%;\r\n    overflow-x: hidden;\r\n    overflow-y: auto;\r\n    outline: 0\r\n}\r\n\r\n.modal-dialog {\r\n    position: relative;\r\n    width: auto;\r\n    margin: var(--bs-modal-margin);\r\n    pointer-events: none\r\n}\r\n\r\n.modal.fade .modal-dialog {\r\n    transition: transform .3s ease-out;\r\n    transform: translate(0, -50px)\r\n}\r\n\r\n@media (prefers-reduced-motion:reduce) {\r\n    .modal.fade .modal-dialog {\r\n        transition: none\r\n    }\r\n}\r\n\r\n.modal.show .modal-dialog {\r\n    transform: none\r\n}\r\n\r\n.modal.modal-static .modal-dialog {\r\n    transform: scale(1.02)\r\n}\r\n\r\n.modal-dialog-scrollable {\r\n    height: calc(100% - var(--bs-modal-margin) * 2)\r\n}\r\n\r\n.modal-dialog-scrollable .modal-content {\r\n    max-height: 100%;\r\n    overflow: hidden\r\n}\r\n\r\n.modal-dialog-scrollable .modal-body {\r\n    overflow-y: auto\r\n}\r\n\r\n.modal-dialog-centered {\r\n    display: flex;\r\n    align-items: center;\r\n    min-height: calc(100% - var(--bs-modal-margin) * 2)\r\n}\r\n\r\n.modal-content {\r\n    position: relative;\r\n    display: flex;\r\n    flex-direction: column;\r\n    width: 100%;\r\n    color: var(--bs-modal-color);\r\n    pointer-events: auto;\r\n    background-color: var(--bs-modal-bg);\r\n    background-clip: padding-box;\r\n    border: var(--bs-modal-border-width) solid var(--bs-modal-border-color);\r\n    border-radius: var(--bs-modal-border-radius);\r\n    outline: 0\r\n}\r\n\r\n.modal-backdrop {\r\n    --bs-backdrop-zindex: 1050;\r\n    --bs-backdrop-bg: #000;\r\n    --bs-backdrop-opacity: 0.5;\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n    z-index: var(--bs-backdrop-zindex);\r\n    width: 100vw;\r\n    height: 100vh;\r\n    background-color: var(--bs-backdrop-bg)\r\n}\r\n\r\n.modal-backdrop.fade {\r\n    opacity: 0\r\n}\r\n\r\n.modal-backdrop.show {\r\n    opacity: var(--bs-backdrop-opacity)\r\n}\r\n\r\n.modal-header {\r\n    display: flex;\r\n    flex-shrink: 0;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n    padding: var(--bs-modal-header-padding);\r\n    border-bottom: var(--bs-modal-header-border-width) solid var(--bs-modal-header-border-color);\r\n    border-top-left-radius: var(--bs-modal-inner-border-radius);\r\n    border-top-right-radius: var(--bs-modal-inner-border-radius)\r\n}\r\n\r\n.modal-header .btn-close {\r\n    padding: calc(var(--bs-modal-header-padding-y) * .5) calc(var(--bs-modal-header-padding-x) * .5);\r\n    margin: calc(var(--bs-modal-header-padding-y) * -.5) calc(var(--bs-modal-header-padding-x) * -.5) calc(var(--bs-modal-header-padding-y) * -.5) auto\r\n}\r\n\r\n.modal-title {\r\n    margin-bottom: 0;\r\n    line-height: var(--bs-modal-title-line-height)\r\n}\r\n\r\n.modal-body {\r\n    position: relative;\r\n    flex: 1 1 auto;\r\n    padding: var(--bs-modal-padding)\r\n}\r\n\r\n.modal-footer {\r\n    display: flex;\r\n    flex-shrink: 0;\r\n    flex-wrap: wrap;\r\n    align-items: center;\r\n    justify-content: flex-end;\r\n    padding: calc(var(--bs-modal-padding) - var(--bs-modal-footer-gap) * .5);\r\n    background-color: var(--bs-modal-footer-bg);\r\n    border-top: var(--bs-modal-footer-border-width) solid var(--bs-modal-footer-border-color);\r\n    border-bottom-right-radius: var(--bs-modal-inner-border-radius);\r\n    border-bottom-left-radius: var(--bs-modal-inner-border-radius)\r\n}\r\n\r\n.modal-footer>* {\r\n    margin: calc(var(--bs-modal-footer-gap) * .5)\r\n}\r\n\r\n@media (min-width:576px) {\r\n    .modal {\r\n        --bs-modal-margin: 1.75rem;\r\n        --bs-modal-box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15)\r\n    }\r\n\r\n    .modal-dialog {\r\n        max-width: var(--bs-modal-width);\r\n        margin-right: auto;\r\n        margin-left: auto\r\n    }\r\n\r\n    .modal-sm {\r\n        --bs-modal-width: 300px\r\n    }\r\n}\r\n\r\n@media (min-width:992px) {\r\n\r\n    .modal-lg,\r\n    .modal-xl {\r\n        --bs-modal-width: 800px\r\n    }\r\n}\r\n\r\n@media (min-width:1200px) {\r\n    .modal-xl {\r\n        --bs-modal-width: 1140px\r\n    }\r\n}\r\n\r\n.modal-fullscreen {\r\n    width: 100vw;\r\n    max-width: none;\r\n    height: 100%;\r\n    margin: 0\r\n}\r\n\r\n.modal-fullscreen .modal-content {\r\n    height: 100%;\r\n    border: 0;\r\n    border-radius: 0\r\n}\r\n\r\n.modal-fullscreen .modal-footer,\r\n.modal-fullscreen .modal-header {\r\n    border-radius: 0\r\n}\r\n\r\n.modal-fullscreen .modal-body {\r\n    overflow-y: auto\r\n}\r\n\r\n@media (max-width:575.98px) {\r\n    .modal-fullscreen-sm-down {\r\n        width: 100vw;\r\n        max-width: none;\r\n        height: 100%;\r\n        margin: 0\r\n    }\r\n\r\n    .modal-fullscreen-sm-down .modal-content {\r\n        height: 100%;\r\n        border: 0;\r\n        border-radius: 0\r\n    }\r\n\r\n    .modal-fullscreen-sm-down .modal-footer,\r\n    .modal-fullscreen-sm-down .modal-header {\r\n        border-radius: 0\r\n    }\r\n\r\n    .modal-fullscreen-sm-down .modal-body {\r\n        overflow-y: auto\r\n    }\r\n}\r\n\r\n@media (max-width:767.98px) {\r\n    .modal-fullscreen-md-down {\r\n        width: 100vw;\r\n        max-width: none;\r\n        height: 100%;\r\n        margin: 0\r\n    }\r\n\r\n    .modal-fullscreen-md-down .modal-content {\r\n        height: 100%;\r\n        border: 0;\r\n        border-radius: 0\r\n    }\r\n\r\n    .modal-fullscreen-md-down .modal-footer,\r\n    .modal-fullscreen-md-down .modal-header {\r\n        border-radius: 0\r\n    }\r\n\r\n    .modal-fullscreen-md-down .modal-body {\r\n        overflow-y: auto\r\n    }\r\n}\r\n\r\n@media (max-width:991.98px) {\r\n    .modal-fullscreen-lg-down {\r\n        width: 100vw;\r\n        max-width: none;\r\n        height: 100%;\r\n        margin: 0\r\n    }\r\n\r\n    .modal-fullscreen-lg-down .modal-content {\r\n        height: 100%;\r\n        border: 0;\r\n        border-radius: 0\r\n    }\r\n\r\n    .modal-fullscreen-lg-down .modal-footer,\r\n    .modal-fullscreen-lg-down .modal-header {\r\n        border-radius: 0\r\n    }\r\n\r\n    .modal-fullscreen-lg-down .modal-body {\r\n        overflow-y: auto\r\n    }\r\n}\r\n\r\n@media (max-width:1199.98px) {\r\n    .modal-fullscreen-xl-down {\r\n        width: 100vw;\r\n        max-width: none;\r\n        height: 100%;\r\n        margin: 0\r\n    }\r\n\r\n    .modal-fullscreen-xl-down .modal-content {\r\n        height: 100%;\r\n        border: 0;\r\n        border-radius: 0\r\n    }\r\n\r\n    .modal-fullscreen-xl-down .modal-footer,\r\n    .modal-fullscreen-xl-down .modal-header {\r\n        border-radius: 0\r\n    }\r\n\r\n    .modal-fullscreen-xl-down .modal-body {\r\n        overflow-y: auto\r\n    }\r\n}\r\n\r\n@media (max-width:1399.98px) {\r\n    .modal-fullscreen-xxl-down {\r\n        width: 100vw;\r\n        max-width: none;\r\n        height: 100%;\r\n        margin: 0\r\n    }\r\n\r\n    .modal-fullscreen-xxl-down .modal-content {\r\n        height: 100%;\r\n        border: 0;\r\n        border-radius: 0\r\n    }\r\n\r\n    .modal-fullscreen-xxl-down .modal-footer,\r\n    .modal-fullscreen-xxl-down .modal-header {\r\n        border-radius: 0\r\n    }\r\n\r\n    .modal-fullscreen-xxl-down .modal-body {\r\n        overflow-y: auto\r\n    }\r\n}\r\n\r\n.tooltip {\r\n    --bs-tooltip-zindex: 1080;\r\n    --bs-tooltip-max-width: 200px;\r\n    --bs-tooltip-padding-x: 0.5rem;\r\n    --bs-tooltip-padding-y: 0.25rem;\r\n    --bs-tooltip-margin: ;\r\n    --bs-tooltip-font-size: 0.875rem;\r\n    --bs-tooltip-color: #fff;\r\n    --bs-tooltip-bg: #000;\r\n    --bs-tooltip-border-radius: 0.375rem;\r\n    --bs-tooltip-opacity: 0.9;\r\n    --bs-tooltip-arrow-width: 0.8rem;\r\n    --bs-tooltip-arrow-height: 0.4rem;\r\n    z-index: var(--bs-tooltip-zindex);\r\n    display: block;\r\n    padding: var(--bs-tooltip-arrow-height);\r\n    margin: var(--bs-tooltip-margin);\r\n    font-family: var(--bs-font-sans-serif);\r\n    font-style: normal;\r\n    font-weight: 400;\r\n    line-height: 1.5;\r\n    text-align: left;\r\n    text-align: start;\r\n    text-decoration: none;\r\n    text-shadow: none;\r\n    text-transform: none;\r\n    letter-spacing: normal;\r\n    word-break: normal;\r\n    white-space: normal;\r\n    word-spacing: normal;\r\n    line-break: auto;\r\n    font-size: var(--bs-tooltip-font-size);\r\n    word-wrap: break-word;\r\n    opacity: 0\r\n}\r\n\r\n.tooltip.show {\r\n    opacity: var(--bs-tooltip-opacity)\r\n}\r\n\r\n.tooltip .tooltip-arrow {\r\n    display: block;\r\n    width: var(--bs-tooltip-arrow-width);\r\n    height: var(--bs-tooltip-arrow-height)\r\n}\r\n\r\n.tooltip .tooltip-arrow::before {\r\n    position: absolute;\r\n    content: \"\";\r\n    border-color: transparent;\r\n    border-style: solid\r\n}\r\n\r\n.bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow,\r\n.bs-tooltip-top .tooltip-arrow {\r\n    bottom: 0\r\n}\r\n\r\n.bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow::before,\r\n.bs-tooltip-top .tooltip-arrow::before {\r\n    top: -1px;\r\n    border-width: var(--bs-tooltip-arrow-height) calc(var(--bs-tooltip-arrow-width) * .5) 0;\r\n    border-top-color: var(--bs-tooltip-bg)\r\n}\r\n\r\n.bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow,\r\n.bs-tooltip-end .tooltip-arrow {\r\n    left: 0;\r\n    width: var(--bs-tooltip-arrow-height);\r\n    height: var(--bs-tooltip-arrow-width)\r\n}\r\n\r\n.bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow::before,\r\n.bs-tooltip-end .tooltip-arrow::before {\r\n    right: -1px;\r\n    border-width: calc(var(--bs-tooltip-arrow-width) * .5) var(--bs-tooltip-arrow-height) calc(var(--bs-tooltip-arrow-width) * .5) 0;\r\n    border-right-color: var(--bs-tooltip-bg)\r\n}\r\n\r\n.bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow,\r\n.bs-tooltip-bottom .tooltip-arrow {\r\n    top: 0\r\n}\r\n\r\n.bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow::before,\r\n.bs-tooltip-bottom .tooltip-arrow::before {\r\n    bottom: -1px;\r\n    border-width: 0 calc(var(--bs-tooltip-arrow-width) * .5) var(--bs-tooltip-arrow-height);\r\n    border-bottom-color: var(--bs-tooltip-bg)\r\n}\r\n\r\n.bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow,\r\n.bs-tooltip-start .tooltip-arrow {\r\n    right: 0;\r\n    width: var(--bs-tooltip-arrow-height);\r\n    height: var(--bs-tooltip-arrow-width)\r\n}\r\n\r\n.bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow::before,\r\n.bs-tooltip-start .tooltip-arrow::before {\r\n    left: -1px;\r\n    border-width: calc(var(--bs-tooltip-arrow-width) * .5) 0 calc(var(--bs-tooltip-arrow-width) * .5) var(--bs-tooltip-arrow-height);\r\n    border-left-color: var(--bs-tooltip-bg)\r\n}\r\n\r\n.tooltip-inner {\r\n    max-width: var(--bs-tooltip-max-width);\r\n    padding: var(--bs-tooltip-padding-y) var(--bs-tooltip-padding-x);\r\n    color: var(--bs-tooltip-color);\r\n    text-align: center;\r\n    background-color: var(--bs-tooltip-bg);\r\n    border-radius: var(--bs-tooltip-border-radius)\r\n}\r\n\r\n.popover {\r\n    --bs-popover-zindex: 1070;\r\n    --bs-popover-max-width: 276px;\r\n    --bs-popover-font-size: 0.875rem;\r\n    --bs-popover-bg: #fff;\r\n    --bs-popover-border-width: 1px;\r\n    --bs-popover-border-color: var(--bs-border-color-translucent);\r\n    --bs-popover-border-radius: 0.5rem;\r\n    --bs-popover-inner-border-radius: calc(0.5rem - 1px);\r\n    --bs-popover-box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);\r\n    --bs-popover-header-padding-x: 1rem;\r\n    --bs-popover-header-padding-y: 0.5rem;\r\n    --bs-popover-header-font-size: 1rem;\r\n    --bs-popover-header-color: var(--bs-heading-color);\r\n    --bs-popover-header-bg: #f0f0f0;\r\n    --bs-popover-body-padding-x: 1rem;\r\n    --bs-popover-body-padding-y: 1rem;\r\n    --bs-popover-body-color: #212529;\r\n    --bs-popover-arrow-width: 1rem;\r\n    --bs-popover-arrow-height: 0.5rem;\r\n    --bs-popover-arrow-border: var(--bs-popover-border-color);\r\n    z-index: var(--bs-popover-zindex);\r\n    display: block;\r\n    max-width: var(--bs-popover-max-width);\r\n    font-family: var(--bs-font-sans-serif);\r\n    font-style: normal;\r\n    font-weight: 400;\r\n    line-height: 1.5;\r\n    text-align: left;\r\n    text-align: start;\r\n    text-decoration: none;\r\n    text-shadow: none;\r\n    text-transform: none;\r\n    letter-spacing: normal;\r\n    word-break: normal;\r\n    white-space: normal;\r\n    word-spacing: normal;\r\n    line-break: auto;\r\n    font-size: var(--bs-popover-font-size);\r\n    word-wrap: break-word;\r\n    background-color: var(--bs-popover-bg);\r\n    background-clip: padding-box;\r\n    border: var(--bs-popover-border-width) solid var(--bs-popover-border-color);\r\n    border-radius: var(--bs-popover-border-radius)\r\n}\r\n\r\n.popover .popover-arrow {\r\n    display: block;\r\n    width: var(--bs-popover-arrow-width);\r\n    height: var(--bs-popover-arrow-height)\r\n}\r\n\r\n.popover .popover-arrow::after,\r\n.popover .popover-arrow::before {\r\n    position: absolute;\r\n    display: block;\r\n    content: \"\";\r\n    border-color: transparent;\r\n    border-style: solid;\r\n    border-width: 0\r\n}\r\n\r\n.bs-popover-auto[data-popper-placement^=top]>.popover-arrow,\r\n.bs-popover-top>.popover-arrow {\r\n    bottom: calc(var(--bs-popover-arrow-height) * -1 - var(--bs-popover-border-width))\r\n}\r\n\r\n.bs-popover-auto[data-popper-placement^=top]>.popover-arrow::after,\r\n.bs-popover-auto[data-popper-placement^=top]>.popover-arrow::before,\r\n.bs-popover-top>.popover-arrow::after,\r\n.bs-popover-top>.popover-arrow::before {\r\n    border-width: var(--bs-popover-arrow-height) calc(var(--bs-popover-arrow-width) * .5) 0\r\n}\r\n\r\n.bs-popover-auto[data-popper-placement^=top]>.popover-arrow::before,\r\n.bs-popover-top>.popover-arrow::before {\r\n    bottom: 0;\r\n    border-top-color: var(--bs-popover-arrow-border)\r\n}\r\n\r\n.bs-popover-auto[data-popper-placement^=top]>.popover-arrow::after,\r\n.bs-popover-top>.popover-arrow::after {\r\n    bottom: var(--bs-popover-border-width);\r\n    border-top-color: var(--bs-popover-bg)\r\n}\r\n\r\n.bs-popover-auto[data-popper-placement^=right]>.popover-arrow,\r\n.bs-popover-end>.popover-arrow {\r\n    left: calc(var(--bs-popover-arrow-height) * -1 - var(--bs-popover-border-width));\r\n    width: var(--bs-popover-arrow-height);\r\n    height: var(--bs-popover-arrow-width)\r\n}\r\n\r\n.bs-popover-auto[data-popper-placement^=right]>.popover-arrow::after,\r\n.bs-popover-auto[data-popper-placement^=right]>.popover-arrow::before,\r\n.bs-popover-end>.popover-arrow::after,\r\n.bs-popover-end>.popover-arrow::before {\r\n    border-width: calc(var(--bs-popover-arrow-width) * .5) var(--bs-popover-arrow-height) calc(var(--bs-popover-arrow-width) * .5) 0\r\n}\r\n\r\n.bs-popover-auto[data-popper-placement^=right]>.popover-arrow::before,\r\n.bs-popover-end>.popover-arrow::before {\r\n    left: 0;\r\n    border-right-color: var(--bs-popover-arrow-border)\r\n}\r\n\r\n.bs-popover-auto[data-popper-placement^=right]>.popover-arrow::after,\r\n.bs-popover-end>.popover-arrow::after {\r\n    left: var(--bs-popover-border-width);\r\n    border-right-color: var(--bs-popover-bg)\r\n}\r\n\r\n.bs-popover-auto[data-popper-placement^=bottom]>.popover-arrow,\r\n.bs-popover-bottom>.popover-arrow {\r\n    top: calc(var(--bs-popover-arrow-height) * -1 - var(--bs-popover-border-width))\r\n}\r\n\r\n.bs-popover-auto[data-popper-placement^=bottom]>.popover-arrow::after,\r\n.bs-popover-auto[data-popper-placement^=bottom]>.popover-arrow::before,\r\n.bs-popover-bottom>.popover-arrow::after,\r\n.bs-popover-bottom>.popover-arrow::before {\r\n    border-width: 0 calc(var(--bs-popover-arrow-width) * .5) var(--bs-popover-arrow-height)\r\n}\r\n\r\n.bs-popover-auto[data-popper-placement^=bottom]>.popover-arrow::before,\r\n.bs-popover-bottom>.popover-arrow::before {\r\n    top: 0;\r\n    border-bottom-color: var(--bs-popover-arrow-border)\r\n}\r\n\r\n.bs-popover-auto[data-popper-placement^=bottom]>.popover-arrow::after,\r\n.bs-popover-bottom>.popover-arrow::after {\r\n    top: var(--bs-popover-border-width);\r\n    border-bottom-color: var(--bs-popover-bg)\r\n}\r\n\r\n.bs-popover-auto[data-popper-placement^=bottom] .popover-header::before,\r\n.bs-popover-bottom .popover-header::before {\r\n    position: absolute;\r\n    top: 0;\r\n    left: 50%;\r\n    display: block;\r\n    width: var(--bs-popover-arrow-width);\r\n    margin-left: calc(var(--bs-popover-arrow-width) * -.5);\r\n    content: \"\";\r\n    border-bottom: var(--bs-popover-border-width) solid var(--bs-popover-header-bg)\r\n}\r\n\r\n.bs-popover-auto[data-popper-placement^=left]>.popover-arrow,\r\n.bs-popover-start>.popover-arrow {\r\n    right: calc(var(--bs-popover-arrow-height) * -1 - var(--bs-popover-border-width));\r\n    width: var(--bs-popover-arrow-height);\r\n    height: var(--bs-popover-arrow-width)\r\n}\r\n\r\n.bs-popover-auto[data-popper-placement^=left]>.popover-arrow::after,\r\n.bs-popover-auto[data-popper-placement^=left]>.popover-arrow::before,\r\n.bs-popover-start>.popover-arrow::after,\r\n.bs-popover-start>.popover-arrow::before {\r\n    border-width: calc(var(--bs-popover-arrow-width) * .5) 0 calc(var(--bs-popover-arrow-width) * .5) var(--bs-popover-arrow-height)\r\n}\r\n\r\n.bs-popover-auto[data-popper-placement^=left]>.popover-arrow::before,\r\n.bs-popover-start>.popover-arrow::before {\r\n    right: 0;\r\n    border-left-color: var(--bs-popover-arrow-border)\r\n}\r\n\r\n.bs-popover-auto[data-popper-placement^=left]>.popover-arrow::after,\r\n.bs-popover-start>.popover-arrow::after {\r\n    right: var(--bs-popover-border-width);\r\n    border-left-color: var(--bs-popover-bg)\r\n}\r\n\r\n.popover-header {\r\n    padding: var(--bs-popover-header-padding-y) var(--bs-popover-header-padding-x);\r\n    margin-bottom: 0;\r\n    font-size: var(--bs-popover-header-font-size);\r\n    color: var(--bs-popover-header-color);\r\n    background-color: var(--bs-popover-header-bg);\r\n    border-bottom: var(--bs-popover-border-width) solid var(--bs-popover-border-color);\r\n    border-top-left-radius: var(--bs-popover-inner-border-radius);\r\n    border-top-right-radius: var(--bs-popover-inner-border-radius)\r\n}\r\n\r\n.popover-header:empty {\r\n    display: none\r\n}\r\n\r\n.popover-body {\r\n    padding: var(--bs-popover-body-padding-y) var(--bs-popover-body-padding-x);\r\n    color: var(--bs-popover-body-color)\r\n}\r\n\r\n.carousel {\r\n    position: relative\r\n}\r\n\r\n.carousel.pointer-event {\r\n    touch-action: pan-y\r\n}\r\n\r\n.carousel-inner {\r\n    position: relative;\r\n    width: 100%;\r\n    overflow: hidden\r\n}\r\n\r\n.carousel-inner::after {\r\n    display: block;\r\n    clear: both;\r\n    content: \"\"\r\n}\r\n\r\n.carousel-item {\r\n    position: relative;\r\n    display: none;\r\n    float: left;\r\n    width: 100%;\r\n    margin-right: -100%;\r\n    -webkit-backface-visibility: hidden;\r\n    backface-visibility: hidden;\r\n    transition: transform .6s ease-in-out\r\n}\r\n\r\n@media (prefers-reduced-motion:reduce) {\r\n    .carousel-item {\r\n        transition: none\r\n    }\r\n}\r\n\r\n.carousel-item-next,\r\n.carousel-item-prev,\r\n.carousel-item.active {\r\n    display: block\r\n}\r\n\r\n.active.carousel-item-end,\r\n.carousel-item-next:not(.carousel-item-start) {\r\n    transform: translateX(100%)\r\n}\r\n\r\n.active.carousel-item-start,\r\n.carousel-item-prev:not(.carousel-item-end) {\r\n    transform: translateX(-100%)\r\n}\r\n\r\n.carousel-fade .carousel-item {\r\n    opacity: 0;\r\n    transition-property: opacity;\r\n    transform: none\r\n}\r\n\r\n.carousel-fade .carousel-item-next.carousel-item-start,\r\n.carousel-fade .carousel-item-prev.carousel-item-end,\r\n.carousel-fade .carousel-item.active {\r\n    z-index: 1;\r\n    opacity: 1\r\n}\r\n\r\n.carousel-fade .active.carousel-item-end,\r\n.carousel-fade .active.carousel-item-start {\r\n    z-index: 0;\r\n    opacity: 0;\r\n    transition: opacity 0s .6s\r\n}\r\n\r\n@media (prefers-reduced-motion:reduce) {\r\n\r\n    .carousel-fade .active.carousel-item-end,\r\n    .carousel-fade .active.carousel-item-start {\r\n        transition: none\r\n    }\r\n}\r\n\r\n.carousel-control-next,\r\n.carousel-control-prev {\r\n    position: absolute;\r\n    top: 0;\r\n    bottom: 0;\r\n    z-index: 1;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    width: 15%;\r\n    padding: 0;\r\n    color: #fff;\r\n    text-align: center;\r\n    background: 0 0;\r\n    border: 0;\r\n    opacity: .5;\r\n    transition: opacity .15s ease\r\n}\r\n\r\n@media (prefers-reduced-motion:reduce) {\r\n\r\n    .carousel-control-next,\r\n    .carousel-control-prev {\r\n        transition: none\r\n    }\r\n}\r\n\r\n.carousel-control-next:focus,\r\n.carousel-control-next:hover,\r\n.carousel-control-prev:focus,\r\n.carousel-control-prev:hover {\r\n    color: #fff;\r\n    text-decoration: none;\r\n    outline: 0;\r\n    opacity: .9\r\n}\r\n\r\n.carousel-control-prev {\r\n    left: 0\r\n}\r\n\r\n.carousel-control-next {\r\n    right: 0\r\n}\r\n\r\n.carousel-control-next-icon,\r\n.carousel-control-prev-icon {\r\n    display: inline-block;\r\n    width: 2rem;\r\n    height: 2rem;\r\n    background-repeat: no-repeat;\r\n    background-position: 50%;\r\n    background-size: 100% 100%\r\n}\r\n\r\n.carousel-control-prev-icon {\r\n    background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23fff'%3e%3cpath d='M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z'/%3e%3c/svg%3e\")\r\n}\r\n\r\n.carousel-control-next-icon {\r\n    background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23fff'%3e%3cpath d='M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e\")\r\n}\r\n\r\n.carousel-indicators {\r\n    position: absolute;\r\n    right: 0;\r\n    bottom: 0;\r\n    left: 0;\r\n    z-index: 2;\r\n    display: flex;\r\n    justify-content: center;\r\n    padding: 0;\r\n    margin-right: 15%;\r\n    margin-bottom: 1rem;\r\n    margin-left: 15%;\r\n    list-style: none\r\n}\r\n\r\n.carousel-indicators [data-bs-target] {\r\n    box-sizing: content-box;\r\n    flex: 0 1 auto;\r\n    width: 30px;\r\n    height: 3px;\r\n    padding: 0;\r\n    margin-right: 3px;\r\n    margin-left: 3px;\r\n    text-indent: -999px;\r\n    cursor: pointer;\r\n    background-color: #fff;\r\n    background-clip: padding-box;\r\n    border: 0;\r\n    border-top: 10px solid transparent;\r\n    border-bottom: 10px solid transparent;\r\n    opacity: .5;\r\n    transition: opacity .6s ease\r\n}\r\n\r\n@media (prefers-reduced-motion:reduce) {\r\n    .carousel-indicators [data-bs-target] {\r\n        transition: none\r\n    }\r\n}\r\n\r\n.carousel-indicators .active {\r\n    opacity: 1\r\n}\r\n\r\n.carousel-caption {\r\n    position: absolute;\r\n    right: 15%;\r\n    bottom: 1.25rem;\r\n    left: 15%;\r\n    padding-top: 1.25rem;\r\n    padding-bottom: 1.25rem;\r\n    color: #fff;\r\n    text-align: center\r\n}\r\n\r\n.carousel-dark .carousel-control-next-icon,\r\n.carousel-dark .carousel-control-prev-icon {\r\n    filter: invert(1) grayscale(100)\r\n}\r\n\r\n.carousel-dark .carousel-indicators [data-bs-target] {\r\n    background-color: #000\r\n}\r\n\r\n.carousel-dark .carousel-caption {\r\n    color: #000\r\n}\r\n\r\n.spinner-border,\r\n.spinner-grow {\r\n    display: inline-block;\r\n    width: var(--bs-spinner-width);\r\n    height: var(--bs-spinner-height);\r\n    vertical-align: var(--bs-spinner-vertical-align);\r\n    border-radius: 50%;\r\n    -webkit-animation: var(--bs-spinner-animation-speed) linear infinite var(--bs-spinner-animation-name);\r\n    animation: var(--bs-spinner-animation-speed) linear infinite var(--bs-spinner-animation-name)\r\n}\r\n\r\n@-webkit-keyframes spinner-border {\r\n    to {\r\n        transform: rotate(360deg)\r\n    }\r\n}\r\n\r\n@keyframes spinner-border {\r\n    to {\r\n        transform: rotate(360deg)\r\n    }\r\n}\r\n\r\n.spinner-border {\r\n    --bs-spinner-width: 2rem;\r\n    --bs-spinner-height: 2rem;\r\n    --bs-spinner-vertical-align: -0.125em;\r\n    --bs-spinner-border-width: 0.25em;\r\n    --bs-spinner-animation-speed: 0.75s;\r\n    --bs-spinner-animation-name: spinner-border;\r\n    border: var(--bs-spinner-border-width) solid currentcolor;\r\n    border-right-color: transparent\r\n}\r\n\r\n.spinner-border-sm {\r\n    --bs-spinner-width: 1rem;\r\n    --bs-spinner-height: 1rem;\r\n    --bs-spinner-border-width: 0.2em\r\n}\r\n\r\n@-webkit-keyframes spinner-grow {\r\n    0% {\r\n        transform: scale(0)\r\n    }\r\n\r\n    50% {\r\n        opacity: 1;\r\n        transform: none\r\n    }\r\n}\r\n\r\n@keyframes spinner-grow {\r\n    0% {\r\n        transform: scale(0)\r\n    }\r\n\r\n    50% {\r\n        opacity: 1;\r\n        transform: none\r\n    }\r\n}\r\n\r\n.spinner-grow {\r\n    --bs-spinner-width: 2rem;\r\n    --bs-spinner-height: 2rem;\r\n    --bs-spinner-vertical-align: -0.125em;\r\n    --bs-spinner-animation-speed: 0.75s;\r\n    --bs-spinner-animation-name: spinner-grow;\r\n    background-color: currentcolor;\r\n    opacity: 0\r\n}\r\n\r\n.spinner-grow-sm {\r\n    --bs-spinner-width: 1rem;\r\n    --bs-spinner-height: 1rem\r\n}\r\n\r\n@media (prefers-reduced-motion:reduce) {\r\n\r\n    .spinner-border,\r\n    .spinner-grow {\r\n        --bs-spinner-animation-speed: 1.5s\r\n    }\r\n}\r\n\r\n.offcanvas,\r\n.offcanvas-lg,\r\n.offcanvas-md,\r\n.offcanvas-sm,\r\n.offcanvas-xl,\r\n.offcanvas-xxl {\r\n    --bs-offcanvas-width: 400px;\r\n    --bs-offcanvas-height: 30vh;\r\n    --bs-offcanvas-padding-x: 1rem;\r\n    --bs-offcanvas-padding-y: 1rem;\r\n    --bs-offcanvas-color: ;\r\n    --bs-offcanvas-bg: #fff;\r\n    --bs-offcanvas-border-width: 1px;\r\n    --bs-offcanvas-border-color: var(--bs-border-color-translucent);\r\n    --bs-offcanvas-box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075)\r\n}\r\n\r\n@media (max-width:575.98px) {\r\n    .offcanvas-sm {\r\n        position: fixed;\r\n        bottom: 0;\r\n        z-index: 1045;\r\n        display: flex;\r\n        flex-direction: column;\r\n        max-width: 100%;\r\n        color: var(--bs-offcanvas-color);\r\n        visibility: hidden;\r\n        background-color: var(--bs-offcanvas-bg);\r\n        background-clip: padding-box;\r\n        outline: 0;\r\n        transition: transform .3s ease-in-out\r\n    }\r\n}\r\n\r\n@media (max-width:575.98px) and (prefers-reduced-motion:reduce) {\r\n    .offcanvas-sm {\r\n        transition: none\r\n    }\r\n}\r\n\r\n@media (max-width:575.98px) {\r\n    .offcanvas-sm.offcanvas-start {\r\n        top: 0;\r\n        left: 0;\r\n        width: var(--bs-offcanvas-width);\r\n        border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\r\n        transform: translateX(-100%)\r\n    }\r\n}\r\n\r\n@media (max-width:575.98px) {\r\n    .offcanvas-sm.offcanvas-end {\r\n        top: 0;\r\n        right: 0;\r\n        width: var(--bs-offcanvas-width);\r\n        border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\r\n        transform: translateX(100%)\r\n    }\r\n}\r\n\r\n@media (max-width:575.98px) {\r\n    .offcanvas-sm.offcanvas-top {\r\n        top: 0;\r\n        right: 0;\r\n        left: 0;\r\n        height: var(--bs-offcanvas-height);\r\n        max-height: 100%;\r\n        border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\r\n        transform: translateY(-100%)\r\n    }\r\n}\r\n\r\n@media (max-width:575.98px) {\r\n    .offcanvas-sm.offcanvas-bottom {\r\n        right: 0;\r\n        left: 0;\r\n        height: var(--bs-offcanvas-height);\r\n        max-height: 100%;\r\n        border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\r\n        transform: translateY(100%)\r\n    }\r\n}\r\n\r\n@media (max-width:575.98px) {\r\n\r\n    .offcanvas-sm.show:not(.hiding),\r\n    .offcanvas-sm.showing {\r\n        transform: none\r\n    }\r\n}\r\n\r\n@media (max-width:575.98px) {\r\n\r\n    .offcanvas-sm.hiding,\r\n    .offcanvas-sm.show,\r\n    .offcanvas-sm.showing {\r\n        visibility: visible\r\n    }\r\n}\r\n\r\n@media (min-width:576px) {\r\n    .offcanvas-sm {\r\n        --bs-offcanvas-height: auto;\r\n        --bs-offcanvas-border-width: 0;\r\n        background-color: transparent !important\r\n    }\r\n\r\n    .offcanvas-sm .offcanvas-header {\r\n        display: none\r\n    }\r\n\r\n    .offcanvas-sm .offcanvas-body {\r\n        display: flex;\r\n        flex-grow: 0;\r\n        padding: 0;\r\n        overflow-y: visible;\r\n        background-color: transparent !important\r\n    }\r\n}\r\n\r\n@media (max-width:767.98px) {\r\n    .offcanvas-md {\r\n        position: fixed;\r\n        bottom: 0;\r\n        z-index: 1045;\r\n        display: flex;\r\n        flex-direction: column;\r\n        max-width: 100%;\r\n        color: var(--bs-offcanvas-color);\r\n        visibility: hidden;\r\n        background-color: var(--bs-offcanvas-bg);\r\n        background-clip: padding-box;\r\n        outline: 0;\r\n        transition: transform .3s ease-in-out\r\n    }\r\n}\r\n\r\n@media (max-width:767.98px) and (prefers-reduced-motion:reduce) {\r\n    .offcanvas-md {\r\n        transition: none\r\n    }\r\n}\r\n\r\n@media (max-width:767.98px) {\r\n    .offcanvas-md.offcanvas-start {\r\n        top: 0;\r\n        left: 0;\r\n        width: var(--bs-offcanvas-width);\r\n        border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\r\n        transform: translateX(-100%)\r\n    }\r\n}\r\n\r\n@media (max-width:767.98px) {\r\n    .offcanvas-md.offcanvas-end {\r\n        top: 0;\r\n        right: 0;\r\n        width: var(--bs-offcanvas-width);\r\n        border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\r\n        transform: translateX(100%)\r\n    }\r\n}\r\n\r\n@media (max-width:767.98px) {\r\n    .offcanvas-md.offcanvas-top {\r\n        top: 0;\r\n        right: 0;\r\n        left: 0;\r\n        height: var(--bs-offcanvas-height);\r\n        max-height: 100%;\r\n        border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\r\n        transform: translateY(-100%)\r\n    }\r\n}\r\n\r\n@media (max-width:767.98px) {\r\n    .offcanvas-md.offcanvas-bottom {\r\n        right: 0;\r\n        left: 0;\r\n        height: var(--bs-offcanvas-height);\r\n        max-height: 100%;\r\n        border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\r\n        transform: translateY(100%)\r\n    }\r\n}\r\n\r\n@media (max-width:767.98px) {\r\n\r\n    .offcanvas-md.show:not(.hiding),\r\n    .offcanvas-md.showing {\r\n        transform: none\r\n    }\r\n}\r\n\r\n@media (max-width:767.98px) {\r\n\r\n    .offcanvas-md.hiding,\r\n    .offcanvas-md.show,\r\n    .offcanvas-md.showing {\r\n        visibility: visible\r\n    }\r\n}\r\n\r\n@media (min-width:768px) {\r\n    .offcanvas-md {\r\n        --bs-offcanvas-height: auto;\r\n        --bs-offcanvas-border-width: 0;\r\n        background-color: transparent !important\r\n    }\r\n\r\n    .offcanvas-md .offcanvas-header {\r\n        display: none\r\n    }\r\n\r\n    .offcanvas-md .offcanvas-body {\r\n        display: flex;\r\n        flex-grow: 0;\r\n        padding: 0;\r\n        overflow-y: visible;\r\n        background-color: transparent !important\r\n    }\r\n}\r\n\r\n@media (max-width:991.98px) {\r\n    .offcanvas-lg {\r\n        position: fixed;\r\n        bottom: 0;\r\n        z-index: 1045;\r\n        display: flex;\r\n        flex-direction: column;\r\n        max-width: 100%;\r\n        color: var(--bs-offcanvas-color);\r\n        visibility: hidden;\r\n        background-color: var(--bs-offcanvas-bg);\r\n        background-clip: padding-box;\r\n        outline: 0;\r\n        transition: transform .3s ease-in-out\r\n    }\r\n}\r\n\r\n@media (max-width:991.98px) and (prefers-reduced-motion:reduce) {\r\n    .offcanvas-lg {\r\n        transition: none\r\n    }\r\n}\r\n\r\n@media (max-width:991.98px) {\r\n    .offcanvas-lg.offcanvas-start {\r\n        top: 0;\r\n        left: 0;\r\n        width: var(--bs-offcanvas-width);\r\n        border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\r\n        transform: translateX(-100%)\r\n    }\r\n}\r\n\r\n@media (max-width:991.98px) {\r\n    .offcanvas-lg.offcanvas-end {\r\n        top: 0;\r\n        right: 0;\r\n        width: var(--bs-offcanvas-width);\r\n        border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\r\n        transform: translateX(100%)\r\n    }\r\n}\r\n\r\n@media (max-width:991.98px) {\r\n    .offcanvas-lg.offcanvas-top {\r\n        top: 0;\r\n        right: 0;\r\n        left: 0;\r\n        height: var(--bs-offcanvas-height);\r\n        max-height: 100%;\r\n        border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\r\n        transform: translateY(-100%)\r\n    }\r\n}\r\n\r\n@media (max-width:991.98px) {\r\n    .offcanvas-lg.offcanvas-bottom {\r\n        right: 0;\r\n        left: 0;\r\n        height: var(--bs-offcanvas-height);\r\n        max-height: 100%;\r\n        border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\r\n        transform: translateY(100%)\r\n    }\r\n}\r\n\r\n@media (max-width:991.98px) {\r\n\r\n    .offcanvas-lg.show:not(.hiding),\r\n    .offcanvas-lg.showing {\r\n        transform: none\r\n    }\r\n}\r\n\r\n@media (max-width:991.98px) {\r\n\r\n    .offcanvas-lg.hiding,\r\n    .offcanvas-lg.show,\r\n    .offcanvas-lg.showing {\r\n        visibility: visible\r\n    }\r\n}\r\n\r\n@media (min-width:992px) {\r\n    .offcanvas-lg {\r\n        --bs-offcanvas-height: auto;\r\n        --bs-offcanvas-border-width: 0;\r\n        background-color: transparent !important\r\n    }\r\n\r\n    .offcanvas-lg .offcanvas-header {\r\n        display: none\r\n    }\r\n\r\n    .offcanvas-lg .offcanvas-body {\r\n        display: flex;\r\n        flex-grow: 0;\r\n        padding: 0;\r\n        overflow-y: visible;\r\n        background-color: transparent !important\r\n    }\r\n}\r\n\r\n@media (max-width:1199.98px) {\r\n    .offcanvas-xl {\r\n        position: fixed;\r\n        bottom: 0;\r\n        z-index: 1045;\r\n        display: flex;\r\n        flex-direction: column;\r\n        max-width: 100%;\r\n        color: var(--bs-offcanvas-color);\r\n        visibility: hidden;\r\n        background-color: var(--bs-offcanvas-bg);\r\n        background-clip: padding-box;\r\n        outline: 0;\r\n        transition: transform .3s ease-in-out\r\n    }\r\n}\r\n\r\n@media (max-width:1199.98px) and (prefers-reduced-motion:reduce) {\r\n    .offcanvas-xl {\r\n        transition: none\r\n    }\r\n}\r\n\r\n@media (max-width:1199.98px) {\r\n    .offcanvas-xl.offcanvas-start {\r\n        top: 0;\r\n        left: 0;\r\n        width: var(--bs-offcanvas-width);\r\n        border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\r\n        transform: translateX(-100%)\r\n    }\r\n}\r\n\r\n@media (max-width:1199.98px) {\r\n    .offcanvas-xl.offcanvas-end {\r\n        top: 0;\r\n        right: 0;\r\n        width: var(--bs-offcanvas-width);\r\n        border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\r\n        transform: translateX(100%)\r\n    }\r\n}\r\n\r\n@media (max-width:1199.98px) {\r\n    .offcanvas-xl.offcanvas-top {\r\n        top: 0;\r\n        right: 0;\r\n        left: 0;\r\n        height: var(--bs-offcanvas-height);\r\n        max-height: 100%;\r\n        border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\r\n        transform: translateY(-100%)\r\n    }\r\n}\r\n\r\n@media (max-width:1199.98px) {\r\n    .offcanvas-xl.offcanvas-bottom {\r\n        right: 0;\r\n        left: 0;\r\n        height: var(--bs-offcanvas-height);\r\n        max-height: 100%;\r\n        border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\r\n        transform: translateY(100%)\r\n    }\r\n}\r\n\r\n@media (max-width:1199.98px) {\r\n\r\n    .offcanvas-xl.show:not(.hiding),\r\n    .offcanvas-xl.showing {\r\n        transform: none\r\n    }\r\n}\r\n\r\n@media (max-width:1199.98px) {\r\n\r\n    .offcanvas-xl.hiding,\r\n    .offcanvas-xl.show,\r\n    .offcanvas-xl.showing {\r\n        visibility: visible\r\n    }\r\n}\r\n\r\n@media (min-width:1200px) {\r\n    .offcanvas-xl {\r\n        --bs-offcanvas-height: auto;\r\n        --bs-offcanvas-border-width: 0;\r\n        background-color: transparent !important\r\n    }\r\n\r\n    .offcanvas-xl .offcanvas-header {\r\n        display: none\r\n    }\r\n\r\n    .offcanvas-xl .offcanvas-body {\r\n        display: flex;\r\n        flex-grow: 0;\r\n        padding: 0;\r\n        overflow-y: visible;\r\n        background-color: transparent !important\r\n    }\r\n}\r\n\r\n@media (max-width:1399.98px) {\r\n    .offcanvas-xxl {\r\n        position: fixed;\r\n        bottom: 0;\r\n        z-index: 1045;\r\n        display: flex;\r\n        flex-direction: column;\r\n        max-width: 100%;\r\n        color: var(--bs-offcanvas-color);\r\n        visibility: hidden;\r\n        background-color: var(--bs-offcanvas-bg);\r\n        background-clip: padding-box;\r\n        outline: 0;\r\n        transition: transform .3s ease-in-out\r\n    }\r\n}\r\n\r\n@media (max-width:1399.98px) and (prefers-reduced-motion:reduce) {\r\n    .offcanvas-xxl {\r\n        transition: none\r\n    }\r\n}\r\n\r\n@media (max-width:1399.98px) {\r\n    .offcanvas-xxl.offcanvas-start {\r\n        top: 0;\r\n        left: 0;\r\n        width: var(--bs-offcanvas-width);\r\n        border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\r\n        transform: translateX(-100%)\r\n    }\r\n}\r\n\r\n@media (max-width:1399.98px) {\r\n    .offcanvas-xxl.offcanvas-end {\r\n        top: 0;\r\n        right: 0;\r\n        width: var(--bs-offcanvas-width);\r\n        border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\r\n        transform: translateX(100%)\r\n    }\r\n}\r\n\r\n@media (max-width:1399.98px) {\r\n    .offcanvas-xxl.offcanvas-top {\r\n        top: 0;\r\n        right: 0;\r\n        left: 0;\r\n        height: var(--bs-offcanvas-height);\r\n        max-height: 100%;\r\n        border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\r\n        transform: translateY(-100%)\r\n    }\r\n}\r\n\r\n@media (max-width:1399.98px) {\r\n    .offcanvas-xxl.offcanvas-bottom {\r\n        right: 0;\r\n        left: 0;\r\n        height: var(--bs-offcanvas-height);\r\n        max-height: 100%;\r\n        border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\r\n        transform: translateY(100%)\r\n    }\r\n}\r\n\r\n@media (max-width:1399.98px) {\r\n\r\n    .offcanvas-xxl.show:not(.hiding),\r\n    .offcanvas-xxl.showing {\r\n        transform: none\r\n    }\r\n}\r\n\r\n@media (max-width:1399.98px) {\r\n\r\n    .offcanvas-xxl.hiding,\r\n    .offcanvas-xxl.show,\r\n    .offcanvas-xxl.showing {\r\n        visibility: visible\r\n    }\r\n}\r\n\r\n@media (min-width:1400px) {\r\n    .offcanvas-xxl {\r\n        --bs-offcanvas-height: auto;\r\n        --bs-offcanvas-border-width: 0;\r\n        background-color: transparent !important\r\n    }\r\n\r\n    .offcanvas-xxl .offcanvas-header {\r\n        display: none\r\n    }\r\n\r\n    .offcanvas-xxl .offcanvas-body {\r\n        display: flex;\r\n        flex-grow: 0;\r\n        padding: 0;\r\n        overflow-y: visible;\r\n        background-color: transparent !important\r\n    }\r\n}\r\n\r\n.offcanvas {\r\n    position: fixed;\r\n    bottom: 0;\r\n    z-index: 1045;\r\n    display: flex;\r\n    flex-direction: column;\r\n    max-width: 100%;\r\n    color: var(--bs-offcanvas-color);\r\n    visibility: hidden;\r\n    background-color: var(--bs-offcanvas-bg);\r\n    background-clip: padding-box;\r\n    outline: 0;\r\n    transition: transform .3s ease-in-out\r\n}\r\n\r\n@media (prefers-reduced-motion:reduce) {\r\n    .offcanvas {\r\n        transition: none\r\n    }\r\n}\r\n\r\n.offcanvas.offcanvas-start {\r\n    top: 0;\r\n    left: 0;\r\n    width: var(--bs-offcanvas-width);\r\n    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\r\n    transform: translateX(-100%)\r\n}\r\n\r\n.offcanvas.offcanvas-end {\r\n    top: 0;\r\n    right: 0;\r\n    width: var(--bs-offcanvas-width);\r\n    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\r\n    transform: translateX(100%)\r\n}\r\n\r\n.offcanvas.offcanvas-top {\r\n    top: 0;\r\n    right: 0;\r\n    left: 0;\r\n    height: var(--bs-offcanvas-height);\r\n    max-height: 100%;\r\n    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\r\n    transform: translateY(-100%)\r\n}\r\n\r\n.offcanvas.offcanvas-bottom {\r\n    right: 0;\r\n    left: 0;\r\n    height: var(--bs-offcanvas-height);\r\n    max-height: 100%;\r\n    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\r\n    transform: translateY(100%)\r\n}\r\n\r\n.offcanvas.show:not(.hiding),\r\n.offcanvas.showing {\r\n    transform: none\r\n}\r\n\r\n.offcanvas.hiding,\r\n.offcanvas.show,\r\n.offcanvas.showing {\r\n    visibility: visible\r\n}\r\n\r\n.offcanvas-backdrop {\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n    z-index: 1040;\r\n    width: 100vw;\r\n    height: 100vh;\r\n    background-color: #000\r\n}\r\n\r\n.offcanvas-backdrop.fade {\r\n    opacity: 0\r\n}\r\n\r\n.offcanvas-backdrop.show {\r\n    opacity: .5\r\n}\r\n\r\n.offcanvas-header {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n    padding: var(--bs-offcanvas-padding-y) var(--bs-offcanvas-padding-x)\r\n}\r\n\r\n.offcanvas-header .btn-close {\r\n    padding: calc(var(--bs-offcanvas-padding-y) * .5) calc(var(--bs-offcanvas-padding-x) * .5);\r\n    margin-top: calc(var(--bs-offcanvas-padding-y) * -.5);\r\n    margin-right: calc(var(--bs-offcanvas-padding-x) * -.5);\r\n    margin-bottom: calc(var(--bs-offcanvas-padding-y) * -.5)\r\n}\r\n\r\n.offcanvas-title {\r\n    margin-bottom: 0;\r\n    line-height: 1.5\r\n}\r\n\r\n.offcanvas-body {\r\n    flex-grow: 1;\r\n    padding: var(--bs-offcanvas-padding-y) var(--bs-offcanvas-padding-x);\r\n    overflow-y: auto\r\n}\r\n\r\n.placeholder {\r\n    display: inline-block;\r\n    min-height: 1em;\r\n    vertical-align: middle;\r\n    cursor: wait;\r\n    background-color: currentcolor;\r\n    opacity: .5\r\n}\r\n\r\n.placeholder.btn::before {\r\n    display: inline-block;\r\n    content: \"\"\r\n}\r\n\r\n.placeholder-xs {\r\n    min-height: .6em\r\n}\r\n\r\n.placeholder-sm {\r\n    min-height: .8em\r\n}\r\n\r\n.placeholder-lg {\r\n    min-height: 1.2em\r\n}\r\n\r\n.placeholder-glow .placeholder {\r\n    -webkit-animation: placeholder-glow 2s ease-in-out infinite;\r\n    animation: placeholder-glow 2s ease-in-out infinite\r\n}\r\n\r\n@-webkit-keyframes placeholder-glow {\r\n    50% {\r\n        opacity: .2\r\n    }\r\n}\r\n\r\n@keyframes placeholder-glow {\r\n    50% {\r\n        opacity: .2\r\n    }\r\n}\r\n\r\n.placeholder-wave {\r\n    -webkit-mask-image: linear-gradient(130deg, #000 55%, rgba(0, 0, 0, 0.8) 75%, #000 95%);\r\n    mask-image: linear-gradient(130deg, #000 55%, rgba(0, 0, 0, 0.8) 75%, #000 95%);\r\n    -webkit-mask-size: 200% 100%;\r\n    mask-size: 200% 100%;\r\n    -webkit-animation: placeholder-wave 2s linear infinite;\r\n    animation: placeholder-wave 2s linear infinite\r\n}\r\n\r\n@-webkit-keyframes placeholder-wave {\r\n    100% {\r\n        -webkit-mask-position: -200% 0%;\r\n        mask-position: -200% 0%\r\n    }\r\n}\r\n\r\n@keyframes placeholder-wave {\r\n    100% {\r\n        -webkit-mask-position: -200% 0%;\r\n        mask-position: -200% 0%\r\n    }\r\n}\r\n\r\n.clearfix::after {\r\n    display: block;\r\n    clear: both;\r\n    content: \"\"\r\n}\r\n\r\n.text-bg-primary {\r\n    color: #fff !important;\r\n    background-color: RGBA(13, 110, 253, var(--bs-bg-opacity, 1)) !important\r\n}\r\n\r\n.text-bg-secondary {\r\n    color: #fff !important;\r\n    background-color: RGBA(108, 117, 125, var(--bs-bg-opacity, 1)) !important\r\n}\r\n\r\n.text-bg-success {\r\n    color: #fff !important;\r\n    background-color: RGBA(25, 135, 84, var(--bs-bg-opacity, 1)) !important\r\n}\r\n\r\n.text-bg-info {\r\n    color: #000 !important;\r\n    background-color: RGBA(13, 202, 240, var(--bs-bg-opacity, 1)) !important\r\n}\r\n\r\n.text-bg-warning {\r\n    color: #000 !important;\r\n    background-color: RGBA(255, 193, 7, var(--bs-bg-opacity, 1)) !important\r\n}\r\n\r\n.text-bg-danger {\r\n    color: #fff !important;\r\n    background-color: RGBA(220, 53, 69, var(--bs-bg-opacity, 1)) !important\r\n}\r\n\r\n.text-bg-light {\r\n    color: #000 !important;\r\n    background-color: RGBA(248, 249, 250, var(--bs-bg-opacity, 1)) !important\r\n}\r\n\r\n.text-bg-dark {\r\n    color: #fff !important;\r\n    background-color: RGBA(33, 37, 41, var(--bs-bg-opacity, 1)) !important\r\n}\r\n\r\n.link-primary {\r\n    color: #0d6efd !important\r\n}\r\n\r\n.link-primary:focus,\r\n.link-primary:hover {\r\n    color: #0a58ca !important\r\n}\r\n\r\n.link-secondary {\r\n    color: #6c757d !important\r\n}\r\n\r\n.link-secondary:focus,\r\n.link-secondary:hover {\r\n    color: #565e64 !important\r\n}\r\n\r\n.link-success {\r\n    color: #198754 !important\r\n}\r\n\r\n.link-success:focus,\r\n.link-success:hover {\r\n    color: #146c43 !important\r\n}\r\n\r\n.link-info {\r\n    color: #0dcaf0 !important\r\n}\r\n\r\n.link-info:focus,\r\n.link-info:hover {\r\n    color: #3dd5f3 !important\r\n}\r\n\r\n.link-warning {\r\n    color: #ffc107 !important\r\n}\r\n\r\n.link-warning:focus,\r\n.link-warning:hover {\r\n    color: #ffcd39 !important\r\n}\r\n\r\n.link-danger {\r\n    color: #dc3545 !important\r\n}\r\n\r\n.link-danger:focus,\r\n.link-danger:hover {\r\n    color: #b02a37 !important\r\n}\r\n\r\n.link-light {\r\n    color: #f8f9fa !important\r\n}\r\n\r\n.link-light:focus,\r\n.link-light:hover {\r\n    color: #f9fafb !important\r\n}\r\n\r\n.link-dark {\r\n    color: #212529 !important\r\n}\r\n\r\n.link-dark:focus,\r\n.link-dark:hover {\r\n    color: #1a1e21 !important\r\n}\r\n\r\n.ratio {\r\n    position: relative;\r\n    width: 100%\r\n}\r\n\r\n.ratio::before {\r\n    display: block;\r\n    padding-top: var(--bs-aspect-ratio);\r\n    content: \"\"\r\n}\r\n\r\n.ratio>* {\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    width: 100%;\r\n    height: 100%\r\n}\r\n\r\n.ratio-1x1 {\r\n    --bs-aspect-ratio: 100%\r\n}\r\n\r\n.ratio-4x3 {\r\n    --bs-aspect-ratio: 75%\r\n}\r\n\r\n.ratio-16x9 {\r\n    --bs-aspect-ratio: 56.25%\r\n}\r\n\r\n.ratio-21x9 {\r\n    --bs-aspect-ratio: 42.8571428571%\r\n}\r\n\r\n.fixed-top {\r\n    position: fixed;\r\n    top: 0;\r\n    right: 0;\r\n    left: 0;\r\n    z-index: 1030\r\n}\r\n\r\n.fixed-bottom {\r\n    position: fixed;\r\n    right: 0;\r\n    bottom: 0;\r\n    left: 0;\r\n    z-index: 1030\r\n}\r\n\r\n.sticky-top {\r\n    position: -webkit-sticky;\r\n    position: sticky;\r\n    top: 0;\r\n    z-index: 1020\r\n}\r\n\r\n.sticky-bottom {\r\n    position: -webkit-sticky;\r\n    position: sticky;\r\n    bottom: 0;\r\n    z-index: 1020\r\n}\r\n\r\n@media (min-width:576px) {\r\n    .sticky-sm-top {\r\n        position: -webkit-sticky;\r\n        position: sticky;\r\n        top: 0;\r\n        z-index: 1020\r\n    }\r\n\r\n    .sticky-sm-bottom {\r\n        position: -webkit-sticky;\r\n        position: sticky;\r\n        bottom: 0;\r\n        z-index: 1020\r\n    }\r\n}\r\n\r\n@media (min-width:768px) {\r\n    .sticky-md-top {\r\n        position: -webkit-sticky;\r\n        position: sticky;\r\n        top: 0;\r\n        z-index: 1020\r\n    }\r\n\r\n    .sticky-md-bottom {\r\n        position: -webkit-sticky;\r\n        position: sticky;\r\n        bottom: 0;\r\n        z-index: 1020\r\n    }\r\n}\r\n\r\n@media (min-width:992px) {\r\n    .sticky-lg-top {\r\n        position: -webkit-sticky;\r\n        position: sticky;\r\n        top: 0;\r\n        z-index: 1020\r\n    }\r\n\r\n    .sticky-lg-bottom {\r\n        position: -webkit-sticky;\r\n        position: sticky;\r\n        bottom: 0;\r\n        z-index: 1020\r\n    }\r\n}\r\n\r\n@media (min-width:1200px) {\r\n    .sticky-xl-top {\r\n        position: -webkit-sticky;\r\n        position: sticky;\r\n        top: 0;\r\n        z-index: 1020\r\n    }\r\n\r\n    .sticky-xl-bottom {\r\n        position: -webkit-sticky;\r\n        position: sticky;\r\n        bottom: 0;\r\n        z-index: 1020\r\n    }\r\n}\r\n\r\n@media (min-width:1400px) {\r\n    .sticky-xxl-top {\r\n        position: -webkit-sticky;\r\n        position: sticky;\r\n        top: 0;\r\n        z-index: 1020\r\n    }\r\n\r\n    .sticky-xxl-bottom {\r\n        position: -webkit-sticky;\r\n        position: sticky;\r\n        bottom: 0;\r\n        z-index: 1020\r\n    }\r\n}\r\n\r\n.hstack {\r\n    display: flex;\r\n    flex-direction: row;\r\n    align-items: center;\r\n    align-self: stretch\r\n}\r\n\r\n.vstack {\r\n    display: flex;\r\n    flex: 1 1 auto;\r\n    flex-direction: column;\r\n    align-self: stretch\r\n}\r\n\r\n.visually-hidden,\r\n.visually-hidden-focusable:not(:focus):not(:focus-within) {\r\n    position: absolute !important;\r\n    width: 1px !important;\r\n    height: 1px !important;\r\n    padding: 0 !important;\r\n    margin: -1px !important;\r\n    overflow: hidden !important;\r\n    clip: rect(0, 0, 0, 0) !important;\r\n    white-space: nowrap !important;\r\n    border: 0 !important\r\n}\r\n\r\n.stretched-link::after {\r\n    position: absolute;\r\n    top: 0;\r\n    right: 0;\r\n    bottom: 0;\r\n    left: 0;\r\n    z-index: 1;\r\n    content: \"\"\r\n}\r\n\r\n.text-truncate {\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n    white-space: nowrap\r\n}\r\n\r\n.vr {\r\n    display: inline-block;\r\n    align-self: stretch;\r\n    width: 1px;\r\n    min-height: 1em;\r\n    background-color: currentcolor;\r\n    opacity: .25\r\n}\r\n\r\n.align-baseline {\r\n    vertical-align: baseline !important\r\n}\r\n\r\n.align-top {\r\n    vertical-align: top !important\r\n}\r\n\r\n.align-middle {\r\n    vertical-align: middle !important\r\n}\r\n\r\n.align-bottom {\r\n    vertical-align: bottom !important\r\n}\r\n\r\n.align-text-bottom {\r\n    vertical-align: text-bottom !important\r\n}\r\n\r\n.align-text-top {\r\n    vertical-align: text-top !important\r\n}\r\n\r\n.float-start {\r\n    float: left !important\r\n}\r\n\r\n.float-end {\r\n    float: right !important\r\n}\r\n\r\n.float-none {\r\n    float: none !important\r\n}\r\n\r\n.opacity-0 {\r\n    opacity: 0 !important\r\n}\r\n\r\n.opacity-25 {\r\n    opacity: .25 !important\r\n}\r\n\r\n.opacity-50 {\r\n    opacity: .5 !important\r\n}\r\n\r\n.opacity-75 {\r\n    opacity: .75 !important\r\n}\r\n\r\n.opacity-100 {\r\n    opacity: 1 !important\r\n}\r\n\r\n.overflow-auto {\r\n    overflow: auto !important\r\n}\r\n\r\n.overflow-hidden {\r\n    overflow: hidden !important\r\n}\r\n\r\n.overflow-visible {\r\n    overflow: visible !important\r\n}\r\n\r\n.overflow-scroll {\r\n    overflow: scroll !important\r\n}\r\n\r\n.d-inline {\r\n    display: inline !important\r\n}\r\n\r\n.d-inline-block {\r\n    display: inline-block !important\r\n}\r\n\r\n.d-block {\r\n    display: block !important\r\n}\r\n\r\n.d-grid {\r\n    display: grid !important\r\n}\r\n\r\n.d-table {\r\n    display: table !important\r\n}\r\n\r\n.d-table-row {\r\n    display: table-row !important\r\n}\r\n\r\n.d-table-cell {\r\n    display: table-cell !important\r\n}\r\n\r\n.d-flex {\r\n    display: flex !important\r\n}\r\n\r\n.d-inline-flex {\r\n    display: inline-flex !important\r\n}\r\n\r\n.d-none {\r\n    display: none !important\r\n}\r\n\r\n.shadow {\r\n    box-shadow: 0 .5rem 1rem rgba(0, 0, 0, .15) !important\r\n}\r\n\r\n.shadow-sm {\r\n    box-shadow: 0 .125rem .25rem rgba(0, 0, 0, .075) !important\r\n}\r\n\r\n.shadow-lg {\r\n    box-shadow: 0 1rem 3rem rgba(0, 0, 0, .175) !important\r\n}\r\n\r\n.shadow-none {\r\n    box-shadow: none !important\r\n}\r\n\r\n.position-static {\r\n    position: static !important\r\n}\r\n\r\n.position-relative {\r\n    position: relative !important\r\n}\r\n\r\n.position-absolute {\r\n    position: absolute !important\r\n}\r\n\r\n.position-fixed {\r\n    position: fixed !important\r\n}\r\n\r\n.position-sticky {\r\n    position: -webkit-sticky !important;\r\n    position: sticky !important\r\n}\r\n\r\n.top-0 {\r\n    top: 0 !important\r\n}\r\n\r\n.top-50 {\r\n    top: 50% !important\r\n}\r\n\r\n.top-100 {\r\n    top: 100% !important\r\n}\r\n\r\n.bottom-0 {\r\n    bottom: 0 !important\r\n}\r\n\r\n.bottom-50 {\r\n    bottom: 50% !important\r\n}\r\n\r\n.bottom-100 {\r\n    bottom: 100% !important\r\n}\r\n\r\n.start-0 {\r\n    left: 0 !important\r\n}\r\n\r\n.start-50 {\r\n    left: 50% !important\r\n}\r\n\r\n.start-100 {\r\n    left: 100% !important\r\n}\r\n\r\n.end-0 {\r\n    right: 0 !important\r\n}\r\n\r\n.end-50 {\r\n    right: 50% !important\r\n}\r\n\r\n.end-100 {\r\n    right: 100% !important\r\n}\r\n\r\n.translate-middle {\r\n    transform: translate(-50%, -50%) !important\r\n}\r\n\r\n.translate-middle-x {\r\n    transform: translateX(-50%) !important\r\n}\r\n\r\n.translate-middle-y {\r\n    transform: translateY(-50%) !important\r\n}\r\n\r\n.border {\r\n    border: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important\r\n}\r\n\r\n.border-0 {\r\n    border: 0 !important\r\n}\r\n\r\n.border-top {\r\n    border-top: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important\r\n}\r\n\r\n.border-top-0 {\r\n    border-top: 0 !important\r\n}\r\n\r\n.border-end {\r\n    border-right: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important\r\n}\r\n\r\n.border-end-0 {\r\n    border-right: 0 !important\r\n}\r\n\r\n.border-bottom {\r\n    border-bottom: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important\r\n}\r\n\r\n.border-bottom-0 {\r\n    border-bottom: 0 !important\r\n}\r\n\r\n.border-start {\r\n    border-left: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important\r\n}\r\n\r\n.border-start-0 {\r\n    border-left: 0 !important\r\n}\r\n\r\n.border-primary {\r\n    --bs-border-opacity: 1;\r\n    border-color: rgba(var(--bs-primary-rgb), var(--bs-border-opacity)) !important\r\n}\r\n\r\n.border-secondary {\r\n    --bs-border-opacity: 1;\r\n    border-color: rgba(var(--bs-secondary-rgb), var(--bs-border-opacity)) !important\r\n}\r\n\r\n.border-success {\r\n    --bs-border-opacity: 1;\r\n    border-color: rgba(var(--bs-success-rgb), var(--bs-border-opacity)) !important\r\n}\r\n\r\n.border-info {\r\n    --bs-border-opacity: 1;\r\n    border-color: rgba(var(--bs-info-rgb), var(--bs-border-opacity)) !important\r\n}\r\n\r\n.border-warning {\r\n    --bs-border-opacity: 1;\r\n    border-color: rgba(var(--bs-warning-rgb), var(--bs-border-opacity)) !important\r\n}\r\n\r\n.border-danger {\r\n    --bs-border-opacity: 1;\r\n    border-color: rgba(var(--bs-danger-rgb), var(--bs-border-opacity)) !important\r\n}\r\n\r\n.border-light {\r\n    --bs-border-opacity: 1;\r\n    border-color: rgba(var(--bs-light-rgb), var(--bs-border-opacity)) !important\r\n}\r\n\r\n.border-dark {\r\n    --bs-border-opacity: 1;\r\n    border-color: rgba(var(--bs-dark-rgb), var(--bs-border-opacity)) !important\r\n}\r\n\r\n.border-white {\r\n    --bs-border-opacity: 1;\r\n    border-color: rgba(var(--bs-white-rgb), var(--bs-border-opacity)) !important\r\n}\r\n\r\n.border-1 {\r\n    --bs-border-width: 1px\r\n}\r\n\r\n.border-2 {\r\n    --bs-border-width: 2px\r\n}\r\n\r\n.border-3 {\r\n    --bs-border-width: 3px\r\n}\r\n\r\n.border-4 {\r\n    --bs-border-width: 4px\r\n}\r\n\r\n.border-5 {\r\n    --bs-border-width: 5px\r\n}\r\n\r\n.border-opacity-10 {\r\n    --bs-border-opacity: 0.1\r\n}\r\n\r\n.border-opacity-25 {\r\n    --bs-border-opacity: 0.25\r\n}\r\n\r\n.border-opacity-50 {\r\n    --bs-border-opacity: 0.5\r\n}\r\n\r\n.border-opacity-75 {\r\n    --bs-border-opacity: 0.75\r\n}\r\n\r\n.border-opacity-100 {\r\n    --bs-border-opacity: 1\r\n}\r\n\r\n.w-25 {\r\n    width: 25% !important\r\n}\r\n\r\n.w-50 {\r\n    width: 50% !important\r\n}\r\n\r\n.w-75 {\r\n    width: 75% !important\r\n}\r\n\r\n.w-100 {\r\n    width: 100% !important\r\n}\r\n\r\n.w-auto {\r\n    width: auto !important\r\n}\r\n\r\n.mw-100 {\r\n    max-width: 100% !important\r\n}\r\n\r\n.vw-100 {\r\n    width: 100vw !important\r\n}\r\n\r\n.min-vw-100 {\r\n    min-width: 100vw !important\r\n}\r\n\r\n.h-25 {\r\n    height: 25% !important\r\n}\r\n\r\n.h-50 {\r\n    height: 50% !important\r\n}\r\n\r\n.h-75 {\r\n    height: 75% !important\r\n}\r\n\r\n.h-100 {\r\n    height: 100% !important\r\n}\r\n\r\n.h-auto {\r\n    height: auto !important\r\n}\r\n\r\n.mh-100 {\r\n    max-height: 100% !important\r\n}\r\n\r\n.vh-100 {\r\n    height: 100vh !important\r\n}\r\n\r\n.min-vh-100 {\r\n    min-height: 100vh !important\r\n}\r\n\r\n.flex-fill {\r\n    flex: 1 1 auto !important\r\n}\r\n\r\n.flex-row {\r\n    flex-direction: row !important\r\n}\r\n\r\n.flex-column {\r\n    flex-direction: column !important\r\n}\r\n\r\n.flex-row-reverse {\r\n    flex-direction: row-reverse !important\r\n}\r\n\r\n.flex-column-reverse {\r\n    flex-direction: column-reverse !important\r\n}\r\n\r\n.flex-grow-0 {\r\n    flex-grow: 0 !important\r\n}\r\n\r\n.flex-grow-1 {\r\n    flex-grow: 1 !important\r\n}\r\n\r\n.flex-shrink-0 {\r\n    flex-shrink: 0 !important\r\n}\r\n\r\n.flex-shrink-1 {\r\n    flex-shrink: 1 !important\r\n}\r\n\r\n.flex-wrap {\r\n    flex-wrap: wrap !important\r\n}\r\n\r\n.flex-nowrap {\r\n    flex-wrap: nowrap !important\r\n}\r\n\r\n.flex-wrap-reverse {\r\n    flex-wrap: wrap-reverse !important\r\n}\r\n\r\n.justify-content-start {\r\n    justify-content: flex-start !important\r\n}\r\n\r\n.justify-content-end {\r\n    justify-content: flex-end !important\r\n}\r\n\r\n.justify-content-center {\r\n    justify-content: center !important\r\n}\r\n\r\n.justify-content-between {\r\n    justify-content: space-between !important\r\n}\r\n\r\n.justify-content-around {\r\n    justify-content: space-around !important\r\n}\r\n\r\n.justify-content-evenly {\r\n    justify-content: space-evenly !important\r\n}\r\n\r\n.align-items-start {\r\n    align-items: flex-start !important\r\n}\r\n\r\n.align-items-end {\r\n    align-items: flex-end !important\r\n}\r\n\r\n.align-items-center {\r\n    align-items: center !important\r\n}\r\n\r\n.align-items-baseline {\r\n    align-items: baseline !important\r\n}\r\n\r\n.align-items-stretch {\r\n    align-items: stretch !important\r\n}\r\n\r\n.align-content-start {\r\n    align-content: flex-start !important\r\n}\r\n\r\n.align-content-end {\r\n    align-content: flex-end !important\r\n}\r\n\r\n.align-content-center {\r\n    align-content: center !important\r\n}\r\n\r\n.align-content-between {\r\n    align-content: space-between !important\r\n}\r\n\r\n.align-content-around {\r\n    align-content: space-around !important\r\n}\r\n\r\n.align-content-stretch {\r\n    align-content: stretch !important\r\n}\r\n\r\n.align-self-auto {\r\n    align-self: auto !important\r\n}\r\n\r\n.align-self-start {\r\n    align-self: flex-start !important\r\n}\r\n\r\n.align-self-end {\r\n    align-self: flex-end !important\r\n}\r\n\r\n.align-self-center {\r\n    align-self: center !important\r\n}\r\n\r\n.align-self-baseline {\r\n    align-self: baseline !important\r\n}\r\n\r\n.align-self-stretch {\r\n    align-self: stretch !important\r\n}\r\n\r\n.order-first {\r\n    order: -1 !important\r\n}\r\n\r\n.order-0 {\r\n    order: 0 !important\r\n}\r\n\r\n.order-1 {\r\n    order: 1 !important\r\n}\r\n\r\n.order-2 {\r\n    order: 2 !important\r\n}\r\n\r\n.order-3 {\r\n    order: 3 !important\r\n}\r\n\r\n.order-4 {\r\n    order: 4 !important\r\n}\r\n\r\n.order-5 {\r\n    order: 5 !important\r\n}\r\n\r\n.order-last {\r\n    order: 6 !important\r\n}\r\n\r\n.m-0 {\r\n    margin: 0 !important\r\n}\r\n\r\n.m-1 {\r\n    margin: .25rem !important\r\n}\r\n\r\n.m-2 {\r\n    margin: .5rem !important\r\n}\r\n\r\n.m-3 {\r\n    margin: 1rem !important\r\n}\r\n\r\n.m-4 {\r\n    margin: 1.5rem !important\r\n}\r\n\r\n.m-5 {\r\n    margin: 3rem !important\r\n}\r\n\r\n.m-auto {\r\n    margin: auto !important\r\n}\r\n\r\n.mx-0 {\r\n    margin-right: 0 !important;\r\n    margin-left: 0 !important\r\n}\r\n\r\n.mx-1 {\r\n    margin-right: .25rem !important;\r\n    margin-left: .25rem !important\r\n}\r\n\r\n.mx-2 {\r\n    margin-right: .5rem !important;\r\n    margin-left: .5rem !important\r\n}\r\n\r\n.mx-3 {\r\n    margin-right: 1rem !important;\r\n    margin-left: 1rem !important\r\n}\r\n\r\n.mx-4 {\r\n    margin-right: 1.5rem !important;\r\n    margin-left: 1.5rem !important\r\n}\r\n\r\n.mx-5 {\r\n    margin-right: 3rem !important;\r\n    margin-left: 3rem !important\r\n}\r\n\r\n.mx-auto {\r\n    margin-right: auto !important;\r\n    margin-left: auto !important\r\n}\r\n\r\n.my-0 {\r\n    margin-top: 0 !important;\r\n    margin-bottom: 0 !important\r\n}\r\n\r\n.my-1 {\r\n    margin-top: .25rem !important;\r\n    margin-bottom: .25rem !important\r\n}\r\n\r\n.my-2 {\r\n    margin-top: .5rem !important;\r\n    margin-bottom: .5rem !important\r\n}\r\n\r\n.my-3 {\r\n    margin-top: 1rem !important;\r\n    margin-bottom: 1rem !important\r\n}\r\n\r\n.my-4 {\r\n    margin-top: 1.5rem !important;\r\n    margin-bottom: 1.5rem !important\r\n}\r\n\r\n.my-5 {\r\n    margin-top: 3rem !important;\r\n    margin-bottom: 3rem !important\r\n}\r\n\r\n.my-auto {\r\n    margin-top: auto !important;\r\n    margin-bottom: auto !important\r\n}\r\n\r\n.mt-0 {\r\n    margin-top: 0 !important\r\n}\r\n\r\n.mt-1 {\r\n    margin-top: .25rem !important\r\n}\r\n\r\n.mt-2 {\r\n    margin-top: .5rem !important\r\n}\r\n\r\n.mt-3 {\r\n    margin-top: 1rem !important\r\n}\r\n\r\n.mt-4 {\r\n    margin-top: 1.5rem !important\r\n}\r\n\r\n.mt-5 {\r\n    margin-top: 3rem !important\r\n}\r\n\r\n.mt-auto {\r\n    margin-top: auto !important\r\n}\r\n\r\n.me-0 {\r\n    margin-right: 0 !important\r\n}\r\n\r\n.me-1 {\r\n    margin-right: .25rem !important\r\n}\r\n\r\n.me-2 {\r\n    margin-right: .5rem !important\r\n}\r\n\r\n.me-3 {\r\n    margin-right: 1rem !important\r\n}\r\n\r\n.me-4 {\r\n    margin-right: 1.5rem !important\r\n}\r\n\r\n.me-5 {\r\n    margin-right: 3rem !important\r\n}\r\n\r\n.me-auto {\r\n    margin-right: auto !important\r\n}\r\n\r\n.mb-0 {\r\n    margin-bottom: 0 !important\r\n}\r\n\r\n.mb-1 {\r\n    margin-bottom: .25rem !important\r\n}\r\n\r\n.mb-2 {\r\n    margin-bottom: .5rem !important\r\n}\r\n\r\n.mb-3 {\r\n    margin-bottom: 1rem !important\r\n}\r\n\r\n.mb-4 {\r\n    margin-bottom: 1.5rem !important\r\n}\r\n\r\n.mb-5 {\r\n    margin-bottom: 3rem !important\r\n}\r\n\r\n.mb-auto {\r\n    margin-bottom: auto !important\r\n}\r\n\r\n.ms-0 {\r\n    margin-left: 0 !important\r\n}\r\n\r\n.ms-1 {\r\n    margin-left: .25rem !important\r\n}\r\n\r\n.ms-2 {\r\n    margin-left: .5rem !important\r\n}\r\n\r\n.ms-3 {\r\n    margin-left: 1rem !important\r\n}\r\n\r\n.ms-4 {\r\n    margin-left: 1.5rem !important\r\n}\r\n\r\n.ms-5 {\r\n    margin-left: 3rem !important\r\n}\r\n\r\n.ms-auto {\r\n    margin-left: auto !important\r\n}\r\n\r\n.p-0 {\r\n    padding: 0 !important\r\n}\r\n\r\n.p-1 {\r\n    padding: .25rem !important\r\n}\r\n\r\n.p-2 {\r\n    padding: .5rem !important\r\n}\r\n\r\n.p-3 {\r\n    padding: 1rem !important\r\n}\r\n\r\n.p-4 {\r\n    padding: 1.5rem !important\r\n}\r\n\r\n.p-5 {\r\n    padding: 3rem !important\r\n}\r\n\r\n.px-0 {\r\n    padding-right: 0 !important;\r\n    padding-left: 0 !important\r\n}\r\n\r\n.px-1 {\r\n    padding-right: .25rem !important;\r\n    padding-left: .25rem !important\r\n}\r\n\r\n.px-2 {\r\n    padding-right: .5rem !important;\r\n    padding-left: .5rem !important\r\n}\r\n\r\n.px-3 {\r\n    padding-right: 1rem !important;\r\n    padding-left: 1rem !important\r\n}\r\n\r\n.px-4 {\r\n    padding-right: 1.5rem !important;\r\n    padding-left: 1.5rem !important\r\n}\r\n\r\n.px-5 {\r\n    padding-right: 3rem !important;\r\n    padding-left: 3rem !important\r\n}\r\n\r\n.py-0 {\r\n    padding-top: 0 !important;\r\n    padding-bottom: 0 !important\r\n}\r\n\r\n.py-1 {\r\n    padding-top: .25rem !important;\r\n    padding-bottom: .25rem !important\r\n}\r\n\r\n.py-2 {\r\n    padding-top: .5rem !important;\r\n    padding-bottom: .5rem !important\r\n}\r\n\r\n.py-3 {\r\n    padding-top: 1rem !important;\r\n    padding-bottom: 1rem !important\r\n}\r\n\r\n.py-4 {\r\n    padding-top: 1.5rem !important;\r\n    padding-bottom: 1.5rem !important\r\n}\r\n\r\n.py-5 {\r\n    padding-top: 3rem !important;\r\n    padding-bottom: 3rem !important\r\n}\r\n\r\n.pt-0 {\r\n    padding-top: 0 !important\r\n}\r\n\r\n.pt-1 {\r\n    padding-top: .25rem !important\r\n}\r\n\r\n.pt-2 {\r\n    padding-top: .5rem !important\r\n}\r\n\r\n.pt-3 {\r\n    padding-top: 1rem !important\r\n}\r\n\r\n.pt-4 {\r\n    padding-top: 1.5rem !important\r\n}\r\n\r\n.pt-5 {\r\n    padding-top: 3rem !important\r\n}\r\n\r\n.pe-0 {\r\n    padding-right: 0 !important\r\n}\r\n\r\n.pe-1 {\r\n    padding-right: .25rem !important\r\n}\r\n\r\n.pe-2 {\r\n    padding-right: .5rem !important\r\n}\r\n\r\n.pe-3 {\r\n    padding-right: 1rem !important\r\n}\r\n\r\n.pe-4 {\r\n    padding-right: 1.5rem !important\r\n}\r\n\r\n.pe-5 {\r\n    padding-right: 3rem !important\r\n}\r\n\r\n.pb-0 {\r\n    padding-bottom: 0 !important\r\n}\r\n\r\n.pb-1 {\r\n    padding-bottom: .25rem !important\r\n}\r\n\r\n.pb-2 {\r\n    padding-bottom: .5rem !important\r\n}\r\n\r\n.pb-3 {\r\n    padding-bottom: 1rem !important\r\n}\r\n\r\n.pb-4 {\r\n    padding-bottom: 1.5rem !important\r\n}\r\n\r\n.pb-5 {\r\n    padding-bottom: 3rem !important\r\n}\r\n\r\n.ps-0 {\r\n    padding-left: 0 !important\r\n}\r\n\r\n.ps-1 {\r\n    padding-left: .25rem !important\r\n}\r\n\r\n.ps-2 {\r\n    padding-left: .5rem !important\r\n}\r\n\r\n.ps-3 {\r\n    padding-left: 1rem !important\r\n}\r\n\r\n.ps-4 {\r\n    padding-left: 1.5rem !important\r\n}\r\n\r\n.ps-5 {\r\n    padding-left: 3rem !important\r\n}\r\n\r\n.gap-0 {\r\n    gap: 0 !important\r\n}\r\n\r\n.gap-1 {\r\n    gap: .25rem !important\r\n}\r\n\r\n.gap-2 {\r\n    gap: .5rem !important\r\n}\r\n\r\n.gap-3 {\r\n    gap: 1rem !important\r\n}\r\n\r\n.gap-4 {\r\n    gap: 1.5rem !important\r\n}\r\n\r\n.gap-5 {\r\n    gap: 3rem !important\r\n}\r\n\r\n.font-monospace {\r\n    font-family: var(--bs-font-monospace) !important\r\n}\r\n\r\n.fs-1 {\r\n    font-size: calc(1.375rem + 1.5vw) !important\r\n}\r\n\r\n.fs-2 {\r\n    font-size: calc(1.325rem + .9vw) !important\r\n}\r\n\r\n.fs-3 {\r\n    font-size: calc(1.3rem + .6vw) !important\r\n}\r\n\r\n.fs-4 {\r\n    font-size: calc(1.275rem + .3vw) !important\r\n}\r\n\r\n.fs-5 {\r\n    font-size: 1.25rem !important\r\n}\r\n\r\n.fs-6 {\r\n    font-size: 1rem !important\r\n}\r\n\r\n.fst-italic {\r\n    font-style: italic !important\r\n}\r\n\r\n.fst-normal {\r\n    font-style: normal !important\r\n}\r\n\r\n.fw-light {\r\n    font-weight: 300 !important\r\n}\r\n\r\n.fw-lighter {\r\n    font-weight: lighter !important\r\n}\r\n\r\n.fw-normal {\r\n    font-weight: 400 !important\r\n}\r\n\r\n.fw-bold {\r\n    font-weight: 700 !important\r\n}\r\n\r\n.fw-semibold {\r\n    font-weight: 600 !important\r\n}\r\n\r\n.fw-bolder {\r\n    font-weight: bolder !important\r\n}\r\n\r\n.lh-1 {\r\n    line-height: 1 !important\r\n}\r\n\r\n.lh-sm {\r\n    line-height: 1.25 !important\r\n}\r\n\r\n.lh-base {\r\n    line-height: 1.5 !important\r\n}\r\n\r\n.lh-lg {\r\n    line-height: 2 !important\r\n}\r\n\r\n.text-start {\r\n    text-align: left !important\r\n}\r\n\r\n.text-end {\r\n    text-align: right !important\r\n}\r\n\r\n.text-center {\r\n    text-align: center !important\r\n}\r\n\r\n.text-decoration-none {\r\n    text-decoration: none !important\r\n}\r\n\r\n.text-decoration-underline {\r\n    text-decoration: underline !important\r\n}\r\n\r\n.text-decoration-line-through {\r\n    text-decoration: line-through !important\r\n}\r\n\r\n.text-lowercase {\r\n    text-transform: lowercase !important\r\n}\r\n\r\n.text-uppercase {\r\n    text-transform: uppercase !important\r\n}\r\n\r\n.text-capitalize {\r\n    text-transform: capitalize !important\r\n}\r\n\r\n.text-wrap {\r\n    white-space: normal !important\r\n}\r\n\r\n.text-nowrap {\r\n    white-space: nowrap !important\r\n}\r\n\r\n.text-break {\r\n    word-wrap: break-word !important;\r\n    word-break: break-word !important\r\n}\r\n\r\n.text-primary {\r\n    --bs-text-opacity: 1;\r\n    color: rgba(var(--bs-primary-rgb), var(--bs-text-opacity)) !important\r\n}\r\n\r\n.text-secondary {\r\n    --bs-text-opacity: 1;\r\n    color: rgba(var(--bs-secondary-rgb), var(--bs-text-opacity)) !important\r\n}\r\n\r\n.text-success {\r\n    --bs-text-opacity: 1;\r\n    color: rgba(var(--bs-success-rgb), var(--bs-text-opacity)) !important\r\n}\r\n\r\n.text-info {\r\n    --bs-text-opacity: 1;\r\n    color: rgba(var(--bs-info-rgb), var(--bs-text-opacity)) !important\r\n}\r\n\r\n.text-warning {\r\n    --bs-text-opacity: 1;\r\n    color: rgba(var(--bs-warning-rgb), var(--bs-text-opacity)) !important\r\n}\r\n\r\n.text-danger {\r\n    --bs-text-opacity: 1;\r\n    color: rgba(var(--bs-danger-rgb), var(--bs-text-opacity)) !important\r\n}\r\n\r\n.text-light {\r\n    --bs-text-opacity: 1;\r\n    color: rgba(var(--bs-light-rgb), var(--bs-text-opacity)) !important\r\n}\r\n\r\n.text-dark {\r\n    --bs-text-opacity: 1;\r\n    color: rgba(var(--bs-dark-rgb), var(--bs-text-opacity)) !important\r\n}\r\n\r\n.text-black {\r\n    --bs-text-opacity: 1;\r\n    color: rgba(var(--bs-black-rgb), var(--bs-text-opacity)) !important\r\n}\r\n\r\n.text-white {\r\n    --bs-text-opacity: 1;\r\n    color: rgba(var(--bs-white-rgb), var(--bs-text-opacity)) !important\r\n}\r\n\r\n.text-body {\r\n    --bs-text-opacity: 1;\r\n    color: rgba(var(--bs-body-color-rgb), var(--bs-text-opacity)) !important\r\n}\r\n\r\n.text-muted {\r\n    --bs-text-opacity: 1;\r\n    color: #6c757d !important\r\n}\r\n\r\n.text-black-50 {\r\n    --bs-text-opacity: 1;\r\n    color: rgba(0, 0, 0, .5) !important\r\n}\r\n\r\n.text-white-50 {\r\n    --bs-text-opacity: 1;\r\n    color: rgba(255, 255, 255, .5) !important\r\n}\r\n\r\n.text-reset {\r\n    --bs-text-opacity: 1;\r\n    color: inherit !important\r\n}\r\n\r\n.text-opacity-25 {\r\n    --bs-text-opacity: 0.25\r\n}\r\n\r\n.text-opacity-50 {\r\n    --bs-text-opacity: 0.5\r\n}\r\n\r\n.text-opacity-75 {\r\n    --bs-text-opacity: 0.75\r\n}\r\n\r\n.text-opacity-100 {\r\n    --bs-text-opacity: 1\r\n}\r\n\r\n.bg-primary {\r\n    --bs-bg-opacity: 1;\r\n    background-color: rgba(var(--bs-primary-rgb), var(--bs-bg-opacity)) !important\r\n}\r\n\r\n.bg-secondary {\r\n    --bs-bg-opacity: 1;\r\n    background-color: rgba(var(--bs-secondary-rgb), var(--bs-bg-opacity)) !important\r\n}\r\n\r\n.bg-success {\r\n    --bs-bg-opacity: 1;\r\n    background-color: rgba(var(--bs-success-rgb), var(--bs-bg-opacity)) !important\r\n}\r\n\r\n.bg-info {\r\n    --bs-bg-opacity: 1;\r\n    background-color: rgba(var(--bs-info-rgb), var(--bs-bg-opacity)) !important\r\n}\r\n\r\n.bg-warning {\r\n    --bs-bg-opacity: 1;\r\n    background-color: rgba(var(--bs-warning-rgb), var(--bs-bg-opacity)) !important\r\n}\r\n\r\n.bg-danger {\r\n    --bs-bg-opacity: 1;\r\n    background-color: rgba(var(--bs-danger-rgb), var(--bs-bg-opacity)) !important\r\n}\r\n\r\n.bg-light {\r\n    --bs-bg-opacity: 1;\r\n    background-color: rgba(var(--bs-light-rgb), var(--bs-bg-opacity)) !important\r\n}\r\n\r\n.bg-dark {\r\n    --bs-bg-opacity: 1;\r\n    background-color: rgba(var(--bs-dark-rgb), var(--bs-bg-opacity)) !important\r\n}\r\n\r\n.bg-black {\r\n    --bs-bg-opacity: 1;\r\n    background-color: rgba(var(--bs-black-rgb), var(--bs-bg-opacity)) !important\r\n}\r\n\r\n.bg-white {\r\n    --bs-bg-opacity: 1;\r\n    background-color: rgba(var(--bs-white-rgb), var(--bs-bg-opacity)) !important\r\n}\r\n\r\n.bg-body {\r\n    --bs-bg-opacity: 1;\r\n    background-color: rgba(var(--bs-body-bg-rgb), var(--bs-bg-opacity)) !important\r\n}\r\n\r\n.bg-transparent {\r\n    --bs-bg-opacity: 1;\r\n    background-color: transparent !important\r\n}\r\n\r\n.bg-opacity-10 {\r\n    --bs-bg-opacity: 0.1\r\n}\r\n\r\n.bg-opacity-25 {\r\n    --bs-bg-opacity: 0.25\r\n}\r\n\r\n.bg-opacity-50 {\r\n    --bs-bg-opacity: 0.5\r\n}\r\n\r\n.bg-opacity-75 {\r\n    --bs-bg-opacity: 0.75\r\n}\r\n\r\n.bg-opacity-100 {\r\n    --bs-bg-opacity: 1\r\n}\r\n\r\n.bg-gradient {\r\n    background-image: var(--bs-gradient) !important\r\n}\r\n\r\n.user-select-all {\r\n    -webkit-user-select: all !important;\r\n    -moz-user-select: all !important;\r\n    user-select: all !important\r\n}\r\n\r\n.user-select-auto {\r\n    -webkit-user-select: auto !important;\r\n    -moz-user-select: auto !important;\r\n    user-select: auto !important\r\n}\r\n\r\n.user-select-none {\r\n    -webkit-user-select: none !important;\r\n    -moz-user-select: none !important;\r\n    user-select: none !important\r\n}\r\n\r\n.pe-none {\r\n    pointer-events: none !important\r\n}\r\n\r\n.pe-auto {\r\n    pointer-events: auto !important\r\n}\r\n\r\n.rounded {\r\n    border-radius: var(--bs-border-radius) !important\r\n}\r\n\r\n.rounded-0 {\r\n    border-radius: 0 !important\r\n}\r\n\r\n.rounded-1 {\r\n    border-radius: var(--bs-border-radius-sm) !important\r\n}\r\n\r\n.rounded-2 {\r\n    border-radius: var(--bs-border-radius) !important\r\n}\r\n\r\n.rounded-3 {\r\n    border-radius: var(--bs-border-radius-lg) !important\r\n}\r\n\r\n.rounded-4 {\r\n    border-radius: var(--bs-border-radius-xl) !important\r\n}\r\n\r\n.rounded-5 {\r\n    border-radius: var(--bs-border-radius-2xl) !important\r\n}\r\n\r\n.rounded-circle {\r\n    border-radius: 50% !important\r\n}\r\n\r\n.rounded-pill {\r\n    border-radius: var(--bs-border-radius-pill) !important\r\n}\r\n\r\n.rounded-top {\r\n    border-top-left-radius: var(--bs-border-radius) !important;\r\n    border-top-right-radius: var(--bs-border-radius) !important\r\n}\r\n\r\n.rounded-end {\r\n    border-top-right-radius: var(--bs-border-radius) !important;\r\n    border-bottom-right-radius: var(--bs-border-radius) !important\r\n}\r\n\r\n.rounded-bottom {\r\n    border-bottom-right-radius: var(--bs-border-radius) !important;\r\n    border-bottom-left-radius: var(--bs-border-radius) !important\r\n}\r\n\r\n.rounded-start {\r\n    border-bottom-left-radius: var(--bs-border-radius) !important;\r\n    border-top-left-radius: var(--bs-border-radius) !important\r\n}\r\n\r\n.visible {\r\n    visibility: visible !important\r\n}\r\n\r\n.invisible {\r\n    visibility: hidden !important\r\n}\r\n\r\n@media (min-width:576px) {\r\n    .float-sm-start {\r\n        float: left !important\r\n    }\r\n\r\n    .float-sm-end {\r\n        float: right !important\r\n    }\r\n\r\n    .float-sm-none {\r\n        float: none !important\r\n    }\r\n\r\n    .d-sm-inline {\r\n        display: inline !important\r\n    }\r\n\r\n    .d-sm-inline-block {\r\n        display: inline-block !important\r\n    }\r\n\r\n    .d-sm-block {\r\n        display: block !important\r\n    }\r\n\r\n    .d-sm-grid {\r\n        display: grid !important\r\n    }\r\n\r\n    .d-sm-table {\r\n        display: table !important\r\n    }\r\n\r\n    .d-sm-table-row {\r\n        display: table-row !important\r\n    }\r\n\r\n    .d-sm-table-cell {\r\n        display: table-cell !important\r\n    }\r\n\r\n    .d-sm-flex {\r\n        display: flex !important\r\n    }\r\n\r\n    .d-sm-inline-flex {\r\n        display: inline-flex !important\r\n    }\r\n\r\n    .d-sm-none {\r\n        display: none !important\r\n    }\r\n\r\n    .flex-sm-fill {\r\n        flex: 1 1 auto !important\r\n    }\r\n\r\n    .flex-sm-row {\r\n        flex-direction: row !important\r\n    }\r\n\r\n    .flex-sm-column {\r\n        flex-direction: column !important\r\n    }\r\n\r\n    .flex-sm-row-reverse {\r\n        flex-direction: row-reverse !important\r\n    }\r\n\r\n    .flex-sm-column-reverse {\r\n        flex-direction: column-reverse !important\r\n    }\r\n\r\n    .flex-sm-grow-0 {\r\n        flex-grow: 0 !important\r\n    }\r\n\r\n    .flex-sm-grow-1 {\r\n        flex-grow: 1 !important\r\n    }\r\n\r\n    .flex-sm-shrink-0 {\r\n        flex-shrink: 0 !important\r\n    }\r\n\r\n    .flex-sm-shrink-1 {\r\n        flex-shrink: 1 !important\r\n    }\r\n\r\n    .flex-sm-wrap {\r\n        flex-wrap: wrap !important\r\n    }\r\n\r\n    .flex-sm-nowrap {\r\n        flex-wrap: nowrap !important\r\n    }\r\n\r\n    .flex-sm-wrap-reverse {\r\n        flex-wrap: wrap-reverse !important\r\n    }\r\n\r\n    .justify-content-sm-start {\r\n        justify-content: flex-start !important\r\n    }\r\n\r\n    .justify-content-sm-end {\r\n        justify-content: flex-end !important\r\n    }\r\n\r\n    .justify-content-sm-center {\r\n        justify-content: center !important\r\n    }\r\n\r\n    .justify-content-sm-between {\r\n        justify-content: space-between !important\r\n    }\r\n\r\n    .justify-content-sm-around {\r\n        justify-content: space-around !important\r\n    }\r\n\r\n    .justify-content-sm-evenly {\r\n        justify-content: space-evenly !important\r\n    }\r\n\r\n    .align-items-sm-start {\r\n        align-items: flex-start !important\r\n    }\r\n\r\n    .align-items-sm-end {\r\n        align-items: flex-end !important\r\n    }\r\n\r\n    .align-items-sm-center {\r\n        align-items: center !important\r\n    }\r\n\r\n    .align-items-sm-baseline {\r\n        align-items: baseline !important\r\n    }\r\n\r\n    .align-items-sm-stretch {\r\n        align-items: stretch !important\r\n    }\r\n\r\n    .align-content-sm-start {\r\n        align-content: flex-start !important\r\n    }\r\n\r\n    .align-content-sm-end {\r\n        align-content: flex-end !important\r\n    }\r\n\r\n    .align-content-sm-center {\r\n        align-content: center !important\r\n    }\r\n\r\n    .align-content-sm-between {\r\n        align-content: space-between !important\r\n    }\r\n\r\n    .align-content-sm-around {\r\n        align-content: space-around !important\r\n    }\r\n\r\n    .align-content-sm-stretch {\r\n        align-content: stretch !important\r\n    }\r\n\r\n    .align-self-sm-auto {\r\n        align-self: auto !important\r\n    }\r\n\r\n    .align-self-sm-start {\r\n        align-self: flex-start !important\r\n    }\r\n\r\n    .align-self-sm-end {\r\n        align-self: flex-end !important\r\n    }\r\n\r\n    .align-self-sm-center {\r\n        align-self: center !important\r\n    }\r\n\r\n    .align-self-sm-baseline {\r\n        align-self: baseline !important\r\n    }\r\n\r\n    .align-self-sm-stretch {\r\n        align-self: stretch !important\r\n    }\r\n\r\n    .order-sm-first {\r\n        order: -1 !important\r\n    }\r\n\r\n    .order-sm-0 {\r\n        order: 0 !important\r\n    }\r\n\r\n    .order-sm-1 {\r\n        order: 1 !important\r\n    }\r\n\r\n    .order-sm-2 {\r\n        order: 2 !important\r\n    }\r\n\r\n    .order-sm-3 {\r\n        order: 3 !important\r\n    }\r\n\r\n    .order-sm-4 {\r\n        order: 4 !important\r\n    }\r\n\r\n    .order-sm-5 {\r\n        order: 5 !important\r\n    }\r\n\r\n    .order-sm-last {\r\n        order: 6 !important\r\n    }\r\n\r\n    .m-sm-0 {\r\n        margin: 0 !important\r\n    }\r\n\r\n    .m-sm-1 {\r\n        margin: .25rem !important\r\n    }\r\n\r\n    .m-sm-2 {\r\n        margin: .5rem !important\r\n    }\r\n\r\n    .m-sm-3 {\r\n        margin: 1rem !important\r\n    }\r\n\r\n    .m-sm-4 {\r\n        margin: 1.5rem !important\r\n    }\r\n\r\n    .m-sm-5 {\r\n        margin: 3rem !important\r\n    }\r\n\r\n    .m-sm-auto {\r\n        margin: auto !important\r\n    }\r\n\r\n    .mx-sm-0 {\r\n        margin-right: 0 !important;\r\n        margin-left: 0 !important\r\n    }\r\n\r\n    .mx-sm-1 {\r\n        margin-right: .25rem !important;\r\n        margin-left: .25rem !important\r\n    }\r\n\r\n    .mx-sm-2 {\r\n        margin-right: .5rem !important;\r\n        margin-left: .5rem !important\r\n    }\r\n\r\n    .mx-sm-3 {\r\n        margin-right: 1rem !important;\r\n        margin-left: 1rem !important\r\n    }\r\n\r\n    .mx-sm-4 {\r\n        margin-right: 1.5rem !important;\r\n        margin-left: 1.5rem !important\r\n    }\r\n\r\n    .mx-sm-5 {\r\n        margin-right: 3rem !important;\r\n        margin-left: 3rem !important\r\n    }\r\n\r\n    .mx-sm-auto {\r\n        margin-right: auto !important;\r\n        margin-left: auto !important\r\n    }\r\n\r\n    .my-sm-0 {\r\n        margin-top: 0 !important;\r\n        margin-bottom: 0 !important\r\n    }\r\n\r\n    .my-sm-1 {\r\n        margin-top: .25rem !important;\r\n        margin-bottom: .25rem !important\r\n    }\r\n\r\n    .my-sm-2 {\r\n        margin-top: .5rem !important;\r\n        margin-bottom: .5rem !important\r\n    }\r\n\r\n    .my-sm-3 {\r\n        margin-top: 1rem !important;\r\n        margin-bottom: 1rem !important\r\n    }\r\n\r\n    .my-sm-4 {\r\n        margin-top: 1.5rem !important;\r\n        margin-bottom: 1.5rem !important\r\n    }\r\n\r\n    .my-sm-5 {\r\n        margin-top: 3rem !important;\r\n        margin-bottom: 3rem !important\r\n    }\r\n\r\n    .my-sm-auto {\r\n        margin-top: auto !important;\r\n        margin-bottom: auto !important\r\n    }\r\n\r\n    .mt-sm-0 {\r\n        margin-top: 0 !important\r\n    }\r\n\r\n    .mt-sm-1 {\r\n        margin-top: .25rem !important\r\n    }\r\n\r\n    .mt-sm-2 {\r\n        margin-top: .5rem !important\r\n    }\r\n\r\n    .mt-sm-3 {\r\n        margin-top: 1rem !important\r\n    }\r\n\r\n    .mt-sm-4 {\r\n        margin-top: 1.5rem !important\r\n    }\r\n\r\n    .mt-sm-5 {\r\n        margin-top: 3rem !important\r\n    }\r\n\r\n    .mt-sm-auto {\r\n        margin-top: auto !important\r\n    }\r\n\r\n    .me-sm-0 {\r\n        margin-right: 0 !important\r\n    }\r\n\r\n    .me-sm-1 {\r\n        margin-right: .25rem !important\r\n    }\r\n\r\n    .me-sm-2 {\r\n        margin-right: .5rem !important\r\n    }\r\n\r\n    .me-sm-3 {\r\n        margin-right: 1rem !important\r\n    }\r\n\r\n    .me-sm-4 {\r\n        margin-right: 1.5rem !important\r\n    }\r\n\r\n    .me-sm-5 {\r\n        margin-right: 3rem !important\r\n    }\r\n\r\n    .me-sm-auto {\r\n        margin-right: auto !important\r\n    }\r\n\r\n    .mb-sm-0 {\r\n        margin-bottom: 0 !important\r\n    }\r\n\r\n    .mb-sm-1 {\r\n        margin-bottom: .25rem !important\r\n    }\r\n\r\n    .mb-sm-2 {\r\n        margin-bottom: .5rem !important\r\n    }\r\n\r\n    .mb-sm-3 {\r\n        margin-bottom: 1rem !important\r\n    }\r\n\r\n    .mb-sm-4 {\r\n        margin-bottom: 1.5rem !important\r\n    }\r\n\r\n    .mb-sm-5 {\r\n        margin-bottom: 3rem !important\r\n    }\r\n\r\n    .mb-sm-auto {\r\n        margin-bottom: auto !important\r\n    }\r\n\r\n    .ms-sm-0 {\r\n        margin-left: 0 !important\r\n    }\r\n\r\n    .ms-sm-1 {\r\n        margin-left: .25rem !important\r\n    }\r\n\r\n    .ms-sm-2 {\r\n        margin-left: .5rem !important\r\n    }\r\n\r\n    .ms-sm-3 {\r\n        margin-left: 1rem !important\r\n    }\r\n\r\n    .ms-sm-4 {\r\n        margin-left: 1.5rem !important\r\n    }\r\n\r\n    .ms-sm-5 {\r\n        margin-left: 3rem !important\r\n    }\r\n\r\n    .ms-sm-auto {\r\n        margin-left: auto !important\r\n    }\r\n\r\n    .p-sm-0 {\r\n        padding: 0 !important\r\n    }\r\n\r\n    .p-sm-1 {\r\n        padding: .25rem !important\r\n    }\r\n\r\n    .p-sm-2 {\r\n        padding: .5rem !important\r\n    }\r\n\r\n    .p-sm-3 {\r\n        padding: 1rem !important\r\n    }\r\n\r\n    .p-sm-4 {\r\n        padding: 1.5rem !important\r\n    }\r\n\r\n    .p-sm-5 {\r\n        padding: 3rem !important\r\n    }\r\n\r\n    .px-sm-0 {\r\n        padding-right: 0 !important;\r\n        padding-left: 0 !important\r\n    }\r\n\r\n    .px-sm-1 {\r\n        padding-right: .25rem !important;\r\n        padding-left: .25rem !important\r\n    }\r\n\r\n    .px-sm-2 {\r\n        padding-right: .5rem !important;\r\n        padding-left: .5rem !important\r\n    }\r\n\r\n    .px-sm-3 {\r\n        padding-right: 1rem !important;\r\n        padding-left: 1rem !important\r\n    }\r\n\r\n    .px-sm-4 {\r\n        padding-right: 1.5rem !important;\r\n        padding-left: 1.5rem !important\r\n    }\r\n\r\n    .px-sm-5 {\r\n        padding-right: 3rem !important;\r\n        padding-left: 3rem !important\r\n    }\r\n\r\n    .py-sm-0 {\r\n        padding-top: 0 !important;\r\n        padding-bottom: 0 !important\r\n    }\r\n\r\n    .py-sm-1 {\r\n        padding-top: .25rem !important;\r\n        padding-bottom: .25rem !important\r\n    }\r\n\r\n    .py-sm-2 {\r\n        padding-top: .5rem !important;\r\n        padding-bottom: .5rem !important\r\n    }\r\n\r\n    .py-sm-3 {\r\n        padding-top: 1rem !important;\r\n        padding-bottom: 1rem !important\r\n    }\r\n\r\n    .py-sm-4 {\r\n        padding-top: 1.5rem !important;\r\n        padding-bottom: 1.5rem !important\r\n    }\r\n\r\n    .py-sm-5 {\r\n        padding-top: 3rem !important;\r\n        padding-bottom: 3rem !important\r\n    }\r\n\r\n    .pt-sm-0 {\r\n        padding-top: 0 !important\r\n    }\r\n\r\n    .pt-sm-1 {\r\n        padding-top: .25rem !important\r\n    }\r\n\r\n    .pt-sm-2 {\r\n        padding-top: .5rem !important\r\n    }\r\n\r\n    .pt-sm-3 {\r\n        padding-top: 1rem !important\r\n    }\r\n\r\n    .pt-sm-4 {\r\n        padding-top: 1.5rem !important\r\n    }\r\n\r\n    .pt-sm-5 {\r\n        padding-top: 3rem !important\r\n    }\r\n\r\n    .pe-sm-0 {\r\n        padding-right: 0 !important\r\n    }\r\n\r\n    .pe-sm-1 {\r\n        padding-right: .25rem !important\r\n    }\r\n\r\n    .pe-sm-2 {\r\n        padding-right: .5rem !important\r\n    }\r\n\r\n    .pe-sm-3 {\r\n        padding-right: 1rem !important\r\n    }\r\n\r\n    .pe-sm-4 {\r\n        padding-right: 1.5rem !important\r\n    }\r\n\r\n    .pe-sm-5 {\r\n        padding-right: 3rem !important\r\n    }\r\n\r\n    .pb-sm-0 {\r\n        padding-bottom: 0 !important\r\n    }\r\n\r\n    .pb-sm-1 {\r\n        padding-bottom: .25rem !important\r\n    }\r\n\r\n    .pb-sm-2 {\r\n        padding-bottom: .5rem !important\r\n    }\r\n\r\n    .pb-sm-3 {\r\n        padding-bottom: 1rem !important\r\n    }\r\n\r\n    .pb-sm-4 {\r\n        padding-bottom: 1.5rem !important\r\n    }\r\n\r\n    .pb-sm-5 {\r\n        padding-bottom: 3rem !important\r\n    }\r\n\r\n    .ps-sm-0 {\r\n        padding-left: 0 !important\r\n    }\r\n\r\n    .ps-sm-1 {\r\n        padding-left: .25rem !important\r\n    }\r\n\r\n    .ps-sm-2 {\r\n        padding-left: .5rem !important\r\n    }\r\n\r\n    .ps-sm-3 {\r\n        padding-left: 1rem !important\r\n    }\r\n\r\n    .ps-sm-4 {\r\n        padding-left: 1.5rem !important\r\n    }\r\n\r\n    .ps-sm-5 {\r\n        padding-left: 3rem !important\r\n    }\r\n\r\n    .gap-sm-0 {\r\n        gap: 0 !important\r\n    }\r\n\r\n    .gap-sm-1 {\r\n        gap: .25rem !important\r\n    }\r\n\r\n    .gap-sm-2 {\r\n        gap: .5rem !important\r\n    }\r\n\r\n    .gap-sm-3 {\r\n        gap: 1rem !important\r\n    }\r\n\r\n    .gap-sm-4 {\r\n        gap: 1.5rem !important\r\n    }\r\n\r\n    .gap-sm-5 {\r\n        gap: 3rem !important\r\n    }\r\n\r\n    .text-sm-start {\r\n        text-align: left !important\r\n    }\r\n\r\n    .text-sm-end {\r\n        text-align: right !important\r\n    }\r\n\r\n    .text-sm-center {\r\n        text-align: center !important\r\n    }\r\n}\r\n\r\n@media (min-width:768px) {\r\n    .float-md-start {\r\n        float: left !important\r\n    }\r\n\r\n    .float-md-end {\r\n        float: right !important\r\n    }\r\n\r\n    .float-md-none {\r\n        float: none !important\r\n    }\r\n\r\n    .d-md-inline {\r\n        display: inline !important\r\n    }\r\n\r\n    .d-md-inline-block {\r\n        display: inline-block !important\r\n    }\r\n\r\n    .d-md-block {\r\n        display: block !important\r\n    }\r\n\r\n    .d-md-grid {\r\n        display: grid !important\r\n    }\r\n\r\n    .d-md-table {\r\n        display: table !important\r\n    }\r\n\r\n    .d-md-table-row {\r\n        display: table-row !important\r\n    }\r\n\r\n    .d-md-table-cell {\r\n        display: table-cell !important\r\n    }\r\n\r\n    .d-md-flex {\r\n        display: flex !important\r\n    }\r\n\r\n    .d-md-inline-flex {\r\n        display: inline-flex !important\r\n    }\r\n\r\n    .d-md-none {\r\n        display: none !important\r\n    }\r\n\r\n    .flex-md-fill {\r\n        flex: 1 1 auto !important\r\n    }\r\n\r\n    .flex-md-row {\r\n        flex-direction: row !important\r\n    }\r\n\r\n    .flex-md-column {\r\n        flex-direction: column !important\r\n    }\r\n\r\n    .flex-md-row-reverse {\r\n        flex-direction: row-reverse !important\r\n    }\r\n\r\n    .flex-md-column-reverse {\r\n        flex-direction: column-reverse !important\r\n    }\r\n\r\n    .flex-md-grow-0 {\r\n        flex-grow: 0 !important\r\n    }\r\n\r\n    .flex-md-grow-1 {\r\n        flex-grow: 1 !important\r\n    }\r\n\r\n    .flex-md-shrink-0 {\r\n        flex-shrink: 0 !important\r\n    }\r\n\r\n    .flex-md-shrink-1 {\r\n        flex-shrink: 1 !important\r\n    }\r\n\r\n    .flex-md-wrap {\r\n        flex-wrap: wrap !important\r\n    }\r\n\r\n    .flex-md-nowrap {\r\n        flex-wrap: nowrap !important\r\n    }\r\n\r\n    .flex-md-wrap-reverse {\r\n        flex-wrap: wrap-reverse !important\r\n    }\r\n\r\n    .justify-content-md-start {\r\n        justify-content: flex-start !important\r\n    }\r\n\r\n    .justify-content-md-end {\r\n        justify-content: flex-end !important\r\n    }\r\n\r\n    .justify-content-md-center {\r\n        justify-content: center !important\r\n    }\r\n\r\n    .justify-content-md-between {\r\n        justify-content: space-between !important\r\n    }\r\n\r\n    .justify-content-md-around {\r\n        justify-content: space-around !important\r\n    }\r\n\r\n    .justify-content-md-evenly {\r\n        justify-content: space-evenly !important\r\n    }\r\n\r\n    .align-items-md-start {\r\n        align-items: flex-start !important\r\n    }\r\n\r\n    .align-items-md-end {\r\n        align-items: flex-end !important\r\n    }\r\n\r\n    .align-items-md-center {\r\n        align-items: center !important\r\n    }\r\n\r\n    .align-items-md-baseline {\r\n        align-items: baseline !important\r\n    }\r\n\r\n    .align-items-md-stretch {\r\n        align-items: stretch !important\r\n    }\r\n\r\n    .align-content-md-start {\r\n        align-content: flex-start !important\r\n    }\r\n\r\n    .align-content-md-end {\r\n        align-content: flex-end !important\r\n    }\r\n\r\n    .align-content-md-center {\r\n        align-content: center !important\r\n    }\r\n\r\n    .align-content-md-between {\r\n        align-content: space-between !important\r\n    }\r\n\r\n    .align-content-md-around {\r\n        align-content: space-around !important\r\n    }\r\n\r\n    .align-content-md-stretch {\r\n        align-content: stretch !important\r\n    }\r\n\r\n    .align-self-md-auto {\r\n        align-self: auto !important\r\n    }\r\n\r\n    .align-self-md-start {\r\n        align-self: flex-start !important\r\n    }\r\n\r\n    .align-self-md-end {\r\n        align-self: flex-end !important\r\n    }\r\n\r\n    .align-self-md-center {\r\n        align-self: center !important\r\n    }\r\n\r\n    .align-self-md-baseline {\r\n        align-self: baseline !important\r\n    }\r\n\r\n    .align-self-md-stretch {\r\n        align-self: stretch !important\r\n    }\r\n\r\n    .order-md-first {\r\n        order: -1 !important\r\n    }\r\n\r\n    .order-md-0 {\r\n        order: 0 !important\r\n    }\r\n\r\n    .order-md-1 {\r\n        order: 1 !important\r\n    }\r\n\r\n    .order-md-2 {\r\n        order: 2 !important\r\n    }\r\n\r\n    .order-md-3 {\r\n        order: 3 !important\r\n    }\r\n\r\n    .order-md-4 {\r\n        order: 4 !important\r\n    }\r\n\r\n    .order-md-5 {\r\n        order: 5 !important\r\n    }\r\n\r\n    .order-md-last {\r\n        order: 6 !important\r\n    }\r\n\r\n    .m-md-0 {\r\n        margin: 0 !important\r\n    }\r\n\r\n    .m-md-1 {\r\n        margin: .25rem !important\r\n    }\r\n\r\n    .m-md-2 {\r\n        margin: .5rem !important\r\n    }\r\n\r\n    .m-md-3 {\r\n        margin: 1rem !important\r\n    }\r\n\r\n    .m-md-4 {\r\n        margin: 1.5rem !important\r\n    }\r\n\r\n    .m-md-5 {\r\n        margin: 3rem !important\r\n    }\r\n\r\n    .m-md-auto {\r\n        margin: auto !important\r\n    }\r\n\r\n    .mx-md-0 {\r\n        margin-right: 0 !important;\r\n        margin-left: 0 !important\r\n    }\r\n\r\n    .mx-md-1 {\r\n        margin-right: .25rem !important;\r\n        margin-left: .25rem !important\r\n    }\r\n\r\n    .mx-md-2 {\r\n        margin-right: .5rem !important;\r\n        margin-left: .5rem !important\r\n    }\r\n\r\n    .mx-md-3 {\r\n        margin-right: 1rem !important;\r\n        margin-left: 1rem !important\r\n    }\r\n\r\n    .mx-md-4 {\r\n        margin-right: 1.5rem !important;\r\n        margin-left: 1.5rem !important\r\n    }\r\n\r\n    .mx-md-5 {\r\n        margin-right: 3rem !important;\r\n        margin-left: 3rem !important\r\n    }\r\n\r\n    .mx-md-auto {\r\n        margin-right: auto !important;\r\n        margin-left: auto !important\r\n    }\r\n\r\n    .my-md-0 {\r\n        margin-top: 0 !important;\r\n        margin-bottom: 0 !important\r\n    }\r\n\r\n    .my-md-1 {\r\n        margin-top: .25rem !important;\r\n        margin-bottom: .25rem !important\r\n    }\r\n\r\n    .my-md-2 {\r\n        margin-top: .5rem !important;\r\n        margin-bottom: .5rem !important\r\n    }\r\n\r\n    .my-md-3 {\r\n        margin-top: 1rem !important;\r\n        margin-bottom: 1rem !important\r\n    }\r\n\r\n    .my-md-4 {\r\n        margin-top: 1.5rem !important;\r\n        margin-bottom: 1.5rem !important\r\n    }\r\n\r\n    .my-md-5 {\r\n        margin-top: 3rem !important;\r\n        margin-bottom: 3rem !important\r\n    }\r\n\r\n    .my-md-auto {\r\n        margin-top: auto !important;\r\n        margin-bottom: auto !important\r\n    }\r\n\r\n    .mt-md-0 {\r\n        margin-top: 0 !important\r\n    }\r\n\r\n    .mt-md-1 {\r\n        margin-top: .25rem !important\r\n    }\r\n\r\n    .mt-md-2 {\r\n        margin-top: .5rem !important\r\n    }\r\n\r\n    .mt-md-3 {\r\n        margin-top: 1rem !important\r\n    }\r\n\r\n    .mt-md-4 {\r\n        margin-top: 1.5rem !important\r\n    }\r\n\r\n    .mt-md-5 {\r\n        margin-top: 3rem !important\r\n    }\r\n\r\n    .mt-md-auto {\r\n        margin-top: auto !important\r\n    }\r\n\r\n    .me-md-0 {\r\n        margin-right: 0 !important\r\n    }\r\n\r\n    .me-md-1 {\r\n        margin-right: .25rem !important\r\n    }\r\n\r\n    .me-md-2 {\r\n        margin-right: .5rem !important\r\n    }\r\n\r\n    .me-md-3 {\r\n        margin-right: 1rem !important\r\n    }\r\n\r\n    .me-md-4 {\r\n        margin-right: 1.5rem !important\r\n    }\r\n\r\n    .me-md-5 {\r\n        margin-right: 3rem !important\r\n    }\r\n\r\n    .me-md-auto {\r\n        margin-right: auto !important\r\n    }\r\n\r\n    .mb-md-0 {\r\n        margin-bottom: 0 !important\r\n    }\r\n\r\n    .mb-md-1 {\r\n        margin-bottom: .25rem !important\r\n    }\r\n\r\n    .mb-md-2 {\r\n        margin-bottom: .5rem !important\r\n    }\r\n\r\n    .mb-md-3 {\r\n        margin-bottom: 1rem !important\r\n    }\r\n\r\n    .mb-md-4 {\r\n        margin-bottom: 1.5rem !important\r\n    }\r\n\r\n    .mb-md-5 {\r\n        margin-bottom: 3rem !important\r\n    }\r\n\r\n    .mb-md-auto {\r\n        margin-bottom: auto !important\r\n    }\r\n\r\n    .ms-md-0 {\r\n        margin-left: 0 !important\r\n    }\r\n\r\n    .ms-md-1 {\r\n        margin-left: .25rem !important\r\n    }\r\n\r\n    .ms-md-2 {\r\n        margin-left: .5rem !important\r\n    }\r\n\r\n    .ms-md-3 {\r\n        margin-left: 1rem !important\r\n    }\r\n\r\n    .ms-md-4 {\r\n        margin-left: 1.5rem !important\r\n    }\r\n\r\n    .ms-md-5 {\r\n        margin-left: 3rem !important\r\n    }\r\n\r\n    .ms-md-auto {\r\n        margin-left: auto !important\r\n    }\r\n\r\n    .p-md-0 {\r\n        padding: 0 !important\r\n    }\r\n\r\n    .p-md-1 {\r\n        padding: .25rem !important\r\n    }\r\n\r\n    .p-md-2 {\r\n        padding: .5rem !important\r\n    }\r\n\r\n    .p-md-3 {\r\n        padding: 1rem !important\r\n    }\r\n\r\n    .p-md-4 {\r\n        padding: 1.5rem !important\r\n    }\r\n\r\n    .p-md-5 {\r\n        padding: 3rem !important\r\n    }\r\n\r\n    .px-md-0 {\r\n        padding-right: 0 !important;\r\n        padding-left: 0 !important\r\n    }\r\n\r\n    .px-md-1 {\r\n        padding-right: .25rem !important;\r\n        padding-left: .25rem !important\r\n    }\r\n\r\n    .px-md-2 {\r\n        padding-right: .5rem !important;\r\n        padding-left: .5rem !important\r\n    }\r\n\r\n    .px-md-3 {\r\n        padding-right: 1rem !important;\r\n        padding-left: 1rem !important\r\n    }\r\n\r\n    .px-md-4 {\r\n        padding-right: 1.5rem !important;\r\n        padding-left: 1.5rem !important\r\n    }\r\n\r\n    .px-md-5 {\r\n        padding-right: 3rem !important;\r\n        padding-left: 3rem !important\r\n    }\r\n\r\n    .py-md-0 {\r\n        padding-top: 0 !important;\r\n        padding-bottom: 0 !important\r\n    }\r\n\r\n    .py-md-1 {\r\n        padding-top: .25rem !important;\r\n        padding-bottom: .25rem !important\r\n    }\r\n\r\n    .py-md-2 {\r\n        padding-top: .5rem !important;\r\n        padding-bottom: .5rem !important\r\n    }\r\n\r\n    .py-md-3 {\r\n        padding-top: 1rem !important;\r\n        padding-bottom: 1rem !important\r\n    }\r\n\r\n    .py-md-4 {\r\n        padding-top: 1.5rem !important;\r\n        padding-bottom: 1.5rem !important\r\n    }\r\n\r\n    .py-md-5 {\r\n        padding-top: 3rem !important;\r\n        padding-bottom: 3rem !important\r\n    }\r\n\r\n    .pt-md-0 {\r\n        padding-top: 0 !important\r\n    }\r\n\r\n    .pt-md-1 {\r\n        padding-top: .25rem !important\r\n    }\r\n\r\n    .pt-md-2 {\r\n        padding-top: .5rem !important\r\n    }\r\n\r\n    .pt-md-3 {\r\n        padding-top: 1rem !important\r\n    }\r\n\r\n    .pt-md-4 {\r\n        padding-top: 1.5rem !important\r\n    }\r\n\r\n    .pt-md-5 {\r\n        padding-top: 3rem !important\r\n    }\r\n\r\n    .pe-md-0 {\r\n        padding-right: 0 !important\r\n    }\r\n\r\n    .pe-md-1 {\r\n        padding-right: .25rem !important\r\n    }\r\n\r\n    .pe-md-2 {\r\n        padding-right: .5rem !important\r\n    }\r\n\r\n    .pe-md-3 {\r\n        padding-right: 1rem !important\r\n    }\r\n\r\n    .pe-md-4 {\r\n        padding-right: 1.5rem !important\r\n    }\r\n\r\n    .pe-md-5 {\r\n        padding-right: 3rem !important\r\n    }\r\n\r\n    .pb-md-0 {\r\n        padding-bottom: 0 !important\r\n    }\r\n\r\n    .pb-md-1 {\r\n        padding-bottom: .25rem !important\r\n    }\r\n\r\n    .pb-md-2 {\r\n        padding-bottom: .5rem !important\r\n    }\r\n\r\n    .pb-md-3 {\r\n        padding-bottom: 1rem !important\r\n    }\r\n\r\n    .pb-md-4 {\r\n        padding-bottom: 1.5rem !important\r\n    }\r\n\r\n    .pb-md-5 {\r\n        padding-bottom: 3rem !important\r\n    }\r\n\r\n    .ps-md-0 {\r\n        padding-left: 0 !important\r\n    }\r\n\r\n    .ps-md-1 {\r\n        padding-left: .25rem !important\r\n    }\r\n\r\n    .ps-md-2 {\r\n        padding-left: .5rem !important\r\n    }\r\n\r\n    .ps-md-3 {\r\n        padding-left: 1rem !important\r\n    }\r\n\r\n    .ps-md-4 {\r\n        padding-left: 1.5rem !important\r\n    }\r\n\r\n    .ps-md-5 {\r\n        padding-left: 3rem !important\r\n    }\r\n\r\n    .gap-md-0 {\r\n        gap: 0 !important\r\n    }\r\n\r\n    .gap-md-1 {\r\n        gap: .25rem !important\r\n    }\r\n\r\n    .gap-md-2 {\r\n        gap: .5rem !important\r\n    }\r\n\r\n    .gap-md-3 {\r\n        gap: 1rem !important\r\n    }\r\n\r\n    .gap-md-4 {\r\n        gap: 1.5rem !important\r\n    }\r\n\r\n    .gap-md-5 {\r\n        gap: 3rem !important\r\n    }\r\n\r\n    .text-md-start {\r\n        text-align: left !important\r\n    }\r\n\r\n    .text-md-end {\r\n        text-align: right !important\r\n    }\r\n\r\n    .text-md-center {\r\n        text-align: center !important\r\n    }\r\n}\r\n\r\n@media (min-width:992px) {\r\n    .float-lg-start {\r\n        float: left !important\r\n    }\r\n\r\n    .float-lg-end {\r\n        float: right !important\r\n    }\r\n\r\n    .float-lg-none {\r\n        float: none !important\r\n    }\r\n\r\n    .d-lg-inline {\r\n        display: inline !important\r\n    }\r\n\r\n    .d-lg-inline-block {\r\n        display: inline-block !important\r\n    }\r\n\r\n    .d-lg-block {\r\n        display: block !important\r\n    }\r\n\r\n    .d-lg-grid {\r\n        display: grid !important\r\n    }\r\n\r\n    .d-lg-table {\r\n        display: table !important\r\n    }\r\n\r\n    .d-lg-table-row {\r\n        display: table-row !important\r\n    }\r\n\r\n    .d-lg-table-cell {\r\n        display: table-cell !important\r\n    }\r\n\r\n    .d-lg-flex {\r\n        display: flex !important\r\n    }\r\n\r\n    .d-lg-inline-flex {\r\n        display: inline-flex !important\r\n    }\r\n\r\n    .d-lg-none {\r\n        display: none !important\r\n    }\r\n\r\n    .flex-lg-fill {\r\n        flex: 1 1 auto !important\r\n    }\r\n\r\n    .flex-lg-row {\r\n        flex-direction: row !important\r\n    }\r\n\r\n    .flex-lg-column {\r\n        flex-direction: column !important\r\n    }\r\n\r\n    .flex-lg-row-reverse {\r\n        flex-direction: row-reverse !important\r\n    }\r\n\r\n    .flex-lg-column-reverse {\r\n        flex-direction: column-reverse !important\r\n    }\r\n\r\n    .flex-lg-grow-0 {\r\n        flex-grow: 0 !important\r\n    }\r\n\r\n    .flex-lg-grow-1 {\r\n        flex-grow: 1 !important\r\n    }\r\n\r\n    .flex-lg-shrink-0 {\r\n        flex-shrink: 0 !important\r\n    }\r\n\r\n    .flex-lg-shrink-1 {\r\n        flex-shrink: 1 !important\r\n    }\r\n\r\n    .flex-lg-wrap {\r\n        flex-wrap: wrap !important\r\n    }\r\n\r\n    .flex-lg-nowrap {\r\n        flex-wrap: nowrap !important\r\n    }\r\n\r\n    .flex-lg-wrap-reverse {\r\n        flex-wrap: wrap-reverse !important\r\n    }\r\n\r\n    .justify-content-lg-start {\r\n        justify-content: flex-start !important\r\n    }\r\n\r\n    .justify-content-lg-end {\r\n        justify-content: flex-end !important\r\n    }\r\n\r\n    .justify-content-lg-center {\r\n        justify-content: center !important\r\n    }\r\n\r\n    .justify-content-lg-between {\r\n        justify-content: space-between !important\r\n    }\r\n\r\n    .justify-content-lg-around {\r\n        justify-content: space-around !important\r\n    }\r\n\r\n    .justify-content-lg-evenly {\r\n        justify-content: space-evenly !important\r\n    }\r\n\r\n    .align-items-lg-start {\r\n        align-items: flex-start !important\r\n    }\r\n\r\n    .align-items-lg-end {\r\n        align-items: flex-end !important\r\n    }\r\n\r\n    .align-items-lg-center {\r\n        align-items: center !important\r\n    }\r\n\r\n    .align-items-lg-baseline {\r\n        align-items: baseline !important\r\n    }\r\n\r\n    .align-items-lg-stretch {\r\n        align-items: stretch !important\r\n    }\r\n\r\n    .align-content-lg-start {\r\n        align-content: flex-start !important\r\n    }\r\n\r\n    .align-content-lg-end {\r\n        align-content: flex-end !important\r\n    }\r\n\r\n    .align-content-lg-center {\r\n        align-content: center !important\r\n    }\r\n\r\n    .align-content-lg-between {\r\n        align-content: space-between !important\r\n    }\r\n\r\n    .align-content-lg-around {\r\n        align-content: space-around !important\r\n    }\r\n\r\n    .align-content-lg-stretch {\r\n        align-content: stretch !important\r\n    }\r\n\r\n    .align-self-lg-auto {\r\n        align-self: auto !important\r\n    }\r\n\r\n    .align-self-lg-start {\r\n        align-self: flex-start !important\r\n    }\r\n\r\n    .align-self-lg-end {\r\n        align-self: flex-end !important\r\n    }\r\n\r\n    .align-self-lg-center {\r\n        align-self: center !important\r\n    }\r\n\r\n    .align-self-lg-baseline {\r\n        align-self: baseline !important\r\n    }\r\n\r\n    .align-self-lg-stretch {\r\n        align-self: stretch !important\r\n    }\r\n\r\n    .order-lg-first {\r\n        order: -1 !important\r\n    }\r\n\r\n    .order-lg-0 {\r\n        order: 0 !important\r\n    }\r\n\r\n    .order-lg-1 {\r\n        order: 1 !important\r\n    }\r\n\r\n    .order-lg-2 {\r\n        order: 2 !important\r\n    }\r\n\r\n    .order-lg-3 {\r\n        order: 3 !important\r\n    }\r\n\r\n    .order-lg-4 {\r\n        order: 4 !important\r\n    }\r\n\r\n    .order-lg-5 {\r\n        order: 5 !important\r\n    }\r\n\r\n    .order-lg-last {\r\n        order: 6 !important\r\n    }\r\n\r\n    .m-lg-0 {\r\n        margin: 0 !important\r\n    }\r\n\r\n    .m-lg-1 {\r\n        margin: .25rem !important\r\n    }\r\n\r\n    .m-lg-2 {\r\n        margin: .5rem !important\r\n    }\r\n\r\n    .m-lg-3 {\r\n        margin: 1rem !important\r\n    }\r\n\r\n    .m-lg-4 {\r\n        margin: 1.5rem !important\r\n    }\r\n\r\n    .m-lg-5 {\r\n        margin: 3rem !important\r\n    }\r\n\r\n    .m-lg-auto {\r\n        margin: auto !important\r\n    }\r\n\r\n    .mx-lg-0 {\r\n        margin-right: 0 !important;\r\n        margin-left: 0 !important\r\n    }\r\n\r\n    .mx-lg-1 {\r\n        margin-right: .25rem !important;\r\n        margin-left: .25rem !important\r\n    }\r\n\r\n    .mx-lg-2 {\r\n        margin-right: .5rem !important;\r\n        margin-left: .5rem !important\r\n    }\r\n\r\n    .mx-lg-3 {\r\n        margin-right: 1rem !important;\r\n        margin-left: 1rem !important\r\n    }\r\n\r\n    .mx-lg-4 {\r\n        margin-right: 1.5rem !important;\r\n        margin-left: 1.5rem !important\r\n    }\r\n\r\n    .mx-lg-5 {\r\n        margin-right: 3rem !important;\r\n        margin-left: 3rem !important\r\n    }\r\n\r\n    .mx-lg-auto {\r\n        margin-right: auto !important;\r\n        margin-left: auto !important\r\n    }\r\n\r\n    .my-lg-0 {\r\n        margin-top: 0 !important;\r\n        margin-bottom: 0 !important\r\n    }\r\n\r\n    .my-lg-1 {\r\n        margin-top: .25rem !important;\r\n        margin-bottom: .25rem !important\r\n    }\r\n\r\n    .my-lg-2 {\r\n        margin-top: .5rem !important;\r\n        margin-bottom: .5rem !important\r\n    }\r\n\r\n    .my-lg-3 {\r\n        margin-top: 1rem !important;\r\n        margin-bottom: 1rem !important\r\n    }\r\n\r\n    .my-lg-4 {\r\n        margin-top: 1.5rem !important;\r\n        margin-bottom: 1.5rem !important\r\n    }\r\n\r\n    .my-lg-5 {\r\n        margin-top: 3rem !important;\r\n        margin-bottom: 3rem !important\r\n    }\r\n\r\n    .my-lg-auto {\r\n        margin-top: auto !important;\r\n        margin-bottom: auto !important\r\n    }\r\n\r\n    .mt-lg-0 {\r\n        margin-top: 0 !important\r\n    }\r\n\r\n    .mt-lg-1 {\r\n        margin-top: .25rem !important\r\n    }\r\n\r\n    .mt-lg-2 {\r\n        margin-top: .5rem !important\r\n    }\r\n\r\n    .mt-lg-3 {\r\n        margin-top: 1rem !important\r\n    }\r\n\r\n    .mt-lg-4 {\r\n        margin-top: 1.5rem !important\r\n    }\r\n\r\n    .mt-lg-5 {\r\n        margin-top: 3rem !important\r\n    }\r\n\r\n    .mt-lg-auto {\r\n        margin-top: auto !important\r\n    }\r\n\r\n    .me-lg-0 {\r\n        margin-right: 0 !important\r\n    }\r\n\r\n    .me-lg-1 {\r\n        margin-right: .25rem !important\r\n    }\r\n\r\n    .me-lg-2 {\r\n        margin-right: .5rem !important\r\n    }\r\n\r\n    .me-lg-3 {\r\n        margin-right: 1rem !important\r\n    }\r\n\r\n    .me-lg-4 {\r\n        margin-right: 1.5rem !important\r\n    }\r\n\r\n    .me-lg-5 {\r\n        margin-right: 3rem !important\r\n    }\r\n\r\n    .me-lg-auto {\r\n        margin-right: auto !important\r\n    }\r\n\r\n    .mb-lg-0 {\r\n        margin-bottom: 0 !important\r\n    }\r\n\r\n    .mb-lg-1 {\r\n        margin-bottom: .25rem !important\r\n    }\r\n\r\n    .mb-lg-2 {\r\n        margin-bottom: .5rem !important\r\n    }\r\n\r\n    .mb-lg-3 {\r\n        margin-bottom: 1rem !important\r\n    }\r\n\r\n    .mb-lg-4 {\r\n        margin-bottom: 1.5rem !important\r\n    }\r\n\r\n    .mb-lg-5 {\r\n        margin-bottom: 3rem !important\r\n    }\r\n\r\n    .mb-lg-auto {\r\n        margin-bottom: auto !important\r\n    }\r\n\r\n    .ms-lg-0 {\r\n        margin-left: 0 !important\r\n    }\r\n\r\n    .ms-lg-1 {\r\n        margin-left: .25rem !important\r\n    }\r\n\r\n    .ms-lg-2 {\r\n        margin-left: .5rem !important\r\n    }\r\n\r\n    .ms-lg-3 {\r\n        margin-left: 1rem !important\r\n    }\r\n\r\n    .ms-lg-4 {\r\n        margin-left: 1.5rem !important\r\n    }\r\n\r\n    .ms-lg-5 {\r\n        margin-left: 3rem !important\r\n    }\r\n\r\n    .ms-lg-auto {\r\n        margin-left: auto !important\r\n    }\r\n\r\n    .p-lg-0 {\r\n        padding: 0 !important\r\n    }\r\n\r\n    .p-lg-1 {\r\n        padding: .25rem !important\r\n    }\r\n\r\n    .p-lg-2 {\r\n        padding: .5rem !important\r\n    }\r\n\r\n    .p-lg-3 {\r\n        padding: 1rem !important\r\n    }\r\n\r\n    .p-lg-4 {\r\n        padding: 1.5rem !important\r\n    }\r\n\r\n    .p-lg-5 {\r\n        padding: 3rem !important\r\n    }\r\n\r\n    .px-lg-0 {\r\n        padding-right: 0 !important;\r\n        padding-left: 0 !important\r\n    }\r\n\r\n    .px-lg-1 {\r\n        padding-right: .25rem !important;\r\n        padding-left: .25rem !important\r\n    }\r\n\r\n    .px-lg-2 {\r\n        padding-right: .5rem !important;\r\n        padding-left: .5rem !important\r\n    }\r\n\r\n    .px-lg-3 {\r\n        padding-right: 1rem !important;\r\n        padding-left: 1rem !important\r\n    }\r\n\r\n    .px-lg-4 {\r\n        padding-right: 1.5rem !important;\r\n        padding-left: 1.5rem !important\r\n    }\r\n\r\n    .px-lg-5 {\r\n        padding-right: 3rem !important;\r\n        padding-left: 3rem !important\r\n    }\r\n\r\n    .py-lg-0 {\r\n        padding-top: 0 !important;\r\n        padding-bottom: 0 !important\r\n    }\r\n\r\n    .py-lg-1 {\r\n        padding-top: .25rem !important;\r\n        padding-bottom: .25rem !important\r\n    }\r\n\r\n    .py-lg-2 {\r\n        padding-top: .5rem !important;\r\n        padding-bottom: .5rem !important\r\n    }\r\n\r\n    .py-lg-3 {\r\n        padding-top: 1rem !important;\r\n        padding-bottom: 1rem !important\r\n    }\r\n\r\n    .py-lg-4 {\r\n        padding-top: 1.5rem !important;\r\n        padding-bottom: 1.5rem !important\r\n    }\r\n\r\n    .py-lg-5 {\r\n        padding-top: 3rem !important;\r\n        padding-bottom: 3rem !important\r\n    }\r\n\r\n    .pt-lg-0 {\r\n        padding-top: 0 !important\r\n    }\r\n\r\n    .pt-lg-1 {\r\n        padding-top: .25rem !important\r\n    }\r\n\r\n    .pt-lg-2 {\r\n        padding-top: .5rem !important\r\n    }\r\n\r\n    .pt-lg-3 {\r\n        padding-top: 1rem !important\r\n    }\r\n\r\n    .pt-lg-4 {\r\n        padding-top: 1.5rem !important\r\n    }\r\n\r\n    .pt-lg-5 {\r\n        padding-top: 3rem !important\r\n    }\r\n\r\n    .pe-lg-0 {\r\n        padding-right: 0 !important\r\n    }\r\n\r\n    .pe-lg-1 {\r\n        padding-right: .25rem !important\r\n    }\r\n\r\n    .pe-lg-2 {\r\n        padding-right: .5rem !important\r\n    }\r\n\r\n    .pe-lg-3 {\r\n        padding-right: 1rem !important\r\n    }\r\n\r\n    .pe-lg-4 {\r\n        padding-right: 1.5rem !important\r\n    }\r\n\r\n    .pe-lg-5 {\r\n        padding-right: 3rem !important\r\n    }\r\n\r\n    .pb-lg-0 {\r\n        padding-bottom: 0 !important\r\n    }\r\n\r\n    .pb-lg-1 {\r\n        padding-bottom: .25rem !important\r\n    }\r\n\r\n    .pb-lg-2 {\r\n        padding-bottom: .5rem !important\r\n    }\r\n\r\n    .pb-lg-3 {\r\n        padding-bottom: 1rem !important\r\n    }\r\n\r\n    .pb-lg-4 {\r\n        padding-bottom: 1.5rem !important\r\n    }\r\n\r\n    .pb-lg-5 {\r\n        padding-bottom: 3rem !important\r\n    }\r\n\r\n    .ps-lg-0 {\r\n        padding-left: 0 !important\r\n    }\r\n\r\n    .ps-lg-1 {\r\n        padding-left: .25rem !important\r\n    }\r\n\r\n    .ps-lg-2 {\r\n        padding-left: .5rem !important\r\n    }\r\n\r\n    .ps-lg-3 {\r\n        padding-left: 1rem !important\r\n    }\r\n\r\n    .ps-lg-4 {\r\n        padding-left: 1.5rem !important\r\n    }\r\n\r\n    .ps-lg-5 {\r\n        padding-left: 3rem !important\r\n    }\r\n\r\n    .gap-lg-0 {\r\n        gap: 0 !important\r\n    }\r\n\r\n    .gap-lg-1 {\r\n        gap: .25rem !important\r\n    }\r\n\r\n    .gap-lg-2 {\r\n        gap: .5rem !important\r\n    }\r\n\r\n    .gap-lg-3 {\r\n        gap: 1rem !important\r\n    }\r\n\r\n    .gap-lg-4 {\r\n        gap: 1.5rem !important\r\n    }\r\n\r\n    .gap-lg-5 {\r\n        gap: 3rem !important\r\n    }\r\n\r\n    .text-lg-start {\r\n        text-align: left !important\r\n    }\r\n\r\n    .text-lg-end {\r\n        text-align: right !important\r\n    }\r\n\r\n    .text-lg-center {\r\n        text-align: center !important\r\n    }\r\n}\r\n\r\n@media (min-width:1200px) {\r\n    .float-xl-start {\r\n        float: left !important\r\n    }\r\n\r\n    .float-xl-end {\r\n        float: right !important\r\n    }\r\n\r\n    .float-xl-none {\r\n        float: none !important\r\n    }\r\n\r\n    .d-xl-inline {\r\n        display: inline !important\r\n    }\r\n\r\n    .d-xl-inline-block {\r\n        display: inline-block !important\r\n    }\r\n\r\n    .d-xl-block {\r\n        display: block !important\r\n    }\r\n\r\n    .d-xl-grid {\r\n        display: grid !important\r\n    }\r\n\r\n    .d-xl-table {\r\n        display: table !important\r\n    }\r\n\r\n    .d-xl-table-row {\r\n        display: table-row !important\r\n    }\r\n\r\n    .d-xl-table-cell {\r\n        display: table-cell !important\r\n    }\r\n\r\n    .d-xl-flex {\r\n        display: flex !important\r\n    }\r\n\r\n    .d-xl-inline-flex {\r\n        display: inline-flex !important\r\n    }\r\n\r\n    .d-xl-none {\r\n        display: none !important\r\n    }\r\n\r\n    .flex-xl-fill {\r\n        flex: 1 1 auto !important\r\n    }\r\n\r\n    .flex-xl-row {\r\n        flex-direction: row !important\r\n    }\r\n\r\n    .flex-xl-column {\r\n        flex-direction: column !important\r\n    }\r\n\r\n    .flex-xl-row-reverse {\r\n        flex-direction: row-reverse !important\r\n    }\r\n\r\n    .flex-xl-column-reverse {\r\n        flex-direction: column-reverse !important\r\n    }\r\n\r\n    .flex-xl-grow-0 {\r\n        flex-grow: 0 !important\r\n    }\r\n\r\n    .flex-xl-grow-1 {\r\n        flex-grow: 1 !important\r\n    }\r\n\r\n    .flex-xl-shrink-0 {\r\n        flex-shrink: 0 !important\r\n    }\r\n\r\n    .flex-xl-shrink-1 {\r\n        flex-shrink: 1 !important\r\n    }\r\n\r\n    .flex-xl-wrap {\r\n        flex-wrap: wrap !important\r\n    }\r\n\r\n    .flex-xl-nowrap {\r\n        flex-wrap: nowrap !important\r\n    }\r\n\r\n    .flex-xl-wrap-reverse {\r\n        flex-wrap: wrap-reverse !important\r\n    }\r\n\r\n    .justify-content-xl-start {\r\n        justify-content: flex-start !important\r\n    }\r\n\r\n    .justify-content-xl-end {\r\n        justify-content: flex-end !important\r\n    }\r\n\r\n    .justify-content-xl-center {\r\n        justify-content: center !important\r\n    }\r\n\r\n    .justify-content-xl-between {\r\n        justify-content: space-between !important\r\n    }\r\n\r\n    .justify-content-xl-around {\r\n        justify-content: space-around !important\r\n    }\r\n\r\n    .justify-content-xl-evenly {\r\n        justify-content: space-evenly !important\r\n    }\r\n\r\n    .align-items-xl-start {\r\n        align-items: flex-start !important\r\n    }\r\n\r\n    .align-items-xl-end {\r\n        align-items: flex-end !important\r\n    }\r\n\r\n    .align-items-xl-center {\r\n        align-items: center !important\r\n    }\r\n\r\n    .align-items-xl-baseline {\r\n        align-items: baseline !important\r\n    }\r\n\r\n    .align-items-xl-stretch {\r\n        align-items: stretch !important\r\n    }\r\n\r\n    .align-content-xl-start {\r\n        align-content: flex-start !important\r\n    }\r\n\r\n    .align-content-xl-end {\r\n        align-content: flex-end !important\r\n    }\r\n\r\n    .align-content-xl-center {\r\n        align-content: center !important\r\n    }\r\n\r\n    .align-content-xl-between {\r\n        align-content: space-between !important\r\n    }\r\n\r\n    .align-content-xl-around {\r\n        align-content: space-around !important\r\n    }\r\n\r\n    .align-content-xl-stretch {\r\n        align-content: stretch !important\r\n    }\r\n\r\n    .align-self-xl-auto {\r\n        align-self: auto !important\r\n    }\r\n\r\n    .align-self-xl-start {\r\n        align-self: flex-start !important\r\n    }\r\n\r\n    .align-self-xl-end {\r\n        align-self: flex-end !important\r\n    }\r\n\r\n    .align-self-xl-center {\r\n        align-self: center !important\r\n    }\r\n\r\n    .align-self-xl-baseline {\r\n        align-self: baseline !important\r\n    }\r\n\r\n    .align-self-xl-stretch {\r\n        align-self: stretch !important\r\n    }\r\n\r\n    .order-xl-first {\r\n        order: -1 !important\r\n    }\r\n\r\n    .order-xl-0 {\r\n        order: 0 !important\r\n    }\r\n\r\n    .order-xl-1 {\r\n        order: 1 !important\r\n    }\r\n\r\n    .order-xl-2 {\r\n        order: 2 !important\r\n    }\r\n\r\n    .order-xl-3 {\r\n        order: 3 !important\r\n    }\r\n\r\n    .order-xl-4 {\r\n        order: 4 !important\r\n    }\r\n\r\n    .order-xl-5 {\r\n        order: 5 !important\r\n    }\r\n\r\n    .order-xl-last {\r\n        order: 6 !important\r\n    }\r\n\r\n    .m-xl-0 {\r\n        margin: 0 !important\r\n    }\r\n\r\n    .m-xl-1 {\r\n        margin: .25rem !important\r\n    }\r\n\r\n    .m-xl-2 {\r\n        margin: .5rem !important\r\n    }\r\n\r\n    .m-xl-3 {\r\n        margin: 1rem !important\r\n    }\r\n\r\n    .m-xl-4 {\r\n        margin: 1.5rem !important\r\n    }\r\n\r\n    .m-xl-5 {\r\n        margin: 3rem !important\r\n    }\r\n\r\n    .m-xl-auto {\r\n        margin: auto !important\r\n    }\r\n\r\n    .mx-xl-0 {\r\n        margin-right: 0 !important;\r\n        margin-left: 0 !important\r\n    }\r\n\r\n    .mx-xl-1 {\r\n        margin-right: .25rem !important;\r\n        margin-left: .25rem !important\r\n    }\r\n\r\n    .mx-xl-2 {\r\n        margin-right: .5rem !important;\r\n        margin-left: .5rem !important\r\n    }\r\n\r\n    .mx-xl-3 {\r\n        margin-right: 1rem !important;\r\n        margin-left: 1rem !important\r\n    }\r\n\r\n    .mx-xl-4 {\r\n        margin-right: 1.5rem !important;\r\n        margin-left: 1.5rem !important\r\n    }\r\n\r\n    .mx-xl-5 {\r\n        margin-right: 3rem !important;\r\n        margin-left: 3rem !important\r\n    }\r\n\r\n    .mx-xl-auto {\r\n        margin-right: auto !important;\r\n        margin-left: auto !important\r\n    }\r\n\r\n    .my-xl-0 {\r\n        margin-top: 0 !important;\r\n        margin-bottom: 0 !important\r\n    }\r\n\r\n    .my-xl-1 {\r\n        margin-top: .25rem !important;\r\n        margin-bottom: .25rem !important\r\n    }\r\n\r\n    .my-xl-2 {\r\n        margin-top: .5rem !important;\r\n        margin-bottom: .5rem !important\r\n    }\r\n\r\n    .my-xl-3 {\r\n        margin-top: 1rem !important;\r\n        margin-bottom: 1rem !important\r\n    }\r\n\r\n    .my-xl-4 {\r\n        margin-top: 1.5rem !important;\r\n        margin-bottom: 1.5rem !important\r\n    }\r\n\r\n    .my-xl-5 {\r\n        margin-top: 3rem !important;\r\n        margin-bottom: 3rem !important\r\n    }\r\n\r\n    .my-xl-auto {\r\n        margin-top: auto !important;\r\n        margin-bottom: auto !important\r\n    }\r\n\r\n    .mt-xl-0 {\r\n        margin-top: 0 !important\r\n    }\r\n\r\n    .mt-xl-1 {\r\n        margin-top: .25rem !important\r\n    }\r\n\r\n    .mt-xl-2 {\r\n        margin-top: .5rem !important\r\n    }\r\n\r\n    .mt-xl-3 {\r\n        margin-top: 1rem !important\r\n    }\r\n\r\n    .mt-xl-4 {\r\n        margin-top: 1.5rem !important\r\n    }\r\n\r\n    .mt-xl-5 {\r\n        margin-top: 3rem !important\r\n    }\r\n\r\n    .mt-xl-auto {\r\n        margin-top: auto !important\r\n    }\r\n\r\n    .me-xl-0 {\r\n        margin-right: 0 !important\r\n    }\r\n\r\n    .me-xl-1 {\r\n        margin-right: .25rem !important\r\n    }\r\n\r\n    .me-xl-2 {\r\n        margin-right: .5rem !important\r\n    }\r\n\r\n    .me-xl-3 {\r\n        margin-right: 1rem !important\r\n    }\r\n\r\n    .me-xl-4 {\r\n        margin-right: 1.5rem !important\r\n    }\r\n\r\n    .me-xl-5 {\r\n        margin-right: 3rem !important\r\n    }\r\n\r\n    .me-xl-auto {\r\n        margin-right: auto !important\r\n    }\r\n\r\n    .mb-xl-0 {\r\n        margin-bottom: 0 !important\r\n    }\r\n\r\n    .mb-xl-1 {\r\n        margin-bottom: .25rem !important\r\n    }\r\n\r\n    .mb-xl-2 {\r\n        margin-bottom: .5rem !important\r\n    }\r\n\r\n    .mb-xl-3 {\r\n        margin-bottom: 1rem !important\r\n    }\r\n\r\n    .mb-xl-4 {\r\n        margin-bottom: 1.5rem !important\r\n    }\r\n\r\n    .mb-xl-5 {\r\n        margin-bottom: 3rem !important\r\n    }\r\n\r\n    .mb-xl-auto {\r\n        margin-bottom: auto !important\r\n    }\r\n\r\n    .ms-xl-0 {\r\n        margin-left: 0 !important\r\n    }\r\n\r\n    .ms-xl-1 {\r\n        margin-left: .25rem !important\r\n    }\r\n\r\n    .ms-xl-2 {\r\n        margin-left: .5rem !important\r\n    }\r\n\r\n    .ms-xl-3 {\r\n        margin-left: 1rem !important\r\n    }\r\n\r\n    .ms-xl-4 {\r\n        margin-left: 1.5rem !important\r\n    }\r\n\r\n    .ms-xl-5 {\r\n        margin-left: 3rem !important\r\n    }\r\n\r\n    .ms-xl-auto {\r\n        margin-left: auto !important\r\n    }\r\n\r\n    .p-xl-0 {\r\n        padding: 0 !important\r\n    }\r\n\r\n    .p-xl-1 {\r\n        padding: .25rem !important\r\n    }\r\n\r\n    .p-xl-2 {\r\n        padding: .5rem !important\r\n    }\r\n\r\n    .p-xl-3 {\r\n        padding: 1rem !important\r\n    }\r\n\r\n    .p-xl-4 {\r\n        padding: 1.5rem !important\r\n    }\r\n\r\n    .p-xl-5 {\r\n        padding: 3rem !important\r\n    }\r\n\r\n    .px-xl-0 {\r\n        padding-right: 0 !important;\r\n        padding-left: 0 !important\r\n    }\r\n\r\n    .px-xl-1 {\r\n        padding-right: .25rem !important;\r\n        padding-left: .25rem !important\r\n    }\r\n\r\n    .px-xl-2 {\r\n        padding-right: .5rem !important;\r\n        padding-left: .5rem !important\r\n    }\r\n\r\n    .px-xl-3 {\r\n        padding-right: 1rem !important;\r\n        padding-left: 1rem !important\r\n    }\r\n\r\n    .px-xl-4 {\r\n        padding-right: 1.5rem !important;\r\n        padding-left: 1.5rem !important\r\n    }\r\n\r\n    .px-xl-5 {\r\n        padding-right: 3rem !important;\r\n        padding-left: 3rem !important\r\n    }\r\n\r\n    .py-xl-0 {\r\n        padding-top: 0 !important;\r\n        padding-bottom: 0 !important\r\n    }\r\n\r\n    .py-xl-1 {\r\n        padding-top: .25rem !important;\r\n        padding-bottom: .25rem !important\r\n    }\r\n\r\n    .py-xl-2 {\r\n        padding-top: .5rem !important;\r\n        padding-bottom: .5rem !important\r\n    }\r\n\r\n    .py-xl-3 {\r\n        padding-top: 1rem !important;\r\n        padding-bottom: 1rem !important\r\n    }\r\n\r\n    .py-xl-4 {\r\n        padding-top: 1.5rem !important;\r\n        padding-bottom: 1.5rem !important\r\n    }\r\n\r\n    .py-xl-5 {\r\n        padding-top: 3rem !important;\r\n        padding-bottom: 3rem !important\r\n    }\r\n\r\n    .pt-xl-0 {\r\n        padding-top: 0 !important\r\n    }\r\n\r\n    .pt-xl-1 {\r\n        padding-top: .25rem !important\r\n    }\r\n\r\n    .pt-xl-2 {\r\n        padding-top: .5rem !important\r\n    }\r\n\r\n    .pt-xl-3 {\r\n        padding-top: 1rem !important\r\n    }\r\n\r\n    .pt-xl-4 {\r\n        padding-top: 1.5rem !important\r\n    }\r\n\r\n    .pt-xl-5 {\r\n        padding-top: 3rem !important\r\n    }\r\n\r\n    .pe-xl-0 {\r\n        padding-right: 0 !important\r\n    }\r\n\r\n    .pe-xl-1 {\r\n        padding-right: .25rem !important\r\n    }\r\n\r\n    .pe-xl-2 {\r\n        padding-right: .5rem !important\r\n    }\r\n\r\n    .pe-xl-3 {\r\n        padding-right: 1rem !important\r\n    }\r\n\r\n    .pe-xl-4 {\r\n        padding-right: 1.5rem !important\r\n    }\r\n\r\n    .pe-xl-5 {\r\n        padding-right: 3rem !important\r\n    }\r\n\r\n    .pb-xl-0 {\r\n        padding-bottom: 0 !important\r\n    }\r\n\r\n    .pb-xl-1 {\r\n        padding-bottom: .25rem !important\r\n    }\r\n\r\n    .pb-xl-2 {\r\n        padding-bottom: .5rem !important\r\n    }\r\n\r\n    .pb-xl-3 {\r\n        padding-bottom: 1rem !important\r\n    }\r\n\r\n    .pb-xl-4 {\r\n        padding-bottom: 1.5rem !important\r\n    }\r\n\r\n    .pb-xl-5 {\r\n        padding-bottom: 3rem !important\r\n    }\r\n\r\n    .ps-xl-0 {\r\n        padding-left: 0 !important\r\n    }\r\n\r\n    .ps-xl-1 {\r\n        padding-left: .25rem !important\r\n    }\r\n\r\n    .ps-xl-2 {\r\n        padding-left: .5rem !important\r\n    }\r\n\r\n    .ps-xl-3 {\r\n        padding-left: 1rem !important\r\n    }\r\n\r\n    .ps-xl-4 {\r\n        padding-left: 1.5rem !important\r\n    }\r\n\r\n    .ps-xl-5 {\r\n        padding-left: 3rem !important\r\n    }\r\n\r\n    .gap-xl-0 {\r\n        gap: 0 !important\r\n    }\r\n\r\n    .gap-xl-1 {\r\n        gap: .25rem !important\r\n    }\r\n\r\n    .gap-xl-2 {\r\n        gap: .5rem !important\r\n    }\r\n\r\n    .gap-xl-3 {\r\n        gap: 1rem !important\r\n    }\r\n\r\n    .gap-xl-4 {\r\n        gap: 1.5rem !important\r\n    }\r\n\r\n    .gap-xl-5 {\r\n        gap: 3rem !important\r\n    }\r\n\r\n    .text-xl-start {\r\n        text-align: left !important\r\n    }\r\n\r\n    .text-xl-end {\r\n        text-align: right !important\r\n    }\r\n\r\n    .text-xl-center {\r\n        text-align: center !important\r\n    }\r\n}\r\n\r\n@media (min-width:1400px) {\r\n    .float-xxl-start {\r\n        float: left !important\r\n    }\r\n\r\n    .float-xxl-end {\r\n        float: right !important\r\n    }\r\n\r\n    .float-xxl-none {\r\n        float: none !important\r\n    }\r\n\r\n    .d-xxl-inline {\r\n        display: inline !important\r\n    }\r\n\r\n    .d-xxl-inline-block {\r\n        display: inline-block !important\r\n    }\r\n\r\n    .d-xxl-block {\r\n        display: block !important\r\n    }\r\n\r\n    .d-xxl-grid {\r\n        display: grid !important\r\n    }\r\n\r\n    .d-xxl-table {\r\n        display: table !important\r\n    }\r\n\r\n    .d-xxl-table-row {\r\n        display: table-row !important\r\n    }\r\n\r\n    .d-xxl-table-cell {\r\n        display: table-cell !important\r\n    }\r\n\r\n    .d-xxl-flex {\r\n        display: flex !important\r\n    }\r\n\r\n    .d-xxl-inline-flex {\r\n        display: inline-flex !important\r\n    }\r\n\r\n    .d-xxl-none {\r\n        display: none !important\r\n    }\r\n\r\n    .flex-xxl-fill {\r\n        flex: 1 1 auto !important\r\n    }\r\n\r\n    .flex-xxl-row {\r\n        flex-direction: row !important\r\n    }\r\n\r\n    .flex-xxl-column {\r\n        flex-direction: column !important\r\n    }\r\n\r\n    .flex-xxl-row-reverse {\r\n        flex-direction: row-reverse !important\r\n    }\r\n\r\n    .flex-xxl-column-reverse {\r\n        flex-direction: column-reverse !important\r\n    }\r\n\r\n    .flex-xxl-grow-0 {\r\n        flex-grow: 0 !important\r\n    }\r\n\r\n    .flex-xxl-grow-1 {\r\n        flex-grow: 1 !important\r\n    }\r\n\r\n    .flex-xxl-shrink-0 {\r\n        flex-shrink: 0 !important\r\n    }\r\n\r\n    .flex-xxl-shrink-1 {\r\n        flex-shrink: 1 !important\r\n    }\r\n\r\n    .flex-xxl-wrap {\r\n        flex-wrap: wrap !important\r\n    }\r\n\r\n    .flex-xxl-nowrap {\r\n        flex-wrap: nowrap !important\r\n    }\r\n\r\n    .flex-xxl-wrap-reverse {\r\n        flex-wrap: wrap-reverse !important\r\n    }\r\n\r\n    .justify-content-xxl-start {\r\n        justify-content: flex-start !important\r\n    }\r\n\r\n    .justify-content-xxl-end {\r\n        justify-content: flex-end !important\r\n    }\r\n\r\n    .justify-content-xxl-center {\r\n        justify-content: center !important\r\n    }\r\n\r\n    .justify-content-xxl-between {\r\n        justify-content: space-between !important\r\n    }\r\n\r\n    .justify-content-xxl-around {\r\n        justify-content: space-around !important\r\n    }\r\n\r\n    .justify-content-xxl-evenly {\r\n        justify-content: space-evenly !important\r\n    }\r\n\r\n    .align-items-xxl-start {\r\n        align-items: flex-start !important\r\n    }\r\n\r\n    .align-items-xxl-end {\r\n        align-items: flex-end !important\r\n    }\r\n\r\n    .align-items-xxl-center {\r\n        align-items: center !important\r\n    }\r\n\r\n    .align-items-xxl-baseline {\r\n        align-items: baseline !important\r\n    }\r\n\r\n    .align-items-xxl-stretch {\r\n        align-items: stretch !important\r\n    }\r\n\r\n    .align-content-xxl-start {\r\n        align-content: flex-start !important\r\n    }\r\n\r\n    .align-content-xxl-end {\r\n        align-content: flex-end !important\r\n    }\r\n\r\n    .align-content-xxl-center {\r\n        align-content: center !important\r\n    }\r\n\r\n    .align-content-xxl-between {\r\n        align-content: space-between !important\r\n    }\r\n\r\n    .align-content-xxl-around {\r\n        align-content: space-around !important\r\n    }\r\n\r\n    .align-content-xxl-stretch {\r\n        align-content: stretch !important\r\n    }\r\n\r\n    .align-self-xxl-auto {\r\n        align-self: auto !important\r\n    }\r\n\r\n    .align-self-xxl-start {\r\n        align-self: flex-start !important\r\n    }\r\n\r\n    .align-self-xxl-end {\r\n        align-self: flex-end !important\r\n    }\r\n\r\n    .align-self-xxl-center {\r\n        align-self: center !important\r\n    }\r\n\r\n    .align-self-xxl-baseline {\r\n        align-self: baseline !important\r\n    }\r\n\r\n    .align-self-xxl-stretch {\r\n        align-self: stretch !important\r\n    }\r\n\r\n    .order-xxl-first {\r\n        order: -1 !important\r\n    }\r\n\r\n    .order-xxl-0 {\r\n        order: 0 !important\r\n    }\r\n\r\n    .order-xxl-1 {\r\n        order: 1 !important\r\n    }\r\n\r\n    .order-xxl-2 {\r\n        order: 2 !important\r\n    }\r\n\r\n    .order-xxl-3 {\r\n        order: 3 !important\r\n    }\r\n\r\n    .order-xxl-4 {\r\n        order: 4 !important\r\n    }\r\n\r\n    .order-xxl-5 {\r\n        order: 5 !important\r\n    }\r\n\r\n    .order-xxl-last {\r\n        order: 6 !important\r\n    }\r\n\r\n    .m-xxl-0 {\r\n        margin: 0 !important\r\n    }\r\n\r\n    .m-xxl-1 {\r\n        margin: .25rem !important\r\n    }\r\n\r\n    .m-xxl-2 {\r\n        margin: .5rem !important\r\n    }\r\n\r\n    .m-xxl-3 {\r\n        margin: 1rem !important\r\n    }\r\n\r\n    .m-xxl-4 {\r\n        margin: 1.5rem !important\r\n    }\r\n\r\n    .m-xxl-5 {\r\n        margin: 3rem !important\r\n    }\r\n\r\n    .m-xxl-auto {\r\n        margin: auto !important\r\n    }\r\n\r\n    .mx-xxl-0 {\r\n        margin-right: 0 !important;\r\n        margin-left: 0 !important\r\n    }\r\n\r\n    .mx-xxl-1 {\r\n        margin-right: .25rem !important;\r\n        margin-left: .25rem !important\r\n    }\r\n\r\n    .mx-xxl-2 {\r\n        margin-right: .5rem !important;\r\n        margin-left: .5rem !important\r\n    }\r\n\r\n    .mx-xxl-3 {\r\n        margin-right: 1rem !important;\r\n        margin-left: 1rem !important\r\n    }\r\n\r\n    .mx-xxl-4 {\r\n        margin-right: 1.5rem !important;\r\n        margin-left: 1.5rem !important\r\n    }\r\n\r\n    .mx-xxl-5 {\r\n        margin-right: 3rem !important;\r\n        margin-left: 3rem !important\r\n    }\r\n\r\n    .mx-xxl-auto {\r\n        margin-right: auto !important;\r\n        margin-left: auto !important\r\n    }\r\n\r\n    .my-xxl-0 {\r\n        margin-top: 0 !important;\r\n        margin-bottom: 0 !important\r\n    }\r\n\r\n    .my-xxl-1 {\r\n        margin-top: .25rem !important;\r\n        margin-bottom: .25rem !important\r\n    }\r\n\r\n    .my-xxl-2 {\r\n        margin-top: .5rem !important;\r\n        margin-bottom: .5rem !important\r\n    }\r\n\r\n    .my-xxl-3 {\r\n        margin-top: 1rem !important;\r\n        margin-bottom: 1rem !important\r\n    }\r\n\r\n    .my-xxl-4 {\r\n        margin-top: 1.5rem !important;\r\n        margin-bottom: 1.5rem !important\r\n    }\r\n\r\n    .my-xxl-5 {\r\n        margin-top: 3rem !important;\r\n        margin-bottom: 3rem !important\r\n    }\r\n\r\n    .my-xxl-auto {\r\n        margin-top: auto !important;\r\n        margin-bottom: auto !important\r\n    }\r\n\r\n    .mt-xxl-0 {\r\n        margin-top: 0 !important\r\n    }\r\n\r\n    .mt-xxl-1 {\r\n        margin-top: .25rem !important\r\n    }\r\n\r\n    .mt-xxl-2 {\r\n        margin-top: .5rem !important\r\n    }\r\n\r\n    .mt-xxl-3 {\r\n        margin-top: 1rem !important\r\n    }\r\n\r\n    .mt-xxl-4 {\r\n        margin-top: 1.5rem !important\r\n    }\r\n\r\n    .mt-xxl-5 {\r\n        margin-top: 3rem !important\r\n    }\r\n\r\n    .mt-xxl-auto {\r\n        margin-top: auto !important\r\n    }\r\n\r\n    .me-xxl-0 {\r\n        margin-right: 0 !important\r\n    }\r\n\r\n    .me-xxl-1 {\r\n        margin-right: .25rem !important\r\n    }\r\n\r\n    .me-xxl-2 {\r\n        margin-right: .5rem !important\r\n    }\r\n\r\n    .me-xxl-3 {\r\n        margin-right: 1rem !important\r\n    }\r\n\r\n    .me-xxl-4 {\r\n        margin-right: 1.5rem !important\r\n    }\r\n\r\n    .me-xxl-5 {\r\n        margin-right: 3rem !important\r\n    }\r\n\r\n    .me-xxl-auto {\r\n        margin-right: auto !important\r\n    }\r\n\r\n    .mb-xxl-0 {\r\n        margin-bottom: 0 !important\r\n    }\r\n\r\n    .mb-xxl-1 {\r\n        margin-bottom: .25rem !important\r\n    }\r\n\r\n    .mb-xxl-2 {\r\n        margin-bottom: .5rem !important\r\n    }\r\n\r\n    .mb-xxl-3 {\r\n        margin-bottom: 1rem !important\r\n    }\r\n\r\n    .mb-xxl-4 {\r\n        margin-bottom: 1.5rem !important\r\n    }\r\n\r\n    .mb-xxl-5 {\r\n        margin-bottom: 3rem !important\r\n    }\r\n\r\n    .mb-xxl-auto {\r\n        margin-bottom: auto !important\r\n    }\r\n\r\n    .ms-xxl-0 {\r\n        margin-left: 0 !important\r\n    }\r\n\r\n    .ms-xxl-1 {\r\n        margin-left: .25rem !important\r\n    }\r\n\r\n    .ms-xxl-2 {\r\n        margin-left: .5rem !important\r\n    }\r\n\r\n    .ms-xxl-3 {\r\n        margin-left: 1rem !important\r\n    }\r\n\r\n    .ms-xxl-4 {\r\n        margin-left: 1.5rem !important\r\n    }\r\n\r\n    .ms-xxl-5 {\r\n        margin-left: 3rem !important\r\n    }\r\n\r\n    .ms-xxl-auto {\r\n        margin-left: auto !important\r\n    }\r\n\r\n    .p-xxl-0 {\r\n        padding: 0 !important\r\n    }\r\n\r\n    .p-xxl-1 {\r\n        padding: .25rem !important\r\n    }\r\n\r\n    .p-xxl-2 {\r\n        padding: .5rem !important\r\n    }\r\n\r\n    .p-xxl-3 {\r\n        padding: 1rem !important\r\n    }\r\n\r\n    .p-xxl-4 {\r\n        padding: 1.5rem !important\r\n    }\r\n\r\n    .p-xxl-5 {\r\n        padding: 3rem !important\r\n    }\r\n\r\n    .px-xxl-0 {\r\n        padding-right: 0 !important;\r\n        padding-left: 0 !important\r\n    }\r\n\r\n    .px-xxl-1 {\r\n        padding-right: .25rem !important;\r\n        padding-left: .25rem !important\r\n    }\r\n\r\n    .px-xxl-2 {\r\n        padding-right: .5rem !important;\r\n        padding-left: .5rem !important\r\n    }\r\n\r\n    .px-xxl-3 {\r\n        padding-right: 1rem !important;\r\n        padding-left: 1rem !important\r\n    }\r\n\r\n    .px-xxl-4 {\r\n        padding-right: 1.5rem !important;\r\n        padding-left: 1.5rem !important\r\n    }\r\n\r\n    .px-xxl-5 {\r\n        padding-right: 3rem !important;\r\n        padding-left: 3rem !important\r\n    }\r\n\r\n    .py-xxl-0 {\r\n        padding-top: 0 !important;\r\n        padding-bottom: 0 !important\r\n    }\r\n\r\n    .py-xxl-1 {\r\n        padding-top: .25rem !important;\r\n        padding-bottom: .25rem !important\r\n    }\r\n\r\n    .py-xxl-2 {\r\n        padding-top: .5rem !important;\r\n        padding-bottom: .5rem !important\r\n    }\r\n\r\n    .py-xxl-3 {\r\n        padding-top: 1rem !important;\r\n        padding-bottom: 1rem !important\r\n    }\r\n\r\n    .py-xxl-4 {\r\n        padding-top: 1.5rem !important;\r\n        padding-bottom: 1.5rem !important\r\n    }\r\n\r\n    .py-xxl-5 {\r\n        padding-top: 3rem !important;\r\n        padding-bottom: 3rem !important\r\n    }\r\n\r\n    .pt-xxl-0 {\r\n        padding-top: 0 !important\r\n    }\r\n\r\n    .pt-xxl-1 {\r\n        padding-top: .25rem !important\r\n    }\r\n\r\n    .pt-xxl-2 {\r\n        padding-top: .5rem !important\r\n    }\r\n\r\n    .pt-xxl-3 {\r\n        padding-top: 1rem !important\r\n    }\r\n\r\n    .pt-xxl-4 {\r\n        padding-top: 1.5rem !important\r\n    }\r\n\r\n    .pt-xxl-5 {\r\n        padding-top: 3rem !important\r\n    }\r\n\r\n    .pe-xxl-0 {\r\n        padding-right: 0 !important\r\n    }\r\n\r\n    .pe-xxl-1 {\r\n        padding-right: .25rem !important\r\n    }\r\n\r\n    .pe-xxl-2 {\r\n        padding-right: .5rem !important\r\n    }\r\n\r\n    .pe-xxl-3 {\r\n        padding-right: 1rem !important\r\n    }\r\n\r\n    .pe-xxl-4 {\r\n        padding-right: 1.5rem !important\r\n    }\r\n\r\n    .pe-xxl-5 {\r\n        padding-right: 3rem !important\r\n    }\r\n\r\n    .pb-xxl-0 {\r\n        padding-bottom: 0 !important\r\n    }\r\n\r\n    .pb-xxl-1 {\r\n        padding-bottom: .25rem !important\r\n    }\r\n\r\n    .pb-xxl-2 {\r\n        padding-bottom: .5rem !important\r\n    }\r\n\r\n    .pb-xxl-3 {\r\n        padding-bottom: 1rem !important\r\n    }\r\n\r\n    .pb-xxl-4 {\r\n        padding-bottom: 1.5rem !important\r\n    }\r\n\r\n    .pb-xxl-5 {\r\n        padding-bottom: 3rem !important\r\n    }\r\n\r\n    .ps-xxl-0 {\r\n        padding-left: 0 !important\r\n    }\r\n\r\n    .ps-xxl-1 {\r\n        padding-left: .25rem !important\r\n    }\r\n\r\n    .ps-xxl-2 {\r\n        padding-left: .5rem !important\r\n    }\r\n\r\n    .ps-xxl-3 {\r\n        padding-left: 1rem !important\r\n    }\r\n\r\n    .ps-xxl-4 {\r\n        padding-left: 1.5rem !important\r\n    }\r\n\r\n    .ps-xxl-5 {\r\n        padding-left: 3rem !important\r\n    }\r\n\r\n    .gap-xxl-0 {\r\n        gap: 0 !important\r\n    }\r\n\r\n    .gap-xxl-1 {\r\n        gap: .25rem !important\r\n    }\r\n\r\n    .gap-xxl-2 {\r\n        gap: .5rem !important\r\n    }\r\n\r\n    .gap-xxl-3 {\r\n        gap: 1rem !important\r\n    }\r\n\r\n    .gap-xxl-4 {\r\n        gap: 1.5rem !important\r\n    }\r\n\r\n    .gap-xxl-5 {\r\n        gap: 3rem !important\r\n    }\r\n\r\n    .text-xxl-start {\r\n        text-align: left !important\r\n    }\r\n\r\n    .text-xxl-end {\r\n        text-align: right !important\r\n    }\r\n\r\n    .text-xxl-center {\r\n        text-align: center !important\r\n    }\r\n}\r\n\r\n@media (min-width:1200px) {\r\n    .fs-1 {\r\n        font-size: 2.5rem !important\r\n    }\r\n\r\n    .fs-2 {\r\n        font-size: 2rem !important\r\n    }\r\n\r\n    .fs-3 {\r\n        font-size: 1.75rem !important\r\n    }\r\n\r\n    .fs-4 {\r\n        font-size: 1.5rem !important\r\n    }\r\n}\r\n\r\n@media print {\r\n    .d-print-inline {\r\n        display: inline !important\r\n    }\r\n\r\n    .d-print-inline-block {\r\n        display: inline-block !important\r\n    }\r\n\r\n    .d-print-block {\r\n        display: block !important\r\n    }\r\n\r\n    .d-print-grid {\r\n        display: grid !important\r\n    }\r\n\r\n    .d-print-table {\r\n        display: table !important\r\n    }\r\n\r\n    .d-print-table-row {\r\n        display: table-row !important\r\n    }\r\n\r\n    .d-print-table-cell {\r\n        display: table-cell !important\r\n    }\r\n\r\n    .d-print-flex {\r\n        display: flex !important\r\n    }\r\n\r\n    .d-print-inline-flex {\r\n        display: inline-flex !important\r\n    }\r\n\r\n    .d-print-none {\r\n        display: none !important\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
